// AUTO-GENERATED by scripts/qlist-normalize.mjs — do not edit by hand.
// Source: https://qlist.ir (via panel.qlist.ir/items/* Directus API)
// Generated at: 2026-05-16T21:58:10.241Z

export interface SubBrand {
  slug: string
  id: number
  name: { en: string; fa: string }
  logo: string | null
  subtitle: { en: string; fa: string }
  categories: string[]
}

export interface Dossier {
  slug: string
  url: string
  title: { en: string; fa: string }
  summary: { en: string; fa: string }
  cover: string | null
}

export type QlistStatus = 'supports-israel' | 'american' | 'flagged'

export interface Company {
  slug: string
  name: { en: string; fa: string }
  country: string
  logo: string | null
  // Faithful translation of qlist.ir's brand.subtitle ("supports Israel" or
  // "American company"). Shown as the status badge.
  qlistStatus: { en: string; fa: string }
  // Machine-friendly form of the same.
  status: QlistStatus
  // Faithful translation of qlist.ir's brand.description — the long-form
  // "why it's listed" reason. Empty string when qlist has no description.
  claim: { en: string; fa: string }
  subBrands: SubBrand[]
  dossier: Dossier | null
}

export interface Category {
  id: number
  label: string
  icon: string
}

export interface EditorJSBlock {
  id?: string
  type: string
  data: Record<string, unknown>
}

export interface EditorJSDoc {
  time?: number
  version?: string
  blocks: EditorJSBlock[]
}

export interface Post {
  slug: string
  sourceUrl: string
  companySlug: string | null
  title: { en: string; fa: string }
  summary: { en: string; fa: string }
  cover: string | null
  // Persian original (EditorJS body) — guaranteed to be present.
  body: EditorJSDoc
  // English translation — null when not yet translated.
  bodyEn: EditorJSDoc | null
}

export interface CompaniesData {
  generatedAt: string
  source: string
  companies: Company[]
  categories: Category[]
  brandIndex: Record<string, string>
  posts: Post[]
  assetManifest: Record<string, string>
}

const data: CompaniesData = {
  "generatedAt": "2026-05-16T21:58:10.241Z",
  "source": "https://qlist.ir (via panel.qlist.ir/items/* Directus API)",
  "companies": [
    {
      "slug": "nestle",
      "name": {
        "en": "Nestlé",
        "fa": "نِستله"
      },
      "country": "ch",
      "logo": "/qlist-assets/b4ed84bf-c809-40a0-a7c7-808d2342252b.png",
      "qlistStatus": {
        "en": "Supports Israel",
        "fa": "حامی اسرائیل"
      },
      "status": "supports-israel",
      "claim": {
        "en": "Nestlé, the Swiss food and beverage giant, is one of the major supporters of the Israeli regime. By acquiring 100% of the shares of one of Israel's largest food companies — Osem — the company, in addition to substantial investment, has significantly helped expand Osem's export markets through technology transfer. Some Osem factories are located in Zionist settlements. According to The Jewish Standard (a subsidiary of The Times of Israel), in 1998 Nestlé received the \"Jubilee\" award from the Israeli Prime Minister in recognition of its efforts to strengthen the Israeli regime's economy.",
        "fa": "شرکت نِستله (Nestle)، غول سوئیسی محصولات غذایی و آشامیدنی، یکی از حامیان مهم رژیم اسرائیل است. این شرکت با خرید کل سهام یکی از بزرگ‌ترین شرکت‌های غذایی اسرائیل به نام اوسِم(Osem)، علاوه‌بر سرمایه‌گذاری قابل توجه، با انتقال فناوری، به توسعه بازارهای صادرات اوسِم کمک شایانی کرده‌است. برخی از کارخانجات اوسِم در شهرک‌های صهیونیستی مستقرند. به نقل از جِویش‌استاندارد(زیرمجموعه تایمز اسرائیل)، نِستله در سال ۱۹۹۸ به پاس تلاش‌هایش برای تقویت اقتصاد رژیم اسرائیل، از دست نخست‌وزیر این کشور جایزه «جوبیلی» را دریافت کرده است."
      },
      "subBrands": [
        {
          "slug": "nescafe",
          "id": 6,
          "name": {
            "en": "Nescafe",
            "fa": "نِسکافه"
          },
          "logo": "/qlist-assets/194e8c5b-de18-4a3b-bed8-d3e36183988f.png",
          "subtitle": {
            "en": "Instant coffee",
            "fa": "قهوه فوری"
          },
          "categories": [
            "Beverage",
            "Food"
          ]
        },
        {
          "slug": "nespresso",
          "id": 38,
          "name": {
            "en": "Nespresso",
            "fa": "نسپرسو"
          },
          "logo": "/qlist-assets/e569ff93-8121-4501-922f-805c061fe2be.png",
          "subtitle": {
            "en": "Coffee machines",
            "fa": "دستگاه قهوه‌ساز"
          },
          "categories": [
            "Beverage",
            "Household"
          ]
        },
        {
          "slug": "guigoz",
          "id": 44,
          "name": {
            "en": "Guigoz",
            "fa": "گیگوز"
          },
          "logo": "/qlist-assets/b8693aa3-3475-4f1d-b9f2-5790ed0e7580.png",
          "subtitle": {
            "en": "Infant formula",
            "fa": "شیرخشک"
          },
          "categories": [
            "Baby food"
          ]
        },
        {
          "slug": "nestle-health-science",
          "id": 47,
          "name": {
            "en": "Nestle Health Science",
            "fa": "نِستله هِلث سایِنس"
          },
          "logo": "/qlist-assets/f3bd2312-daf3-484f-9404-7685dbddcdf5.png",
          "subtitle": {
            "en": "Health & nutrition research",
            "fa": "تحقیق درباره سلامتی و رژیم"
          },
          "categories": [
            "Supplements"
          ]
        },
        {
          "slug": "nankid",
          "id": 48,
          "name": {
            "en": "NANKID",
            "fa": "نان‌کید"
          },
          "logo": "/qlist-assets/688115c5-a691-43ff-b24d-2506760362a7.png",
          "subtitle": {
            "en": "Fortified infant milk",
            "fa": "شیر خشک غنی شده"
          },
          "categories": [
            "Baby food"
          ]
        },
        {
          "slug": "peptamen",
          "id": 52,
          "name": {
            "en": "Peptamen",
            "fa": "پِپتامِن"
          },
          "logo": "/qlist-assets/035deef9-c3ba-44af-8ba1-eca229bd9ba1.png",
          "subtitle": {
            "en": "Nutritional supplement",
            "fa": "مکمل خوراکی"
          },
          "categories": [
            "Supplements"
          ]
        },
        {
          "slug": "nan",
          "id": 5,
          "name": {
            "en": "NAN",
            "fa": "نان"
          },
          "logo": "/qlist-assets/5e43ebc4-fec7-495a-a77c-1fde4166bcfc.png",
          "subtitle": {
            "en": "Infant formula",
            "fa": "شیر خشک"
          },
          "categories": [
            "Baby food",
            "Supplements"
          ]
        },
        {
          "slug": "kitkat",
          "id": 7,
          "name": {
            "en": "KitKat",
            "fa": "کیت‌کَت"
          },
          "logo": "/qlist-assets/bd136a6e-18a4-4b1b-95b9-3174ad1537bf.png",
          "subtitle": {
            "en": "Chocolate",
            "fa": "شکلات"
          },
          "categories": [
            "Food",
            "Electronics"
          ]
        },
        {
          "slug": "coffeemate",
          "id": 9,
          "name": {
            "en": "CoffeeMate",
            "fa": "کافی‌مِیت"
          },
          "logo": "/qlist-assets/e2f32ac3-b570-41cf-ad4d-2c685888704f.png",
          "subtitle": {
            "en": "Creamer",
            "fa": "خامه‌ساز"
          },
          "categories": [
            "Beverage",
            "Food",
            "Apparel"
          ]
        },
        {
          "slug": "nesquik",
          "id": 37,
          "name": {
            "en": "Nesquik",
            "fa": "نسکوییک"
          },
          "logo": "/qlist-assets/5aa2e9ef-3cf0-4328-ba75-66f00c93537c.png",
          "subtitle": {
            "en": "Cocoa powder",
            "fa": "پودر کاکائو"
          },
          "categories": [
            "Beverage",
            "Food"
          ]
        },
        {
          "slug": "optifast",
          "id": 46,
          "name": {
            "en": "OPTIFAST",
            "fa": "اُپتیفست"
          },
          "logo": "/qlist-assets/22fc04c8-866a-4fc9-a18e-d2590c839c26.png",
          "subtitle": {
            "en": "Weight-management products",
            "fa": "محصولات رژیمی و لاغری"
          },
          "categories": [
            "Supplements"
          ]
        },
        {
          "slug": "purelife",
          "id": 8,
          "name": {
            "en": "PureLife",
            "fa": "پیورلایف"
          },
          "logo": "/qlist-assets/eb42cdbb-2198-4af7-80a1-58b9fc7c4f99.png",
          "subtitle": {
            "en": "Mineral water",
            "fa": "آب معدنی"
          },
          "categories": [
            "Drinking water",
            "Technology"
          ]
        },
        {
          "slug": "cerelac",
          "id": 13,
          "name": {
            "en": "CERELAC",
            "fa": "سِرِلاک"
          },
          "logo": "/qlist-assets/a9a39760-d7a9-44c7-8bf0-9dfe2aef67d2.png",
          "subtitle": {
            "en": "Infant cereal",
            "fa": "غذای کمکی کودک"
          },
          "categories": [
            "Baby food",
            "Household"
          ]
        },
        {
          "slug": "corn-flakes",
          "id": 39,
          "name": {
            "en": "Corn Flakes",
            "fa": "کورن‌فلکس"
          },
          "logo": "/qlist-assets/27bae53e-bc80-4697-b09d-75c7341cf73e.png",
          "subtitle": {
            "en": "Breakfast cereal",
            "fa": "غلات صبحانه"
          },
          "categories": [
            "Food"
          ]
        },
        {
          "slug": "nan-optipro",
          "id": 49,
          "name": {
            "en": "NAN-OPTIPRO",
            "fa": "نان اُپتی‌پرو"
          },
          "logo": "/qlist-assets/0034be70-bd14-40c0-aea2-a460264af362.png",
          "subtitle": {
            "en": "Infant formula",
            "fa": "شیر خشک"
          },
          "categories": [
            "Baby food"
          ]
        }
      ],
      "dossier": {
        "slug": "nestle",
        "url": "https://qlist.ir/blog/nestle/",
        "title": {
          "en": "نِستله؛ غذای خوب، زندگی خوب، مرگ خوب!",
          "fa": "همه چیز درباره تحریم نستله؛ حمایت از اسرائیل تا حضور رسمی در ایران"
        },
        "summary": {
          "en": "Nestlé, the Swiss food and beverage giant, is one of the major supporters of the Israeli regime. By acquiring 100% of the shares of one of Israel's largest food companies — Osem — the company, in addition to substantial investment, has significantly helped expand Osem's export markets through technology transfer. Some Osem factories are located in Zionist settlements. According to The Jewish Standard (a subsidiary of The Times of Israel), in 1998 Nestlé received the \"Jubilee\" award from the Israeli Prime Minister in recognition of its efforts to strengthen the Israeli regime's economy.",
          "fa": "معرفی شرکت نستله، مستندات حمایت از اسرائیل و حضور در بازار ایران با استناد به منابع رسمی"
        },
        "cover": null
      }
    },
    {
      "slug": "cocacola",
      "name": {
        "en": "The Coca-Cola Company",
        "fa": "کوکاکولا"
      },
      "country": "us",
      "logo": "/qlist-assets/19ea970c-f17c-49fe-b935-6face159732b.png",
      "qlistStatus": {
        "en": "American company",
        "fa": "شرکت آمریکایی"
      },
      "status": "american",
      "claim": {
        "en": "",
        "fa": ""
      },
      "subBrands": [
        {
          "slug": "sprite",
          "id": 18,
          "name": {
            "en": "Sprite",
            "fa": "اسپرایت"
          },
          "logo": "/qlist-assets/835e86c0-b6e3-460c-bbf1-0eeffaa6e8bc.png",
          "subtitle": {
            "en": "Lemon-lime soda",
            "fa": ""
          },
          "categories": [
            "Beverage"
          ]
        },
        {
          "slug": "dasani",
          "id": 19,
          "name": {
            "en": "Dasani",
            "fa": "دَسانی"
          },
          "logo": "/qlist-assets/77094194-fb10-450b-928b-4a38f0846922.png",
          "subtitle": {
            "en": "Mineral water",
            "fa": ""
          },
          "categories": [
            "Drinking water"
          ]
        },
        {
          "slug": "coca-cola-zero",
          "id": 17,
          "name": {
            "en": "Coca-Cola Zero",
            "fa": "کوکاکولا زیرو"
          },
          "logo": "/qlist-assets/790f385a-cc73-4653-9d8d-304c88393af2.png",
          "subtitle": {
            "en": "Sugar-free cola",
            "fa": ""
          },
          "categories": [
            "Beverage"
          ]
        },
        {
          "slug": "fanta",
          "id": 16,
          "name": {
            "en": "Fanta",
            "fa": "فانتا"
          },
          "logo": "/qlist-assets/7921bc99-61f1-4536-9c16-274fb92d2b39.png",
          "subtitle": {
            "en": "Orange soda",
            "fa": ""
          },
          "categories": [
            "Beverage"
          ]
        },
        {
          "slug": "canada-dry",
          "id": 72,
          "name": {
            "en": "Canada Dry",
            "fa": "کانادا دِرای"
          },
          "logo": "/qlist-assets/fc907bb2-f710-439c-a337-298de290ce61.jpg",
          "subtitle": {
            "en": "Ginger ale",
            "fa": "نوشابه"
          },
          "categories": [
            "Beverage"
          ]
        },
        {
          "slug": "rani",
          "id": 73,
          "name": {
            "en": "Rani",
            "fa": "رانی"
          },
          "logo": "/qlist-assets/27b3c769-1b76-4909-b550-75c32d329185.jpg",
          "subtitle": {
            "en": "Juice drink",
            "fa": "آب‌میوه"
          },
          "categories": [
            "Beverage"
          ]
        },
        {
          "slug": "barbican",
          "id": 74,
          "name": {
            "en": "Barbican",
            "fa": "باربیکن"
          },
          "logo": "/qlist-assets/5a129186-789a-4a8c-94b9-24ae62b361ab.png",
          "subtitle": {
            "en": "Non-alcoholic malt beverage",
            "fa": "نوشیدنی گازدار"
          },
          "categories": [
            "Beverage"
          ]
        }
      ],
      "dossier": {
        "slug": "cocacola-part-1",
        "url": "https://qlist.ir/blog/cocacola-part-1/",
        "title": {
          "en": "همه چیز درباره تحریم کوکاکولا؛ پرده اول، کوکاکولا در ایران",
          "fa": "همه چیز درباره تحریم کوکاکولا؛ پرده اول، کوکاکولا در ایران"
        },
        "summary": {
          "en": "",
          "fa": "معرفی سیستم کوکاکولا، اثبات حضور برندهای زیرمجموعه در ایران و پاسخ به شبهات رایج با استناد به منابع رسمی"
        },
        "cover": null
      }
    },
    {
      "slug": "unilever",
      "name": {
        "en": "Unilever",
        "fa": "یونیلیوِر"
      },
      "country": "gb",
      "logo": "/qlist-assets/1c46adbb-b7bb-4370-b11d-f6427dbc3f93.png",
      "qlistStatus": {
        "en": "Supports Israel",
        "fa": "حامی اسرائیل"
      },
      "status": "supports-israel",
      "claim": {
        "en": "Unilever, an Anglo-Dutch multinational corporation with revenue exceeding $59 billion in 2023, operates in 190 countries including Iran and Israel. Through extensive investments in Israel — such as buying stakes in Israeli companies like Vitco and Strauss, and operating in Zionist settlements — it has contributed to the expansion of Israel's economy. Unilever also owns eight companies under the \"Unilever Israel\" name. The company has consistently been criticised by pro-Palestinian movements for supporting Israel and operating in occupied territories. Even its subsidiary brand Ben & Jerry's, which tried to halt sales in occupied settlements, faced opposition from Unilever and pressure from Israel and was ultimately sold to an Israeli company. Unilever has also directly supported settlement-building in the past by purchasing shares of settlement-based companies.",
        "fa": "شرکت یونیلیور، یک شرکت چندملیتی انگلیسی-هلندی، با درآمد بیش از ۵۹ میلیارد دلار در سال ۲۰۲۳، در ۱۹۰ کشور از جمله ایران و اسرائیل فعالیت دارد. این شرکت از طریق سرمایه‌گذاری‌های گسترده در اسرائیل، مانند خرید سهام شرکت‌های اسرائیلی نظیر ویتکو و اشتراوس، و فعالیت در شهرک‌های صهیونیستی، به توسعه اقتصاد اسرائیل کمک کرده است. یونیلیور همچنین مالک هشت شرکت تحت عنوان «یونیلیور اسرائیل» است. این شرکت به دلیل حمایت از اسرائیل و فعالیت در مناطق اشغالی، همواره مورد انتقاد جنبش‌های حامی فلسطین قرار گرفته است. حتی برند زیرمجموعه‌اش، بن و جری، به دلیل توقف فروش در شهرک‌های اشغالی با مخالفت یونیلیور و فشارهای اسرائیل مواجه شد و در نهایت به یک شرکت اسرائیلی فروخته شد. یونیلیور همچنین در گذشته با خرید سهام شرکت‌های مستقر در شهرک‌ها، به طور مستقیم از شهرک‌سازی حمایت کرده است."
      },
      "subBrands": [
        {
          "slug": "signal",
          "id": 28,
          "name": {
            "en": "Signal",
            "fa": "سیگنال"
          },
          "logo": "/qlist-assets/f9e6cf85-44f7-4899-8de5-f4ae7ed81347.png",
          "subtitle": {
            "en": "Toothpaste",
            "fa": "خمیر دندان"
          },
          "categories": [
            "Hygiene"
          ]
        },
        {
          "slug": "comfort",
          "id": 27,
          "name": {
            "en": "Comfort",
            "fa": "کامفورت"
          },
          "logo": "/qlist-assets/fd285d04-2809-4d00-89d9-eccb1915fa11.jpg",
          "subtitle": {
            "en": "Fabric softener",
            "fa": "شوینده"
          },
          "categories": [
            "Household"
          ]
        },
        {
          "slug": "clear",
          "id": 31,
          "name": {
            "en": "Clear",
            "fa": "کلیِر"
          },
          "logo": "/qlist-assets/f62154ae-33f4-4478-a2ef-cf5d80e9d3a2.png",
          "subtitle": {
            "en": "Anti-dandruff shampoo",
            "fa": "شامپو ضد شوره"
          },
          "categories": [
            "Hygiene",
            "Cosmetics"
          ]
        },
        {
          "slug": "sunsilk",
          "id": 29,
          "name": {
            "en": "Sunsilk",
            "fa": "سان‌سیلک"
          },
          "logo": "/qlist-assets/5f32c21e-f75b-4719-871d-0f98dba8bfd4.png",
          "subtitle": {
            "en": "Shampoo & hair care",
            "fa": "شامپو و محصولات مراقبت مو"
          },
          "categories": [
            "Hygiene",
            "Cosmetics"
          ]
        },
        {
          "slug": "closeup",
          "id": 30,
          "name": {
            "en": "Closeup",
            "fa": "کلوزآپ"
          },
          "logo": "/qlist-assets/13134619-3cb0-4992-82c5-f297527c8e8d.png",
          "subtitle": {
            "en": "Toothpaste",
            "fa": "خمیر دندان"
          },
          "categories": [
            "Hygiene"
          ]
        },
        {
          "slug": "lux",
          "id": 22,
          "name": {
            "en": "Lux",
            "fa": "لوکس"
          },
          "logo": "/qlist-assets/6e43b5c1-5433-4074-847f-c726f74912eb.png",
          "subtitle": {
            "en": "Soap & toiletries",
            "fa": "صابون و محصولات آرایشی بهداشتی"
          },
          "categories": [
            "Hygiene"
          ]
        },
        {
          "slug": "axe",
          "id": 23,
          "name": {
            "en": "Axe",
            "fa": "اَکس"
          },
          "logo": "/qlist-assets/b38779e8-6f19-4a8f-9a1c-dbcdc8af5628.png",
          "subtitle": {
            "en": "Men's body spray",
            "fa": "اسپری و محصولات مردانه"
          },
          "categories": [
            "Cosmetics"
          ]
        },
        {
          "slug": "domestos",
          "id": 25,
          "name": {
            "en": "Domestos",
            "fa": "دامِستوس"
          },
          "logo": "/qlist-assets/080234e7-f90b-455d-8e0f-19d914ea0053.png",
          "subtitle": {
            "en": "Bleach & cleaner",
            "fa": "سفیدکننده و جرم‌گیر"
          },
          "categories": [
            "Household"
          ]
        },
        {
          "slug": "cif",
          "id": 24,
          "name": {
            "en": "Cif",
            "fa": "سیف"
          },
          "logo": "/qlist-assets/a50ce2f6-4f6b-4c10-b9ae-1ec998ab1d18.png",
          "subtitle": {
            "en": "Dish soap",
            "fa": "مایع ظرفشویی"
          },
          "categories": [
            "Household"
          ]
        },
        {
          "slug": "omo",
          "id": 26,
          "name": {
            "en": "Omo",
            "fa": "اُمو"
          },
          "logo": "/qlist-assets/dc833532-8774-4f7c-b5b7-7cee1e577acc.png",
          "subtitle": {
            "en": "Laundry detergent",
            "fa": "پودر لباسشویی"
          },
          "categories": [
            "Household"
          ]
        },
        {
          "slug": "rexona",
          "id": 43,
          "name": {
            "en": "Rexona",
            "fa": "رِکسونا"
          },
          "logo": "/qlist-assets/fee52cce-0365-4b13-aa41-9045a87c46ef.png",
          "subtitle": {
            "en": "Deodorant & antiperspirant",
            "fa": "دئودورانت و ضدعرق"
          },
          "categories": [
            "Cosmetics",
            "Hygiene"
          ]
        },
        {
          "slug": "dove",
          "id": 21,
          "name": {
            "en": "Dove",
            "fa": "داو"
          },
          "logo": "/qlist-assets/354db9b8-b195-4507-a0b8-602264f74eee.png",
          "subtitle": {
            "en": "Skin & hair care",
            "fa": "محصولات مراقبت پوست و مو"
          },
          "categories": [
            "Cosmetics"
          ]
        },
        {
          "slug": "vaseline",
          "id": 70,
          "name": {
            "en": "Vaseline",
            "fa": "وازِلین"
          },
          "logo": "/qlist-assets/0ec6ca5c-5bbd-4b20-a3e2-874d09c0ff08.png",
          "subtitle": {
            "en": "Skincare",
            "fa": "محصولات مراقبت از پوست"
          },
          "categories": [
            "Cosmetics"
          ]
        }
      ],
      "dossier": {
        "slug": "unilever",
        "url": "https://qlist.ir/blog/unilever/",
        "title": {
          "en": "یونیلیوِر، پاکیزگی گران‌بها",
          "fa": "همه چیز درباره تحریم یونیلیور؛ حمایت از اسرائیل تا حضور رسمی در ایران"
        },
        "summary": {
          "en": "Unilever, an Anglo-Dutch multinational corporation with revenue exceeding $59 billion in 2023, operates in 190 countries including Iran and Israel. Through extensive investments in Israel — such as buying stakes in Israeli companies like Vitco and Strauss, and operating in Zionist settlements — it has contributed to the expansion of Israel's economy. Unilever also owns eight companies under the \"Unilever Israel\" name. The company has consistently been criticised by pro-Palestinian movements for supporting Israel and operating in occupied territories. Even its subsidiary brand Ben & Jerry's, which tried to halt sales in occupied settlements, faced opposition from Unilever and pressure from Israel and was ultimately sold to an Israeli company. Unilever has also directly supported settlement-building in the past by purchasing shares of settlement-based companies.",
          "fa": "معرفی شرکت یونیلیور، مستندات حمایت از اسرائیل و حضور در بازار ایران با استناد به منابع رسمی"
        },
        "cover": null
      }
    },
    {
      "slug": "carrefour",
      "name": {
        "en": "Carrefour",
        "fa": "کارفور"
      },
      "country": "fr",
      "logo": "/qlist-assets/5dd1a6e6-4fc2-469e-af5a-25db4cc16a0a.png",
      "qlistStatus": {
        "en": "Supports Israel",
        "fa": "حامی اسرائیل"
      },
      "status": "supports-israel",
      "claim": {
        "en": "Carrefour, the French retail-chain giant, is one of the major supporters of the Israeli regime. By opening 50 stores in Israel through a partnership with the Zionist company \"Electra\", the company is complicit in Zionist settlement-building in Palestine. \"Electra\" has been on the United Nations sanctions list for years because of its active participation in settlement-building. Carrefour, with its broad supply chain, has also lowered the cost of supplying goods in Israel and helped improve Israeli citizens' purchasing power. Carrefour is present in the Iranian market through a partnership with the Emirati holding company \"Majid Al Futtaim\", under the \"Hyperstar\" and \"MyliMarket\" brands.",
        "fa": "شرکت «کارفور»، غول فروشگاه‌ زنجیره‌ای فرانسوی، یکی از حامیان مهم رژیم اسرائیل است. این شرکت با افتتاح 50 فروشگاه در اسرائیل از طریق همکاری با شرکت‌ صهیونیستی «اِلکترا»، شریک جرم شهرک‌سازی‌های صهیونیستی در فلسطین است. «اِلکترا» به خاطر مشارکت فعالش در شهرک‌سازی‌ها، سال‌هاست در لیست تحریم سازمان ملل قرار دارد]. همچنین کارفور با زنجیره تأمین گسترده‌اش، هزینه‌های تأمین کالا در اسرائیل را کاهش داده و به بهبود قدرت خرید شهروندان اسرائیلی کمک می‌کند. کارفور از طریق شراکت با هُلدینگ اماراتی «ماجدالفُطَیم»، تحت برند «هایپراستار» و «مایلی‌مارکت» در بازار ایران حضور دارد."
      },
      "subBrands": [
        {
          "slug": "hyperstar",
          "id": 4,
          "name": {
            "en": "Hyperstar",
            "fa": "هایپراِستار"
          },
          "logo": "/qlist-assets/efa107d5-7c8a-449e-bac8-70545959675a.png",
          "subtitle": {
            "en": "Hypermarket chain",
            "fa": "فروشگاه زنجیره‌ای"
          },
          "categories": [
            "Retail"
          ]
        },
        {
          "slug": "mylimarket",
          "id": 12,
          "name": {
            "en": "MyliMarket",
            "fa": "مایلی‌مارکت"
          },
          "logo": "/qlist-assets/560a8d68-bf21-4c45-bf06-31e2dda0efa4.png",
          "subtitle": {
            "en": "Online grocery",
            "fa": "فروشگاه زنجیره‌ای"
          },
          "categories": [
            "Retail"
          ]
        }
      ],
      "dossier": {
        "slug": "carrefour",
        "url": "https://qlist.ir/blog/carrefour/",
        "title": {
          "en": "هایپراستار، سایه کارفور در آسمان ایران",
          "fa": "تحریم کارفور؛ صفر تا صد حمایت از اسرائیل تا حضور نیابتی هایپراستار در بازار ایران"
        },
        "summary": {
          "en": "Carrefour, the French retail-chain giant, is one of the major supporters of the Israeli regime. By opening 50 stores in Israel through a partnership with the Zionist company \"Electra\", the company is complicit in Zionist settlement-building in Palestine. \"Electra\" has been on the United Nations sanctions list for years because of its active participation in settlement-building. Carrefour, with its broad supply chain, has also lowered the cost of supplying goods in Israel and helped improve Israeli citizens' purchasing power. Carrefour is present in the Iranian market through a partnership with the Emirati holding company \"Majid Al Futtaim\", under the \"Hyperstar\" and \"MyliMarket\" brands.",
          "fa": "معرفی شرکت کارفور، مستندات حمایت از اسرائیل و حضور نیابتی هایپراستار در بازار ایران با استناد به منابع رسمی"
        },
        "cover": null
      }
    },
    {
      "slug": "danone",
      "name": {
        "en": "Danone",
        "fa": "دَنون"
      },
      "country": "fr",
      "logo": "/qlist-assets/17eb52b3-db9c-4deb-80ed-5ce869113ef6.png",
      "qlistStatus": {
        "en": "Supports Israel",
        "fa": "حامی اسرائیل"
      },
      "status": "supports-israel",
      "claim": {
        "en": "Danone, the multinational food-products giant — which we in Iran know by products such as \"Danette\", \"Aptamil\" and \"Bebelac\" — is one of the best-known supporters of the Israeli regime. Through investments in Israeli start-ups and partnerships with large Israeli companies such as \"Strauss\", the company has made a significant contribution to the expansion of Israel's economy. Danone has had a strong presence in the Iranian market for years through subsidiaries such as \"Danone Lebani Pars\" and \"Nutricia MMP\".",
        "fa": "شرکت «دَنون»، غول چندملیتی محصولات غذایی، که ما ایرانی‌های نامش را با محصولات «دَنِت»، «آپتامیل» و «بِبِلاک» می‌شناسیم یکی از مشهورترین حامیان رژیم اسرائیل است. این شرکت با سرمایه‌گذاری‌های‌اش در استارتاپ‌های اسرائیلی و شراکت با شرکت‌های بزرگ اسرائیل همچون «اِشتراوس»، به توسعه اقتصاد اسرائیل کمک قابل توجهی کرده است. دَنون از طریق شرکت‌های تابعه‌اش مانند «دنون لبنی پارس» و «نوتریشیا ام ام پی»، سال‌هاست که حضور پررنگی در بازار ایران دارد."
      },
      "subBrands": [
        {
          "slug": "aptamil",
          "id": 10,
          "name": {
            "en": "Aptamil",
            "fa": "آپتامیل"
          },
          "logo": "/qlist-assets/a77aa550-5536-4196-a236-f93b0e164117.png",
          "subtitle": {
            "en": "Infant formula",
            "fa": "شیر خشک نوزاد"
          },
          "categories": [
            "Baby food"
          ]
        },
        {
          "slug": "bebelac",
          "id": 11,
          "name": {
            "en": "Bebelac",
            "fa": "بِبِلاک"
          },
          "logo": "/qlist-assets/819503e3-a4d5-4af3-95c2-dc3798441388.png",
          "subtitle": {
            "en": "Infant & toddler nutrition",
            "fa": "شیر خشک و غذای کودک"
          },
          "categories": [
            "Baby food"
          ]
        },
        {
          "slug": "danette",
          "id": 3,
          "name": {
            "en": "Danette",
            "fa": "دَنِت"
          },
          "logo": "/qlist-assets/f6ca94b0-1fa3-4d19-9128-93c60eab34fc.png",
          "subtitle": {
            "en": "Dairy dessert",
            "fa": "دسر آماده لبنی"
          },
          "categories": [
            "Food"
          ]
        },
        {
          "slug": "danette-pop",
          "id": 45,
          "name": {
            "en": "Danette Pop",
            "fa": "دنِت پاپ"
          },
          "logo": "/qlist-assets/c87f7c45-fafc-4e87-ba65-0755aef9dda2.png",
          "subtitle": {
            "en": "Dairy dessert",
            "fa": "دسر آماده لبنی"
          },
          "categories": [
            "Food"
          ]
        }
      ],
      "dossier": {
        "slug": "danone",
        "url": "https://qlist.ir/blog/danone/",
        "title": {
          "en": "«دَنون»، دِسِر فرانسوی با تزئین عِبری",
          "fa": "همه چیز درباره تحریم دنون؛ حمایت از اسرائیل تا حضور رسمی در ایران"
        },
        "summary": {
          "en": "Danone, the multinational food-products giant — which we in Iran know by products such as \"Danette\", \"Aptamil\" and \"Bebelac\" — is one of the best-known supporters of the Israeli regime. Through investments in Israeli start-ups and partnerships with large Israeli companies such as \"Strauss\", the company has made a significant contribution to the expansion of Israel's economy. Danone has had a strong presence in the Iranian market for years through subsidiaries such as \"Danone Lebani Pars\" and \"Nutricia MMP\".",
          "fa": "معرفی شرکت دنون، مستندات حمایت از اسرائیل و حضور در بازار ایران با استناد به منابع رسمی"
        },
        "cover": null
      }
    },
    {
      "slug": "pepsi",
      "name": {
        "en": "PepsiCo",
        "fa": "پِپسی"
      },
      "country": "us",
      "logo": "/qlist-assets/26b73fda-bd99-4899-9ed2-dd73636bb2b8.png",
      "qlistStatus": {
        "en": "American company",
        "fa": "شرکت آمریکایی"
      },
      "status": "american",
      "claim": {
        "en": "",
        "fa": ""
      },
      "subBrands": [
        {
          "slug": "mountain-dew",
          "id": 61,
          "name": {
            "en": "Mountain Dew",
            "fa": "ماونتن دیو"
          },
          "logo": "/qlist-assets/49ab3759-09f0-4c9e-a8a5-3d475e23ec8e.png",
          "subtitle": {
            "en": "Citrus soda",
            "fa": ""
          },
          "categories": [
            "Beverage"
          ]
        },
        {
          "slug": "pepsi-max",
          "id": 58,
          "name": {
            "en": "Pepsi Max",
            "fa": "پِپسی مَکس"
          },
          "logo": "/qlist-assets/02af7f13-c132-4778-9d87-c23d31795a82.png",
          "subtitle": {
            "en": "Sugar-free cola",
            "fa": ""
          },
          "categories": [
            "Beverage"
          ]
        },
        {
          "slug": "mirinda",
          "id": 59,
          "name": {
            "en": "Mirinda",
            "fa": "میراندا"
          },
          "logo": "/qlist-assets/574d0133-aab8-4b41-a52c-4ef6b1460263.png",
          "subtitle": {
            "en": "Orange soda",
            "fa": ""
          },
          "categories": [
            "Beverage"
          ]
        },
        {
          "slug": "7up",
          "id": 60,
          "name": {
            "en": "7up",
            "fa": "سِوِن‌آپ"
          },
          "logo": "/qlist-assets/9828c841-2069-4c20-b5b8-aa64c249f4cb.png",
          "subtitle": {
            "en": "Lemon-lime soda",
            "fa": ""
          },
          "categories": [
            "Beverage"
          ]
        },
        {
          "slug": "aquafina",
          "id": 62,
          "name": {
            "en": "Aquafina",
            "fa": "آکوافینا"
          },
          "logo": "/qlist-assets/d244b55d-09d3-4ac5-9d23-eb378832bdb0.png",
          "subtitle": {
            "en": "Mineral water",
            "fa": ""
          },
          "categories": [
            "Drinking water"
          ]
        },
        {
          "slug": "lipton",
          "id": 63,
          "name": {
            "en": "Lipton",
            "fa": "لیپتون"
          },
          "logo": "/qlist-assets/8b191f58-f7ca-448b-8751-0fd793bba960.png",
          "subtitle": {
            "en": "Tea",
            "fa": ""
          },
          "categories": [
            "Beverage"
          ]
        }
      ],
      "dossier": null
    },
    {
      "slug": "p-and-g",
      "name": {
        "en": "Procter & Gamble",
        "fa": "پی‌اَند‌جی"
      },
      "country": "us",
      "logo": "/qlist-assets/fc6a69df-bd93-490b-ab81-8431bad23316.png",
      "qlistStatus": {
        "en": "American company",
        "fa": "شرکت آمریکایی"
      },
      "status": "american",
      "claim": {
        "en": "",
        "fa": ""
      },
      "subBrands": [
        {
          "slug": "crest",
          "id": 53,
          "name": {
            "en": "Crest",
            "fa": "کرِست"
          },
          "logo": "/qlist-assets/e18ba909-1009-493c-b45f-6d2516daf4ab.png",
          "subtitle": {
            "en": "Toothpaste",
            "fa": ""
          },
          "categories": [
            "Hygiene"
          ]
        },
        {
          "slug": "oral-b",
          "id": 54,
          "name": {
            "en": "Oral-B",
            "fa": "اورال‌ بی"
          },
          "logo": "/qlist-assets/dd50ef86-9fdd-4457-b9e5-739b51cbeae3.png",
          "subtitle": {
            "en": "Oral care",
            "fa": ""
          },
          "categories": [
            "Hygiene"
          ]
        },
        {
          "slug": "pampers",
          "id": 33,
          "name": {
            "en": "Pampers",
            "fa": "پَمپِرز"
          },
          "logo": "/qlist-assets/c217d2fc-8f57-48b0-b307-313f1e9f6e00.png",
          "subtitle": {
            "en": "Diapers",
            "fa": ""
          },
          "categories": [
            "Baby food",
            "Hygiene"
          ]
        },
        {
          "slug": "always",
          "id": 34,
          "name": {
            "en": "Always",
            "fa": "آلوِیز"
          },
          "logo": "/qlist-assets/221ef687-3634-41d1-8b81-2a138c7752d5.png",
          "subtitle": {
            "en": "Feminine care",
            "fa": ""
          },
          "categories": [
            "Hygiene"
          ]
        },
        {
          "slug": "braun",
          "id": 35,
          "name": {
            "en": "Braun",
            "fa": "براون"
          },
          "logo": "/qlist-assets/b836db68-88b9-4f08-a897-415245c3331d.png",
          "subtitle": {
            "en": "Small appliances",
            "fa": ""
          },
          "categories": [
            "Household",
            "Electronics"
          ]
        },
        {
          "slug": "gillette",
          "id": 36,
          "name": {
            "en": "Gillette",
            "fa": "ژیلت"
          },
          "logo": "/qlist-assets/3dcfec2f-0288-4293-9ac2-53fbe162508b.png",
          "subtitle": {
            "en": "Razors",
            "fa": ""
          },
          "categories": [
            "Hygiene"
          ]
        },
        {
          "slug": "head-and-shoulders",
          "id": 42,
          "name": {
            "en": "head & shoulders",
            "fa": "هِداَندشولدِرز"
          },
          "logo": "/qlist-assets/3b2d9545-663b-444c-91ab-6a41e62506cf.png",
          "subtitle": {
            "en": "Hair care",
            "fa": ""
          },
          "categories": [
            "Cosmetics",
            "Hygiene"
          ]
        },
        {
          "slug": "venus",
          "id": 41,
          "name": {
            "en": "Venus",
            "fa": "ونوس"
          },
          "logo": "/qlist-assets/420da01e-4f22-4b8b-bc88-250cc40d3c19.png",
          "subtitle": {
            "en": "Women's razors",
            "fa": ""
          },
          "categories": [
            "Hygiene",
            "Cosmetics"
          ]
        },
        {
          "slug": "fairy",
          "id": 71,
          "name": {
            "en": "Fairy",
            "fa": "فِیری"
          },
          "logo": "/qlist-assets/99e9d745-9860-4fc2-9096-2afed827186e.png",
          "subtitle": {
            "en": "Dish soap",
            "fa": ""
          },
          "categories": [
            "Household"
          ]
        }
      ],
      "dossier": null
    },
    {
      "slug": "hp",
      "name": {
        "en": "HP Inc.",
        "fa": "اِچ پی"
      },
      "country": "us",
      "logo": "/qlist-assets/c1dfb757-3aa6-44b2-8003-0827206cd68a.png",
      "qlistStatus": {
        "en": "American company",
        "fa": "شرکت آمریکایی"
      },
      "status": "american",
      "claim": {
        "en": "",
        "fa": ""
      },
      "subBrands": [
        {
          "slug": "hyperx",
          "id": 65,
          "name": {
            "en": "HyperX",
            "fa": "هایپر ایکس"
          },
          "logo": "/qlist-assets/7c0eab32-374c-40d3-9cf4-10eb145b3dd2.png",
          "subtitle": {
            "en": "Gaming peripherals",
            "fa": ""
          },
          "categories": [
            "Electronics",
            "Technology"
          ]
        },
        {
          "slug": "victus",
          "id": 67,
          "name": {
            "en": "Victus",
            "fa": "ویکتوس"
          },
          "logo": "/qlist-assets/2728c9b2-3115-4f9e-87d8-d47f645492e3.png",
          "subtitle": {
            "en": "Gaming laptops",
            "fa": ""
          },
          "categories": [
            "Electronics",
            "Technology"
          ]
        },
        {
          "slug": "omen",
          "id": 66,
          "name": {
            "en": "Omen",
            "fa": "اُمِن"
          },
          "logo": "/qlist-assets/0d088aed-6b1a-410d-9ed6-bad3e203b970.png",
          "subtitle": {
            "en": "Gaming PCs",
            "fa": ""
          },
          "categories": [
            "Electronics",
            "Technology"
          ]
        },
        {
          "slug": "z-by-hp",
          "id": 68,
          "name": {
            "en": "Z by HP",
            "fa": "زِد"
          },
          "logo": "/qlist-assets/3139087a-af00-4f57-bd9f-884cffe44638.png",
          "subtitle": {
            "en": "Workstations",
            "fa": ""
          },
          "categories": [
            "Electronics",
            "Technology"
          ]
        }
      ],
      "dossier": null
    },
    {
      "slug": "microsoft",
      "name": {
        "en": "Microsoft",
        "fa": "مایکروسافت"
      },
      "country": "us",
      "logo": "/qlist-assets/35a0dd19-47de-44bf-82e0-2a55ddfe716c.png",
      "qlistStatus": {
        "en": "American company",
        "fa": "شرکت آمریکایی"
      },
      "status": "american",
      "claim": {
        "en": "",
        "fa": ""
      },
      "subBrands": [
        {
          "slug": "microsoft-surface",
          "id": 80,
          "name": {
            "en": "Microsoft Surface",
            "fa": "مایکروسافت سرفیس"
          },
          "logo": "/qlist-assets/7c3e50fb-b4bc-4d5e-a9dc-17eba5c5fae7.png",
          "subtitle": {
            "en": "Surface devices",
            "fa": ""
          },
          "categories": [
            "Electronics",
            "Technology"
          ]
        },
        {
          "slug": "xbox",
          "id": 81,
          "name": {
            "en": "XBOX",
            "fa": "ایکس‌باکس"
          },
          "logo": "/qlist-assets/f5e7a13e-fab7-42e1-9d5b-226aef7d1528.png",
          "subtitle": {
            "en": "Gaming consoles",
            "fa": ""
          },
          "categories": [
            "Electronics",
            "Technology"
          ]
        }
      ],
      "dossier": null
    },
    {
      "slug": "skechers",
      "name": {
        "en": "Skechers",
        "fa": "اسکچرز"
      },
      "country": "us",
      "logo": "/qlist-assets/abb9e4f6-93b4-449a-82df-de1de0eb7700.png",
      "qlistStatus": {
        "en": "American company",
        "fa": "شرکت آمریکایی"
      },
      "status": "american",
      "claim": {
        "en": "",
        "fa": ""
      },
      "subBrands": [],
      "dossier": null
    },
    {
      "slug": "nike",
      "name": {
        "en": "Nike",
        "fa": "نایکی"
      },
      "country": "us",
      "logo": "/qlist-assets/13361db9-ed10-4f5b-b76a-9f8a6378033b.png",
      "qlistStatus": {
        "en": "American company",
        "fa": "شرکت آمریکایی"
      },
      "status": "american",
      "claim": {
        "en": "",
        "fa": ""
      },
      "subBrands": [],
      "dossier": null
    },
    {
      "slug": "mars",
      "name": {
        "en": "Mars, Incorporated",
        "fa": "مارس"
      },
      "country": "us",
      "logo": "/qlist-assets/0c62fef4-fad5-4122-b536-88094aa16ce8.png",
      "qlistStatus": {
        "en": "American company",
        "fa": "شرکت آمریکایی"
      },
      "status": "american",
      "claim": {
        "en": "",
        "fa": ""
      },
      "subBrands": [
        {
          "slug": "mandm",
          "id": 85,
          "name": {
            "en": "M&M",
            "fa": "اِم اند اِم"
          },
          "logo": "/qlist-assets/47ac4db4-afa8-4e9c-a682-52b1499908b5.png",
          "subtitle": {
            "en": "Confectionery",
            "fa": ""
          },
          "categories": [
            "Food"
          ]
        }
      ],
      "dossier": null
    },
    {
      "slug": "apple",
      "name": {
        "en": "Apple Inc.",
        "fa": "اَپل"
      },
      "country": "us",
      "logo": "/qlist-assets/aea44a11-39fa-45b3-904c-8bbe60f98143.png",
      "qlistStatus": {
        "en": "American company",
        "fa": "شرکت آمریکایی"
      },
      "status": "american",
      "claim": {
        "en": "",
        "fa": ""
      },
      "subBrands": [],
      "dossier": null
    },
    {
      "slug": "dell",
      "name": {
        "en": "Dell Technologies",
        "fa": "دِل"
      },
      "country": "us",
      "logo": "/qlist-assets/c7945832-0946-4bf1-a27c-a947bd84e34d.png",
      "qlistStatus": {
        "en": "American company",
        "fa": "شرکت آمریکایی"
      },
      "status": "american",
      "claim": {
        "en": "",
        "fa": ""
      },
      "subBrands": [
        {
          "slug": "alienware",
          "id": 78,
          "name": {
            "en": "Alienware",
            "fa": "الیِن‌ویر"
          },
          "logo": "/qlist-assets/20e5b21b-9e3f-4dce-a3de-7486fc8e0ad0.png",
          "subtitle": {
            "en": "Gaming hardware",
            "fa": ""
          },
          "categories": [
            "Electronics",
            "Technology"
          ]
        }
      ],
      "dossier": null
    },
    {
      "slug": "cisco",
      "name": {
        "en": "Cisco Systems",
        "fa": "سیسکو"
      },
      "country": "us",
      "logo": "/qlist-assets/125ccf47-9eae-42e0-a8cd-772558b2ab95.png",
      "qlistStatus": {
        "en": "American company",
        "fa": "آمریکایی"
      },
      "status": "american",
      "claim": {
        "en": "",
        "fa": ""
      },
      "subBrands": [],
      "dossier": null
    }
  ],
  "categories": [
    {
      "id": 9,
      "label": "Cosmetics",
      "icon": "💄"
    },
    {
      "id": 23,
      "label": "Food",
      "icon": "🍔"
    },
    {
      "id": 24,
      "label": "Baby food",
      "icon": "🍼"
    },
    {
      "id": 25,
      "label": "Drinking water",
      "icon": "💧"
    },
    {
      "id": 26,
      "label": "Hygiene",
      "icon": "🧼"
    },
    {
      "id": 27,
      "label": "Retail",
      "icon": "🛒"
    },
    {
      "id": 28,
      "label": "Beverage",
      "icon": "☕"
    },
    {
      "id": 29,
      "label": "Supplements",
      "icon": "🥣"
    },
    {
      "id": 30,
      "label": "Electronics",
      "icon": "⚡"
    },
    {
      "id": 31,
      "label": "Technology",
      "icon": "💻"
    },
    {
      "id": 32,
      "label": "Household",
      "icon": "🧺"
    },
    {
      "id": 33,
      "label": "Apparel",
      "icon": "👕"
    }
  ],
  "brandIndex": {
    "nestle": "nestle",
    "nescafe": "nestle",
    "nespresso": "nestle",
    "guigoz": "nestle",
    "nestlehealthscience": "nestle",
    "nankid": "nestle",
    "peptamen": "nestle",
    "nan": "nestle",
    "kitkat": "nestle",
    "coffeemate": "nestle",
    "nesquik": "nestle",
    "optifast": "nestle",
    "purelife": "nestle",
    "cerelac": "nestle",
    "cornflakes": "nestle",
    "nanoptipro": "nestle",
    "thecocacolacompany": "cocacola",
    "sprite": "cocacola",
    "dasani": "cocacola",
    "cocacolazero": "cocacola",
    "fanta": "cocacola",
    "canadadry": "cocacola",
    "rani": "cocacola",
    "barbican": "cocacola",
    "unilever": "unilever",
    "signal": "unilever",
    "comfort": "unilever",
    "clear": "unilever",
    "sunsilk": "unilever",
    "closeup": "unilever",
    "lux": "unilever",
    "axe": "unilever",
    "domestos": "unilever",
    "cif": "unilever",
    "omo": "unilever",
    "rexona": "unilever",
    "dove": "unilever",
    "vaseline": "unilever",
    "carrefour": "carrefour",
    "hyperstar": "carrefour",
    "mylimarket": "carrefour",
    "danone": "danone",
    "aptamil": "danone",
    "bebelac": "danone",
    "danette": "danone",
    "danettepop": "danone",
    "pepsico": "pepsi",
    "mountaindew": "pepsi",
    "pepsimax": "pepsi",
    "mirinda": "pepsi",
    "7up": "pepsi",
    "aquafina": "pepsi",
    "lipton": "pepsi",
    "proctergamble": "p-and-g",
    "crest": "p-and-g",
    "oralb": "p-and-g",
    "pampers": "p-and-g",
    "always": "p-and-g",
    "braun": "p-and-g",
    "gillette": "p-and-g",
    "headshoulders": "p-and-g",
    "venus": "p-and-g",
    "fairy": "p-and-g",
    "hpinc": "hp",
    "hyperx": "hp",
    "victus": "hp",
    "omen": "hp",
    "zbyhp": "hp",
    "microsoft": "microsoft",
    "microsoftsurface": "microsoft",
    "xbox": "microsoft",
    "skechers": "skechers",
    "nike": "nike",
    "marsincorporated": "mars",
    "mm": "mars",
    "appleinc": "apple",
    "delltechnologies": "dell",
    "alienware": "dell",
    "ciscosystems": "cisco"
  },
  "posts": [
    {
      "slug": "nestle",
      "sourceUrl": "https://qlist.ir/blog/nestle/",
      "companySlug": "nestle",
      "title": {
        "en": "Everything about boycotting Nestlé: from supporting Israel to its official presence in Iran",
        "fa": "همه چیز درباره تحریم نستله؛ حمایت از اسرائیل تا حضور رسمی در ایران"
      },
      "summary": {
        "en": "An introduction to Nestlé, documentation of its support for Israel and its presence in the Iranian market, citing official sources.",
        "fa": "معرفی شرکت نستله، مستندات حمایت از اسرائیل و حضور در بازار ایران با استناد به منابع رسمی"
      },
      "cover": null,
      "body": {
        "time": 1769936038396,
        "version": "2.31.0-rc.7",
        "blocks": [
          {
            "id": "PJqTQb-E77",
            "type": "header",
            "data": {
              "text": "نستله؛ غذای خوب، زندگی خوب!",
              "level": 2
            }
          },
          {
            "id": "intro-quote",
            "type": "quote",
            "data": {
              "text": "یک فنجان داغ نسکافه برای خیلی از مردم مترادف با سرحال شدن و انرژی برای کار بیشتر است. البته برخی دوست دارند یک قاشق پودر خامه‌ساز <b>کافی‌فِیت</b> را هم به فنجانشان اضافه کنند تا تلخی نسکافه‌شان کمتر شود. یک بطری آب معدنی خنک در داغی تابستان، می‌تواند آب حیات شود، حتی اگر اسم آن <b>پیورلایف</b> باشد. بسیاری از آنهایی که بچه دارند حتماً تجربه گشتن در داروخانه‌ها برای پیدا کردن شیرخشک را دارند. در چشم این آدم‌ها شیرخشک <b>نان</b> مثل یک ستاره همیشه تابان در قفسه‌ها خودنمایی کرده است. آنهایی که نوزادانشان معده‌های حساسی داشته‌اند احتمالاً دنبال شیرخشک <b>گیگوز</b> هم گشته‌اند. <b>سِرِلاک</b> غذای کودک است، اما همیشه بین بزرگ‌ترها پرطرفدارتر از بچه‌ها بوده! بعضی‌ها هم در بین انبوه رنگارنگ شکلات‌های یک فروشگاه آنقدر نگاهشان را می‌چرخانند تا بالاخره سرخی بسته‌های <b>کیت‌کَت</b> را پیدا کنند. اما آیا خرید یک بسته نسکافه، یک بطری آب‌معدنی پیورلایف، یک قوطی سرلاک یا شیرخشک نان، یک بسته کیت‌کت و... آن هم در ایران، می‌تواند تاثیری در اقتصاد رژیم اسرائیل داشته باشد؟ در ادامه تلاش کرده‌ایم تا این موضوع را تشریح کنیم.",
              "caption": "",
              "alignment": "left"
            }
          },
          {
            "id": "9Q5Q3XSSmp",
            "type": "image",
            "data": {
              "caption": "ساختمان مرکزی نستله در سوئیس",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 1024,
                "height": 683,
                "size": "65808",
                "name": "vvibkeamv930.webp",
                "title": "Vvibkeamv930.webp",
                "extension": "webp",
                "fileId": "816b9cf9-568a-4b38-b64d-32db5c8e9469",
                "fileURL": "/files/816b9cf9-568a-4b38-b64d-32db5c8e9469",
                "url": "/qlist-assets/816b9cf9-568a-4b38-b64d-32db5c8e9469.webp"
              }
            }
          },
          {
            "id": "para-1",
            "type": "paragraph",
            "data": {
              "text": "در سال ۱۹۰۵ میلادی، شرکت <b>هِنری ﻧﺴــﺘﻠﻪ</b> با شرکت <b>آنگلو-ﺳــﻮﺋﯿﺲ</b> تلفیق شدند و مجموعه‌ای که امروز به عنوان بزرگترین شرکت مواد غذایی و آشامیدنی جهان، نستله، میشناسیم راه‌اندازی شد. <a href=\"https://www.nestle.com/about/history/nestle-company-history\">[وبسایت نستله ایران]</a> نستله یک شرکت چند ملیتی مستقر در سوئیس و صاحب برندها و محصولات شناخته شده‌ای از جمله خانواده قهوه نسکافه، کافی‌میت، و نسپرسو، شکلات‌های کیت‌کت، شیرخشک و محصولات تغذیه کودک نان و سرلاک، آب معدنی پیورلایف، افزودنی‌های شیر نِسکوئیک و... است. <a href=\"https://www.nestle.com/brands/brandssearchlist\">[نستله ایران]</a> <a href=\"https://www.nestle.ir/fa/brands\">[نستله بین الملل]</a> این شرکت با حضور در بازار 188 کشور دنیا به فروش سالیانه 93 میلیارد فرانک سوئیس (بیش از 105 میلیارد دلار) در 2023 رسیده است. نستله هم اکنون 340 کارخانه در 76 کشور دنیا دارد؛ از جمله 6 کارخانه در فلسطین اشغالی (اسرائیل) و 2 کارخانه در ایران! <a href=\"https://www.nestle.com/sites/default/files/2024-02/2023-annual-review-en.pdf\">[گزارش سالیانه نستله]</a>"
            }
          },
          {
            "id": "5yWIwqnLeY",
            "type": "delimiter",
            "data": {}
          },
          {
            "id": "header-2",
            "type": "header",
            "data": {
              "text": "در آشیانه پرنده! نستله در اسرائیل",
              "level": 2
            }
          },
          {
            "id": "OlxZx3RlGM",
            "type": "image",
            "data": {
              "caption": "نشان شرکت «اوسم-نِستله»",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 1024,
                "height": 548,
                "size": "27414",
                "name": "gi34ttl7zogv.webp",
                "title": "Gi34ttl7zogv.webp",
                "extension": "webp",
                "fileId": "77f97241-dbff-40a5-9146-da3262366063",
                "fileURL": "/files/77f97241-dbff-40a5-9146-da3262366063",
                "url": "/qlist-assets/77f97241-dbff-40a5-9146-da3262366063.webp"
              }
            }
          },
          {
            "id": "para-2",
            "type": "paragraph",
            "data": {
              "text": "نام نستله در فلسطین اشغالی (اسرائیل) با نام اوسِم گره خورده است. اوسِم یک شرکت بزرگ تولید و توزیع مواد غذایی در اسرائیل است که در سال 1942 تاسیس شده و محصولات آن در خانه‌ی هر اسرائیلی یافت می‌شود. طبق اطلاعات سایت رسمی این شرکت، 4200 نفر در اسرائیل و خارج از آن برای اوسِم مشغول به کار هستند. <a href=\"https://www.osem-nestle.co.il/about/company-profile\">(وبسایت رسمی اوسِم نستله)</a>"
            }
          },
          {
            "id": "nw93tdG2AA",
            "type": "image",
            "data": {
              "caption": "یک پوستر تبلیغاتی از محصول شرکت اوسِم در آمریکا",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 1024,
                "height": 561,
                "size": "114186",
                "name": "9jxkepn2ydqv.webp",
                "title": "9jxkepn2ydqv.webp",
                "extension": "webp",
                "fileId": "46476d45-44fc-43e6-bb55-50f278659420",
                "fileURL": "/files/46476d45-44fc-43e6-bb55-50f278659420",
                "url": "/qlist-assets/46476d45-44fc-43e6-bb55-50f278659420.webp"
              }
            }
          },
          {
            "id": "para-3",
            "type": "paragraph",
            "data": {
              "text": "اوسم همواره یک بازوی پشتیبان برای رژیم اسرائیل در حوزه غذا بوده است. در تاریخچه‌ای که در سایت رسمی اوسِم آمده است، با افتخار به مشارکت کاروان اوسِم در رساندن مواد غذایی تولیدی این شرکت به صهیونیست‌ها در بیت‌المقدس در خلال جنگ‌های پیش از تاسیس رژیم اسرائیل (1948) اشاره شده است. در سال 1950 این شرکت به درخواست بِن‌گوریون نخست‌وزیر وقت اسرائیل یک محصول جایگزین برای برنج معرفی می‌کند. در جنگ اعراب و اسرائیل (1973) هم اوسِم حضور فعالی در تامین غذا برای خط مقدم جنگ داشته است. <a href=\"https://www.osem-nestle.co.il/about/history\">(وبسایت رسمی اوسِم-نستله)</a>"
            }
          },
          {
            "id": "hRTvSnYx4i",
            "type": "image",
            "data": {
              "caption": "کاروان اوسِم در حال ارسال مواد غذایی تولید این شرکت به صهیونیست‌ها در بیت‌المقدس در خلال جنگ‌های پیش از تاسیس رژیم اسرائیل (1948)",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 1024,
                "height": 613,
                "size": "38004",
                "name": "3utxy3wsyjql.webp",
                "title": "3utxy3wsyjql.webp",
                "extension": "webp",
                "fileId": "35aabe66-012d-46a0-b468-5f204b12737b",
                "fileURL": "/files/35aabe66-012d-46a0-b468-5f204b12737b",
                "url": "/qlist-assets/35aabe66-012d-46a0-b468-5f204b12737b.webp"
              }
            }
          },
          {
            "id": "header-3",
            "type": "header",
            "data": {
              "text": "تراکنش موفق؛&nbsp;از سوئیس به اسرائیل",
              "level": 3
            }
          },
          {
            "id": "para-4",
            "type": "paragraph",
            "data": {
              "text": "1995 سالی بود که اوسِم پس از حضور در بازارهای بین‌المللی و در پی یافتن یک شریک معتبر، مذاکره با شرکت بزرگ نستله را آغاز کرد. در نتیجه توافق آن‌ها قرار شد تا اوسِم، محصولات نستله را به اسرائیل وارد کند و به دنبال آن دانش و فناوری محصولات غذایی نیز از نستله به اوسِم منتقل شود. یک سال بعد نسکافه به عنوان اولین محصول، توسط اوسِم به بازار اسرائیل وارد، و به دنبال آن سایر محصولات نستله از جمله غذای حیوانات، بستنی، غلات صبحانه و غیره نیز عرضه شدند. این روند به خوبی ادامه یافت تا آنکه در ابتدای هزاره جدید نستله تصمیم به خرید 50.1 درصد سهام اوسِم گرفت و با این کار به روند توسعه محصولات جدید نیز شتاب بخشید. در سال‌های 2012 و 2013 به ترتیب، سهام نستله در اوسم به 58.8 و 63.7 درصد افزایش یافت تا آن که در نهایت در سال 2016 این شرکت به طور کامل در نستله ادغام شد و نام آن اوسم-نستله تغییر یافت. نستله بابت تصاحب مابقی سهام اوسم (36.3 درصد) مبلغ 840 میلیون دلار پرداخت کرد. به این ترتیب اوسم تبدیل به یک شرکت خصوصی متعلق به نستله شده و از بورس تل‌آویو خارج شد. <a href=\"https://www.osem-nestle.co.il/about/history\">(منبع: وبسایت رسمی اوسم-نستله)</a> <a href=\"https://www.reuters.com/article/business/nestle-to-buy-rest-of-israeli-foodmaker-osem-for-840-million-idUSKCN0VD15Q/\">(رویترز)</a>"
            }
          },
          {
            "id": "para-5",
            "type": "paragraph",
            "data": {
              "text": "در گزارش سالیانه نستله برای سال 2022 میزان فروش نستله در فلسطین اشغالی (اسرائیل) به صورت مجزا وجود ندارد. با این حال مجموع درآمد نستله از بازارهای ترکیه و فلسطین اشغالی مبلغ 1.6 میلیارد دلار عنوان شده است که 8 درصد از کل فروش بازار اروپای شرکت را شامل می‌شود. این اعداد نشان دهنده حضور گسترده نستله در اقتصاد رژیم اسرائیل است. <a href=\"https://www.nestle.com/sites/default/files/2023-03/2022-annual-review-en.pdf\">(وبسایت رسمی نستله)</a>"
            }
          },
          {
            "id": "para-6",
            "type": "paragraph",
            "data": {
              "text": "نستله همچنین برای ورود به حوزه تولید گوشت آزمایشگاهی سلول پایه (تولید گوشت بدون دام) در حال مشارکت با استارت‌آپ اسرائیلی، فیوچر مِیت تکنولوژی است. <a href=\"https://www.bloomberg.com/news/articles/2021-07-12/nestle-eyes-lab-grown-meat-market-to-tap-future-growth\">(بلومبرگ)</a> حوزه‌ای که نگرانی‌های زیادی در مورد آن وجود دارد. به عنوان مثال دولت ایتالیا در سال 2023 در لایحه‌ای ممنوعیت استفاده از غذای سلولی را تصویب کرد. <a href=\"https://www.just-food.com/news/danone-invests-in-israel-cell-based-dairy-and-infant-milk-producer-wilk/?cf-view&amp;cf-closed\">(منبع: جاست فود)</a>"
            }
          },
          {
            "id": "bTJTHE39il",
            "type": "image",
            "data": {
              "caption": "سردر کارخانه اوسم-نستله در یکنئام",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 1024,
                "height": 657,
                "size": "109822",
                "name": "5jwaij26xbmi.webp",
                "title": "5jwaij26xbmi.webp",
                "extension": "webp",
                "fileId": "3ed3590d-c2d9-480c-938c-a020dbbc8ca4",
                "fileURL": "/files/3ed3590d-c2d9-480c-938c-a020dbbc8ca4",
                "url": "/qlist-assets/3ed3590d-c2d9-480c-938c-a020dbbc8ca4.webp"
              }
            }
          },
          {
            "id": "header-4",
            "type": "header",
            "data": {
              "text": "امتداد تا عمق؛ کارخانجات نستله در شهرک‌ها",
              "level": 3
            }
          },
          {
            "id": "para-7",
            "type": "paragraph",
            "data": {
              "text": "در واقع 6 کارخانه نستله در فلسطین اشغالی (اسرائیل) که پیش‌تر از آن صحبت کردیم همین کارخانجات اوسم هستند که برخی از آنها در شهرک‌های صهیونیستی مستقر شده‌اند. در سال 2007 این شرکت تصمیم می‌گیرد. کارخانه خود در&nbsp;پـِتَخ تیکْوا&nbsp;را تعطیل و آن را به منطقه شهرک‌نشین سِدیروت منتقل کند. در سال‌های اخیر و پس از مالکیت نستله نیز بسیاری از کارخانه‌ها و زیرساخت‌های اوسم به منطقه شهرک‌نشین کریات‌گَت منتقل شده است. <a href=\"https://www.osem-nestle.co.il/about/factories\">(وبسایت اوسِم نستله)</a> <a href=\"https://www.osem-nestle.co.il/about/history\">(تاریخچه موجود در سایت اوسِم نستله)</a>"
            }
          },
          {
            "id": "gN8LBBCT1m",
            "type": "image",
            "data": {
              "caption": "کارخانه اوسِم-نستله در شهرک سَدیروت",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 1024,
                "height": 657,
                "size": "79124",
                "name": "zgmcnhjjkmla.webp",
                "title": "Zgmcnhjjkmla.webp",
                "extension": "webp",
                "fileId": "2f2bf087-d07c-4c5a-977e-99167dffa27e",
                "fileURL": "/files/2f2bf087-d07c-4c5a-977e-99167dffa27e",
                "url": "/qlist-assets/2f2bf087-d07c-4c5a-977e-99167dffa27e.webp"
              }
            }
          },
          {
            "id": "header-5",
            "type": "header",
            "data": {
              "text": "ارتباط قدیمی؛ سابقه حضور نستله در اسرائیل",
              "level": 3
            }
          },
          {
            "id": "para-8",
            "type": "paragraph",
            "data": {
              "text": "به نظر می‌رسد ایفای نقش نستله در تقویت و کمک به اقتصاد رژیم اسرائیل به قبل‌تر از همکاری و سرمایه‌گذاری آن در اوسم برمی‌گردد؛ طبق ادعای سایت روزنامه آمریکایی جِویش استاندارد (شریک روزنامه تایمز اسرائیل)، مدیر عامل وقت نستله آقای پیتر برابک-لیتماث یکی از کسانی است که در سال 1998 جایزه جوبیلی را از نخست‌وزیر وقت رژیم اسرائیل، بنیامین نتانیاهو دریافت کرده است. طبق همین مقاله، این جایزه بالاترین مراتب تشکر دولت [رژیم] اسرائیل از اشخاص و شرکت‌هایی بود که از طریق سرمایه‌گذاری یا ایجاد روابط تجاری به تقویت اقتصاد اسرائیل کمک کرده بودند. <a href=\"https://jewishstandard.timesofisrael.com/pro-israel-businesses/\">(روزنامه جِویش استاندارد)</a> جشن جوبیلی در سال 1998 به مناسبت 50 سالگی رژیم اسرائیل برگزار شد و سران این رژیم و اَل‌گور معاون رئیس جمهور وقت آمریکا در آن سخنرانی کردند. <a href=\"https://www.c-span.org/program/international-telecasts/israel-50th-anniversary-celebration/78996\">(C-SPAN)</a>"
            }
          },
          {
            "id": "0gGvjkKEKO",
            "type": "image",
            "data": {
              "caption": "معاون بیل کلینتون رئیس جمهور اسبق ایالات متحده در حال سخنرانی در جشن جوبیلی 50 سالگی رژیم اسرائیل (1998)",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 1024,
                "height": 768,
                "size": "17860",
                "name": "6gtnhw1nxx3g.webp",
                "title": "6gtnhw1nxx3g.webp",
                "extension": "webp",
                "fileId": "c783d1d6-930b-41c5-a349-a91bbf29815c",
                "fileURL": "/files/c783d1d6-930b-41c5-a349-a91bbf29815c",
                "url": "/qlist-assets/c783d1d6-930b-41c5-a349-a91bbf29815c.webp"
              }
            }
          },
          {
            "id": "header-6",
            "type": "header",
            "data": {
              "text": "غرامت به مجرم؛ نستله و پرداخت غرامت هولوکاست",
              "level": 3
            }
          },
          {
            "id": "para-9",
            "type": "paragraph",
            "data": {
              "text": "نستله از جمله شرکت‌هایی است که غربی‌ها آن را در فهرست متهمان استفاده از نیروهای کار اجباری در برهه جنگ جهانی دوم می‌دانند. آنان برای نستله و سایر شرکت‌های حاضر در این فهرست یک بار حقوقی ایجاد کرده و با ایجاد فشار آنان را ملزم به پرداخت غرامت هولوکاست کرده‌اند. بنابر گزارش روزنامه ایندیپندنت، با وجود اینکه استفاده نستله از نیروهای کار اجباری هیچگاه تایید رسمی نشد، اما&nbsp;این شرکت&nbsp;در سال 2000 میلادی مبلغ 25 میلیون فرانک سوئیس (معادل 14.6 میلیون دلار) را به بازماندگان ادعایی هولوکاست و برخی سازمان‌های یهودی در دو بانک بزرگ سوئیس پرداخت کرد. همچنین زیرمجموعه‌های نستله در آلمان و اتریش نیز چنین پرداخت‌هایی را به بنیادهای مرتبط با جبران هولوکاست پرداخت کرده‌اند که البته عدد این پرداخت‌ها اعلام نشده است. <a href=\"https://www.independent.co.uk/news/business/news/nestle-pays-14-6m-into-swiss-banks-holocaust-settlement-5370420.html\">(ایندیپندنت)</a>"
            }
          },
          {
            "id": "header-7",
            "type": "header",
            "data": {
              "text": "شهرت عالم‌گیر؛ سابقه تحریم‌های مردمی علیه نستله",
              "level": 3
            }
          },
          {
            "id": "para-10",
            "type": "paragraph",
            "data": {
              "text": "نستله در بین مردم سایر کشورها و حتی حکومت‌های آن‌ها نیز به عنوان شریک جرم رژیم اسرائیل شناخته می‌شود و اقدامات زیادی نیز بر ضد آن انجام شده است. از جمله این اقدامات می‌توان به تصمیم مجلس ترکیه در تاریخ 16 آبان 1402 مبنی بر ممنوعیت حضور محصولات دو شرکت <b>کوکاکولا</b> و <b>نستله</b> در فهرست غذایی رستوران‌های این کشور اشاره کرد. سخنگوی مجلس ترکیه دلیل این اقدام را حمایت این شرکت‌ها از جنایات صهیونیست‌ها در غزه عنوان کرده بود. <a href=\"https://www.reuters.com/world/middle-east/turkish-parliament-removes-brands-menu-over-alleged-israel-support-2023-11-07/\">(رویترز)</a>"
            }
          },
          {
            "id": "4e7FrCh-Fx",
            "type": "image",
            "data": {
              "caption": "مجلس ترکیه",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 1024,
                "height": 576,
                "size": "90884",
                "name": "ap21zh9pewak.webp",
                "title": "Ap21zh9pewak.webp",
                "extension": "webp",
                "fileId": "8116a9cb-a69a-4e7c-8085-24347f742210",
                "fileURL": "/files/8116a9cb-a69a-4e7c-8085-24347f742210",
                "url": "/qlist-assets/8116a9cb-a69a-4e7c-8085-24347f742210.webp"
              }
            }
          },
          {
            "id": "para-11",
            "type": "paragraph",
            "data": {
              "text": "میدل‌ایست‌مانیتور نیز در تاریخ 3 اسفند 1402 به نقل از مدیر عامل نستله نوشته است که این شرکت از زمان شروع درگیری‌های غزه، در میان مصرف‌کنندگان غرب آسیا با تردید در خرید و تمایل به جایگزینی محصولات محلی مواجه شده است. <a href=\"https://www.middleeastmonitor.com/20240222-nestle-sees-hesitancy-among-consumers-since-war-on-gaza/\">(میدل ایست مانیتور)</a>"
            }
          },
          {
            "id": "HN5e574oSC",
            "type": "image",
            "data": {
              "caption": "شعارنوشته یکی از حاضران در تظاهرات، دانشگاه بیروت",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 1024,
                "height": 683,
                "size": "55662",
                "name": "xvcn0p29k1n9.webp",
                "title": "Xvcn0p29k1n9.webp",
                "extension": "webp",
                "fileId": "f0fe035f-ca05-4cbd-a1ac-4ef26717c45b",
                "fileURL": "/files/f0fe035f-ca05-4cbd-a1ac-4ef26717c45b",
                "url": "/qlist-assets/f0fe035f-ca05-4cbd-a1ac-4ef26717c45b.webp"
              }
            }
          },
          {
            "id": "para-12",
            "type": "paragraph",
            "data": {
              "text": "طبق گزارشی که نستله ارائه کرده است، مجموع فروش این شرکت در 9 ماهه ابتدایی سال 2024 با وجود افزایش 1.6 درصدی قیمت محصولات، نسبت به مدت مشابه سال قبل کاهش 2.5 درصدی داشته و به عدد 77.6 میلیارد دلار رسیده است. نستله کاهش فروش امسال این شرکت را ناشی از تحریم شرکت‌های مرتبط با رژیم اسرائیل دانسته و اعلام کرده است که شرکت از این تحریم‌ها آسیب دیده است. <a href=\"https://www.marketwatch.com/story/nestle-says-its-sales-are-suffering-due-to-israel-boycotts-7982f5f7\">(منبع: مارکِت واچ)</a>"
            }
          },
          {
            "id": "header-8",
            "type": "header",
            "data": {
              "text": "مجرم سابقه‌دار؛ دلایل دیگر برای تحریم نستله",
              "level": 3
            }
          },
          {
            "id": "para-13",
            "type": "paragraph",
            "data": {
              "text": "موضوع تحریم نستله سابقه طولانی دارد. البته نه فقط به خاطر موضوع حمایت از اسرائیل! نستله هم مثل بسیاری دیگر از شرکت‌های بزرگ چندملیتی در کارنامه خود موارد زیادی از ایجاد مشکلات زیست محیطی، بهداشتی، اجتماعی و غیره دارد. این شرکت به دلیل رفتارهایش در زمینه ترویج غیرمسئولانه شیرخشک خصوصاً در کشورهای فقیر مورد انتقاد و حتی تحریم از سوی نهادهای غیردولتی بین‌المللی و ملی کشورهای مختلف قرار گرفته است. در منابع ارائه شده در انتهای این بند می‌توانید اطلاعات و سرنخ‌های زیادی در رابطه با موضوع «تخلفات نستله در رابطه با شیر خشک» و «تحریم نستله» دریافت کنید. <a href=\"https://www.babymilkaction.org/nestlefree\">(منبع: بِیبی میلک)</a> <a href=\"https://en.wikipedia.org/wiki/1977_Nestl%C3%A9_boycott\">(ویکی‌پدیا)</a>"
            }
          },
          {
            "id": "w0iIgVszlB",
            "type": "image",
            "data": {
              "caption": "پوستر معروف تحریم نستله به خاطر تبلیغات غیرمسئولانه شیرخشک",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 1024,
                "height": 1334,
                "size": "68132",
                "name": "taiimpi344xh.webp",
                "title": "Taiimpi344xh.webp",
                "extension": "webp",
                "fileId": "c12fcbc7-481d-4e01-86af-9c7728b249ab",
                "fileURL": "/files/c12fcbc7-481d-4e01-86af-9c7728b249ab",
                "url": "/qlist-assets/c12fcbc7-481d-4e01-86af-9c7728b249ab.webp"
              }
            }
          },
          {
            "id": "para-14",
            "type": "paragraph",
            "data": {
              "text": "روزنامه گاردین در مقاله‌ای بسیار جالب توجه گزارش داده است که بررسی‌های یک سازمان ارزیاب سوئیسی نشان می‌دهد شیرخشک‌ها و غذاهای کودک (سرلاک) نستله در کشورهای در حال توسعه دارای 4 تا 6.8 گرم شکر اضافه در هر وعده بوده است. این در حالی است که همان محصولات در کشورهای توسعه‌یافته از جمله انگلستان یا خود سوئیس چنین مشکلی نداشته‌اند! شیوه‌نامه‌های بهداشت جهانی اجازه افزوده شدن شکر اضافی به غذای کودکان خصوصاً کودکان زیر دو سال را به دلیل بروز مشکلات چاقی و بیماری‌های مزمن نمی‌دهند. <a href=\"https://www.theguardian.com/global-development/2024/apr/17/nestle-adds-sugar-to-infant-milk-sold-in-poorer-countries-report-finds\">(منبع: گاردین)</a>"
            }
          },
          {
            "id": "QgTnlM88rW",
            "type": "image",
            "data": {
              "caption": "",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 1024,
                "height": 612,
                "size": "52450",
                "name": "zz2g2ilchl6b.webp",
                "title": "Zz2g2ilchl6b.webp",
                "extension": "webp",
                "fileId": "d7349ff3-6a82-475a-9175-5df41ec9598b",
                "fileURL": "/files/d7349ff3-6a82-475a-9175-5df41ec9598b",
                "url": "/qlist-assets/d7349ff3-6a82-475a-9175-5df41ec9598b.webp"
              }
            }
          },
          {
            "id": "GBrB8M3vv9",
            "type": "image",
            "data": {
              "caption": "",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 1024,
                "height": 682,
                "size": "87008",
                "name": "1q5xoavgackx.webp",
                "title": "1q5xoavgackx.webp",
                "extension": "webp",
                "fileId": "b612e331-080f-431e-9dce-f66897afd358",
                "fileURL": "/files/b612e331-080f-431e-9dce-f66897afd358",
                "url": "/qlist-assets/b612e331-080f-431e-9dce-f66897afd358.webp"
              }
            }
          },
          {
            "id": "RpIcLPNNvV",
            "type": "delimiter",
            "data": {}
          },
          {
            "id": "header-9",
            "type": "header",
            "data": {
              "text": "نستله در ایران",
              "level": 2
            }
          },
          {
            "id": "para-15",
            "type": "paragraph",
            "data": {
              "text": "نستله از جمله شرکت‌های خارجی است که اقدام به سرمایه‌گذاری مستقیم در ایران نموده و به صورت رسمی در بازار کشور حضور دارد."
            }
          },
          {
            "id": "quote-1",
            "type": "quote",
            "data": {
              "text": "«نستله اس.آ. در تاریخ پنجم مرداد ماه 1373 اجازه مشارکت و سرمایه‌گذاری (28.800.000 فرانک سوئیس) در جمهوری اسلامی ایران را دریافت کرد. در نهم اسفند همان سال، شرکت نستله ایران به طور رسمی در کشور ثبت شد و فعالیت‌های خود را آغاز کرد. در سال 1380 (2001 میلادی)، نستله ایران نخستین کارخانه خود را در استان قزوین تاسیس کرد»",
              "caption": "<a href=\"https://www.nestle.ir/sites/g/files/pydnoa236/files/2023-09/%235630%20Nestle-E-Corporate%20Brochure%20for%20Website%20-%20Brochure%20V6.pdf\">(منبع: نستله ایران)</a>",
              "alignment": "left"
            }
          },
          {
            "id": "para-16",
            "type": "paragraph",
            "data": {
              "text": "طبق گزارش سالیانه رسمی 2023 نستله، این شرکت هم‌اکنون دو کارخانه فعال در ایران دارد که یکی مربوط به تولید شیرخشک و دیگری مربوط به تولید آب آشامیدنی است. <a href=\"https://www.nestle.com/sites/default/files/2024-02/2023-annual-review-en.pdf\">(گزارش سالیانه نستله)</a>"
            }
          },
          {
            "id": "Nv0K9aHX0A",
            "type": "image",
            "data": {
              "caption": "کارخانه نستله در قزوین",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 1024,
                "height": 683,
                "size": "119604",
                "name": "sfqkxexwjxvl.webp",
                "title": "Sfqkxexwjxvl.webp",
                "extension": "webp",
                "fileId": "9762ba46-49a5-45a6-8fff-93d1cdc28deb",
                "fileURL": "/files/9762ba46-49a5-45a6-8fff-93d1cdc28deb",
                "url": "/qlist-assets/9762ba46-49a5-45a6-8fff-93d1cdc28deb.webp"
              }
            }
          },
          {
            "id": "ExlXkXIhGy",
            "type": "image",
            "data": {
              "caption": "",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 1024,
                "height": 682,
                "size": "48544",
                "name": "10rzqlwjihic.webp",
                "title": "10rzqlwjihic.webp",
                "extension": "webp",
                "fileId": "e29dae59-148d-48f1-aad4-5e2cb9c163c4",
                "fileURL": "/files/e29dae59-148d-48f1-aad4-5e2cb9c163c4",
                "url": "/qlist-assets/e29dae59-148d-48f1-aad4-5e2cb9c163c4.webp"
              }
            }
          },
          {
            "id": "para-17",
            "type": "paragraph",
            "data": {
              "text": "سبد محصولات نستله در ایران از مسیر رسمی شرکت به صورت «تولید» و «واردات» به بازار راه می‌یابند. همچنین برخی دیگر از محصولات این شرکت از طریق واردات اشخاص ثالث و یا به صورت قاچاق وارد شده و در دسترس مشتریان قرار می‌گیرند."
            }
          },
          {
            "id": "para-18",
            "type": "paragraph",
            "data": {
              "text": "حالا قضاوت با شماست. به نظر شما آیا به هنگام خرید یک بسته نسکافه، یک بطری آب‌معدنی پیورلایف، یک قوطی سرلاک یا شیرخشک نان، یک بسته کیت‌کت و... آن هم در ایران باید نگران تقویت اقتصاد اسرائیل باشیم؟"
            }
          }
        ]
      },
      "bodyEn": {
        "version": "2.30.7",
        "blocks": [
          {
            "id": "PJqTQb-E77",
            "type": "header",
            "data": {
              "text": "Nestlé: good food, good life!",
              "level": 2
            }
          },
          {
            "id": "intro-quote",
            "type": "quote",
            "data": {
              "text": "For many people, a hot cup of Nescafé is synonymous with feeling refreshed and energised for more work. Of course, some like to add a scoop of <b>CoffeeMate</b> creamer to their cup to take some of the bitterness off their Nescafé. A bottle of cold mineral water in the heat of summer can be the water of life — even if it's called <b>PureLife</b>. Many parents have had the experience of trekking to pharmacies looking for infant formula. To them <b>NAN</b> infant milk shines on the shelves like a constant star. Those whose newborns have had sensitive stomachs have probably hunted down <b>Guigoz</b> too. <b>CERELAC</b> is baby food, but it has always been more popular with adults than with children! Some, among a store's colourful pile of chocolates, keep looking until they finally spot the red of a <b>KitKat</b> wrapper. But can buying a packet of Nescafé, a bottle of PureLife mineral water, a tin of CERELAC or NAN infant formula, a KitKat… in Iran really have an impact on the Israeli regime's economy? We've tried to explain this below.",
              "caption": "",
              "alignment": "left"
            }
          },
          {
            "id": "9Q5Q3XSSmp",
            "type": "image",
            "data": {
              "caption": "Nestlé headquarters in Switzerland",
              "file": {
                "fileId": "816b9cf9-568a-4b38-b64d-32db5c8e9469"
              }
            }
          },
          {
            "id": "para-1",
            "type": "paragraph",
            "data": {
              "text": "In 1905, the company <b>Henri Nestlé</b> merged with <b>Anglo-Swiss</b>, founding the group we know today as the world's largest food and beverage company — Nestlé. <a href=\"https://www.nestle.com/about/history/nestle-company-history\">[Nestlé Iran website]</a> Nestlé is a Swiss multinational company that owns well-known brands and products including the Nescafé, CoffeeMate and Nespresso coffee family, KitKat chocolates, NAN and CERELAC infant formulas and baby foods, PureLife mineral water, Nesquik milk additives and more. <a href=\"https://www.nestle.com/brands/brandssearchlist\">[Nestlé Iran]</a> <a href=\"https://www.nestle.ir/fa/brands\">[Nestlé International]</a> With a presence in 188 countries, the company reached annual sales of 93 billion Swiss francs (over $105 billion) in 2023. Nestlé now operates 340 factories in 76 countries — including 6 factories in occupied Palestine (Israel) and 2 factories in Iran! <a href=\"https://www.nestle.com/sites/default/files/2024-02/2023-annual-review-en.pdf\">[Nestlé annual report]</a>"
            }
          },
          {
            "id": "5yWIwqnLeY",
            "type": "delimiter",
            "data": {}
          },
          {
            "id": "header-2",
            "type": "header",
            "data": {
              "text": "In the eagle's nest: Nestlé in Israel",
              "level": 2
            }
          },
          {
            "id": "OlxZx3RlGM",
            "type": "image",
            "data": {
              "caption": "The logo of \"Osem-Nestlé\"",
              "file": {
                "fileId": "77f97241-dbff-40a5-9146-da3262366063"
              }
            }
          },
          {
            "id": "para-2",
            "type": "paragraph",
            "data": {
              "text": "Nestlé's name in occupied Palestine (Israel) is tied to Osem. Osem is a large food production and distribution company in Israel, founded in 1942, whose products can be found in every Israeli household. According to its official website, 4,200 people in Israel and abroad work for Osem. <a href=\"https://www.osem-nestle.co.il/about/company-profile\">(Osem-Nestlé official website)</a>"
            }
          },
          {
            "id": "nw93tdG2AA",
            "type": "image",
            "data": {
              "caption": "A promotional poster for an Osem product in the United States",
              "file": {
                "fileId": "46476d45-44fc-43e6-bb55-50f278659420"
              }
            }
          },
          {
            "id": "para-3",
            "type": "paragraph",
            "data": {
              "text": "Osem has always been a support arm for the Israeli regime in the food sector. In the history published on Osem's official website, the company proudly recounts the role of the Osem convoy in delivering its food products to Zionists in Jerusalem during the wars that preceded the founding of the Israeli regime (1948). In 1950, at the request of then-prime-minister Ben-Gurion, the company introduced a substitute product for rice. During the Arab-Israeli war (1973), Osem was also actively involved in supplying food to the front lines. <a href=\"https://www.osem-nestle.co.il/about/history\">(Osem-Nestlé official website)</a>"
            }
          },
          {
            "id": "hRTvSnYx4i",
            "type": "image",
            "data": {
              "caption": "The Osem convoy delivering the company's food to Zionists in Jerusalem during the wars before the founding of the Israeli regime (1948)",
              "file": {
                "fileId": "35aabe66-012d-46a0-b468-5f204b12737b"
              }
            }
          },
          {
            "id": "header-3",
            "type": "header",
            "data": {
              "text": "A successful transaction: from Switzerland to Israel",
              "level": 3
            }
          },
          {
            "id": "para-4",
            "type": "paragraph",
            "data": {
              "text": "1995 was the year Osem, after entering international markets and looking for a credible partner, began negotiations with the giant Nestlé. As a result of their agreement, Osem would import Nestlé products into Israel, and food product knowledge and technology would be transferred from Nestlé to Osem. A year later Nescafé entered the Israeli market via Osem as the first product, followed by other Nestlé products including pet food, ice cream, breakfast cereals and so on. The trend continued well, until at the start of the new millennium Nestlé decided to buy 50.1% of Osem's shares — also accelerating the development of new products. In 2012 and 2013 Nestlé's stake in Osem rose to 58.8% and 63.7% respectively, until finally in 2016 the company was fully merged into Nestlé and renamed Osem-Nestlé. Nestlé paid $840 million to acquire the remaining 36.3% of Osem. Osem thus became a private company owned by Nestlé and was delisted from the Tel Aviv stock exchange. <a href=\"https://www.osem-nestle.co.il/about/history\">(Source: Osem-Nestlé official website)</a> <a href=\"https://www.reuters.com/article/business/nestle-to-buy-rest-of-israeli-foodmaker-osem-for-840-million-idUSKCN0VD15Q/\">(Reuters)</a>"
            }
          },
          {
            "id": "para-5",
            "type": "paragraph",
            "data": {
              "text": "Nestlé's 2022 annual report does not break out sales in occupied Palestine (Israel) separately. However, total Nestlé revenue from the Turkey and occupied-Palestine markets was reported at $1.6 billion — 8% of the company's total European market sales. These numbers indicate Nestlé's significant presence in the Israeli regime's economy. <a href=\"https://www.nestle.com/sites/default/files/2023-03/2022-annual-review-en.pdf\">(Nestlé official website)</a>"
            }
          },
          {
            "id": "para-6",
            "type": "paragraph",
            "data": {
              "text": "Nestlé is also partnering with the Israeli start-up Future Meat Technologies to enter cell-based lab-grown meat (meat produced without livestock). <a href=\"https://www.bloomberg.com/news/articles/2021-07-12/nestle-eyes-lab-grown-meat-market-to-tap-future-growth\">(Bloomberg)</a> This is a field with many concerns. For example, in 2023 the Italian government passed a bill banning cell-based food. <a href=\"https://www.just-food.com/news/danone-invests-in-israel-cell-based-dairy-and-infant-milk-producer-wilk/?cf-view&amp;cf-closed\">(Source: Just Food)</a>"
            }
          },
          {
            "id": "bTJTHE39il",
            "type": "image",
            "data": {
              "caption": "The entrance of the Osem-Nestlé factory in Yokneam",
              "file": {
                "fileId": "3ed3590d-c2d9-480c-938c-a020dbbc8ca4"
              }
            }
          },
          {
            "id": "header-4",
            "type": "header",
            "data": {
              "text": "Reaching into the depths: Nestlé's factories in the settlements",
              "level": 3
            }
          },
          {
            "id": "para-7",
            "type": "paragraph",
            "data": {
              "text": "In fact, the 6 Nestlé factories in occupied Palestine (Israel) we mentioned earlier are these Osem factories — and some of them are located in Zionist settlements. In 2007 the company decided to close its factory in Petah Tikva and move it to the settlement area of Sderot. In recent years, after Nestlé took ownership, many of Osem's factories and infrastructure have been moved to the Kiryat Gat settlement area. <a href=\"https://www.osem-nestle.co.il/about/factories\">(Osem-Nestlé website)</a> <a href=\"https://www.osem-nestle.co.il/about/history\">(History on the Osem-Nestlé site)</a>"
            }
          },
          {
            "id": "gN8LBBCT1m",
            "type": "image",
            "data": {
              "caption": "Osem-Nestlé factory in the Sderot settlement",
              "file": {
                "fileId": "2f2bf087-d07c-4c5a-977e-99167dffa27e"
              }
            }
          },
          {
            "id": "header-5",
            "type": "header",
            "data": {
              "text": "An old connection: the history of Nestlé in Israel",
              "level": 3
            }
          },
          {
            "id": "para-8",
            "type": "paragraph",
            "data": {
              "text": "Nestlé's role in strengthening and helping the Israeli regime's economy appears to predate its cooperation with and investment in Osem. According to the American newspaper site The Jewish Standard (a partner of The Times of Israel), then-Nestlé CEO Peter Brabeck-Letmathe is one of the people who received the Jubilee Award from then-prime-minister of the Israeli regime Benjamin Netanyahu in 1998. According to the same article, this award was the highest acknowledgement of thanks from the Israeli [regime's] government to individuals and companies who, through investment or building trade relations, had helped strengthen the Israeli economy. <a href=\"https://jewishstandard.timesofisrael.com/pro-israel-businesses/\">(The Jewish Standard)</a> The Jubilee celebration in 1998 was held for the 50th anniversary of the Israeli regime, and the regime's leaders and then-US Vice-President Al Gore gave speeches. <a href=\"https://www.c-span.org/program/international-telecasts/israel-50th-anniversary-celebration/78996\">(C-SPAN)</a>"
            }
          },
          {
            "id": "0gGvjkKEKO",
            "type": "image",
            "data": {
              "caption": "Bill Clinton's vice-president, former US Vice-President Al Gore, speaks at the 50th-anniversary Jubilee celebration of the Israeli regime (1998)",
              "file": {
                "fileId": "c783d1d6-930b-41c5-a349-a91bbf29815c"
              }
            }
          },
          {
            "id": "header-6",
            "type": "header",
            "data": {
              "text": "Compensation to the perpetrator: Nestlé and Holocaust reparations",
              "level": 3
            }
          },
          {
            "id": "para-9",
            "type": "paragraph",
            "data": {
              "text": "Nestlé is among the companies that Westerners include on lists of those accused of using forced labour during World War II. They have built a legal case against Nestlé and other companies on these lists and pressured them to pay Holocaust reparations. According to The Independent, although Nestlé's use of forced labour was never officially confirmed, the company paid 25 million Swiss francs (equivalent to $14.6 million) in 2000 to alleged Holocaust survivors and certain Jewish organisations in two large Swiss banks. Nestlé subsidiaries in Germany and Austria have also made such payments to Holocaust-reparation foundations — though the amounts were not announced. <a href=\"https://www.independent.co.uk/news/business/news/nestle-pays-14-6m-into-swiss-banks-holocaust-settlement-5370420.html\">(The Independent)</a>"
            }
          },
          {
            "id": "header-7",
            "type": "header",
            "data": {
              "text": "Worldwide notoriety: the history of popular boycotts against Nestlé",
              "level": 3
            }
          },
          {
            "id": "para-10",
            "type": "paragraph",
            "data": {
              "text": "Nestlé is also recognised by people in other countries — and even their governments — as a partner in the Israeli regime's crimes, and many actions have been taken against it. Among these we can point to the decision of the Turkish parliament on 7 November 2023 to ban the products of two companies, <b>Coca-Cola</b> and <b>Nestlé</b>, from the food menus of that country's restaurants. The Turkish parliamentary spokesperson stated the reason was these companies' support for Zionist crimes in Gaza. <a href=\"https://www.reuters.com/world/middle-east/turkish-parliament-removes-brands-menu-over-alleged-israel-support-2023-11-07/\">(Reuters)</a>"
            }
          },
          {
            "id": "4e7FrCh-Fx",
            "type": "image",
            "data": {
              "caption": "The Turkish parliament",
              "file": {
                "fileId": "8116a9cb-a69a-4e7c-8085-24347f742210"
              }
            }
          },
          {
            "id": "para-11",
            "type": "paragraph",
            "data": {
              "text": "Middle East Monitor also reported on 22 February 2024, quoting Nestlé's CEO, that since the start of the Gaza conflict the company has faced hesitancy in purchasing and a tendency to switch to local products among West-Asian consumers. <a href=\"https://www.middleeastmonitor.com/20240222-nestle-sees-hesitancy-among-consumers-since-war-on-gaza/\">(Middle East Monitor)</a>"
            }
          },
          {
            "id": "HN5e574oSC",
            "type": "image",
            "data": {
              "caption": "A protest slogan held by one of the participants in a demonstration at Beirut University",
              "file": {
                "fileId": "f0fe035f-ca05-4cbd-a1ac-4ef26717c45b"
              }
            }
          },
          {
            "id": "para-12",
            "type": "paragraph",
            "data": {
              "text": "According to a Nestlé report, the company's total sales in the first 9 months of 2024 — despite a 1.6% price increase — fell 2.5% year-on-year to $77.6 billion. Nestlé attributed this year's drop in sales to the boycotts of companies linked to the Israeli regime and announced that the company has been hurt by these boycotts. <a href=\"https://www.marketwatch.com/story/nestle-says-its-sales-are-suffering-due-to-israel-boycotts-7982f5f7\">(Source: MarketWatch)</a>"
            }
          },
          {
            "id": "header-8",
            "type": "header",
            "data": {
              "text": "A repeat offender: other reasons to boycott Nestlé",
              "level": 3
            }
          },
          {
            "id": "para-13",
            "type": "paragraph",
            "data": {
              "text": "The Nestlé boycott has a long history — and not only because of support for Israel! Like many other large multinationals, Nestlé has a record of many environmental, health, social and other problems. The company has been criticised — and even boycotted — by international and national non-governmental bodies for irresponsible marketing of infant formula, particularly in poor countries. In the sources listed at the end of this section you can find information and leads about Nestlé's infant-formula violations and the Nestlé boycott. <a href=\"https://www.babymilkaction.org/nestlefree\">(Source: Baby Milk)</a> <a href=\"https://en.wikipedia.org/wiki/1977_Nestl%C3%A9_boycott\">(Wikipedia)</a>"
            }
          },
          {
            "id": "w0iIgVszlB",
            "type": "image",
            "data": {
              "caption": "The famous Nestlé boycott poster over irresponsible infant-formula marketing",
              "file": {
                "fileId": "c12fcbc7-481d-4e01-86af-9c7728b249ab"
              }
            }
          },
          {
            "id": "para-14",
            "type": "paragraph",
            "data": {
              "text": "The Guardian, in a particularly notable article, reported that investigations by a Swiss evaluation organisation showed Nestlé's infant formulas and baby foods (CERELAC) in developing countries contained 4 to 6.8 grams of added sugar per serving. Yet the same products in developed countries, including the United Kingdom and Switzerland itself, did not have this problem! World-health guidelines do not allow added sugar in children's food, especially for children under two, because of the resulting obesity and chronic-disease risks. <a href=\"https://www.theguardian.com/global-development/2024/apr/17/nestle-adds-sugar-to-infant-milk-sold-in-poorer-countries-report-finds\">(Source: The Guardian)</a>"
            }
          },
          {
            "id": "QgTnlM88rW",
            "type": "image",
            "data": {
              "caption": "",
              "file": {
                "fileId": "d7349ff3-6a82-475a-9175-5df41ec9598b"
              }
            }
          },
          {
            "id": "GBrB8M3vv9",
            "type": "image",
            "data": {
              "caption": "",
              "file": {
                "fileId": "b612e331-080f-431e-9dce-f66897afd358"
              }
            }
          },
          {
            "id": "RpIcLPNNvV",
            "type": "delimiter",
            "data": {}
          },
          {
            "id": "header-9",
            "type": "header",
            "data": {
              "text": "Nestlé in Iran",
              "level": 2
            }
          },
          {
            "id": "para-15",
            "type": "paragraph",
            "data": {
              "text": "Nestlé is among the foreign companies that have invested directly in Iran and have an official presence in the country's market."
            }
          },
          {
            "id": "quote-1",
            "type": "quote",
            "data": {
              "text": "Nestlé S.A. was granted permission to participate and invest (CHF 28,800,000) in the Islamic Republic of Iran on 27 July 1994. On 28 February of the same year, Nestlé Iran was officially registered in the country and began its activities. In 2001, Nestlé Iran established its first factory in Qazvin province.",
              "caption": "<a href=\"https://www.nestle.ir/sites/g/files/pydnoa236/files/2023-09/%235630%20Nestle-E-Corporate%20Brochure%20for%20Website%20-%20Brochure%20V6.pdf\">(Source: Nestlé Iran)</a>"
            }
          },
          {
            "id": "para-16",
            "type": "paragraph",
            "data": {
              "text": "According to Nestlé's official 2023 annual report, the company currently operates two factories in Iran — one for infant-formula production and the other for drinking-water production. <a href=\"https://www.nestle.com/sites/default/files/2024-02/2023-annual-review-en.pdf\">(Nestlé annual report)</a>"
            }
          },
          {
            "id": "Nv0K9aHX0A",
            "type": "image",
            "data": {
              "caption": "Nestlé factory in Qazvin",
              "file": {
                "fileId": "9762ba46-49a5-45a6-8fff-93d1cdc28deb"
              }
            }
          },
          {
            "id": "ExlXkXIhGy",
            "type": "image",
            "data": {
              "caption": "",
              "file": {
                "fileId": "e29dae59-148d-48f1-aad4-5e2cb9c163c4"
              }
            }
          },
          {
            "id": "para-17",
            "type": "paragraph",
            "data": {
              "text": "Nestlé's product range in Iran reaches the market through the company's official channels — both as locally produced and imported goods. Some other Nestlé products also enter the country through third-party importers or smuggling and are made available to customers."
            }
          },
          {
            "id": "para-18",
            "type": "paragraph",
            "data": {
              "text": "Now the judgement is yours. In your view, when buying a packet of Nescafé, a bottle of PureLife mineral water, a tin of CERELAC or NAN infant formula, a KitKat… in Iran, should we be worried about strengthening Israel's economy?"
            }
          }
        ]
      }
    },
    {
      "slug": "danone",
      "sourceUrl": "https://qlist.ir/blog/danone/",
      "companySlug": "danone",
      "title": {
        "en": "Everything about boycotting Danone: from supporting Israel to its official presence in Iran",
        "fa": "همه چیز درباره تحریم دنون؛ حمایت از اسرائیل تا حضور رسمی در ایران"
      },
      "summary": {
        "en": "An introduction to Danone, documentation of its support for Israel and its presence in the Iranian market, citing official sources.",
        "fa": "معرفی شرکت دنون، مستندات حمایت از اسرائیل و حضور در بازار ایران با استناد به منابع رسمی"
      },
      "cover": null,
      "body": {
        "time": 1776170774963,
        "version": "2.31.0-rc.7",
        "blocks": [
          {
            "id": "ialv0xYISb",
            "type": "header",
            "data": {
              "text": "«دَنون»، دِسِر فرانسوی با تزئین عِبری",
              "level": 2
            }
          },
          {
            "id": "2SszbyUo9s",
            "type": "image",
            "data": {
              "caption": "",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 1024,
                "height": 494,
                "size": "45482",
                "name": "wa53nfjibke0.webp",
                "title": "Wa53nfjibke0.webp",
                "extension": "webp",
                "fileId": "bc7560c9-cabe-4df1-9463-778806a50828",
                "fileURL": "/files/bc7560c9-cabe-4df1-9463-778806a50828",
                "url": "/qlist-assets/bc7560c9-cabe-4df1-9463-778806a50828.webp"
              }
            }
          },
          {
            "id": "lF4S4UuJ0s",
            "type": "quote",
            "data": {
              "text": "حتما تا به حال نام «دَنِت» به گوشتان خورده است. دِسِرهایی بر پایه شیر، که سال‌هاست به عنوان یک میان وعده سالم و خوشمزه برای بچه‌ها، جای خود را در سبد خانواده‌های ایرانی باز کرده‌اند. اگر هم سر و کارتان با نوزاد افتاده باشد قطعاً نام‌هایی مثل «آپتامیل» یا «بِبِلاک» را در بازار شیرخشک می‌شناسید. شیرخشک‌هایی که در کنار محصولات نستله پرفروش‌ترین شیرخشک‌های بازار ایران اند. این‌‌ موارد، بخشی از محصولات اَبَرشرکت چندملیتی «دَنون» هستند که به صورت رسمی در بازار کشورمان حضور دارند. ابرشرکتی که همواره به عنوان یکی از شرکت‌های حامی اسرائیل، پای ثابت همه لیست‌های تحریمی حامیان فلسطین بوده است. اما آیا واقعاً دنون همان‌طور که می‌گویند حامی و مرتبط با اسرائیلی‌هاست؟ آیا زمانی که داریم یک قاشق از دسر فرانسوی سرد و تازه را در دهانمان می‌گذاریم و از طعم خوشمزه‌اش لذت می‌بریم واقعاً باید نگران کمک به اقتصاد اسرائیل باشیم؟ با ما همراه باشید تا این ادعای عجیب را بررسی کنیم.",
              "caption": "",
              "alignment": "left"
            }
          },
          {
            "id": "o1LY_s3Sc1",
            "type": "header",
            "data": {
              "text": "بخش اول: سرمایه‌گذاری می‌کنم، پس هستم!",
              "level": 2
            }
          },
          {
            "id": "qO0mQ77nWz",
            "type": "image",
            "data": {
              "caption": "",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 1024,
                "height": 1041,
                "size": "105236",
                "name": "ereur5kp39kh.webp",
                "title": "Ereur5kp39kh.webp",
                "extension": "webp",
                "fileId": "1a999fc5-50d3-48c0-b691-dc071b1fff99",
                "fileURL": "/files/1a999fc5-50d3-48c0-b691-dc071b1fff99",
                "url": "/qlist-assets/1a999fc5-50d3-48c0-b691-dc071b1fff99.webp"
              }
            }
          },
          {
            "id": "B7PYekQU5u",
            "type": "paragraph",
            "data": {
              "text": "شرکت&nbsp;«دَنون»، یکی از بزرگ‌ترین شرکت‌های غذایی جهان است. طبق اسناد مالی این شرکت، در سال 2023 با 27.6 میلیارد یورو فروش در سراسر جهان، رتبه اول محصولات لبنی، گیاهی و نوشیدنی، رتبه دوم آب‌های بسته‌بندی و غذای نوزاد، و رتبه چهارم در غذای بزرگسالان را در میان شرکت‌ها در اختیار دارد<a href=\"https://www.danone.com/content/dam/corp/global/danonecom/investors/en-all-publications/2023/integratedreports/integratedannualreport2023.pdf\" target=\"_blank\">(وبسایت دنون)</a>. اما این غول مواد غذایی چگونه سر از لیست تحریم کالاهای صهیونیستی درآورده است؟"
            }
          },
          {
            "id": "J18dVuOuMp",
            "type": "paragraph",
            "data": {
              "text": "ماجرا از علاقه دَنون به سرمایه‌گذاری در شرکت‌های اسرائیلی شروع می‌شود. برای مثال، دَنون تنها در یک دور، در سال 2023 به میزان 4 میلیون دلار در یک شرکت تازه‌تأسیس فن‌آوری اسرائیلی به نام&nbsp;«ویلک»&nbsp;سرمایه‌گذاری کرده است<a href=\"https://www.jpost.com/business-and-innovation/banking-and-finance/article-743853\" target=\"_blank\">(اورشلیم پُست)</a>. حوزه فعالیت این شرکت نوبنیاد، تولید محصولات لبنی از طریق سلول‌های تولیدکننده آن است. شاید با خودتان بگویید 4 میلیون دلار که عدد بزرگی برای یک شرکت چند میلیارد دلاری به حساب نمی‌آید. حق با شماست! هرچند این مبلغ برای یک استارتاپ تازه تأسیس رقم قابل توجهی است اما در واقع، در این سرمایه‌گذاری، چیزهای مهم‌تری از مبلغ آن وجود دارد:"
            }
          },
          {
            "id": "hLLNtGtUXW",
            "type": "quote",
            "data": {
              "text": "\"سرمایه‌گذاری حدود 4 میلیون دلاری در یک شرکت فناوری اسرائیلی، حتی در شرایطی که سرمایه گذاری در بخش فناوری محلی به شدت کاهش یافته، کار [چندان] بزرگی نیست. اما این بار، به جای مبلغ، هویت سرمایه‌گذاران است که جالب توجه است. بنابراین، [این] نوبت جذب سرمایه شرکت فناوری ویلک را می‌توان یک پیشرفت تجاری نامید.\"&nbsp;منبع:&nbsp;اورشلیم پُست",
              "caption": "",
              "alignment": "left"
            }
          },
          {
            "id": "v6KbyZzRvs",
            "type": "paragraph",
            "data": {
              "text": "یادداشت‌نویس اورشلیم‌پست به خوبی اهمیت این سرمایه‌گذاری را توضیح داده است. داده‌ها نشان می‌دهد نرخ سرمایه‌گذاری خارجی در اسرائیل، علی رغم مشوق‌های بسیار در چند سال اخیر روندی سینوسی داشته است. این رقم در سه ماهه نخست 2023 حدود 1.7 میلیارد دلار را نشان می‌داد که کمترین میزان از سال 2019 بود<a href=\"https://sciencebusiness.net/network-updates/israeli-high-tech-sector-risk-splitting-away-global-trends-israel-innovation\" target=\"_blank\">(ساینس بیزنس)</a>. به نظر می‌رسد اختلافات داخلی بر سر اصلاحات قضایی، عمده‌ترین دلیل این کاهش سرمایه گذاری بوده است:"
            }
          },
          {
            "id": "LQBvCHK8SR",
            "type": "quote",
            "data": {
              "text": "\"ما امروز در میانه یک بحران جهانی هستیم و هنوز خیلی زود است که بدانیم [این بحران] چه زمانی و چگونه پایان خواهد یافت. به این یک بحران محلی هم اضافه شده است که عدم اطمینان بیشتری [برای سرمایه‌گذاران] ایجاد کرده است. [حتی] اگر بحران قضایی حل شود، [باز هم] رسیدن به برون‌رفت زمان‌بر است و حتی آن‌موقع هم، اعتمادسازی مجدد سرمایه گذاران زمان بر است.\"دِرور بین/مدیرعامل سازمان نوآوری اسرائیلمنبع:&nbsp;ساینس بیزنس",
              "caption": "",
              "alignment": "left"
            }
          },
          {
            "id": "KY2ydyCBTP",
            "type": "paragraph",
            "data": {
              "text": "حالا تصور کنید در میانه این بحران و تردید سرمایه گذاران خارجی، یک نام معتبر، همچون دنون با چند میلیون دلار وارد صحنه می‌شود تا ورق را برگرداند و به سرمایه گذاران مردد قوت قلب بدهد(دقیقاً مثل کاری که سلبریتی‌ها با حضورشان در تبلیغات تلویزیونی برندهای مشهور، با شما انجام می‌دهند). علت بازتاب گسترده این سرمایه‌گذاری در میان رسانه‌های اسرائیلی هم، همین وجهه تبلیغاتی آن است."
            }
          },
          {
            "id": "F6pkFJwsK-",
            "type": "image",
            "data": {
              "caption": "استفاده از چهره‌های آشنا در تبلیغات تجاری[بالا]/بازتاب گسترده سرمایه‌گذاری دَنون در رسانه‌های اسرائیلی با تاکید بر اعتبار سرمایه‌گذار[پایین]",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 600,
                "height": 795,
                "size": "88212",
                "name": "r53uq4eu3jqh.jpg",
                "title": "R53uq4eu3jqh.jpg",
                "extension": "jpg",
                "fileId": "40d62404-321e-47a3-afca-46d3f252982b",
                "fileURL": "/files/40d62404-321e-47a3-afca-46d3f252982b",
                "url": "/qlist-assets/40d62404-321e-47a3-afca-46d3f252982b.jpg"
              }
            }
          },
          {
            "id": "MIZhuj-Iz9",
            "type": "paragraph",
            "data": {
              "text": "دَنون کمتر از یک ماه بعد، در یک کسب‌وکار نوپای دیگر اسرائیلی به نام «ایمجین‌دِیری» هم سرمایه‌گذاری مشابهی را انجام داد&nbsp;<a href=\"https://www.timesofisrael.com/israels-imagindairy-nabs-danone-as-strategic-investor-for-cow-free-dairy-products/\" target=\"_blank\">(تایمز اسرائیل)</a>&nbsp;تا نشان دهد سرمایه‌گذاری‌اش در اسرائیل نه یک استثنا بلکه یک قاعده است. اما آیا ماجرای دنون و اسرائیل از سال 2023 شروع و به سرمایه‌گذاری در استارتاپ‌های اسرائیلی محدود می‌شود؟"
            }
          },
          {
            "id": "1Da8IzANfW",
            "type": "image",
            "data": {
              "caption": "«ویلک» و «ایمجین‌دیری» آخرین سرمایه‌گذاری های دنون در وبسایت دَنون‌ونچرز",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 1024,
                "height": 669,
                "size": "23988",
                "name": "t3q2o7tkqzrp.webp",
                "title": "T3q2o7tkqzrp.webp",
                "extension": "webp",
                "fileId": "712386e5-905c-4f28-818f-08dd3b3132fe",
                "fileURL": "/files/712386e5-905c-4f28-818f-08dd3b3132fe",
                "url": "/qlist-assets/712386e5-905c-4f28-818f-08dd3b3132fe.webp"
              }
            }
          },
          {
            "id": "eyLTk_Hd7Y",
            "type": "header",
            "data": {
              "text": "بخش دوم: «اِشتراوس»؛ دَنون به عِبری!",
              "level": 2
            }
          },
          {
            "id": "8hqtOpSYwI",
            "type": "image",
            "data": {
              "caption": "",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 1024,
                "height": 583,
                "size": "39710",
                "name": "bjbvt0uiykv2.webp",
                "title": "Bjbvt0uiykv2.webp",
                "extension": "webp",
                "fileId": "64ddd0a4-0eef-4f1c-a2a3-bf9ae7c556ea",
                "fileURL": "/files/64ddd0a4-0eef-4f1c-a2a3-bf9ae7c556ea",
                "url": "/qlist-assets/64ddd0a4-0eef-4f1c-a2a3-bf9ae7c556ea.webp"
              }
            }
          },
          {
            "id": "1r_09xIFRz",
            "type": "paragraph",
            "data": {
              "text": "ماجرای علاقه‌مندی دَنون به سرمایه‌گذاری در اسرائیل، به 55 سال قبل باز می‌گردد. در سال 1969 دَنون یک توافق‌نامه همکاری با یک شرکت مواد غذایی اسرائیلی به نام&nbsp;«اِشتراوس»&nbsp;امضا کرد. در آن سال اشتراوس ضمن دسترسی به دانش تولید دنون، نمایندگی عرضه محصولات مختلف این شرکت در اسرائیل را نیز کسب کرد. در سال 1972، دَنون و اشترواس کارخانه جدیدی را در اسرائیل افتتاح کردند و به تولید محصولات برند «دَنی»[همان دنت خودمان]، پرداختند که موفقیت‌های چشم گیری را برای هر دو شرکت رقم زد<a href=\"https://www.strauss-group.com/partner/partnership_danone/\" target=\"_blank\">(وبسایت اشترواس)</a>."
            }
          },
          {
            "id": "BPlCP_j6EZ",
            "type": "image",
            "data": {
              "caption": "شروع همکاری اشتراوس و دنون در سیر تاریخی این شرکت که در وبسایت اشتراوس آمده",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 1024,
                "height": 437,
                "size": "34974",
                "name": "jmvsxsgvrkw5.webp",
                "title": "Jmvsxsgvrkw5.webp",
                "extension": "webp",
                "fileId": "a136e893-060f-4249-b647-9f9c8e7e02f7",
                "fileURL": "/files/a136e893-060f-4249-b647-9f9c8e7e02f7",
                "url": "/qlist-assets/a136e893-060f-4249-b647-9f9c8e7e02f7.webp"
              }
            }
          },
          {
            "id": "sNZ7FYzyva",
            "type": "header",
            "data": {
              "text": "پیوند ناگسستنی",
              "level": 4
            }
          },
          {
            "id": "CWHGEb5EBl",
            "type": "paragraph",
            "data": {
              "text": "پس از یک دهه همکاری موفق، در سال 1982 دنون برای مصون ماندن از&nbsp;<a href=\"https://en.wikipedia.org/wiki/Arab_League_boycott_of_Israel\" target=\"_blank\">«تحریم کالاهای اسرائیلی از سوی اعراب»</a>، تصمیم گرفت تا به این همکاری پایان دهد. این فراق، 14 سال ادامه داشت تا اینکه دنون در سال 1996 و پس از پایان خطر تحریم عربی، مجدداً با یک سرمایه‌گذاری بزرگ، این بار 20 درصد از سهام لبنیات اشتراوس را صاحب شد. بازگشتی که اشتراوس از آن به عنوان «بازگشت بزرگ» اسم می‌برد."
            }
          },
          {
            "id": "AXNKNlGgKP",
            "type": "image",
            "data": {
              "caption": "روایت بازگشت بزرگ دنون به همکاری با اشتراوس",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 1024,
                "height": 506,
                "size": "36448",
                "name": "tvpc5mmpfhqs.webp",
                "title": "Tvpc5mmpfhqs.webp",
                "extension": "webp",
                "fileId": "4af9d39d-d405-432b-95a4-15ebaef239ba",
                "fileURL": "/files/4af9d39d-d405-432b-95a4-15ebaef239ba",
                "url": "/qlist-assets/4af9d39d-d405-432b-95a4-15ebaef239ba.webp"
              }
            }
          },
          {
            "id": "9iB2-V1Bug",
            "type": "paragraph",
            "data": {
              "text": "وبگاه اشتراوس این اقدام را عامل موثری در تسهیل نوآوری و توسعه اشتراوس و همچنین تولید و فروش محصولات دنون از سوی این شرکت اسرائیلی دانسته است:"
            }
          },
          {
            "id": "LziEY5C1QU",
            "type": "quote",
            "data": {
              "text": "\"فعالیت ما در اسرائیل با مجموعه‌ای از همکاری‌های راهبردی با تولیدکنندگان جهانی مواد غذایی همراه است؛ گروه دنون 20 درصد از از لبنیات اشتراوس را در اختیار دارد و پپسی در تنقلات نمکی ما 50 درصد شریک است. این مشارکت‌های سازنده و طولانی مدت هستند که ما را قادر ساخته‌اند زیرساخت‌های حرفه‌ای و تجاری گسترده و پایدار ایجاد کنیم.\"منبع:&nbsp;وبسایت اشتراوس",
              "caption": "",
              "alignment": "left"
            }
          },
          {
            "id": "ABw114tPOW",
            "type": "paragraph",
            "data": {
              "text": "اما اشتراوس چه کرده بود که دنون از ترس تحریم اعراب، 14 سال قید همکاری با آن را زد؟"
            }
          },
          {
            "id": "p9dsK32uUT",
            "type": "header",
            "data": {
              "text": "اسرائیل خانه من است!",
              "level": 4
            }
          },
          {
            "id": "F5Hk9Mmi2n",
            "type": "quote",
            "data": {
              "text": "\"اسرائیل خانه اصلی ماست، چشمه‌ای از فرهنگ که بستر فعالیت‌های ارزش‌محور و دانش حرفه‌ای ما شد. بزرگترین شرکت مواد غذایی اسرائیل با یکایدئولوژی صهیونیستی، عشق به میهن(!) و بخشش متولد شد.\"منبع:&nbsp;وبسایت اشتراوس",
              "caption": "",
              "alignment": "left"
            }
          },
          {
            "id": "nN2gnPRNK2",
            "type": "image",
            "data": {
              "caption": "",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 1024,
                "height": 705,
                "size": "55550",
                "name": "rjax2wuf92ju.webp",
                "title": "Rjax2wuf92ju.webp",
                "extension": "webp",
                "fileId": "53211373-644c-40d4-9a7f-a584f589d51d",
                "fileURL": "/files/53211373-644c-40d4-9a7f-a584f589d51d",
                "url": "/qlist-assets/53211373-644c-40d4-9a7f-a584f589d51d.webp"
              }
            }
          },
          {
            "id": "4ZUEL3fHGw",
            "type": "paragraph",
            "data": {
              "text": "این‌ بخشی از معرفی اشتراوس در وبگاه رسمی خود شرکت است. اشتراوس که به گفته خودش بزرگترین شرکت مواد غذایی و رهبر بازار محصولات غذایی اسرائیل است، بیش از 80 سال است که در سرزمین‌های اشغالی فعال بوده و حدود 6500 نفر در بیش از 20 سایت تولیدی آن در سراسر فلسطین اشغالی مشغول به کارند. به گواه وبگاه رسمی شرکت، اشتراوس همواره بیش از از 50 درصد گردش مالی خود را داخل خود اسرائیل حفظ کرده است.&nbsp;<a href=\"https://www.strauss-group.com/location/strauss_israel/\" target=\"_blank\">(وبسایت اشتراوس)</a>"
            }
          },
          {
            "id": "qty7L8y5BU",
            "type": "paragraph",
            "data": {
              "text": "نکته جالب درباره اشتراوس همین رویکردهای سیاسی و ایدئولوژیک تند و تیز آن است. اشتراوس به معنای واقعی، خود را یک برند صهیونیستی مؤمن به آرمان‌های اسرائیل می‌داند."
            }
          },
          {
            "id": "lJDc-qQpQF",
            "type": "image",
            "data": {
              "caption": "محصولات اشتراوس در دستان نظامیان صهیونیست در ویدیوی تبلیغاتی این شرکت",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 1024,
                "height": 580,
                "size": "109458",
                "name": "34bloesciqoc.webp",
                "title": "34bloesciqoc.webp",
                "extension": "webp",
                "fileId": "d0ff83e9-42f6-4b9d-9d9b-cba6e763558a",
                "fileURL": "/files/d0ff83e9-42f6-4b9d-9d9b-cba6e763558a",
                "url": "/qlist-assets/d0ff83e9-42f6-4b9d-9d9b-cba6e763558a.webp"
              }
            }
          },
          {
            "id": "pDWALdeXAD",
            "type": "paragraph",
            "data": {
              "text": "با وجود بین المللی بودن فعالیت های اشتراوس، پرچم اسرائیل و تصاویر نظامیان صهیونیست، در جای جای وبگاه شرکت خودنمایی می‌کند. اشتراوس پس از درگیری‌های پس از 15 مهر 1402[عملیات طوفان الاقصی] پویشی با عنوان «همیشه با هم» ایجاد کرده است. در صفحه اول وبگاه این شرکت، ذیل همین پویش، تصاویری تبلیغاتی از نظامیان صهیونیست در حال پایکوبی در کنار محصولات این شرکت نمایش داده می‌شود."
            }
          },
          {
            "id": "2dkXFrQDUV",
            "type": "paragraph",
            "data": {
              "text": "<a href=\"https://www.namasha.com/v/jD9QqxfH\">ویدیوی تبلیغاتی این شرکت برای معرفی پویش «همیشه با هم»</a>"
            }
          },
          {
            "id": "9qyYC864du",
            "type": "paragraph",
            "data": {
              "text": "در صفحات مختلف مربوط با این پویش، بر تعهد شرکت به حمایت از شهرک‌نشینان در تیررس راکت‌های حماس و عدم تعطیلی فعالیت‌های شرکت در مناطق نزدیک غزه تاکید شده است. همچنین اشتراوس پشتیبانی‌هایی از اهالی کوچ کرده از مناطق درگیر جنگ داشته است<a href=\"https://www.strauss-group.com/sustainability/stronger-together/hugs-and-gift-packs-for-the-kibbutz-communities/\" target=\"_blank\">(وبسایت اشتراوس)</a>. در این صفحات به طور گسترده‌ای از شهرک‌های اشغالی که اشتراوس در آن‌ها به نوعی حضور و فعالیت دارد نام برده شده است، از جمله کارخانه تولید چیپس در سدیروت<a href=\"https://www.strauss-group.com/sustainability/stronger-together/hugs-and-gift-packs-for-the-kibbutz-communities/\" target=\"_blank\">(وبسایت اشتراوس)</a>. جالب‌تر آن که در پایین تمام صفحات شرکت، ثانیه‌شماری برای آزادی اسرای اسرائیلی در غزه وجود دارد."
            }
          },
          {
            "id": "ASG6ekjf1H",
            "type": "quote",
            "data": {
              "text": "«به عنوان شرکتی که ریشه‌های آن از دل تاریخ کشور(!) اسرائیل روییده، محصولات و برندهای ما ارتباط قوی با مصرف‌کنندگان[اسرائیلی] دارند، آن‌ها را در زندگی روزمره‌شان همراهی می‌کنند و بخش اصلی آشنایی در هر خانه [اسرائیلی] هستند.»منبع:&nbsp;وبسایت اشتراوس",
              "caption": "",
              "alignment": "left"
            }
          },
          {
            "id": "0cQp11qesy",
            "type": "paragraph",
            "data": {
              "text": "اشتراوس به گفته خودش در جنگ چهارم اعراب و اسرائیل(جنگ یوم کیپور) در سال 1973 هم کمک‌حال ارتش اسرائیل بوده است. در بخشی از تاریخچه این شرکت با عنوان&nbsp;«در جبهه جنگ، در خط مقدم اقتصاد»، اشتراوس به 24 ساعته کردن خطوط تولیدش در زمان جنگ، برای تأمین نیازهای نظامیان اشاره کرده است. علت قرار گرفتن اشتراوس در لیست تحریم اعراب هم همین مشارکت فعالش در جنگ‌ها بود."
            }
          },
          {
            "id": "Bd0Oxhsh-s",
            "type": "image",
            "data": {
              "caption": "",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 1024,
                "height": 491,
                "size": "34094",
                "name": "co1y9xhvygyh.webp",
                "title": "Co1y9xhvygyh.webp",
                "extension": "webp",
                "fileId": "c9c6b191-fb28-4627-8759-47743a72f75c",
                "fileURL": "/files/c9c6b191-fb28-4627-8759-47743a72f75c",
                "url": "/qlist-assets/c9c6b191-fb28-4627-8759-47743a72f75c.webp"
              }
            }
          },
          {
            "id": "LQx37V1St7",
            "type": "paragraph",
            "data": {
              "text": "خب حالا شراکت دَنون و اشتراوس و سرمایه‌گذاری در استارتاپ‌های اسرائیلی چه ارتباطی به ما مصرف‌کنندگان ایرانی دارد؟ آیا ما ایرانی‌ها هم مشتری دنون هستیم؟"
            }
          },
          {
            "id": "sch8n4NR3l",
            "type": "header",
            "data": {
              "text": "بخش سوم: کافیه لبخندش رو پیدا کنی!",
              "level": 2
            }
          },
          {
            "id": "i0dDDZYE4G",
            "type": "image",
            "data": {
              "caption": "پویش تبلیغاتی دنون برای تمایز محصولاتش از رقبا",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 1024,
                "height": 875,
                "size": "40512",
                "name": "vi23rvf2qxz8.webp",
                "title": "Vi23rvf2qxz8.webp",
                "extension": "webp",
                "fileId": "74dde232-7b79-4c1e-b950-4dcf0a5adc52",
                "fileURL": "/files/74dde232-7b79-4c1e-b950-4dcf0a5adc52",
                "url": "/qlist-assets/74dde232-7b79-4c1e-b950-4dcf0a5adc52.webp"
              }
            }
          },
          {
            "id": "263soOCm1_",
            "type": "paragraph",
            "data": {
              "text": "شرکت دنون فرانسه از سال 1386 فعالیت خود در ایران را از طریق تاسیس شرکت&nbsp;<a href=\"https://www.rrk.ir/News/ShowOldNews.aspx?Code=11395260\" target=\"_blank\">دنون سحر</a>&nbsp;با همکاری شرکت لبنیات سحر آغاز کرد. این حضور ابتدا با واردات محصول شروع شد. دنون سحر از 1388 تولید محصولات دنون در ایران را هم شروع کرد. تاریخچه کامل حضور دنون در ایران را می‌توانید&nbsp;<a href=\"https://danone.ir/about_danone/\" target=\"_blank\">اینجا</a>&nbsp;و در وبسایت خود شرکت ببینید. دنون در سال 1394 حضورش در ایران را با نام&nbsp;<a href=\"https://www.rrk.ir/News/ShowOldNews.aspx?Code=12343678\" target=\"_blank\">دنون لبنی پارس</a>&nbsp;ادامه داد."
            }
          },
          {
            "id": "Tur3CxM2uv",
            "type": "image",
            "data": {
              "caption": "طبق اسناد رسمی شرکت دنون، ۱۰۰ درصد مالکیت شرکت «دنون لبنی پارس» متعلق به دنون است.",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 1024,
                "height": 805,
                "size": "119882",
                "name": "3panfiskddbx.webp",
                "title": "3panfiskddbx.webp",
                "extension": "webp",
                "fileId": "63bc6556-9830-49ec-a5f9-131b0b5a22e0",
                "fileURL": "/files/63bc6556-9830-49ec-a5f9-131b0b5a22e0",
                "url": "/qlist-assets/63bc6556-9830-49ec-a5f9-131b0b5a22e0.webp"
              }
            }
          },
          {
            "id": "VombbR3QKA",
            "type": "image",
            "data": {
              "caption": "خانواده دنت مشهورترین محصول دنون در بازار ایران است.",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 1024,
                "height": 1024,
                "size": "104094",
                "name": "137b49rofop4.webp",
                "title": "137b49rofop4.webp",
                "extension": "webp",
                "fileId": "64618fb8-5ed5-4581-9f11-845163a377f1",
                "fileURL": "/files/64618fb8-5ed5-4581-9f11-845163a377f1",
                "url": "/qlist-assets/64618fb8-5ed5-4581-9f11-845163a377f1.webp"
              }
            }
          },
          {
            "id": "Kql3Q_Repb",
            "type": "paragraph",
            "data": {
              "text": "دنون در ایران علاوه بر فرآورده‌های لبنی، در دو حوزه&nbsp;آب‌های بسته‌بندی&nbsp;شیرِ خشک&nbsp;و&nbsp;غذای کودک&nbsp;هم حضور پررنگی دارد. دنون از سال 1388 تا 1400، آب معدنی دماوند را در اختیار داشت، اما با سرمایه‌گذاری شرکت فرمینوست فرانسه در سال 1400، و با توجه به&nbsp;<a href=\"https://rasm.io/News/Details/17328101/\" target=\"_blank\">آگهی‌های اخیر این شرکت</a>، به نظر می‌رسد دنون دیگر در این شرکت سهم قابل توجهی ندارد."
            }
          },
          {
            "id": "Ef79Mib08m",
            "type": "paragraph",
            "data": {
              "text": "اما در صنعت شیر خشک، 60 درصد سهام شرکت&nbsp;صنایع پودر شیر مشهد(نوتریشیا ام ام پی)&nbsp;متعلق به دنون است.<a href=\"https://www.danone.com/content/dam/corp/global/danonecom/investors/danone-at-a-glance/listofsubsidiairies2022amf.pdf\" target=\"_blank\">(گزارش رسمی سال 2023 دنون)</a>. فعالیت دنون در حوزه تغذیه کودک از مسیر زیرمجموعه‌های آن یعنی نوتریشیا و میلوپا است. در واقع&nbsp;نوتریشیا ام ام پی&nbsp;نماینده دنون نوتریشیا در ایران است."
            }
          },
          {
            "id": "FgqXO85Zqq",
            "type": "image",
            "data": {
              "caption": "بخش «درباره ما» در وبسایت صنایع پودر شیر مشهد",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 1024,
                "height": 488,
                "size": "73042",
                "name": "sqzphidz8voa.webp",
                "title": "Sqzphidz8voa.webp",
                "extension": "webp",
                "fileId": "3193a059-893c-4c09-89b5-bcfd386791f0",
                "fileURL": "/files/3193a059-893c-4c09-89b5-bcfd386791f0",
                "url": "/qlist-assets/3193a059-893c-4c09-89b5-bcfd386791f0.webp"
              }
            }
          },
          {
            "id": "oQI1dLSv9q",
            "type": "paragraph",
            "data": {
              "text": "دنون در بازار شیرخشک ایران با دو برند&nbsp;آپتامیل&nbsp;و&nbsp;ببلاک میلوپا&nbsp;حضور دارد. محصولات ذکر شده در کارخانه صنایع پودر شیر مشهد تولید می‌شوند."
            }
          },
          {
            "id": "Sw7nYRimmF",
            "type": "image",
            "data": {
              "caption": "آپتامیل محصول میلوپا و ببلاک محصول نوتریشیا هر دو از زیرمجموعه‌های دنون هستند.",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 1024,
                "height": 826,
                "size": "73142",
                "name": "m1pyriklnygn.webp",
                "title": "M1pyriklnygn.webp",
                "extension": "webp",
                "fileId": "7926addf-7976-4182-a787-bf8d60938baf",
                "fileURL": "/files/7926addf-7976-4182-a787-bf8d60938baf",
                "url": "/qlist-assets/7926addf-7976-4182-a787-bf8d60938baf.webp"
              }
            }
          },
          {
            "id": "dU9TAr7Uc6",
            "type": "header",
            "data": {
              "text": "گنبد آهنین اقتصادی",
              "level": 4
            }
          },
          {
            "id": "jgRQftd6eM",
            "type": "paragraph",
            "data": {
              "text": "شاید آوازه سامانه پدافند هوایی اسرائیل‌ را شنیده باشید. سامانه‌ای که طراحی شده تا اثر راکت‌ها، پهپادها و موشک‌هایی که به سمت اسرائیل پرتاب می‌شوند را خنثی کند. این دقیقا کاری است که امثال دنون برای اقتصاد اسرائیل انجام می‌دهند. هر بار که مشکلات داخلی یا جنگ، ضربه‌ای به اقتصاد اسرائیل وارد می‌کنند، دنون، با پشتیبانی و سرمایه‌گذاری‌اش، این اثر را خنثی می‌کنند. دنون قبلاً یک مرتبه و به مدت 14 سال مجبور به عقب‌نشینی از ارتباطش با صهیونیست‌ها شده است. آیا امکان دارد این اتفاق باز هم تکرار شود؟"
            }
          },
          {
            "id": "xfIl-ElaJP",
            "type": "paragraph",
            "data": {
              "text": "حالا زمانی که دارید از طعم دسر فرانسوی، لذت می‌برید یا برای نوزادتان شیرخشک آپتامیل یا بِبِلاک آماده می‌کنید، ربطش را به اقتصاد اسرائیل بهتر می‌دانید. ربطی که دانستنش حق هر مصرف‌کننده ایرانی است."
            }
          }
        ]
      },
      "bodyEn": {
        "version": "2.30.7",
        "blocks": [
          {
            "id": "ialv0xYISb",
            "type": "header",
            "data": {
              "text": "\"Danone\": a French dessert with Hebrew garnish",
              "level": 2
            }
          },
          {
            "id": "2SszbyUo9s",
            "type": "image",
            "data": {
              "caption": "",
              "file": {
                "fileId": "bc7560c9-cabe-4df1-9463-778806a50828"
              }
            }
          },
          {
            "id": "lF4S4UuJ0s",
            "type": "quote",
            "data": {
              "text": "You've certainly heard the name \"Danette\" before. Milk-based desserts that have for years been carving a place in Iranian families' shopping baskets as a healthy, tasty snack for children. And if you've had to deal with a newborn you definitely recognise names like \"Aptamil\" and \"Bebelac\" in the infant-formula market — formulas that, alongside Nestlé products, are the best-sellers of the Iranian formula market. These are a portion of the products of the multinational mega-corporation \"Danone\" that have an official presence in our country's market. A mega-corporation that has always been one of the supporters of Israel, a fixture on every boycott list of pro-Palestinian movements. But is Danone really, as they say, a supporter of and connected to the Israelis? When we put a spoonful of cold, fresh French dessert in our mouths and enjoy its delicious taste, do we really need to worry about helping Israel's economy? Stay with us as we examine this strange claim."
            }
          },
          {
            "id": "o1LY_s3Sc1",
            "type": "header",
            "data": {
              "text": "Part one: I invest, therefore I am!",
              "level": 2
            }
          },
          {
            "id": "qO0mQ77nWz",
            "type": "image",
            "data": {
              "caption": "",
              "file": {
                "fileId": "1a999fc5-50d3-48c0-b691-dc071b1fff99"
              }
            }
          },
          {
            "id": "B7PYekQU5u",
            "type": "paragraph",
            "data": {
              "text": "Danone is one of the largest food companies in the world. According to the company's financial documents, in 2023 — with €27.6 billion in worldwide sales — it ranked first among companies in dairy, plant-based and beverages; second in bottled waters and infant nutrition; and fourth in adult food. <a href=\"https://www.danone.com/content/dam/corp/global/danonecom/investors/en-all-publications/2023/integratedreports/integratedannualreport2023.pdf\" target=\"_blank\">(Danone website)</a>. But how has this food giant ended up on the Zionist-goods boycott list?"
            }
          },
          {
            "id": "J18dVuOuMp",
            "type": "paragraph",
            "data": {
              "text": "The story begins with Danone's interest in investing in Israeli companies. For example, in a single round in 2023 Danone invested $4 million in a newly founded Israeli technology company called \"Wilk\". <a href=\"https://www.jpost.com/business-and-innovation/banking-and-finance/article-743853\" target=\"_blank\">(The Jerusalem Post)</a>. This start-up's field is producing dairy products via the cells that produce them. You might say $4 million is not a big number for a multi-billion-dollar company. You'd be right! Although for a new start-up it's a notable sum, in fact what matters more about this investment than the amount is something else:"
            }
          },
          {
            "id": "hLLNtGtUXW",
            "type": "quote",
            "data": {
              "text": "\"An investment of about $4 million in an Israeli tech company — even when investment in the local tech sector has dropped sharply — is not [much of a] big deal. But this time, instead of the amount, it is the identity of the investors that is notable. So this funding round for the tech firm Wilk can be called a commercial breakthrough.\"",
              "caption": "Source: The Jerusalem Post"
            }
          },
          {
            "id": "v6KbyZzRvs",
            "type": "paragraph",
            "data": {
              "text": "The Jerusalem Post columnist explains the importance of this investment well. The data shows that the rate of foreign investment in Israel, despite many incentives in recent years, has been wave-like. The figure in Q1 2023 was around $1.7 billion — the lowest level since 2019. <a href=\"https://sciencebusiness.net/network-updates/israeli-high-tech-sector-risk-splitting-away-global-trends-israel-innovation\" target=\"_blank\">(Science Business)</a>. Internal disagreements over judicial reforms appear to have been the main reason for this drop:"
            }
          },
          {
            "id": "LQBvCHK8SR",
            "type": "quote",
            "data": {
              "text": "\"We are in the middle of a global crisis today and it's still too early to know when and how [this crisis] will end. A local crisis has been added on top of this, creating even more uncertainty [for investors]. [Even] if the judicial crisis is resolved, [it will still] take time to get out of it — and even then, rebuilding investor trust takes time.\"",
              "caption": "Dror Bin / CEO, Israel Innovation Authority — Source: Science Business"
            }
          },
          {
            "id": "KY2ydyCBTP",
            "type": "paragraph",
            "data": {
              "text": "Now imagine that in the middle of this crisis and the hesitation of foreign investors, a reputable name like Danone steps in with a few million dollars to turn the page and reassure hesitant investors (just like celebrities do for you in TV commercials for famous brands). The widespread coverage of this investment in Israeli media is due to precisely this advertising value."
            }
          },
          {
            "id": "F6pkFJwsK-",
            "type": "image",
            "data": {
              "caption": "Using familiar faces in commercial ads [top] / Wide coverage of Danone's investment in Israeli media, emphasising the credibility of the investor [bottom]",
              "file": {
                "fileId": "40d62404-321e-47a3-afca-46d3f252982b"
              }
            }
          },
          {
            "id": "MIZhuj-Iz9",
            "type": "paragraph",
            "data": {
              "text": "Less than a month later Danone made a similar investment in another Israeli start-up, \"ImaginDairy\" <a href=\"https://www.timesofisrael.com/israels-imagindairy-nabs-danone-as-strategic-investor-for-cow-free-dairy-products/\" target=\"_blank\">(The Times of Israel)</a>, showing that its investment in Israel was not an exception but a rule. But does the story of Danone and Israel begin in 2023 and is it limited to investing in Israeli start-ups?"
            }
          },
          {
            "id": "1Da8IzANfW",
            "type": "image",
            "data": {
              "caption": "\"Wilk\" and \"ImaginDairy\": Danone's most recent investments on the Danone Ventures website",
              "file": {
                "fileId": "712386e5-905c-4f28-818f-08dd3b3132fe"
              }
            }
          },
          {
            "id": "eyLTk_Hd7Y",
            "type": "header",
            "data": {
              "text": "Part two: \"Strauss\": Danone in Hebrew!",
              "level": 2
            }
          },
          {
            "id": "8hqtOpSYwI",
            "type": "image",
            "data": {
              "caption": "",
              "file": {
                "fileId": "64ddd0a4-0eef-4f1c-a2a3-bf9ae7c556ea"
              }
            }
          },
          {
            "id": "1r_09xIFRz",
            "type": "paragraph",
            "data": {
              "text": "Danone's interest in investing in Israel goes back 55 years. In 1969 Danone signed a cooperation agreement with an Israeli food company called \"Strauss\". That year Strauss got access to Danone's production knowledge and also took over distribution of various Danone products in Israel. In 1972 Danone and Strauss opened a new factory in Israel and began producing the \"Dani\" brand (which is our \"Danette\"), which brought significant success for both companies. <a href=\"https://www.strauss-group.com/partner/partnership_danone/\" target=\"_blank\">(Strauss website)</a>."
            }
          },
          {
            "id": "BPlCP_j6EZ",
            "type": "image",
            "data": {
              "caption": "The start of Strauss and Danone's cooperation in the company's timeline on the Strauss website",
              "file": {
                "fileId": "a136e893-060f-4249-b647-9f9c8e7e02f7"
              }
            }
          },
          {
            "id": "sNZ7FYzyva",
            "type": "header",
            "data": {
              "text": "An unbreakable bond",
              "level": 4
            }
          },
          {
            "id": "CWHGEb5EBl",
            "type": "paragraph",
            "data": {
              "text": "After a decade of successful cooperation, in 1982 — to stay safe from the <a href=\"https://en.wikipedia.org/wiki/Arab_League_boycott_of_Israel\" target=\"_blank\">\"Arab boycott of Israeli goods\"</a> — Danone decided to end the partnership. That separation lasted 14 years, until in 1996, after the Arab-boycott danger had passed, Danone returned with a big investment, this time acquiring 20% of Strauss Dairy. Strauss refers to this as \"the great return\"."
            }
          },
          {
            "id": "AXNKNlGgKP",
            "type": "image",
            "data": {
              "caption": "The story of Danone's \"great return\" to cooperation with Strauss",
              "file": {
                "fileId": "4af9d39d-d405-432b-95a4-15ebaef239ba"
              }
            }
          },
          {
            "id": "9iB2-V1Bug",
            "type": "paragraph",
            "data": {
              "text": "The Strauss website considers this move an effective factor in facilitating innovation and growth at Strauss, as well as in producing and selling Danone products via this Israeli company:"
            }
          },
          {
            "id": "LziEY5C1QU",
            "type": "quote",
            "data": {
              "text": "\"Our activity in Israel is accompanied by a set of strategic partnerships with global food manufacturers; the Danone Group owns 20% of Strauss Dairy, and PepsiCo is a 50% partner in our salty snacks. These constructive long-term partnerships have enabled us to build extensive and stable professional and commercial infrastructure.\"",
              "caption": "Source: Strauss website"
            }
          },
          {
            "id": "ABw114tPOW",
            "type": "paragraph",
            "data": {
              "text": "But what had Strauss done that Danone, fearing the Arab boycott, gave up the partnership for 14 years?"
            }
          },
          {
            "id": "p9dsK32uUT",
            "type": "header",
            "data": {
              "text": "Israel is my home!",
              "level": 4
            }
          },
          {
            "id": "F5Hk9Mmi2n",
            "type": "quote",
            "data": {
              "text": "\"Israel is our true home, a wellspring of culture that became the foundation of our value-driven work and professional knowledge. Israel's largest food company was born with a Zionist ideology, love of homeland(!) and generosity.\"",
              "caption": "Source: Strauss website"
            }
          },
          {
            "id": "nN2gnPRNK2",
            "type": "image",
            "data": {
              "caption": "",
              "file": {
                "fileId": "53211373-644c-40d4-9a7f-a584f589d51d"
              }
            }
          },
          {
            "id": "4ZUEL3fHGw",
            "type": "paragraph",
            "data": {
              "text": "This is part of Strauss's self-introduction on its own official website. Strauss, which by its own description is Israel's largest food company and the leader of the Israeli food market, has been active in the occupied territories for over 80 years; some 6,500 people work at its more than 20 production sites across occupied Palestine. According to its own website, Strauss has always kept over 50% of its turnover inside Israel. <a href=\"https://www.strauss-group.com/location/strauss_israel/\" target=\"_blank\">(Strauss website)</a>"
            }
          },
          {
            "id": "qty7L8y5BU",
            "type": "paragraph",
            "data": {
              "text": "What's interesting about Strauss is precisely these sharp political and ideological attitudes. Strauss truly considers itself a Zionist brand committed to Israel's ideals."
            }
          },
          {
            "id": "lJDc-qQpQF",
            "type": "image",
            "data": {
              "caption": "Strauss products in the hands of Zionist soldiers in the company's promotional video",
              "file": {
                "fileId": "d0ff83e9-42f6-4b9d-9d9b-cba6e763558a"
              }
            }
          },
          {
            "id": "pDWALdeXAD",
            "type": "paragraph",
            "data": {
              "text": "Despite Strauss's international operations, the Israeli flag and images of Zionist soldiers appear all over the company's website. After the clashes following 7 October 2023 [Operation Al-Aqsa Storm], Strauss launched a campaign called \"Always Together\". On the website's front page, under this very campaign, promotional images of Zionist soldiers celebrating with the company's products are displayed."
            }
          },
          {
            "id": "2dkXFrQDUV",
            "type": "paragraph",
            "data": {
              "text": "<a href=\"https://www.namasha.com/v/jD9QqxfH\">The company's promotional video introducing the \"Always Together\" campaign</a>"
            }
          },
          {
            "id": "9qyYC864du",
            "type": "paragraph",
            "data": {
              "text": "Across various pages about this campaign, the company's commitment to supporting settlers within range of Hamas rockets — and to not shutting down operations in areas near Gaza — is emphasised. Strauss has also supported residents displaced from war zones. <a href=\"https://www.strauss-group.com/sustainability/stronger-together/hugs-and-gift-packs-for-the-kibbutz-communities/\" target=\"_blank\">(Strauss website)</a>. These pages also extensively mention occupied settlements where Strauss has some kind of presence and operations, including a chip-production factory in Sderot <a href=\"https://www.strauss-group.com/sustainability/stronger-together/hugs-and-gift-packs-for-the-kibbutz-communities/\" target=\"_blank\">(Strauss website)</a>. More strikingly, at the bottom of every page of the company's website there's a countdown for the release of Israeli hostages in Gaza."
            }
          },
          {
            "id": "ASG6ekjf1H",
            "type": "quote",
            "data": {
              "text": "\"As a company whose roots have grown from the very history of the country(!) of Israel, our products and brands have a strong connection with [Israeli] consumers, accompany them in their daily lives, and are a central part of recognition in every [Israeli] home.\"",
              "caption": "Source: Strauss website"
            }
          },
          {
            "id": "0cQp11qesy",
            "type": "paragraph",
            "data": {
              "text": "According to its own account, Strauss helped the Israeli army during the fourth Arab-Israeli war (the Yom Kippur war) in 1973 as well. In a section of the company's history titled \"At the war front, at the front lines of the economy\", Strauss mentions running its production lines 24 hours a day during the war to meet the military's needs. The reason Strauss was placed on the Arab boycott list was precisely this active participation in wars."
            }
          },
          {
            "id": "Bd0Oxhsh-s",
            "type": "image",
            "data": {
              "caption": "",
              "file": {
                "fileId": "c9c6b191-fb28-4627-8759-47743a72f75c"
              }
            }
          },
          {
            "id": "LQx37V1St7",
            "type": "paragraph",
            "data": {
              "text": "OK, so what does Danone's partnership with Strauss and its investment in Israeli start-ups have to do with us, Iranian consumers? Are we Iranians also Danone customers?"
            }
          },
          {
            "id": "sch8n4NR3l",
            "type": "header",
            "data": {
              "text": "Part three: Just find its smile!",
              "level": 2
            }
          },
          {
            "id": "i0dDDZYE4G",
            "type": "image",
            "data": {
              "caption": "Danone's advertising campaign to differentiate its products from competitors",
              "file": {
                "fileId": "74dde232-7b79-4c1e-b950-4dcf0a5adc52"
              }
            }
          },
          {
            "id": "263soOCm1_",
            "type": "paragraph",
            "data": {
              "text": "Danone France began its activities in Iran in 2007 (1386) through the establishment of <a href=\"https://www.rrk.ir/News/ShowOldNews.aspx?Code=11395260\" target=\"_blank\">Danone Sahar</a> in cooperation with Sahar Dairy. This presence initially started with importing products. From 2009 (1388) Danone Sahar also began producing Danone products in Iran. You can see the full history of Danone's presence in Iran <a href=\"https://danone.ir/about_danone/\" target=\"_blank\">here</a> on the company's own website. In 2015 (1394) Danone continued its presence in Iran under the name <a href=\"https://www.rrk.ir/News/ShowOldNews.aspx?Code=12343678\" target=\"_blank\">Danone Lebani Pars</a>."
            }
          },
          {
            "id": "Tur3CxM2uv",
            "type": "image",
            "data": {
              "caption": "According to Danone's official documents, 100% of the ownership of \"Danone Lebani Pars\" belongs to Danone.",
              "file": {
                "fileId": "63bc6556-9830-49ec-a5f9-131b0b5a22e0"
              }
            }
          },
          {
            "id": "VombbR3QKA",
            "type": "image",
            "data": {
              "caption": "The Danette family is Danone's best-known product in the Iranian market.",
              "file": {
                "fileId": "64618fb8-5ed5-4581-9f11-845163a377f1"
              }
            }
          },
          {
            "id": "Kql3Q_Repb",
            "type": "paragraph",
            "data": {
              "text": "In addition to dairy products, Danone has a strong presence in Iran in two other areas: bottled water and infant formula and baby food. From 2009 (1388) to 2021 (1400) Danone owned Damavand mineral water, but with the 2021 investment by the French company Fromineust, and given <a href=\"https://rasm.io/News/Details/17328101/\" target=\"_blank\">the company's recent announcements</a>, Danone no longer appears to hold a significant share in that company."
            }
          },
          {
            "id": "Ef79Mib08m",
            "type": "paragraph",
            "data": {
              "text": "However, in the infant-formula industry, 60% of the shares of Mashhad Milk Powder Industries (Nutricia MMP) belong to Danone. <a href=\"https://www.danone.com/content/dam/corp/global/danonecom/investors/danone-at-a-glance/listofsubsidiairies2022amf.pdf\" target=\"_blank\">(Danone's official 2023 report)</a>. Danone's activity in child-nutrition runs through its subsidiaries — that is, Nutricia and Milupa. In fact, Nutricia MMP is Danone Nutricia's representative in Iran."
            }
          },
          {
            "id": "FgqXO85Zqq",
            "type": "image",
            "data": {
              "caption": "The \"About Us\" section on the Mashhad Milk Powder Industries website",
              "file": {
                "fileId": "3193a059-893c-4c09-89b5-bcfd386791f0"
              }
            }
          },
          {
            "id": "oQI1dLSv9q",
            "type": "paragraph",
            "data": {
              "text": "Danone is present in Iran's infant-formula market with two brands: Aptamil and Bebelac Milupa. The products mentioned are produced at the Mashhad Milk Powder Industries factory."
            }
          },
          {
            "id": "Sw7nYRimmF",
            "type": "image",
            "data": {
              "caption": "Aptamil, a Milupa product, and Bebelac, a Nutricia product — both subsidiaries of Danone.",
              "file": {
                "fileId": "7926addf-7976-4182-a787-bf8d60938baf"
              }
            }
          },
          {
            "id": "dU9TAr7Uc6",
            "type": "header",
            "data": {
              "text": "An economic Iron Dome",
              "level": 4
            }
          },
          {
            "id": "jgRQftd6eM",
            "type": "paragraph",
            "data": {
              "text": "You may have heard of Israel's air-defence system — the system designed to neutralise the impact of rockets, drones and missiles launched towards Israel. This is exactly what the likes of Danone do for Israel's economy. Every time internal problems or war strike a blow to Israel's economy, Danone — with its backing and investment — neutralises that blow. Danone has previously, once, been forced to retreat from its ties to the Zionists for 14 years. Is it possible this happens again?"
            }
          },
          {
            "id": "xfIl-ElaJP",
            "type": "paragraph",
            "data": {
              "text": "Now, when you're enjoying the taste of French dessert or preparing Aptamil or Bebelac infant formula for your baby, you'll better understand its connection to Israel's economy — a connection that every Iranian consumer has the right to know."
            }
          }
        ]
      }
    },
    {
      "slug": "unilever",
      "sourceUrl": "https://qlist.ir/blog/unilever/",
      "companySlug": "unilever",
      "title": {
        "en": "Everything about boycotting Unilever: from supporting Israel to its official presence in Iran",
        "fa": "همه چیز درباره تحریم یونیلیور؛ حمایت از اسرائیل تا حضور رسمی در ایران"
      },
      "summary": {
        "en": "An introduction to Unilever, documentation of its support for Israel and its presence in the Iranian market, citing official sources.",
        "fa": "معرفی شرکت یونیلیور، مستندات حمایت از اسرائیل و حضور در بازار ایران با استناد به منابع رسمی"
      },
      "cover": null,
      "body": {
        "time": 1769935915234,
        "version": "2.31.0-rc.7",
        "blocks": [
          {
            "id": "NLpuzU3Ypf",
            "type": "quote",
            "data": {
              "text": "پشت بخش بزرگی از تمیزی‌ها و درخشش‌های روزانه ما ایرانی‌‌ها یک حرف U مخفی شده است که معمولاً کسی آن را نمی‌بیند؛ یک حرف U زیبا که از جمع شدن نمادهای زندگی کنار هم تشکیل شده است. نمادی که به عنوان یکی موفق‌ترین برندهای جهان شناخته می‌شود. اما آیا سیاست‌های این برند هم به اندازه نشانه‌اش سرشار از زندگی است؟ در این یادداشت قصد داریم به شرح ارتباط پر فراز و نشیب یونیلیور با رژیم اسرائیل و همچنین نحوه حضورش در ایران بپردازیم. با ما همراه باشید.",
              "caption": "",
              "alignment": "left"
            }
          },
          {
            "id": "2FIz5XG6wA",
            "type": "image",
            "data": {
              "caption": "نشان شرکت یونیلیور",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 1024,
                "height": 499,
                "size": "37340",
                "name": "6mjfxo3im6ga.webp",
                "title": "6mjfxo3im6ga.webp",
                "extension": "webp",
                "fileId": "5edb453a-34e1-42c5-b6fc-bde2b165bca4",
                "fileURL": "/files/5edb453a-34e1-42c5-b6fc-bde2b165bca4",
                "url": "/qlist-assets/5edb453a-34e1-42c5-b6fc-bde2b165bca4.webp"
              }
            }
          },
          {
            "id": "oL_YOOxHxO",
            "type": "paragraph",
            "data": {
              "text": "درباره&nbsp;یونیلیوِر&nbsp;صحبت می‌کنیم. شرکت چند ملیتی با ریشه انگلیسی- هلندی که امروزه ششمین شرکت پردرآمد دنیا در حوزه محصولات مصرفی و چهل و پنجمین شرکت ارزشمند جهان است.&nbsp;<a href=\"https://www.statista.com/companies/ranking/3/top-100-consumer-goods-and-fmcg-companies\" target=\"_blank\">(منبع:استاتیستا)</a><a href=\"https://www.statista.com/statistics/263264/top-companies-in-the-world-by-market-capitalization/\" target=\"_blank\">(استاتیستا)</a>&nbsp;برای ملموس‌تر شدن این اعداد کافیست بدانیم که درآمد این شرکت در سال 2023 بیش از 59 میلیارد دلار بوده و تولیداتش در 190 کشور جهان از جمله فلسطین اشغالی (اسرائیل) و ایران به فروش می‌رسد.&nbsp;<a href=\"https://www.unilever.com/files/66bc4aea-608f-46ee-8da3-cde0ec8ebe90/unilever-annual-report-and-accounts-2023.pdf\" target=\"_blank\">(وبسایت رسمی یونیلیوِر)</a>"
            }
          },
          {
            "id": "QBn7V4U_Rp",
            "type": "image",
            "data": {
              "caption": "ساختمان مرکزی یونیلیور در لندن",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 1024,
                "height": 705,
                "size": "96122",
                "name": "imvzmmiorvfv.webp",
                "title": "Imvzmmiorvfv.webp",
                "extension": "webp",
                "fileId": "e1b3dc02-3813-4933-be7f-204164d376d1",
                "fileURL": "/files/e1b3dc02-3813-4933-be7f-204164d376d1",
                "url": "/qlist-assets/e1b3dc02-3813-4933-be7f-204164d376d1.webp"
              }
            }
          },
          {
            "id": "johFGTNvy0",
            "type": "header",
            "data": {
              "text": "شرکت انگلیسی در قلمرو انگلیسی",
              "level": 2
            }
          },
          {
            "id": "1r7vGxv5e_",
            "type": "paragraph",
            "data": {
              "text": "سابقه فعالیت یونیلیور در فلسطین اشغالی (اسرائیل) به زمانی برمی‌گردد که هنوز اسرائیلی وجود نداشت. یونیلیور در سال 1938 یعنی یک دهه پس از جنگ جهانی اول، با تاسیس یک کارخانه محصولات غذایی پا به سرزمین فلسطین گذاشت.&nbsp;<a href=\"https://www.unilever.co.il/our-company/\" target=\"_blank\">(وبسایت رسمی یونیلیور)</a>&nbsp;در آن زمان فلسطین به واسطه انحلال حکومت عثمانی تحت قیمومت دولت انگلیس درآمده بود. در راستای تعهدات اعلامیه بالفور، موج مهاجرت یهودیان و درگیری‌هایشان با مردم فلسطین برای یهودی‌سازی آن، روز به روز بیشتر می‌شد. این روند آنقدر پیش رفت تا در سال 1948 رژیم اسرائیل رسماً اعلام موجودیت کرد.&nbsp;<a href=\"https://aje.io/8mqot4\" target=\"_blank\">(منبع: الجزیره)</a>"
            }
          },
          {
            "id": "z0S3_pC9d-",
            "type": "paragraph",
            "data": {
              "text": "حضور یونیلیور در فلسطین اشغالی(اسرائیل) پس از&nbsp;<a href=\"https://en.wikipedia.org/wiki/Arab_League_boycott_of_Israel\" target=\"_blank\">تحریم‌های اتحادیه عرب</a>&nbsp;با چالش‌هایی مواجه بود، اما پس از کم فروغ شدن این تحریم‌ها، شرکت، فعالیت در این سرزمین را با اشتیاق بیشتری دنبال کرد. یونیلیور با سرمایه‌گذاری و خرید سهام شرکت‌های اسرائیلی حجم تولید و سبد محصولات خود در این منطقه را به طور قابل توجهی گسترش داد. برای مثال می‌توان به سرمایه‌گذاری 13 میلیون دلاری در شرکت ویتکو/Vitco در سال 1996 و ورود به حوزه بهداشتی و آرایشی در بازار اسرائیل اشاره کرد.&nbsp;<a href=\"https://en.globes.co.il/en/article-373057\" target=\"_blank\">(منبع: روزنامه اسرائیلی گلوبز)</a>&nbsp;یونیلیور یک سال قبل نیز پنجاه درصد از سهام بخش تولید بستنی شرکت اشتراوس اسرائیل را خریداری کرده بود. غول انگلیسی-هلندی به مرور بقیه سهام بستنی اشتراوس را هم خریدد تا بالاخره در سال 2014 مالک کل آن شد.&nbsp;<a href=\"https://www.strauss-group.com/about-us/history_and_legacy/\" target=\"_blank\">(وبسایت گروه اشتراوس)</a>&nbsp;پیش از آن نیز یونیلیور در دهه 90 میلادی شرکت صنایع غذایی بِست‌فودز و تامی اسرائیل را به تملک خود درآورده بود.&nbsp;<a href=\"https://www.just-food.com/news/israel-unilever-takes-control-of-strauss-ice-cream/?cf-view\" target=\"_blank\">(منبع: جاست‌فود)</a>"
            }
          },
          {
            "id": "tVdPFR0HKT",
            "type": "image",
            "data": {
              "caption": "روایت شراکت یونیلیور و اشتراوس در سایت رسمی اشتراوس",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 1024,
                "height": 420,
                "size": "37868",
                "name": "cdixijn7pveh.webp",
                "title": "Cdixijn7pveh.webp",
                "extension": "webp",
                "fileId": "d9f48f6f-2168-4df5-a5a1-d0eba1f8ceae",
                "fileURL": "/files/d9f48f6f-2168-4df5-a5a1-d0eba1f8ceae",
                "url": "/qlist-assets/d9f48f6f-2168-4df5-a5a1-d0eba1f8ceae.webp"
              }
            }
          },
          {
            "id": "uW_LLNK2DY",
            "type": "paragraph",
            "data": {
              "text": "طبق گزارش سالیانه 2023، یونیلیور با مالکیت هشت شرکت در اسرائیل به صورت یکپارچه تحت عنوان «یونیلیور اسرائیل» مشغول فعالیت است.&nbsp;<a href=\"https://www.unilever.com/files/92ui5egz/production/b09c3510ee7cec58440d5f044f02bdefe85aa186.pdf\" target=\"_blank\">(وبسایت یونیلیور)</a>"
            }
          },
          {
            "id": "fqs-RwMz9P",
            "type": "paragraph",
            "data": {
              "text": "یونیلیور اسرائیل چهار کارخانه در شهرهای عراد، صفد، عکّا و حیفا داشته و برای 1850 نفر در اقتصاد اسرائیل شغل ایجاد کرده است.&nbsp;<a href=\"https://www.unilever.co.il/our-company/our-factories/\" target=\"_blank\">(منبع: یونیلیور اسرائیل)</a><a href=\"https://www.unilever.co.il/our-company/\" target=\"_blank\">(یونیلیور اسرائیل)</a>"
            }
          },
          {
            "id": "M4qWU3o3gF",
            "type": "image",
            "data": {
              "caption": "",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 1200,
                "height": 675,
                "size": "137040",
                "name": "ailqqupba9tw.jpg",
                "title": "Ailqqupba9tw.jpg",
                "extension": "jpg",
                "fileId": "f39f2528-e529-488a-b5ff-59fb4ef6682f",
                "fileURL": "/files/f39f2528-e529-488a-b5ff-59fb4ef6682f",
                "url": "/qlist-assets/f39f2528-e529-488a-b5ff-59fb4ef6682f.jpg"
              }
            }
          },
          {
            "id": "zzVY7d9C5Q",
            "type": "image",
            "data": {
              "caption": "تصاویری از کارخانجات یونیلیور در اسرائیل",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 1200,
                "height": 675,
                "size": "114537",
                "name": "banlhrrpwhso.jpg",
                "title": "Banlhrrpwhso.jpg",
                "extension": "jpg",
                "fileId": "4d0a0933-f5a1-47d0-901f-e2f1ed1b6337",
                "fileURL": "/files/4d0a0933-f5a1-47d0-901f-e2f1ed1b6337",
                "url": "/qlist-assets/4d0a0933-f5a1-47d0-901f-e2f1ed1b6337.jpg"
              }
            }
          },
          {
            "id": "VIGIAnjNOv",
            "type": "header",
            "data": {
              "text": "بستنی دردسرساز",
              "level": 3
            }
          },
          {
            "id": "FnxtczCoZw",
            "type": "paragraph",
            "data": {
              "text": "یونیلیور اغلب در میان جنبش‌های حامی فلسطین متهم به حمایت از رژیم اسرائیل بوده است. اما چیزی که در سال‌های اخیر دوباره توجهات را به طور خاص به این شرکت معطوف کرد ماجرای&nbsp;بِن و جِری&nbsp;در شهرک‌های اشغالی بود."
            }
          },
          {
            "id": "1XL9NEPPjB",
            "type": "paragraph",
            "data": {
              "text": "یونیلیور در حال حاضر یکی از سه کسب‌وکار بزرگ بستنی در جهان است.&nbsp;<a href=\"https://www.insidermonkey.com/blog/5-biggest-ice-cream-companies-in-the-world-1103401/3/\" target=\"_blank\">(وبسایت اینسایدِرمانکی)</a>&nbsp;این شرکت به اتکای برندهایی همچون بن و جری و مگنوم در سال 2023 نزدیک به 8 میلیارد یورو از فروش بستنی درآمد کسب کرده است.&nbsp;<a href=\"https://www.unilever.com/files/66bc4aea-608f-46ee-8da3-cde0ec8ebe90/unilever-annual-report-and-accounts-2023.pdf\" target=\"_blank\">(گزارش سالانه یونیلیور)</a>&nbsp;بِن و جِری یک برند آمریکایی مشهور تولیدکننده بستنی است که تلاش دارد توجه به موضوعات اجتماعی را بخشی از هویت خود نشان دهد. این شرکت در سال 2000 توسط یونیلیور خریداری شد.&nbsp;<a href=\"https://www.unileverusa.com/brands/ice-cream/ben-jerrys/\" target=\"_blank\">(یونیلیور آمریکا)</a>"
            }
          },
          {
            "id": "f4PVBtKvbw",
            "type": "paragraph",
            "data": {
              "text": "هیئت مدیره بن و جری در سال 2021 طی بیانیه‌ای اعلام کرد که به خاطر نقض گسترده قوانین بین‌الملل و حقوق بشر توسط رژیم اسرائیل، فعالیت خود در شهرک‌های اشغالی فلسطین‌ را پایان خواهد داد. در توضیح چرایی این تصمیم آمده بود که تولید یا فروش محصول در شهرک‌های صهیونیستی با ارزش‌های مورد تاکید این شرکت از جمله حقوق بشر در تناقض است. بن و جری البته تصریح کرد که به فروش محصولاتش در سایر سرزمین‌های فلسطین اشغالی (اسرائیل) ادامه می‌دهد. قرار بود این تصمیم بعد از سال 2022 و با پایان قرارداد بن و جری با نماینده انحصاری آن در فلسطین اشغالی (اسرائیل) اجرایی شود.&nbsp;<a href=\"https://www.benjerry.com/about-us/media-center/opt-statement\" target=\"_blank\">(بسایت رسمی بن و جری)</a>&nbsp;<a href=\"https://www.nbcnews.com/business/business-news/ben-jerry-s-withdraws-sales-israeli-settlements-clashes-parent-company-n1274403\" target=\"_blank\">(NBCNews)</a>"
            }
          },
          {
            "id": "Xnlto83xcD",
            "type": "image",
            "data": {
              "caption": "کارخانه بن وجری در بعرتوفیا-فلسطین اشغالی(اسرائیل)",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 1024,
                "height": 683,
                "size": "71090",
                "name": "jbxllkclrwan.webp",
                "title": "Jbxllkclrwan.webp",
                "extension": "webp",
                "fileId": "38f0fd8f-ef19-4d7b-a008-cc59250f89b0",
                "fileURL": "/files/38f0fd8f-ef19-4d7b-a008-cc59250f89b0",
                "url": "/qlist-assets/38f0fd8f-ef19-4d7b-a008-cc59250f89b0.webp"
              }
            }
          },
          {
            "id": "KUXtYrFrOj",
            "type": "paragraph",
            "data": {
              "text": "این تصمیم، مورد حمایت جنبش‌های حامی فلسطین از جمله بی‌دی‌اس و همزمان مورد انتقاد نهادهای طرفدار رژیم اسرائیل قرار گرفت.&nbsp;<a href=\"https://bdsmovement.net/news/unilever-stop-undermining-ben-jerrys-decision-end-israel-settlement-business\" target=\"_blank\">(BDS)</a>&nbsp;یکی از اولین واکنش‌ها را وزیر داخلی وقت رژیم اسرائیل به این موضوع داشت. او یک هفته پس از اعلام تصمیم بن و جری گفت مقامات رژیم در تلاش هستند تا با کمک جوامع یهودی و حامیان اسرائیل در آمریکا، این شرکت را به صورت مردمی تحریم و از تصمیم خود منصرف کنند.&nbsp;<a href=\"https://www.timesofisrael.com/interior-minister-israel-drumming-up-us-grassroots-boycott-of-ben-jerrys/\" target=\"_blank\">(تایمز اسرائیل)</a>"
            }
          },
          {
            "id": "7FU4EHLS_g",
            "type": "image",
            "data": {
              "caption": "تجمع حامیان رژیم اسرائیل در منهتن نیویورک برای اعتراض و دعوت به تحریم بن و جری - 2021",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 1024,
                "height": 640,
                "size": "106344",
                "name": "ujt2eglfqmhf.webp",
                "title": "Ujt2eglfqmhf.webp",
                "extension": "webp",
                "fileId": "83c5b7c7-fd14-4bfc-bb1d-23389baf52d6",
                "fileURL": "/files/83c5b7c7-fd14-4bfc-bb1d-23389baf52d6",
                "url": "/qlist-assets/83c5b7c7-fd14-4bfc-bb1d-23389baf52d6.webp"
              }
            }
          },
          {
            "id": "XbYYYPZNBG",
            "type": "paragraph",
            "data": {
              "text": "حتی برخی از سهامداران عمده یونیلیور به صورت تلویحی یا با صراحت شرکت را بابت تصمیم جنجالی زیرمجموعه‌اش تهدید کرند.&nbsp;<a href=\"https://www.reuters.com/markets/europe/unilever-expects-new-ben-jerrys-arrangement-israel-by-year-end-2022-02-10/\" target=\"_blank\">(رویترز)</a>&nbsp;جالب اینکه لابی‌ها و شخصیت‌های مختلف نیز بر یونیلیور فشار وارد کردند تا این تصمیم هرچه زودتر لغو شود اما این مساله تاثیری بر اراده مدیران بن و جری نگذاشت.&nbsp;<a href=\"https://thehill.com/homenews/state-watch/566069-florida-takes-action-against-ben-jerrys-parent-company-amid-boycott/\" target=\"_blank\">(مجله THE HILL)</a>&nbsp;در مقاله روزنامه دیلی‌مِیل به برخی از فشارهای شکل گرفته حول این موضوع اشاره شده است.&nbsp;<a href=\"https://www.dailymail.co.uk/news/article-9814063/Unilever-chief-says-company-fully-committed-Israel.html\" target=\"_blank\">(دِیلی‌مِیل)</a>"
            }
          },
          {
            "id": "EMCUofDlGo",
            "type": "image",
            "data": {
              "caption": "آیلت شاکد وزیر داخلی وقت رژیم صهیونیستی در بازدید از کارخانه بن و جری در اسرائیل - ژوئیه 2021",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 1024,
                "height": 681,
                "size": "79868",
                "name": "6x3zwxgy8cwr.webp",
                "title": "6x3zwxgy8cwr.webp",
                "extension": "webp",
                "fileId": "4b478e80-2c4a-4a9f-97f9-446e5aaeac45",
                "fileURL": "/files/4b478e80-2c4a-4a9f-97f9-446e5aaeac45",
                "url": "/qlist-assets/4b478e80-2c4a-4a9f-97f9-446e5aaeac45.webp"
              }
            }
          },
          {
            "id": "vkdzzoBpmD",
            "type": "paragraph",
            "data": {
              "text": "در این میان آلن جوپ مدیر عامل وقت شرکت یونیلیور (مالک بن و جری) نیز در کنار منتقدان قرار گرفت و اعلام کرد که «بهتر است برندهای زیرمجموعه یونیلیور در موضوعاتی که در آن تخصص ندارند ورود نکنند». صحبت‌های جوپ نشان می‌داد که یونیلیور درحال اعمال فشار بر بن و جری است. او همچنین گفت که «یونیلیور در تلاش است تا در مقابل تصمیم هیئت مدیره بن و جری راهی برای فروش مجدد محصولات این شرکت در شهرک‌ها پیدا کند».&nbsp;<a href=\"https://www.reuters.com/markets/europe/unilever-expects-new-ben-jerrys-arrangement-israel-by-year-end-2022-02-10/\" target=\"_blank\">(رویترز)</a>&nbsp;جوپ اطمینان داد که «شرکت تحت مدیریتش&nbsp;به طور کامل به تجارت با اسرائیل متعهد است.»&nbsp;<a href=\"https://www.dailymail.co.uk/news/article-9814063/Unilever-chief-says-company-fully-committed-Israel.html\" target=\"_blank\">(دیلی‌میل)</a>"
            }
          },
          {
            "id": "h-Nj4YimO9",
            "type": "image",
            "data": {
              "caption": "آلن جوپ، مدیر عامل وقت یونیلیور",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 1024,
                "height": 683,
                "size": "42304",
                "name": "kcuk4fgxj6vn.webp",
                "title": "Kcuk4fgxj6vn.webp",
                "extension": "webp",
                "fileId": "871a0e5a-720a-4bb4-a829-c6ef0dff50cf",
                "fileURL": "/files/871a0e5a-720a-4bb4-a829-c6ef0dff50cf",
                "url": "/qlist-assets/871a0e5a-720a-4bb4-a829-c6ef0dff50cf.webp"
              }
            }
          },
          {
            "id": "-T6PANgpxj",
            "type": "paragraph",
            "data": {
              "text": "در ادامه سیل واکنش‌ها حتی به سطح نخست‌وزیر هم رسید؛ نفتالی بنت، نخست‌وزیر وقت اسرائیل به آلن جوپ، مدیرعامل یونیلیور، نسبت به «پیامدهای جدی» تصمیم بن و جری هشدار داد.&nbsp;<a href=\"https://fortune.com/2022/12/16/unilever-ben-jerrys-israel-west-bank-ice-cream/\" target=\"_blank\">(فورچون)</a>&nbsp;این حساسیت‌ها نشان می‌داد که اجرایی شدن تصمیم بن و جری می‌تواند ضربه بزرگی به اعتبار اسرائیل باشد و ممکن است اقدامات مشابهی را از سوی سایر شرکت‌ها برای تجدید نظر در حضورشان در بازار اسرائیل به دنبال بیاورد."
            }
          },
          {
            "id": "2vG7B2xaGl",
            "type": "paragraph",
            "data": {
              "text": "دولت اسرائیل اقدام بن و جری را غیراخلاقی دانسته و یونیلیور را در مورد آن تهدید کرد. یونیلیور هم تعهد داد که تا سال آینده راه حلی برای این موضوع پیدا کند. این شرکت در بیانیه‌اش تاکید کرد که «مثل گذشته به هیچ وجه از جنبش تحریم اسرائیل (بی‌دی‌اس) حمایت نمی‌کند.»&nbsp;<a href=\"https://www.reuters.com/business/retail-consumer/unilever-sells-ben-jerrys-israeli-business-2022-06-29/?_x_tr_sl=en&amp;_x_tr_tl=fa&amp;_x_tr_hl=en-US&amp;_x_tr_pto=wapp\" target=\"_blank\">(رویترز)</a>"
            }
          },
          {
            "id": "fwbHKPGTEA",
            "type": "header",
            "data": {
              "text": "اسرائیل بستنی‌اش را می‌‌خواهد",
              "level": 3
            }
          },
          {
            "id": "e7MlrCeqeU",
            "type": "paragraph",
            "data": {
              "text": "بالاخره یونیلیور در مقابل اقدام هیئت مدیره مستقل بن و جری و پافشاری آنها بر تصمیم خود یک راهکار عملی پیدا کرد؛ فروش سهام بن و جری در فلسطین اشغالی (اسرائیل) به شرکت اسرائیلی آبی و سفید. این اقدام باعث شد تا شرکت مذکور بتواند با نام‌های عربی و عبری (نه انگلیسی) محصولات بن و جری را در سرزمین‌های اشغالی عرضه کند.&nbsp;<a href=\"https://www.unilever.com/news/press-and-media/press-releases/2022/unilever-statement-on-ben-jerrys/\" target=\"_blank\">(وبسایت یونیلیور)</a><a href=\"https://bdsmovement.net/news/statement-unilevers-sale-ben-jerrys-interests-apartheid-israel\" target=\"_blank\">(BDS)</a>"
            }
          },
          {
            "id": "eBUxUuuewl",
            "type": "paragraph",
            "data": {
              "text": "خبرگزاری رویترز این تصمیم یونیلیور را اقدامی در جهت «خنثی کردن جبهه تحریم اسرائیل» خوانده و وزارت خارجه رژیم اسرائیل نیز آن را یک&nbsp;«پیروزی بزرگ»&nbsp;توصیف کرده است.<a href=\"https://www.reuters.com/business/retail-consumer/unilever-sells-ben-jerrys-israeli-business-2022-06-29/?_x_tr_sl=en&amp;_x_tr_tl=fa&amp;_x_tr_hl=en-US&amp;_x_tr_pto=wapp\" target=\"_blank\">(رویترز)</a>&nbsp;حتی لاپید نخست‌وزیر بعدی اسرائیل هم این تغییر را به عنوان یک «پیروزی» در برابر تبعیض و نفرت ستود!&nbsp;<a href=\"https://www.bbc.com/news/world-middle-east-62643392\" target=\"_blank\">(بی‌بی‌سی)</a>"
            }
          },
          {
            "id": "DgHc9G4JOZ",
            "type": "paragraph",
            "data": {
              "text": "اما نکته جالب این که اقدام یونیلیور در بی‌اثر کردن تصمیم بن و جری در حالی انجام شد که همین شرکت در مورد جنگ اوکراین مواضع سفت و سختی گرفته بود؛ آنها طی بیانیه‌ای اقدامات روسیه را وحشیانه دانسته و اعلام کردند فعالیت‌هایشان در روسیه را به شکل سختگیرانه‌ای محدود کرده‌اند.&nbsp;<a href=\"https://www.unilever.com/news/press-and-media/press-releases/2023/unilever-statement-on-the-war-in-ukraine/\" target=\"_blank\">(وبسایت رسمی یونیلیور)</a>"
            }
          },
          {
            "id": "C5LslRwbpi",
            "type": "paragraph",
            "data": {
              "text": "ماجرای تصمیم بن و جری و یونیلیور یک موضوع پیچیده و مفصل با ابعاد گوناگون است که امکان شرح بیشتر آن در این مقاله وجود ندارد. اما شاید مهم‌ترین نکته این ماجرا، اهمیت رفتار شرکت‌های بزرگ و اثرگذاری آن بر معادلات مختلف است، به حدی که حاکمیت کشورها را در بالاترین سطوح وادار به واکنش می‌کند."
            }
          },
          {
            "id": "Qie2lIixaL",
            "type": "header",
            "data": {
              "text": "ماجرا ادامه دارد...",
              "level": 3
            }
          },
          {
            "id": "csNZXZD-ks",
            "type": "paragraph",
            "data": {
              "text": "گسل بین یونیلیور و بن و جری هر روز فعال‌تر می‌شود و در بین این تکانه‌ها موضوعات جدیدی نیز در حال آشکار شدن است. در 23 آبان 1403، بن و جری شکایتی را در دادگاه فدرال نیویورک علیه شرکت مادر خود یعنی یونیلیور مطرح کرد که در آن موارد بسیار جالبی وجود داشت."
            }
          },
          {
            "id": "9_XMx0X9yT",
            "type": "paragraph",
            "data": {
              "text": "در متن این شکایت یونیلیور متهم شده است که تلاش‌های چند باره بن و جری برای صدور بیانیه‌ای در حمایت از فلسطینیان غزه را سرکوب و ساکت کرده است. بیانیه‌ای که خواستار آتش‌بس فوری در غزه نیز می‌شد. یونیلیور همچنین بیانیه عمومی بن و جری که قصد داشت در حمایت از تظاهرات‌کنندگان ضد جنگ در دانشگاه‌های آمریکا منتشر کند را سانسور کرده است."
            }
          },
          {
            "id": "cL0IU_a05p",
            "type": "paragraph",
            "data": {
              "text": "طبق ادعای این بستنی‌ساز معروف آمریکایی، شرکت مادر تهدید کرده است که در صورت انتشار بیانیه‌ای از سوی بن و جری برای درخواست آتش‌بس فوری، هیئت مدیره مستقلِ آن را برکنار و از آنها شکایت خواهد کرد. مدیر بخش بستنی یونیلیور و مدیر حقوقی این شرکت نیز کارکنان یونیلیور را تهدید کرده‌اند که در صورت انتشار بیانیه حمایت از آتش‌بس، تاوان آن را پرداخت خواهند کرد."
            }
          },
          {
            "id": "7eVGNmyfMk",
            "type": "paragraph",
            "data": {
              "text": "بن و جری همچنین مدعی شده است که یونیلیور مانع از پرداخت کمک‌های مالی این شرکت به دو موسسه «ندای یهودی برای صلح» و «انجمن روابط آمریکایی اسلامی» شده است؛ موسسه‌هایی که مشغول جمع‌آوری و انتقال کمک‌های بشردوستانه برای فلسطینیان درگیر جنگ در نوار غزه هستند. در متن شکایت عنوان شده که یونیلیور دلیل ممانعت از این کار را اتخاذ موضع بی‌طرفی در این درگیری اعلام کرده است. در حالی که خودش یک کمک 500 هزار یورویی به یک نهاد خدمات پزشکی و بانک خون اسرائیلی که خدمات امدادی به نیروهای ارتش اسرائیل ارائه می‌دهد پرداخت کرده است."
            }
          },
          {
            "id": "MVSDDkXOT7",
            "type": "paragraph",
            "data": {
              "text": "یونیلیور در واکنش به طرح این شکایت ضمن رد ادعاها گفته که «دلمان برای تمام قربانیان حوادث تلخ اخیر در منطقه می‌تپد».&nbsp;<a href=\"https://www.reuters.com/business/retail-consumer/ben-jerrys-says-parent-unilever-silenced-it-over-gaza-stance-2024-11-14/\" target=\"_blank\">(رویترز)</a><a href=\"https://www.esgdive.com/news/ben-jerrys-sues-parent-company-unilever-for-stifling-its-stance-on-gaza/733385/\" target=\"_blank\">(نشریه امریکایی ESGDive)</a>"
            }
          },
          {
            "id": "uOzvpGPBJp",
            "type": "header",
            "data": {
              "text": "مشارکت در شهرک‌سازی",
              "level": 3
            }
          },
          {
            "id": "w68iQx8Hqd",
            "type": "paragraph",
            "data": {
              "text": "ماجرای بِن و جری اولین همراهی شرکت انگلیسی- هلندی با صهیونیست‌ها در شهرک‌سازی‌هایشان نبود. یونیلیور در سال 2001 با خرید 51 درصد سهام شرکت بیگل و بیگل که در منطقه صنعتی برکان در شهرک صهیونیستی آریل[11] قرار داشت، پا به شهرک‌های صهیونیستی گذاشت.&nbsp;<a href=\"https://www.theguardian.com/world/2008/dec/01/israel-palestine-unilever\" target=\"_blank\">(گاردین)</a>"
            }
          },
          {
            "id": "pyTSDhUJxC",
            "type": "image",
            "data": {
              "caption": "تصویری از منطقه صنعتی بَرکان",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 1024,
                "height": 768,
                "size": "162514",
                "name": "ck5z62qyakfx.webp",
                "title": "Ck5z62qyakfx.webp",
                "extension": "webp",
                "fileId": "1d133791-c577-49f2-babd-b6904f46b0b8",
                "fileURL": "/files/1d133791-c577-49f2-babd-b6904f46b0b8",
                "url": "/qlist-assets/1d133791-c577-49f2-babd-b6904f46b0b8.webp"
              }
            }
          },
          {
            "id": "-Gv0iNjAkS",
            "type": "paragraph",
            "data": {
              "text": "طبق گزارش روزنامه هلندی اِن‌آرسی، این موضوع در سال 2006 با گزارش یک سازمان مردم نهاد هلندی به نام یوسی‌پی مورد توجه قرار گرفت. یوسی‌پی از یونیلیور که آن زمان در روتردام هلند مستقر بود خواست تا به قوانین بین‌المللی پایبند بوده و از شهرک‌ها خارج شود.&nbsp;<a href=\"https://www.nrc.nl/nieuws/2013/02/04/unilever-sluit-fabriek-in-israelische-nederzetting-a1437554\" target=\"_blank\">(روزنامه هلندی NRC)</a>&nbsp;در سال 2008 یونیلیور اعلام کرد که سهامش را از کارخانه مستقر در شهرک آریل خارج خواهد کرد. البته یونیلیور اعلام کرد که این یک تصمیم راهبردی است، نه اخلاقی، و به دنبال سیاست شرکت برای خروج از کسب‌وکارهای غیرکلیدی گرفته شده است.&nbsp;<a href=\"https://www.theguardian.com/world/2008/dec/01/israel-palestine-unilever\" target=\"_blank\">(گاردین)</a>&nbsp;اما این تصمیم عملی نشد و لذا فشارهای یوسی‌پی و دیگران هم ادامه پیدا کرد. دو سال بعد یونیلیور اعلام کرد که موفق به فروش سهام خود نشده بقیه 49 درصد سهام بیگل و بیگل را نیز خریداری و سپس نسبت به جابجایی کارخانه از شهرک آریل اقدام خواهد کرد. یونیلیور باز هم تاکید کرده بود که این جابجایی سیاسی نبوده و صرفاً بر اساس یک تصمیم کسب‌وکاری و با هدف کاهش هزینه‌ها انجام خواهد شد.&nbsp;<a href=\"https://www.nrc.nl/nieuws/2013/02/04/unilever-sluit-fabriek-in-israelische-nederzetting-a1437554\" target=\"_blank\">(NRC)</a><a href=\"https://www.israelnationalnews.com/news/140039\" target=\"_blank\">(رسانه اسرائیل نشنال نیوز)</a>"
            }
          },
          {
            "id": "6FsLYP88Y6",
            "type": "image",
            "data": {
              "caption": "کارخانه بیگل و بیگل یونیلیور در شهرک آریل",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 1024,
                "height": 768,
                "size": "107386",
                "name": "un3oeddwdhgh.webp",
                "title": "Un3oeddwdhgh.webp",
                "extension": "webp",
                "fileId": "ab18f93c-f966-466e-97e4-d5b663ca94e9",
                "fileURL": "/files/ab18f93c-f966-466e-97e4-d5b663ca94e9",
                "url": "/qlist-assets/ab18f93c-f966-466e-97e4-d5b663ca94e9.webp"
              }
            }
          },
          {
            "id": "bmd8hnsO9L",
            "type": "paragraph",
            "data": {
              "text": "در آغاز سال 2013، یونیلیور اعلام کرد که کارخانه‌اش در شهرک آریل را جمع‌آوری و آن را به صفد منتقل کرده است. برخی سازمان‌های مردم‌نهاد از جمله یوسی‌پی نیز این موضوع را تایید کردند.&nbsp;<a href=\"https://bdsmovement.net/news/unilever-removed-its-beigel-beigel-factory-from-illegal-barkan-settlement\" target=\"_blank\">(BDS)</a>&nbsp;اما این اتفاق درست چند روز بعد از آن رخ داد که گزارش هیئت حقیقت یاب سازمان ملل در مورد وضعیت حقوق بشر در فلسطین و سایر مناطق اشغالی عربی منتشر شد. این گزارش نسبت به الحاق خزنده مناطق اشغالی هشدار داده و دعوت به تحریم اسرائیل به خاطر نقض حقوق بشر فلسطینیان و قوانین بین‌المللی کرده بود. در گزارش سازمان ملل از شرکت‌ها خواسته شده بود تا به هرگونه منافع تجاری خود در شهرک‌ها پایان دهند.&nbsp;<a href=\"https://www.ohchr.org/sites/default/files/Documents/HRBodies/HRCouncil/RegularSession/Session19/FFM/FFMSettlements.pdf\" target=\"_blank\">(کمیسریای حقوق بشر سازمان ملل)</a><a href=\"https://mondoweiss.net/2013/01/settlements-international-governments/\" target=\"_blank\">(وبسایت خبری موندووایز)</a>&nbsp;به این ترتیب یونیلیور پس از 12 سال بالاخره حاضر شد از شهرک‌های صهیونیستی عقب‌نشینی کند. به نظر می‌رسد این تصمیم با اکراه و البته تحت فشارهای اجتماعی گسترده اتخاذ شده باشد.&nbsp;<a href=\"https://bdsmovement.net/news/unilever-removed-its-beigel-beigel-factory-from-illegal-barkan-settlement\" target=\"_blank\">(BDS)</a>&nbsp;سازمان مردم‌نهاد یوسی‌پی در گزارش خود اشاره می‌کند که یونیلیور به خاطر تولید در شهرک‌ها از اسرائیل یارانه دریافت می‌کرده است. شرکت‌های حاضر در شهرک‌ها همچنین از مزیت نیروی کار ارزان فلسطینی بهره‌مند هستند؛ کارگرانی که حتی مشمول حداقل دستمزد تعیین شده در اسرائیل هم نمی‌شوند.&nbsp;<a href=\"https://www.theguardian.com/world/2008/dec/01/israel-palestine-unilever\" target=\"_blank\">(گاردین)</a>"
            }
          },
          {
            "id": "QYumbNFS9-",
            "type": "image",
            "data": {
              "caption": "کارخانه بیگل و بیگل در شهرک آریل پس از تعطیلی",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 1024,
                "height": 764,
                "size": "65176",
                "name": "yngggrpwzs9g.webp",
                "title": "Yngggrpwzs9g.webp",
                "extension": "webp",
                "fileId": "4320af1c-7746-40b2-a7f4-5ce927562055",
                "fileURL": "/files/4320af1c-7746-40b2-a7f4-5ce927562055",
                "url": "/qlist-assets/4320af1c-7746-40b2-a7f4-5ce927562055.webp"
              }
            }
          },
          {
            "id": "djfSgU9hOh",
            "type": "header",
            "data": {
              "text": "بخشش در سرزمین اشغالی",
              "level": 3
            }
          },
          {
            "id": "Kjhndw6W-q",
            "type": "paragraph",
            "data": {
              "text": "یونیلیور دستی هم در فعالیت‌های خیریه در اسرائیل دارد. یک قلم از این مشارکت‌ها همکاری با موسسه لاتِت است. لاتت (به معنای بخشیدن) بزرگ‌ترین سازمان مردم‌نهاد خیریه فعال در حوزه مبارزه با فقر، کمک به نیازمندان و امنیت غذایی در رژیم صهیونیستی است. این موسسه به طور ماهیانه کمک‌های خود را به 95 هزار خانواده صهیونیست و 1450 بازمانده هولوکاست (!) ارائه می‌کند.&nbsp;<a href=\"https://www.latet.org.il/en/about/\" target=\"_blank\">(وبسایت لاتِت)</a>"
            }
          },
          {
            "id": "xm_V5ZjN-I",
            "type": "image",
            "data": {
              "caption": "",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 1024,
                "height": 923,
                "size": "9722",
                "name": "1afjnyfitqkd.webp",
                "title": "1afjnyfitqkd.webp",
                "extension": "webp",
                "fileId": "5f1d26e3-cccd-42e3-ae6a-b5b9a98fd0eb",
                "fileURL": "/files/5f1d26e3-cccd-42e3-ae6a-b5b9a98fd0eb",
                "url": "/qlist-assets/5f1d26e3-cccd-42e3-ae6a-b5b9a98fd0eb.webp"
              }
            }
          },
          {
            "id": "uWVInqZ59b",
            "type": "paragraph",
            "data": {
              "text": "یکی از فعالیت‌های اخیر لاتت آماده‌سازی کمک‌های اضطراری برای ساکنان مناطق درگیر جنگ در جبهه شمال فلسطین اشغالی (اسرائیل) است تا بتواند در وضعیت فعلی شرایط ادامه زندگی را برای آنان فراهم نماید. طبق اطلاعات سایت موسسه در آذر 1403، لاتت از شروع جنگ تا کنون 196.000 بسته اقلام غذایی و بهداشتی برای ساکنان این مناطق ارسال کرده است. این موسسه همچنین برای تدارک بسته‌های بیشتر مناسب پناهگاه تلاش می‌کند. هریک از این بسته‌ها شامل غذا، اقلام بهداشتی، آب، کمک‌های اولیه، رادیو و باتری و اسباب‌بازی است که پاسخگوی نیاز چند خانواده برای 4 روز خواهد بود. این بسته‌ها به صهیونیست‌ها کمک می‌کند تا در داخل پناهگاه‌ها بیشتر دوام بیاورند.&nbsp;<a href=\"https://www.latet.org.il/en/world-1/articles/israelatwar2024\" target=\"_blank\">(لاتت)</a>"
            }
          },
          {
            "id": "htiNzg5Wcy",
            "type": "image",
            "data": {
              "caption": "پوستر لاتت برای ارسال کمک به ساکنان شمال",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 1024,
                "height": 1024,
                "size": "44206",
                "name": "bkswsexoknvv.webp",
                "title": "Bkswsexoknvv.webp",
                "extension": "webp",
                "fileId": "2b85d968-c232-42a9-8029-97033e568d89",
                "fileURL": "/files/2b85d968-c232-42a9-8029-97033e568d89",
                "url": "/qlist-assets/2b85d968-c232-42a9-8029-97033e568d89.webp"
              }
            }
          },
          {
            "id": "NSjj2OCQvv",
            "type": "paragraph",
            "data": {
              "text": "یونیلیور هم یکی از مشارکت‌کنندگان در این کمک‌هاست. در صفحه رسمی یونیلیور در یوتیوب ویدئویی از مشارکت این شرکت در تهیه بسته‌های غذایی و بهداشتی برای لاتت قرار داده شده است. در این ویدئو کارکنان یونیلیور که لباس‌هایی با علائم مشترک لاتت به تن کرده‌اند، با شور و اشتیاق مشغول قرار دادن تولیدات غذایی و بهداشتی شرکت در بسته‌‌بندی‌های لاتت هستند. البته این موضوع بخشی از همکاری‌های گسترده یونیلیور با لاتت است که برخی از آنها در صفحات مجازی لاتت در فیسبوک و اینستاگرام نیز پوشش داده شده است."
            }
          },
          {
            "id": "VUKdx3N_uU",
            "type": "paragraph",
            "data": {
              "text": "📷📷📷📷📷"
            }
          },
          {
            "id": "KIQ9MfRc2c",
            "type": "paragraph",
            "data": {
              "text": "راوی ویدئوی مذکور توضیح می‌دهد: «یونیلیور بیش از پانزده سال است که کمک‌های خود را به هزاران خانواده اسرائیلی (صهیونیست) اهدا می‌کند. امسال هم کارکنان یونیلیور از سراسر اسرائیل دور هم جمع شده‌اند تا با ارسال بسته‌های غذایی برای یهودیان، آنها را با قلبشان در آغوش بکشند...امسال همه ما با چالش‌هایی (جنگ) مواجه هستیم که جمع شدن ما و «بخشش» برای حفظ اسرائیل را با اهمیت‌تر از همیشه کرده است.»"
            }
          },
          {
            "id": "B-fz4j3M25",
            "type": "paragraph",
            "data": {
              "text": "<a href=\"https://youtu.be/2lhNfQJ6YvE?feature=shared\" target=\"_blank\">لینک مشاهده ویدیو یوتیوب</a>"
            }
          },
          {
            "id": "GILtE2-tHs",
            "type": "paragraph",
            "data": {
              "text": "همکاری یونیلیور با لاتت تا آنجاست که این موسسه در فهرست شرکا و حامیان خود نام یونیلیور را ذکر کرده است. البته با نگاهی به اسامی موجود در این فهرست، نام‌های بزرگ دیگری از شرکت‌های بزرگ چندملیتی همچون کوکاکولا، اینتل، اوسم (متعلق به نستله)، اشتراوس (متعلق به دنون و پپسی) و حتی وزارت اقتصاد آلمان نیز دیده می‌شود.&nbsp;<a href=\"https://www.latet.org.il/en/partners/\" target=\"_blank\">(لاتِت)</a>"
            }
          },
          {
            "id": "Wpj-1VoujP",
            "type": "image",
            "data": {
              "caption": "",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 868,
                "height": 1200,
                "size": "109418",
                "name": "u3251bqaalhx.webp",
                "title": "U3251bqaalhx.webp",
                "extension": "webp",
                "fileId": "52f2faf5-2956-4c8e-9102-4506fe878e48",
                "fileURL": "/files/52f2faf5-2956-4c8e-9102-4506fe878e48",
                "url": "/qlist-assets/52f2faf5-2956-4c8e-9102-4506fe878e48.webp"
              }
            }
          },
          {
            "id": "9sh-rZsps0",
            "type": "header",
            "data": {
              "text": "یونیلیور و تحریم اسرائیل",
              "level": 3
            }
          },
          {
            "id": "yxEAsXIkhN",
            "type": "paragraph",
            "data": {
              "text": "پس از شروع جنگ در غزه، بار دیگر تحریم شرکت‌های چند ملیتی متهم به حمایت از رژیم اسرائیل در بین مردم کشورهای مختلف مورد توجه قرار گرفت. در گزارش فروش سه ماهه چهارم 2023 شرکت یونیلیور، رشد مورد نظر این شرکت در منطقه جنوب شرق آسیا آسیب دیده است. دلیل این مساله تحریم شرکت‌های چند ملیتی از جمله یونیلیور توسط مردم اندونزی بوده است. تحریمی که به طور مشخص در پاسخ به شرایط منطقه و جنگ غزه شکل گرفته است. طبق گفته‌های شرکت، در اندونزی که بیش از ۲۰۰ میلیون مسلمان در آن زندگی می‌کنند، فروش سه‌ماهه چهارم شرکت یونیلیور کاهش دو رقمی داشته است.&nbsp;<a href=\"https://www.middleeastmonitor.com/20240208-unilever-takes-sales-hit-in-indonesia-over-anti-israel-boycott/\" target=\"_blank\">(میدل‌ایست‌مانیتور)</a>"
            }
          },
          {
            "id": "1kNUhK5DBN",
            "type": "paragraph",
            "data": {
              "text": "این شرایط هنوز برای یونیلیور ادامه دارد. مدیر مالی یونیلیور خبر از تصمیم شرکت برای ایجاد تغییرات «گسترده» در اندونزی داده است. دلیل این موضوع تحریم شرکت‌های چند ملیتی توسط مردم اندونزی عنوان شده‌است. این تحریم‌ها حتی منجر به کاهش ارزش سهام یونیلیور نیز شده است.&nbsp;<a href=\"https://www.reuters.com/business/retail-consumer/unilever-making-drastic-changes-indonesia-amid-boycotts-2024-10-24/\" target=\"_blank\">(رویترز)</a>"
            }
          },
          {
            "id": "4kQc4s0Zei",
            "type": "paragraph",
            "data": {
              "text": "حتی برخی مقالات دانشگاهی در اندونزی به بررسی تاثیرات تحریم مردمی یونیلیور پرداخته‌اند. نتایج این پژوهش‌ها نشان می‌دهد که تحریم یونیلیور در اندونزی به ویژه پس از فتوای مجلس علمای این کشور تاثیر معنی‌داری بر عملکرد مالی و ارزش سهام این شرکت داشته است.&nbsp;<a href=\"https://ejournalugj.com/index.php/cicee/article/view/9287/4124\" target=\"_blank\">(منبع)</a>"
            }
          },
          {
            "id": "vDqvzg5wAL",
            "type": "header",
            "data": {
              "text": "این‌ها و بیشتر",
              "level": 3
            }
          },
          {
            "id": "REkXsIaZc0",
            "type": "paragraph",
            "data": {
              "text": "یونیلیور در سال 2023 سومین تولیدکننده آلودگی‌های پلاستیکی در جهان بوده است.&nbsp;<a href=\"https://brandaudit.breakfreefromplastic.org/brand-audit-2023/\" target=\"_blank\">(Brand Audit)</a>&nbsp;این شرکت در هر ثانیه 1700 پاکت بسته‌بندی چندلایه را وارد چرخه مصرف کرده است. یعنی 53 میلیارد پاکت چندلایه در یک سال. پاکت‌هایی که یکی از مخرب‌ترین آلودگی‌های پلاستیکی به شمار می‌آیند.&nbsp;<a href=\"https://www.greenpeace.org.uk/news/unilever-profit-warning-delivered-by-greenpeace-uk-as-activists-scale-hq-in-plastic-pollution-protest/\" target=\"_blank\">منبع:Greenpeace</a>"
            }
          },
          {
            "id": "8swwxFnvkZ",
            "type": "image",
            "data": {
              "caption": "",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 1024,
                "height": 681,
                "size": "116300",
                "name": "chz7lukdz4zn.webp",
                "title": "Chz7lukdz4zn.webp",
                "extension": "webp",
                "fileId": "80fe2727-50ee-42f4-b99e-ad1164ecc95a",
                "fileURL": "/files/80fe2727-50ee-42f4-b99e-ad1164ecc95a",
                "url": "/qlist-assets/80fe2727-50ee-42f4-b99e-ad1164ecc95a.webp"
              }
            }
          },
          {
            "id": "IedTvYJvmh",
            "type": "delimiter",
            "data": {}
          },
          {
            "id": "BP3unpvTOx",
            "type": "header",
            "data": {
              "text": "یونیلیور در ایران",
              "level": 2
            }
          },
          {
            "id": "940ommL3pd",
            "type": "paragraph",
            "data": {
              "text": "«۱۴ مهرماه ۱۳۸۲، یونیلیور فعالیتش را با نام تجاری ثبت‌شده&nbsp;یونیلیور ایران&nbsp;در جمهوری اسلامی ایران آغاز کرد و در ابتدا، به واردات رسمی برخی محصولاتش به کشور پرداخت. در سال ۱۳۸۴ ، یونیلیور ... برنامه‌ریزی در خصوص تولید مستقیم محصولاتش در خاک جمهوری اسلامی ایران را پیش برد و استان قزوین را ... برای سرمایه‌گذاری، طراحی و شروع ساخت کارخانه خود انتخاب کرد. در سال ۱۳۸۵، یونیلیور واحد تولیدی خود را افتتاح و تولید محصولاتش را به طور مستقیم در ایران آغاز کرد.»&nbsp;<a href=\"https://unilever.ir/unilever-iran/\" target=\"_blank\">(وبسایت یونیلیور ایران)</a>"
            }
          },
          {
            "id": "hBYvdmESiG",
            "type": "image",
            "data": {
              "caption": "کارخانه یونیلیور ایران در شهر صنعتی البرز استان قزوین",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 1024,
                "height": 682,
                "size": "60736",
                "name": "d600letovy4o.webp",
                "title": "D600letovy4o.webp",
                "extension": "webp",
                "fileId": "17322403-834e-47e2-8a7a-aeabdc115eaf",
                "fileURL": "/files/17322403-834e-47e2-8a7a-aeabdc115eaf",
                "url": "/qlist-assets/17322403-834e-47e2-8a7a-aeabdc115eaf.webp"
              }
            }
          },
          {
            "id": "xtTRzZzSSk",
            "type": "image",
            "data": {
              "caption": "خط تولید شامپو کلیِر در کارخانه یونیلیور ایران - شهر صنعتی البرز استان قزوین",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 1024,
                "height": 683,
                "size": "87236",
                "name": "mclon3r8fgob.webp",
                "title": "Mclon3r8fgob.webp",
                "extension": "webp",
                "fileId": "dc2fb676-91de-4230-a2e0-82f7a1ecd4f9",
                "fileURL": "/files/dc2fb676-91de-4230-a2e0-82f7a1ecd4f9",
                "url": "/qlist-assets/dc2fb676-91de-4230-a2e0-82f7a1ecd4f9.webp"
              }
            }
          },
          {
            "id": "K5W73tDWQe",
            "type": "paragraph",
            "data": {
              "text": "طبق گزارش سالیانه 2023 یونیلیور، شرکت یونیلیور ایران در خیابان زاگرس تهران، به طور کامل (99/99 درصد) متعلق به گروه یونیلیور بوده و زیر نظر آن مشغول فعالیت است.&nbsp;<a href=\"https://www.unilever.com/files/92ui5egz/production/b09c3510ee7cec58440d5f044f02bdefe85aa186.pdf\" target=\"_blank\">(گزارش سالیانه یونیلیور)</a>"
            }
          },
          {
            "id": "j5us7xh420",
            "type": "image",
            "data": {
              "caption": "",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 1024,
                "height": 317,
                "size": "63894",
                "name": "me2ityenejca.webp",
                "title": "Me2ityenejca.webp",
                "extension": "webp",
                "fileId": "a438251d-0fa8-4fc8-a3b6-37f9ca44b25a",
                "fileURL": "/files/a438251d-0fa8-4fc8-a3b6-37f9ca44b25a",
                "url": "/qlist-assets/a438251d-0fa8-4fc8-a3b6-37f9ca44b25a.webp"
              }
            }
          },
          {
            "id": "m1YYOczB_C",
            "type": "paragraph",
            "data": {
              "text": "محصولات یونیلیور هم‌اکنون با برندهای شناخته شده‌ای مثل اُمو Omo – دامستوس Domestos – سیف Cif – کامفورت Comfort – داو Dove – کلیر Clear – سانسیلک Sunsilk – رکسونا Rexona – کلوزآپ Closeup – سیگنال Signal – لوکس LUX – آکس AXE به طور گسترده در بازار ایران حضور دارند.&nbsp;<a href=\"https://unilever.ir/our-brands/all-brands/\" target=\"_blank\">(یونیلیور ایران)</a><a href=\"https://www.unilever.com/brands/all-brands/\" target=\"_blank\">(یونیلیور)</a>"
            }
          },
          {
            "id": "oqrknAxKAK",
            "type": "image",
            "data": {
              "caption": "",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 1024,
                "height": 533,
                "size": "63884",
                "name": "orvww7wfqg55.webp",
                "title": "Orvww7wfqg55.webp",
                "extension": "webp",
                "fileId": "1ae0fc51-51b6-4aba-aa91-d02ba4076229",
                "fileURL": "/files/1ae0fc51-51b6-4aba-aa91-d02ba4076229",
                "url": "/qlist-assets/1ae0fc51-51b6-4aba-aa91-d02ba4076229.webp"
              }
            }
          },
          {
            "id": "E-Loy7JoBy",
            "type": "paragraph",
            "data": {
              "text": "[1] Vitco"
            }
          },
          {
            "id": "54eOHifLZL",
            "type": "paragraph",
            "data": {
              "text": "[2] Bestfoods"
            }
          },
          {
            "id": "kPq20qz_m8",
            "type": "paragraph",
            "data": {
              "text": "[3] Tami food company"
            }
          },
          {
            "id": "pftkkpokAA",
            "type": "paragraph",
            "data": {
              "text": "[4] Occupied Palestinian Territory"
            }
          },
          {
            "id": "R3_on8DCSG",
            "type": "paragraph",
            "data": {
              "text": "[5] BDS"
            }
          },
          {
            "id": "MZ30E_ZY7C",
            "type": "paragraph",
            "data": {
              "text": "[6] Dailymail"
            }
          },
          {
            "id": "oSVhUPG0rO",
            "type": "paragraph",
            "data": {
              "text": "[7] Independent Board of Directors"
            }
          },
          {
            "id": "4PKFPZONu2",
            "type": "paragraph",
            "data": {
              "text": "[8] Jewish Voice for Peace"
            }
          },
          {
            "id": "sFiDcX5-Rd",
            "type": "paragraph",
            "data": {
              "text": "[9] Council on American Islamic Relations"
            }
          },
          {
            "id": "dfTQFrPTmW",
            "type": "paragraph",
            "data": {
              "text": "[10]Barkan"
            }
          },
          {
            "id": "Kdur21I8fq",
            "type": "paragraph",
            "data": {
              "text": "[11] Ariel"
            }
          },
          {
            "id": "bv_ogoyQtN",
            "type": "paragraph",
            "data": {
              "text": "[12] NRC"
            }
          },
          {
            "id": "8HWHaYCoJT",
            "type": "paragraph",
            "data": {
              "text": "[13] United Civilians for Peace"
            }
          },
          {
            "id": "OTI8plfblp",
            "type": "paragraph",
            "data": {
              "text": "[14] Latet"
            }
          },
          {
            "id": "j-C6KQzeCm",
            "type": "paragraph",
            "data": {
              "text": "[15] Youtube"
            }
          }
        ]
      },
      "bodyEn": {
        "version": "2.30.7",
        "blocks": [
          {
            "id": "NLpuzU3Ypf",
            "type": "quote",
            "data": {
              "text": "Behind a large part of our daily cleanliness and shine — for us Iranians — hides a letter \"U\" that no-one usually sees: a beautiful letter U formed by gathering the symbols of life together. A symbol recognised as one of the most successful brands in the world. But are this brand's policies as full of life as its emblem? In this note we aim to describe Unilever's ups-and-downs with the Israeli regime and how it operates in Iran. Stay with us."
            }
          },
          {
            "id": "2FIz5XG6wA",
            "type": "image",
            "data": {
              "caption": "Unilever's company logo",
              "file": {
                "fileId": "5edb453a-34e1-42c5-b6fc-bde2b165bca4"
              }
            }
          },
          {
            "id": "oL_YOOxHxO",
            "type": "paragraph",
            "data": {
              "text": "We're talking about Unilever — the multinational company with Anglo-Dutch roots that is today the sixth-highest-earning consumer-goods company in the world and the 45th most valuable company globally. <a href=\"https://www.statista.com/companies/ranking/3/top-100-consumer-goods-and-fmcg-companies\" target=\"_blank\">(Source: Statista)</a> <a href=\"https://www.statista.com/statistics/263264/top-companies-in-the-world-by-market-capitalization/\" target=\"_blank\">(Statista)</a> To make these numbers concrete: the company's revenue in 2023 was more than $59 billion, and its products are sold in 190 countries worldwide — including occupied Palestine (Israel) and Iran. <a href=\"https://www.unilever.com/files/66bc4aea-608f-46ee-8da3-cde0ec8ebe90/unilever-annual-report-and-accounts-2023.pdf\" target=\"_blank\">(Unilever's official website)</a>"
            }
          },
          {
            "id": "QBn7V4U_Rp",
            "type": "image",
            "data": {
              "caption": "Unilever's headquarters in London",
              "file": {
                "fileId": "e1b3dc02-3813-4933-be7f-204164d376d1"
              }
            }
          },
          {
            "id": "johFGTNvy0",
            "type": "header",
            "data": {
              "text": "An English company on English-Mandate territory",
              "level": 2
            }
          },
          {
            "id": "1r7vGxv5e_",
            "type": "paragraph",
            "data": {
              "text": "Unilever's history in occupied Palestine (Israel) goes back to a time when Israel did not yet exist. Unilever set foot on Palestinian soil in 1938 — a decade after the First World War — by establishing a food-products factory. <a href=\"https://www.unilever.co.il/our-company/\" target=\"_blank\">(Unilever's official website)</a> Palestine at that time was under British Mandate following the dissolution of the Ottoman state. In line with the commitments of the Balfour Declaration, the wave of Jewish immigration and the resulting clashes with Palestinians over the Judaisation of Palestine grew day by day. This trend continued until in 1948 the Israeli regime officially declared its existence. <a href=\"https://aje.io/8mqot4\" target=\"_blank\">(Source: Al Jazeera)</a>"
            }
          },
          {
            "id": "z0S3_pC9d-",
            "type": "paragraph",
            "data": {
              "text": "Unilever's presence in occupied Palestine (Israel) faced challenges after the <a href=\"https://en.wikipedia.org/wiki/Arab_League_boycott_of_Israel\" target=\"_blank\">Arab League boycott</a>, but as those boycotts faded the company resumed activities in that territory with greater enthusiasm. Through investment and the purchase of stakes in Israeli companies, Unilever significantly expanded its production and product range in the region. For example, it invested $13 million in Vitco in 1996 and entered the Israeli health-and-beauty market. <a href=\"https://en.globes.co.il/en/article-373057\" target=\"_blank\">(Source: Israeli newspaper Globes)</a> A year earlier Unilever had also bought 50% of the ice-cream division of Israel's Strauss group. The Anglo-Dutch giant gradually acquired the rest of Strauss's ice-cream shares until in 2014 it owned the whole division. <a href=\"https://www.strauss-group.com/about-us/history_and_legacy/\" target=\"_blank\">(Strauss Group website)</a> Earlier still in the 1990s Unilever had also acquired the food-industry firm Bestfoods and Israel's Tami. <a href=\"https://www.just-food.com/news/israel-unilever-takes-control-of-strauss-ice-cream/?cf-view\" target=\"_blank\">(Source: Just Food)</a>"
            }
          },
          {
            "id": "tVdPFR0HKT",
            "type": "image",
            "data": {
              "caption": "The Unilever-Strauss partnership story on Strauss's official site",
              "file": {
                "fileId": "d9f48f6f-2168-4df5-a5a1-d0eba1f8ceae"
              }
            }
          },
          {
            "id": "uW_LLNK2DY",
            "type": "paragraph",
            "data": {
              "text": "According to its 2023 annual report, Unilever operates in Israel under the umbrella name \"Unilever Israel\", owning eight companies in an integrated manner. <a href=\"https://www.unilever.com/files/92ui5egz/production/b09c3510ee7cec58440d5f044f02bdefe85aa186.pdf\" target=\"_blank\">(Unilever website)</a>"
            }
          },
          {
            "id": "fqs-RwMz9P",
            "type": "paragraph",
            "data": {
              "text": "Unilever Israel has four factories in the cities of Arad, Safed, Acre and Haifa, and has created jobs for 1,850 people in the Israeli economy. <a href=\"https://www.unilever.co.il/our-company/our-factories/\" target=\"_blank\">(Source: Unilever Israel)</a> <a href=\"https://www.unilever.co.il/our-company/\" target=\"_blank\">(Unilever Israel)</a>"
            }
          },
          {
            "id": "M4qWU3o3gF",
            "type": "image",
            "data": {
              "caption": "",
              "file": {
                "fileId": "f39f2528-e529-488a-b5ff-59fb4ef6682f"
              }
            }
          },
          {
            "id": "zzVY7d9C5Q",
            "type": "image",
            "data": {
              "caption": "Photos of Unilever factories in Israel",
              "file": {
                "fileId": "4d0a0933-f5a1-47d0-901f-e2f1ed1b6337"
              }
            }
          },
          {
            "id": "VIGIAnjNOv",
            "type": "header",
            "data": {
              "text": "Troublesome ice cream",
              "level": 3
            }
          },
          {
            "id": "FnxtczCoZw",
            "type": "paragraph",
            "data": {
              "text": "Unilever has often been accused by pro-Palestinian movements of supporting the Israeli regime. But what re-drew particular attention to this company in recent years was the Ben & Jerry's story in the occupied settlements."
            }
          },
          {
            "id": "1XL9NEPPjB",
            "type": "paragraph",
            "data": {
              "text": "Unilever is currently one of the three largest ice-cream businesses in the world. <a href=\"https://www.insidermonkey.com/blog/5-biggest-ice-cream-companies-in-the-world-1103401/3/\" target=\"_blank\">(Insider Monkey website)</a> In 2023 the company earned close to €8 billion from ice-cream sales, thanks to brands like Ben & Jerry's and Magnum. <a href=\"https://www.unilever.com/files/66bc4aea-608f-46ee-8da3-cde0ec8ebe90/unilever-annual-report-and-accounts-2023.pdf\" target=\"_blank\">(Unilever annual report)</a> Ben & Jerry's is a well-known American ice-cream brand that tries to make attention to social issues part of its identity. The company was acquired by Unilever in 2000. <a href=\"https://www.unileverusa.com/brands/ice-cream/ben-jerrys/\" target=\"_blank\">(Unilever USA)</a>"
            }
          },
          {
            "id": "f4PVBtKvbw",
            "type": "paragraph",
            "data": {
              "text": "Ben & Jerry's board, in a statement in 2021, announced it would end activities in the occupied settlements of Palestine because of the Israeli regime's widespread violations of international law and human rights. The statement explained the reason for the decision: producing or selling product in Zionist settlements contradicted the company's emphasised values, including human rights. Ben & Jerry's nevertheless clarified that it would continue selling its products in other parts of occupied Palestine (Israel). This decision was to take effect after 2022, with the expiry of Ben & Jerry's contract with its exclusive distributor in occupied Palestine (Israel). <a href=\"https://www.benjerry.com/about-us/media-center/opt-statement\" target=\"_blank\">(Ben & Jerry's official site)</a> <a href=\"https://www.nbcnews.com/business/business-news/ben-jerry-s-withdraws-sales-israeli-settlements-clashes-parent-company-n1274403\" target=\"_blank\">(NBCNews)</a>"
            }
          },
          {
            "id": "Xnlto83xcD",
            "type": "image",
            "data": {
              "caption": "Ben & Jerry's factory in Be'erotayim in occupied Palestine (Israel)",
              "file": {
                "fileId": "38f0fd8f-ef19-4d7b-a008-cc59250f89b0"
              }
            }
          },
          {
            "id": "KUXtYrFrOj",
            "type": "paragraph",
            "data": {
              "text": "The decision was supported by pro-Palestinian movements including BDS — and simultaneously criticised by bodies aligned with the Israeli regime. <a href=\"https://bdsmovement.net/news/unilever-stop-undermining-ben-jerrys-decision-end-israel-settlement-business\" target=\"_blank\">(BDS)</a> One of the first reactions came from the then-Interior Minister of the Israeli regime. A week after Ben & Jerry's announcement, he said the regime's officials were trying — with the help of Jewish communities and Israel supporters in America — to drive a popular boycott of the company and make it back away from its decision. <a href=\"https://www.timesofisrael.com/interior-minister-israel-drumming-up-us-grassroots-boycott-of-ben-jerrys/\" target=\"_blank\">(The Times of Israel)</a>"
            }
          },
          {
            "id": "7FU4EHLS_g",
            "type": "image",
            "data": {
              "caption": "Israel-regime supporters gather in Manhattan, New York to protest and call for a boycott of Ben & Jerry's — 2021",
              "file": {
                "fileId": "83c5b7c7-fd14-4bfc-bb1d-23389baf52d6"
              }
            }
          },
          {
            "id": "XbYYYPZNBG",
            "type": "paragraph",
            "data": {
              "text": "Some major Unilever shareholders also — implicitly or explicitly — threatened the company over its subsidiary's controversial decision. <a href=\"https://www.reuters.com/markets/europe/unilever-expects-new-ben-jerrys-arrangement-israel-by-year-end-2022-02-10/\" target=\"_blank\">(Reuters)</a> Interestingly, various lobbies and figures also pressured Unilever to reverse the decision as soon as possible, but this had no effect on the will of Ben & Jerry's executives. <a href=\"https://thehill.com/homenews/state-watch/566069-florida-takes-action-against-ben-jerrys-parent-company-amid-boycott/\" target=\"_blank\">(The Hill)</a> A Daily Mail article points to some of the pressures that built up around this issue. <a href=\"https://www.dailymail.co.uk/news/article-9814063/Unilever-chief-says-company-fully-committed-Israel.html\" target=\"_blank\">(Daily Mail)</a>"
            }
          },
          {
            "id": "EMCUofDlGo",
            "type": "image",
            "data": {
              "caption": "Ayelet Shaked, then-interior-minister of the Zionist regime, visiting Ben & Jerry's factory in Israel — July 2021",
              "file": {
                "fileId": "4b478e80-2c4a-4a9f-97f9-446e5aaeac45"
              }
            }
          },
          {
            "id": "vkdzzoBpmD",
            "type": "paragraph",
            "data": {
              "text": "Among the critics was Unilever's then-CEO Alan Jope (parent of Ben & Jerry's), who said: \"It is better that Unilever's subsidiary brands do not weigh in on issues outside their expertise.\" Jope's comments showed Unilever was applying pressure on Ben & Jerry's. He also said that \"Unilever is trying to find a way to put Ben & Jerry's products back on sale in the settlements despite the board's decision.\" <a href=\"https://www.reuters.com/markets/europe/unilever-expects-new-ben-jerrys-arrangement-israel-by-year-end-2022-02-10/\" target=\"_blank\">(Reuters)</a> Jope assured that \"the company under his management is fully committed to trading with Israel.\" <a href=\"https://www.dailymail.co.uk/news/article-9814063/Unilever-chief-says-company-fully-committed-Israel.html\" target=\"_blank\">(Daily Mail)</a>"
            }
          },
          {
            "id": "h-Nj4YimO9",
            "type": "image",
            "data": {
              "caption": "Alan Jope, then-CEO of Unilever",
              "file": {
                "fileId": "871a0e5a-720a-4bb4-a829-c6ef0dff50cf"
              }
            }
          },
          {
            "id": "-T6PANgpxj",
            "type": "paragraph",
            "data": {
              "text": "The flood of reactions reached as high as the prime ministerial level: Naftali Bennett, then-prime minister of Israel, warned Unilever CEO Alan Jope of the \"serious consequences\" of Ben & Jerry's decision. <a href=\"https://fortune.com/2022/12/16/unilever-ben-jerrys-israel-west-bank-ice-cream/\" target=\"_blank\">(Fortune)</a> These sensitivities indicated that the implementation of Ben & Jerry's decision could be a major blow to Israel's prestige and might trigger similar moves by other companies to reconsider their Israeli-market presence."
            }
          },
          {
            "id": "2vG7B2xaGl",
            "type": "paragraph",
            "data": {
              "text": "The Israeli government called Ben & Jerry's action immoral and threatened Unilever over it. Unilever in turn pledged to find a solution to the matter by the following year. In its statement the company emphasised that \"as in the past, it in no way supports the Boycott Israel movement (BDS).\" <a href=\"https://www.reuters.com/business/retail-consumer/unilever-sells-ben-jerrys-israeli-business-2022-06-29/?_x_tr_sl=en&amp;_x_tr_tl=fa&amp;_x_tr_hl=en-US&amp;_x_tr_pto=wapp\" target=\"_blank\">(Reuters)</a>"
            }
          },
          {
            "id": "fwbHKPGTEA",
            "type": "header",
            "data": {
              "text": "Israel wants its ice cream",
              "level": 3
            }
          },
          {
            "id": "e7MlrCeqeU",
            "type": "paragraph",
            "data": {
              "text": "In the end, in the face of Ben & Jerry's independent board and its insistence on its decision, Unilever found a practical workaround: selling Ben & Jerry's shares in occupied Palestine (Israel) to the Israeli company \"Blue and White\". This step let that company sell Ben & Jerry's products in the occupied territories under Arabic and Hebrew names (no longer English). <a href=\"https://www.unilever.com/news/press-and-media/press-releases/2022/unilever-statement-on-ben-jerrys/\" target=\"_blank\">(Unilever website)</a> <a href=\"https://bdsmovement.net/news/statement-unilevers-sale-ben-jerrys-interests-apartheid-israel\" target=\"_blank\">(BDS)</a>"
            }
          },
          {
            "id": "eBUxUuuewl",
            "type": "paragraph",
            "data": {
              "text": "Reuters called Unilever's decision a move to \"neutralise the front to boycott Israel\", and the Israeli regime's Foreign Ministry described it as a \"great victory\". <a href=\"https://www.reuters.com/business/retail-consumer/unilever-sells-ben-jerrys-israeli-business-2022-06-29/?_x_tr_sl=en&amp;_x_tr_tl=fa&amp;_x_tr_hl=en-US&amp;_x_tr_pto=wapp\" target=\"_blank\">(Reuters)</a> Even Yair Lapid, Israel's next prime minister, hailed the change as a \"victory\" against discrimination and hatred! <a href=\"https://www.bbc.com/news/world-middle-east-62643392\" target=\"_blank\">(BBC)</a>"
            }
          },
          {
            "id": "DgHc9G4JOZ",
            "type": "paragraph",
            "data": {
              "text": "What is interesting is that Unilever neutralised Ben & Jerry's decision while the same company had taken a firm stance on the Ukraine war: in a statement it called Russia's actions barbaric and announced strict limits on its activities in Russia. <a href=\"https://www.unilever.com/news/press-and-media/press-releases/2023/unilever-statement-on-the-war-in-ukraine/\" target=\"_blank\">(Unilever's official website)</a>"
            }
          },
          {
            "id": "C5LslRwbpi",
            "type": "paragraph",
            "data": {
              "text": "The Ben & Jerry's and Unilever story is a complex and lengthy matter with many dimensions, more than can be detailed in this article. But perhaps the most important point is the importance of large companies' behaviour and its impact on various equations — enough that the leadership of countries is forced to respond at the highest levels."
            }
          },
          {
            "id": "Qie2lIixaL",
            "type": "header",
            "data": {
              "text": "The story continues…",
              "level": 3
            }
          },
          {
            "id": "csNZXZD-ks",
            "type": "paragraph",
            "data": {
              "text": "The rift between Unilever and Ben & Jerry's is widening daily, and amid these tremors new matters are also emerging. On 13 November 2024 Ben & Jerry's filed a complaint in the New York federal court against its parent company Unilever — containing a number of very interesting items."
            }
          },
          {
            "id": "9_XMx0X9yT",
            "type": "paragraph",
            "data": {
              "text": "In the text of this complaint, Unilever is accused of suppressing and silencing Ben & Jerry's repeated attempts to issue a statement supporting Palestinians in Gaza — a statement that would also call for an immediate ceasefire in Gaza. Unilever also censored a public Ben & Jerry's statement intended to support anti-war protesters at American universities."
            }
          },
          {
            "id": "cL0IU_a05p",
            "type": "paragraph",
            "data": {
              "text": "According to this famous American ice-cream maker's claim, the parent company threatened to dismiss its independent board and sue them if Ben & Jerry's published a statement calling for an immediate ceasefire. The head of Unilever's ice-cream division and the company's legal director have also threatened Unilever employees that they would face consequences if they released a statement in support of a ceasefire."
            }
          },
          {
            "id": "7eVGNmyfMk",
            "type": "paragraph",
            "data": {
              "text": "Ben & Jerry's has also claimed that Unilever prevented the company's financial donations to two organisations — Jewish Voice for Peace and the Council on American-Islamic Relations — which are collecting and delivering humanitarian aid to Palestinians caught up in the Gaza war. The text of the complaint states that Unilever justified blocking this on the grounds of adopting a neutral position in the conflict. Meanwhile Unilever itself made a €500,000 donation to an Israeli medical-services and blood-bank body that provides aid to Israeli army personnel."
            }
          },
          {
            "id": "MVSDDkXOT7",
            "type": "paragraph",
            "data": {
              "text": "Unilever, in response to the complaint, denied the claims and said: \"Our hearts go out to all victims of the recent bitter events in the region.\" <a href=\"https://www.reuters.com/business/retail-consumer/ben-jerrys-says-parent-unilever-silenced-it-over-gaza-stance-2024-11-14/\" target=\"_blank\">(Reuters)</a> <a href=\"https://www.esgdive.com/news/ben-jerrys-sues-parent-company-unilever-for-stifling-its-stance-on-gaza/733385/\" target=\"_blank\">(American outlet ESG Dive)</a>"
            }
          },
          {
            "id": "uOzvpGPBJp",
            "type": "header",
            "data": {
              "text": "Participation in settlement-building",
              "level": 3
            }
          },
          {
            "id": "w68iQx8Hqd",
            "type": "paragraph",
            "data": {
              "text": "The Ben & Jerry's story was not the Anglo-Dutch company's first partnership with Zionists in their settlement-building. In 2001 Unilever entered the Zionist settlements by acquiring 51% of Beigel & Beigel — a company located in the Barkan industrial zone in the Zionist settlement of Ariel. <a href=\"https://www.theguardian.com/world/2008/dec/01/israel-palestine-unilever\" target=\"_blank\">(The Guardian)</a>"
            }
          },
          {
            "id": "pyTSDhUJxC",
            "type": "image",
            "data": {
              "caption": "View of the Barkan industrial zone",
              "file": {
                "fileId": "1d133791-c577-49f2-babd-b6904f46b0b8"
              }
            }
          },
          {
            "id": "-Gv0iNjAkS",
            "type": "paragraph",
            "data": {
              "text": "According to the Dutch newspaper NRC, this issue drew attention in 2006 through a report by a Dutch NGO called United Civilians for Peace (UCP). UCP asked Unilever — then headquartered in Rotterdam — to comply with international law and withdraw from the settlements. <a href=\"https://www.nrc.nl/nieuws/2013/02/04/unilever-sluit-fabriek-in-israelische-nederzetting-a1437554\" target=\"_blank\">(Dutch newspaper NRC)</a> In 2008 Unilever announced it would withdraw its stake in the factory in the Ariel settlement. Unilever stated, however, that this was a strategic — not ethical — decision, following the company's policy of exiting non-core businesses. <a href=\"https://www.theguardian.com/world/2008/dec/01/israel-palestine-unilever\" target=\"_blank\">(The Guardian)</a> But this decision was not implemented, and so pressure from UCP and others continued. Two years later Unilever announced that, having failed to sell its stake, it would buy the remaining 49% of Beigel & Beigel and then move the factory from the Ariel settlement. Unilever again emphasised that this relocation was not political but a business decision aimed at cost reduction. <a href=\"https://www.nrc.nl/nieuws/2013/02/04/unilever-sluit-fabriek-in-israelische-nederzetting-a1437554\" target=\"_blank\">(NRC)</a> <a href=\"https://www.israelnationalnews.com/news/140039\" target=\"_blank\">(Israel National News)</a>"
            }
          },
          {
            "id": "6FsLYP88Y6",
            "type": "image",
            "data": {
              "caption": "Unilever's Beigel & Beigel factory in the Ariel settlement",
              "file": {
                "fileId": "ab18f93c-f966-466e-97e4-d5b663ca94e9"
              }
            }
          },
          {
            "id": "bmd8hnsO9L",
            "type": "paragraph",
            "data": {
              "text": "In early 2013 Unilever announced it had dismantled its factory in the Ariel settlement and moved it to Safed. Several civil-society organisations including UCP confirmed this. <a href=\"https://bdsmovement.net/news/unilever-removed-its-beigel-beigel-factory-from-illegal-barkan-settlement\" target=\"_blank\">(BDS)</a> This happened just days after the publication of the UN fact-finding mission's report on the human-rights situation in Palestine and other occupied Arab areas. The report warned of the creeping annexation of occupied areas and called for the boycott of Israel for its violations of Palestinian human rights and international law. The UN report asked companies to end any commercial interests in the settlements. <a href=\"https://www.ohchr.org/sites/default/files/Documents/HRBodies/HRCouncil/RegularSession/Session19/FFM/FFMSettlements.pdf\" target=\"_blank\">(UN High Commissioner for Human Rights)</a> <a href=\"https://mondoweiss.net/2013/01/settlements-international-governments/\" target=\"_blank\">(news site Mondoweiss)</a> Thus, after 12 years, Unilever finally agreed to retreat from the Zionist settlements. The decision appears to have been taken reluctantly and under widespread social pressure. <a href=\"https://bdsmovement.net/news/unilever-removed-its-beigel-beigel-factory-from-illegal-barkan-settlement\" target=\"_blank\">(BDS)</a> The NGO UCP notes in its report that Unilever received subsidies from Israel for producing in the settlements. Companies operating in the settlements also benefit from cheap Palestinian labour; workers who are not even covered by Israel's official minimum wage. <a href=\"https://www.theguardian.com/world/2008/dec/01/israel-palestine-unilever\" target=\"_blank\">(The Guardian)</a>"
            }
          },
          {
            "id": "QYumbNFS9-",
            "type": "image",
            "data": {
              "caption": "Beigel & Beigel factory in the Ariel settlement after closure",
              "file": {
                "fileId": "4320af1c-7746-40b2-a7f4-5ce927562055"
              }
            }
          },
          {
            "id": "djfSgU9hOh",
            "type": "header",
            "data": {
              "text": "Charity in occupied land",
              "level": 3
            }
          },
          {
            "id": "Kjhndw6W-q",
            "type": "paragraph",
            "data": {
              "text": "Unilever also has a hand in charitable activities in Israel. One example of these partnerships is its cooperation with Latet. Latet (meaning \"to give\") is the largest active NGO in fighting poverty, helping the needy, and ensuring food security in the Zionist regime. The organisation provides monthly aid to 95,000 Zionist families and 1,450 Holocaust survivors(!). <a href=\"https://www.latet.org.il/en/about/\" target=\"_blank\">(Latet website)</a>"
            }
          },
          {
            "id": "xm_V5ZjN-I",
            "type": "image",
            "data": {
              "caption": "",
              "file": {
                "fileId": "5f1d26e3-cccd-42e3-ae6a-b5b9a98fd0eb"
              }
            }
          },
          {
            "id": "uWVInqZ59b",
            "type": "paragraph",
            "data": {
              "text": "One of Latet's recent activities is preparing emergency aid for residents of war-affected areas in the northern front of occupied Palestine (Israel) to enable them to continue living under current conditions. According to information on the foundation's website in November-December 2024, Latet has sent 196,000 food and hygiene packages to residents of these areas since the start of the war. The foundation is also working to prepare more shelter-appropriate packages. Each of these packages includes food, hygiene items, water, first aid, a radio and batteries, and toys — enough to meet the needs of several families for four days. These packages help Zionists endure longer inside shelters. <a href=\"https://www.latet.org.il/en/world-1/articles/israelatwar2024\" target=\"_blank\">(Latet)</a>"
            }
          },
          {
            "id": "htiNzg5Wcy",
            "type": "image",
            "data": {
              "caption": "Latet poster for sending aid to residents in the north",
              "file": {
                "fileId": "2b85d968-c232-42a9-8029-97033e568d89"
              }
            }
          },
          {
            "id": "NSjj2OCQvv",
            "type": "paragraph",
            "data": {
              "text": "Unilever is also one of the participants in this aid. On Unilever's official YouTube page a video has been posted of the company's participation in preparing food and hygiene packages for Latet. In the video, Unilever employees wearing clothing with shared Latet branding eagerly pack the company's food and hygiene products into Latet packages. This is part of Unilever's broader cooperation with Latet, some of which is also covered on Latet's social-media pages on Facebook and Instagram."
            }
          },
          {
            "id": "VUKdx3N_uU",
            "type": "paragraph",
            "data": {
              "text": "📷📷📷📷📷"
            }
          },
          {
            "id": "KIQ9MfRc2c",
            "type": "paragraph",
            "data": {
              "text": "The narrator of the video explains: \"Unilever has been donating to thousands of Israeli (Zionist) families for over fifteen years. This year, too, Unilever employees from across Israel have come together to send food packages to Jews and embrace them with their hearts… This year we are all facing challenges (the war) that make us coming together and \"giving\" to preserve Israel more important than ever.\""
            }
          },
          {
            "id": "B-fz4j3M25",
            "type": "paragraph",
            "data": {
              "text": "<a href=\"https://youtu.be/2lhNfQJ6YvE?feature=shared\" target=\"_blank\">Link to the YouTube video</a>"
            }
          },
          {
            "id": "GILtE2-tHs",
            "type": "paragraph",
            "data": {
              "text": "Unilever's cooperation with Latet is such that the foundation lists Unilever among its partners and supporters. Looking at the names on that list, other large multinational names also appear: Coca-Cola, Intel, Osem (Nestlé-owned), Strauss (Danone- and PepsiCo-owned), and even Germany's Federal Ministry of Economy. <a href=\"https://www.latet.org.il/en/partners/\" target=\"_blank\">(Latet)</a>"
            }
          },
          {
            "id": "Wpj-1VoujP",
            "type": "image",
            "data": {
              "caption": "",
              "file": {
                "fileId": "52f2faf5-2956-4c8e-9102-4506fe878e48"
              }
            }
          },
          {
            "id": "9sh-rZsps0",
            "type": "header",
            "data": {
              "text": "Unilever and the boycott of Israel",
              "level": 3
            }
          },
          {
            "id": "yxEAsXIkhN",
            "type": "paragraph",
            "data": {
              "text": "After the Gaza war began, the boycott of multinational companies accused of supporting the Israeli regime again drew attention from people in many countries. In Unilever's Q4 2023 sales report, the company's expected growth in Southeast Asia was hit. The reason was the boycott of multinationals — including Unilever — by Indonesians, a boycott shaped specifically in response to the regional situation and the Gaza war. According to the company, in Indonesia — home to over 200 million Muslims — Unilever's Q4 sales fell by a double-digit percentage. <a href=\"https://www.middleeastmonitor.com/20240208-unilever-takes-sales-hit-in-indonesia-over-anti-israel-boycott/\" target=\"_blank\">(Middle East Monitor)</a>"
            }
          },
          {
            "id": "1kNUhK5DBN",
            "type": "paragraph",
            "data": {
              "text": "These conditions still continue for Unilever. The company's CFO announced a decision to make \"extensive\" changes in Indonesia. The reason given was the boycott of multinationals by the Indonesian public. These boycotts have even hit Unilever's share price. <a href=\"https://www.reuters.com/business/retail-consumer/unilever-making-drastic-changes-indonesia-amid-boycotts-2024-10-24/\" target=\"_blank\">(Reuters)</a>"
            }
          },
          {
            "id": "4kQc4s0Zei",
            "type": "paragraph",
            "data": {
              "text": "Even some academic articles in Indonesia have examined the impact of the popular Unilever boycott. The results of these studies show that the Unilever boycott in Indonesia — especially after the fatwa of the country's Council of Religious Scholars — has had a significant impact on the company's financial performance and share price. <a href=\"https://ejournalugj.com/index.php/cicee/article/view/9287/4124\" target=\"_blank\">(Source)</a>"
            }
          },
          {
            "id": "vDqvzg5wAL",
            "type": "header",
            "data": {
              "text": "These — and more",
              "level": 3
            }
          },
          {
            "id": "REkXsIaZc0",
            "type": "paragraph",
            "data": {
              "text": "In 2023 Unilever was the third-largest producer of plastic pollution in the world. <a href=\"https://brandaudit.breakfreefromplastic.org/brand-audit-2023/\" target=\"_blank\">(Brand Audit)</a> The company put 1,700 multi-layer packaging sachets into the consumption cycle every second — i.e. 53 billion multi-layer sachets in a year. Sachets that count among the most destructive forms of plastic pollution. <a href=\"https://www.greenpeace.org.uk/news/unilever-profit-warning-delivered-by-greenpeace-uk-as-activists-scale-hq-in-plastic-pollution-protest/\" target=\"_blank\">Source: Greenpeace</a>"
            }
          },
          {
            "id": "8swwxFnvkZ",
            "type": "image",
            "data": {
              "caption": "",
              "file": {
                "fileId": "80fe2727-50ee-42f4-b99e-ad1164ecc95a"
              }
            }
          },
          {
            "id": "IedTvYJvmh",
            "type": "delimiter",
            "data": {}
          },
          {
            "id": "BP3unpvTOx",
            "type": "header",
            "data": {
              "text": "Unilever in Iran",
              "level": 2
            }
          },
          {
            "id": "940ommL3pd",
            "type": "paragraph",
            "data": {
              "text": "\"On 6 October 2003 (14 Mehr 1382) Unilever began activity in the Islamic Republic of Iran under the registered trade name Unilever Iran, and initially focused on officially importing some of its products. In 2005 (1384) Unilever planned for direct production of its products on the soil of the Islamic Republic of Iran and chose Qazvin province to invest, design and begin building its factory. In 2006 (1385) Unilever opened its production unit and began producing its products in Iran directly.\" <a href=\"https://unilever.ir/unilever-iran/\" target=\"_blank\">(Unilever Iran website)</a>"
            }
          },
          {
            "id": "hBYvdmESiG",
            "type": "image",
            "data": {
              "caption": "Unilever Iran's factory in Alborz Industrial Town, Qazvin province",
              "file": {
                "fileId": "17322403-834e-47e2-8a7a-aeabdc115eaf"
              }
            }
          },
          {
            "id": "xtTRzZzSSk",
            "type": "image",
            "data": {
              "caption": "Clear shampoo production line at the Unilever Iran factory — Alborz Industrial Town, Qazvin province",
              "file": {
                "fileId": "dc2fb676-91de-4230-a2e0-82f7a1ecd4f9"
              }
            }
          },
          {
            "id": "K5W73tDWQe",
            "type": "paragraph",
            "data": {
              "text": "According to Unilever's 2023 annual report, Unilever Iran on Zagros Street in Tehran is wholly (99.99%) owned by the Unilever Group and operates under it. <a href=\"https://www.unilever.com/files/92ui5egz/production/b09c3510ee7cec58440d5f044f02bdefe85aa186.pdf\" target=\"_blank\">(Unilever annual report)</a>"
            }
          },
          {
            "id": "j5us7xh420",
            "type": "image",
            "data": {
              "caption": "",
              "file": {
                "fileId": "a438251d-0fa8-4fc8-a3b6-37f9ca44b25a"
              }
            }
          },
          {
            "id": "m1YYOczB_C",
            "type": "paragraph",
            "data": {
              "text": "Unilever's products are widely present in the Iranian market today under well-known brands such as Omo, Domestos, Cif, Comfort, Dove, Clear, Sunsilk, Rexona, Closeup, Signal, LUX and Axe. <a href=\"https://unilever.ir/our-brands/all-brands/\" target=\"_blank\">(Unilever Iran)</a> <a href=\"https://www.unilever.com/brands/all-brands/\" target=\"_blank\">(Unilever)</a>"
            }
          },
          {
            "id": "oqrknAxKAK",
            "type": "image",
            "data": {
              "caption": "",
              "file": {
                "fileId": "1ae0fc51-51b6-4aba-aa91-d02ba4076229"
              }
            }
          },
          {
            "id": "E-Loy7JoBy",
            "type": "paragraph",
            "data": {
              "text": "[1] Vitco"
            }
          },
          {
            "id": "54eOHifLZL",
            "type": "paragraph",
            "data": {
              "text": "[2] Bestfoods"
            }
          },
          {
            "id": "kPq20qz_m8",
            "type": "paragraph",
            "data": {
              "text": "[3] Tami food company"
            }
          },
          {
            "id": "pftkkpokAA",
            "type": "paragraph",
            "data": {
              "text": "[4] Occupied Palestinian Territory"
            }
          },
          {
            "id": "R3_on8DCSG",
            "type": "paragraph",
            "data": {
              "text": "[5] BDS"
            }
          },
          {
            "id": "MZ30E_ZY7C",
            "type": "paragraph",
            "data": {
              "text": "[6] Daily Mail"
            }
          },
          {
            "id": "oSVhUPG0rO",
            "type": "paragraph",
            "data": {
              "text": "[7] Independent Board of Directors"
            }
          },
          {
            "id": "4PKFPZONu2",
            "type": "paragraph",
            "data": {
              "text": "[8] Jewish Voice for Peace"
            }
          },
          {
            "id": "sFiDcX5-Rd",
            "type": "paragraph",
            "data": {
              "text": "[9] Council on American-Islamic Relations"
            }
          },
          {
            "id": "dfTQFrPTmW",
            "type": "paragraph",
            "data": {
              "text": "[10] Barkan"
            }
          },
          {
            "id": "Kdur21I8fq",
            "type": "paragraph",
            "data": {
              "text": "[11] Ariel"
            }
          },
          {
            "id": "bv_ogoyQtN",
            "type": "paragraph",
            "data": {
              "text": "[12] NRC"
            }
          },
          {
            "id": "8HWHaYCoJT",
            "type": "paragraph",
            "data": {
              "text": "[13] United Civilians for Peace"
            }
          },
          {
            "id": "OTI8plfblp",
            "type": "paragraph",
            "data": {
              "text": "[14] Latet"
            }
          },
          {
            "id": "j-C6KQzeCm",
            "type": "paragraph",
            "data": {
              "text": "[15] YouTube"
            }
          }
        ]
      }
    },
    {
      "slug": "carrefour",
      "sourceUrl": "https://qlist.ir/blog/carrefour/",
      "companySlug": "carrefour",
      "title": {
        "en": "Boycotting Carrefour: A-to-Z of supporting Israel and Hyperstar's proxy presence in the Iranian market",
        "fa": "تحریم کارفور؛ صفر تا صد حمایت از اسرائیل تا حضور نیابتی هایپراستار در بازار ایران"
      },
      "summary": {
        "en": "An introduction to Carrefour, documentation of its support for Israel, and Hyperstar's proxy presence in the Iranian market, citing official sources.",
        "fa": "معرفی شرکت کارفور، مستندات حمایت از اسرائیل و حضور نیابتی هایپراستار در بازار ایران با استناد به منابع رسمی"
      },
      "cover": null,
      "body": {
        "time": 1769935979128,
        "version": "2.31.0-rc.7",
        "blocks": [
          {
            "id": "p6MfvVy7tpG",
            "type": "header",
            "data": {
              "text": "هایپراستار، سایه کارفور در آسمان ایران",
              "level": 2
            }
          },
          {
            "id": "H_b858INaO",
            "type": "image",
            "data": {
              "caption": "هایپر استار شعبه ایران‌مال تهران",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 1024,
                "height": 488,
                "size": "52376",
                "name": "m3zgori3qqu8.webp",
                "title": "M3zgori3qqu8.webp",
                "extension": "webp",
                "fileId": "c523758b-42e3-4f93-b90f-24749468edc4",
                "fileURL": "/files/c523758b-42e3-4f93-b90f-24749468edc4",
                "url": "/qlist-assets/c523758b-42e3-4f93-b90f-24749468edc4.webp"
              }
            }
          },
          {
            "id": "ObVY24LRd7",
            "type": "quote",
            "data": {
              "text": "هایپراستار را همه می‌شناسیم. فروشگاه زنجیره‌ای که از سال ۸۸ در ایران حضور دارد و به تخفیف‌های خوب، تنوع برندها و کامل بودن محصولاتش شناخته شده است. هایپراستار در سال‌های اخیر هم با <b>اسنپ</b> یک شراکت راهبردی تحت برند اسنپ‌مارکت در حوزه فروش غیرحضوری راه انداخته تا سهم بازارش در ایران را افزایش دهد. همچنین برند <b>مایلی‌مارکت</b> زیرمجموعه هایپراستار، برای رقابت با فروشگاه‌های کوچک‌تر، مدتی است که در بازار ایران فعال است. شاید ادعای بزرگی باشد اگر کسی ادعا کند <b>با خرید از هایپراستار دارید به اقتصاد اسرائیل کمک می‌کنید!</b> آن هم در قلب بزرگ‌ترین دشمن اسرائیل، یعنی ایران. دشمنی که بارها تا درگیری نظامی با اسرائیل هم پیش رفته است. در این یادداشت این ادعای عجیب را با هم بررسی می‌کنیم. با ما همراه باشید.",
              "caption": "",
              "alignment": "left"
            }
          },
          {
            "id": "JDwgoyZX9Z",
            "type": "delimiter",
            "data": {}
          },
          {
            "id": "Rz6xJ7Bj8my",
            "type": "header",
            "data": {
              "text": "فصل اول؛ کارفور مفتخر است!",
              "level": 2
            }
          },
          {
            "id": "bNDJ7Jhvvle",
            "type": "quote",
            "data": {
              "text": "«کارفور مفتخر است که امروز ۵۰ فروشگاه در اسرائیل افتتاح کرده و راهبرد رشد بین المللی خود را [در اسرائیل] دنبال می‌کند. اسرائیل اکنون پنجاه و دومین کشوری است که کارفور در سراسر جهان در آن فعالیت می‌کند، به ویژه به لطف شرکای فرانچایز (تابلوسپاری) ما. ما مطمئن هستیم که کارفور به مشتریان اسرائیلی که از اثرات <b>بحران هزینه زندگی</b> آسیب دیده‌اند کمک خواهد کرد.»",
              "caption": "<b>الکساندر بومپارد</b>، رئیس هیئت مدیره و مدیرعامل گروه کارفور / ۱۹ اردیبهشت ۱۴۰۲ (<a href=\"https://www.carrefour.com/en/news/2023/arrivee-de-carrefour-en-israel\">منبع: وبسایت رسمی کارفور</a>)",
              "alignment": "left"
            }
          },
          {
            "id": "Ot55C3I0B6",
            "type": "image",
            "data": {
              "caption": "نقل قول بومپارد در سایت رسمی کارفور",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 1024,
                "height": 625,
                "size": "49036",
                "name": "fpfghszkvcep.webp",
                "title": "Fpfghszkvcep.webp",
                "extension": "webp",
                "fileId": "803b93bb-d14f-479f-b452-00c03d7a6ec2",
                "fileURL": "/files/803b93bb-d14f-479f-b452-00c03d7a6ec2",
                "url": "/qlist-assets/803b93bb-d14f-479f-b452-00c03d7a6ec2.webp"
              }
            }
          },
          {
            "id": "uzVj_-4O8W1",
            "type": "paragraph",
            "data": {
              "text": "ممکن است نام کارفور به گوشتان آشنا بیاید. غول زنجیره‌ای فرانسوی، که قدیمی‌ترین خرده فروش زنجیره‌ای دنیا و هفتمین برند با ارزش، در صنعت خرده فروشی است. کارفور که امروزه بیش از 13.900 شعبه در سراسر دنیا دارد، (<a href=\"https://www.carrefour.com/fr/groupe\">منبع: وبسایت گروه کارفور</a>)، سال‌هاست که به حمایت از رژیم اسرائیل متهم بوده و پای ثابت فهرست برندهای حامی این رژیم است. اما مگر یک فروشگاه زنجیره‌ای چه کمکی می‌تواند به اقتصاد اسرائیل بکند؟"
            }
          },
          {
            "id": "uozpNfbhMZJ",
            "type": "paragraph",
            "data": {
              "text": "نقل قول ابتدای متن از <b>الکساندر بومپارد</b> رییس هیات مدیره کارفور است. او در این سخنان به حضور کارفور در اسرائیل با کمک شریکانش اشاره می‌کند. او همچنین می‌گوید که حضور کارفور در سرزمین‌های اشغالی می‌تواند کمک حال اسرائیلی‌هایی باشد که از <b>بحران هزینه زندگی</b> آسیب دیده‌اند."
            }
          },
          {
            "id": "2k06g6V5aaF",
            "type": "quote",
            "data": {
              "text": "بر اساس اطلاعات منتشر شده توسط سازمان همکاری و توسعه اقتصادی (OECD)، اسرائیل بالاترین هزینه زندگی را در میان ۳۸ کشور این سازمان در سال ۲۰۲۲ داشته و از سوئیس هم پیشی گرفته است! این قضیه به بحران هزینه زندگی در اسرائیل مشهور است.",
              "caption": "<a href=\"https://www.i24news.tv/en/news/israel/economy/1693119432-israel-named-oecd-country-with-highest-cost-of-living-in-2022\">منبع: شبکه اسرائیلی i24</a>",
              "alignment": "left"
            }
          },
          {
            "id": "1QoTXwzDsDb",
            "type": "paragraph",
            "data": {
              "text": "اقتصاد اسرائیل به دلیل وابستگی به واردات در بخش‌هایی مثل صنایع غذایی و کشاورزی بسیار غیر رقابتی و انحصاری است. همین انحصار، شاخص هزینه زندگی را در سال‌های اخیر مدام بالا برده است. این موضوع که در اسرائیل از آن به بحران هزینه زندگی یاد می‌شود بسیاری از شهروندان دو پاسپورته را برای انتخاب اسرائیل به عنوان محل زندگی دچار تردید کرده است. قیمت مواد غذایی در اسرائیل طی دو دهه گذشته ۵۰ درصد افزایش یافته است و ۲۵ تا ۸۰ درصد بالاتر از میانگین کشورهای OECD است و محصولات لبنی، نوشابه‌ها و محصولات مبتنی بر غلات بسیار گران هستند. در بخش خرده‌فروشی مواد غذایی، سه سوپرمارکت‌ زنجیره‌ای محلی بیش از نیمی از بازار اسرائیل را به خود اختصاص داده‌اند. این انحصار رقابت را محدود می‌کند و باعث صعود قیمت‌ها می‌شود. <a href=\"https://oecdecoscope.blog/2025/04/02/why-is-life-so-expensive-in-israel/\">(منبع)</a>"
            }
          },
          {
            "id": "43QtLMxF2x",
            "type": "quote",
            "data": {
              "text": "تصور کنید در اسرائیل زندگی می‌کنید و هر روز با مسائل و ناامنی‌های مختلفی روبرو می‌شوید درحالی‌که دارید هزینه زندگی در سوئیس را پرداخت می‌کنید!",
              "caption": "",
              "alignment": "left"
            }
          },
          {
            "id": "H0usdcc_Bu",
            "type": "delimiter",
            "data": {}
          },
          {
            "id": "xmXNjL6O2ai",
            "type": "header",
            "data": {
              "text": "کارفور وارد می‌شود",
              "level": 3
            }
          },
          {
            "id": "wWDw3DKd54H",
            "type": "paragraph",
            "data": {
              "text": "اینجاست که کارفور وارد میدان می‌شود. کارفور با زنجیره تامین گسترده‌ و بین المللی‌اش می‌تواند هزینه تامین کالا را پایین بیاورد و به کمک شهروندان اسرائیلی بیاید. چیزی که مدیرعامل کارفور به آن اشاره کرده بود. این موضوع چنان از لحاظ تبلیغاتی برای صهیونیست‌ها حیاتی است که بعضاً مقاماتی در سطح نخست وزیر یا وزیر اقتصاد هنگام افتتاح شعب کارفور حضور پیدا می‌کنند! کارفور در تبلیغات خود ادعا می‌کند سبد خرید مشابهی با رقیبان محلی را می‌تواند <b>تا 60 درصد ارزان‌تر</b> به دست مصرف کننده برساند. <a href=\"https://www.timesofisrael.com/french-retail-chain-carrefour-opens-50-stores-across-israel-vowing-to-disrupt-prices/\">(تایمزِ اسرائیل)</a>"
            }
          },
          {
            "id": "wPxLni2GsJ",
            "type": "image",
            "data": {
              "caption": "نخست وزیر و وزیر اقتصاد و صنعت اسرائیل، در شعبه بِت شِمِش کارفور اسرائیل به هنگام آغاز به کار رسمی این شعبه/۱۸ اردیبهشت ۱۴۰۲",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 1024,
                "height": 1341,
                "size": "197399",
                "name": "vvgcep0hovny.jpg",
                "title": "Vvgcep0hovny.jpg",
                "extension": "jpg",
                "fileId": "460ba094-4d4a-4e92-a134-bea582700cb3",
                "fileURL": "/files/460ba094-4d4a-4e92-a134-bea582700cb3",
                "url": "/qlist-assets/460ba094-4d4a-4e92-a134-bea582700cb3.jpg"
              }
            }
          },
          {
            "id": "y9u-ucaDTj1",
            "type": "paragraph",
            "data": {
              "text": "در تصاویر بالا نتانیاهو در حال اشاره به مبلغ فاکتور سبد خریدی است که کارفور ادعا دارد ۶۰ درصد ارزان‌تر تمام شده‌است. لوگوی کارفور بالای لیست سمت راست و عدد ۵۹.۳% تخفیف، بالای بنر خودنمایی می‌کند. <a href=\"https://www.gov.il/en/pages/event-carrefour080523\">( منبع: وبسایت رسمی دولت اسرائیل)</a>"
            }
          },
          {
            "id": "1vPB23a834F",
            "type": "quote",
            "data": {
              "text": "«ما متقاعد شده‌ایم که کارفور اسرائیل، یک راه‌حلی واقعی برای مصرف‌کنندگان اسرائیلی ارائه خواهد کرد و قدرت خرید آنها را به میزان قابل توجهی بهبود خواهد بخشید.»",
              "caption": "<b>پاتریک لاسفارگس</b>/رئیس بخش بین‌المللی کارفور (<a href=\"https://www.timesofisrael.com/french-retail-chain-carrefour-opens-50-stores-across-israel-vowing-to-disrupt-prices/\">منبع: تایمزِ اسرائیل</a>)",
              "alignment": "left"
            }
          },
          {
            "id": "S-Cu819Jkbc",
            "type": "paragraph",
            "data": {
              "text": "حضور برند معتبر، جهانی و نام آشنایی همچون کارفور را می‌توان نماد تلاش دولتمردان رژیم اسرائیل در جهت مقابله با بحران هزینه زندگی دانست؛ شاید شبیه پیمان ابراهیم که نماد شکستن انزوای سیاسی اسرائیل است."
            }
          },
          {
            "id": "y_s4TxDAGlU",
            "type": "paragraph",
            "data": {
              "text": "اما این تنها اتهام کارفور نیست. کارفور برای حضور بین المللی‌اش مدل‌های همکاری متنوعی دارد. یکی از این مدل‌‎ها استفاده از شرکای محلی و به اصطلاح تابلوسپاری به آن‌هاست. موضوعی که پرونده دوم کارفور را با خود به همراه دارد."
            }
          },
          {
            "id": "DwS1smd2Er",
            "type": "delimiter",
            "data": {}
          },
          {
            "id": "h7ov238X7Rp",
            "type": "header",
            "data": {
              "text": "کارفور مشارکت می‌کند",
              "level": 3
            }
          },
          {
            "id": "rNsuXhzEiv1",
            "type": "paragraph",
            "data": {
              "text": "در مدل مشارکتی کارفور معمولا با یک رقیب محلی، سرمایه‌گذاری 50-50 صورت می‌پذیرد و تمام شعب آن رقیب، به تابلوهای کارفور و زنجیره تامین کالایی‌اش متصل می‌شوند. اما شریک کارفور در اسرائیل کیست؟"
            }
          },
          {
            "id": "wUxFwGbL6Dx",
            "type": "paragraph",
            "data": {
              "text": "در 8 مارس 2022، گروه کارفور از یک قرارداد تابلوسِپاری جدید در اسرائیل با شرکت<b> الِکترا</b>/Electra Consumer Product و شرکت تابعه آن <b>یِنوت بیتان</b>/Yenot Bitan، رونمایی کرد."
            }
          },
          {
            "id": "r-4ni_YWkVO",
            "type": "paragraph",
            "data": {
              "text": "این دو شرکت هر دو از مشارکت کنندگان جدّی در شهرک‌سازی‌های غیرقانونی و شریک اشغال‌گری شهرک‌نشینان اسرائیلی هستند. نام آن‌ها در فهرست سازمان ملل به عنوان شرکای تجاری شهرک‌سازی‌های غیرقانونی قید شده است. <a href=\"https://www.ohchr.org/sites/default/files/documents/hrbodies/hrcouncil/sessions-regular/session31/database-hrc3136/23-06-30-Update-israeli-settlement-opt-database-hrc3136.pdf\">(منبع: کمیسریای عالی حقوق بشر سازمان ملل)</a>"
            }
          },
          {
            "id": "10flPQYPm-",
            "type": "image",
            "data": {
              "caption": "نام یکی از زیر مجموعه‌های اِلکترا در لیست سازمان ملل از مشارکت کنندگان در شهرک‌سازی غیرقانونی",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 1024,
                "height": 765,
                "size": "77252",
                "name": "pyewdur4anm9.webp",
                "title": "Pyewdur4anm9.webp",
                "extension": "webp",
                "fileId": "43777372-42e8-4f3b-bbab-c210ae06a75a",
                "fileURL": "/files/43777372-42e8-4f3b-bbab-c210ae06a75a",
                "url": "/qlist-assets/43777372-42e8-4f3b-bbab-c210ae06a75a.webp"
              }
            }
          },
          {
            "id": "zczVlEUNEGI",
            "type": "paragraph",
            "data": {
              "text": "الکترا یک هلدینگ بزرگ اسرائیلی است که مشارکت جدی در پروژه‌های شهرک‌سازی و دولتی اسرائیل و همچنین تأمین نیازهای شهرک‌نشینان دارد. تصمیم بر مشارکت با الکترا، کارفور را متهم به همکاری در اقدامات اشغال‌گرایانه شهرک‌نشینان کرده است."
            }
          },
          {
            "id": "kwyvDWA7G8p",
            "type": "paragraph",
            "data": {
              "text": "علت قرارگرفتن نام کارفور در همه فهرست‌های تحریم کالای صهیونیستی از جمله BDS، همین مشارکتش با الکترا است. <a href=\"https://bdsmovement.net/boycott-carrefour\">(BDS)</a>"
            }
          },
          {
            "id": "aHP9MVOM_zH",
            "type": "paragraph",
            "data": {
              "text": "خب، فرض می‌کنیم تا الان متوجه شدیم که کارفور چه نقشی در بقای اسرائیل ایفا می‌کند. حالا این ماجراها چه ارتباطی به هایپراستار و ما ایرانی‌ها دارد؟ آیا ما هم مشتری کارفور هستیم؟"
            }
          },
          {
            "id": "x0ncTaUp-wO",
            "type": "header",
            "data": {
              "text": "فصل دوم؛ هایپر استار، کارفورِ اسلامی!",
              "level": 2
            }
          },
          {
            "id": "yeVGAoo1ycZ",
            "type": "header",
            "data": {
              "text": "ماجِد و کارفور در ایران",
              "level": 3
            }
          },
          {
            "id": "e5I625XpsEL",
            "type": "paragraph",
            "data": {
              "text": "همان‌طور که پیش از این اشاره شد یکی از مدل‌های توسعه کارفور مشارکت و سرمایه گذاری مشترک با شرکای محلی است. توسعه کارفور در منطقه ما هم از همین الگو پیروی می‌کند. هلدینگ اماراتی <b>ماجِدالفُطَیم</b> (MAF)، شریک راهبردی کارفور در خاورمیانه است که بسیاری از شعب این منطقه از شمال آفریقا تا غرب آسیا از طریق مشارکت با همین هلدینگ افتتاح شده است."
            }
          },
          {
            "id": "hSjbT8gN1c6",
            "type": "quote",
            "data": {
              "text": "هلدینگ ماجدالفطیم در زمینه مراکز فروشگاهی، هایپرمارکت‌ها و هتل‌ها فعالیت دارد. این شرکت از ابتدای تأسیس خود یک شراکت کلیدی با کارفور ایجاد کرد. ماجد با پرداخت 2.5 میلیون درهم (530 میلیون دلار) در سال 2013 صاحب 25 درصد سهام این غول فرانسوی شد.",
              "caption": "<a href=\"https://www.reuters.com/article/business/carrefour-sells-stake-in-middle-east-venture-for-683-million-idUSBRE94L0Z5/\">منبع: رویترز</a>&nbsp;و <a href=\"https://www.thenationalnews.com/business/majid-al-futtaim-in-dh2-5-billion-carrefour-deal-to-buy-hypermarkets-1.576534/\">روزنامه اماراتی نَشنال نیوز</a>",
              "alignment": "left"
            }
          },
          {
            "id": "_bZCljDMEZP",
            "type": "paragraph",
            "data": {
              "text": "سال 1388 ماجد و کارفور اولین شعبه کارفور در ایران را در تهران و به نام هایپراستار افتتاح کردند. این شعبه با مشارکت 49-51 یک طرف ناشناس ایرانی در شرق تهران رسماً آغاز به کار کرد. از این 49 درصد طرف غیر ایرانی، 25 درصد متعلق به ماجد و 24 درصد متعلق به کارفور است. <a href=\"https://www.dailynewsegypt.com/2009/09/25/tehran-hypermarket-opens-without-carrefour-name/\">(دیلی نیوزِ مصر)</a>"
            }
          },
          {
            "id": "L8WE_ok2V6H",
            "type": "paragraph",
            "data": {
              "text": "مدیرعامل بخشِ مراکز خرید ماجد در ماه مِی سال 2007 در مصاحبه‌ای با رسانه Arabian Business توضیحات جالبی درباره حضورشان در ایران می‌دهد:"
            }
          },
          {
            "id": "iUh1rG3hMTE",
            "type": "quote",
            "data": {
              "text": "«گروه هایپرمارکت فرانسوی کارفور متعهد شده است که اولین هایپرمارکت خود را در ایران راه اندازی کند و بخش خرده فروشی گروه ماجدالفطیم (MAF) - که فروشگاه های کارفور را در خاورمیانه اداره می‌کند - نیز به این پروژه متعهد شده است.",
              "caption": "<a href=\"https://www.arabianbusiness.com/industries/retail/carrefour-plans-iranian-store-145419\">منبع: Arabian Business</a>",
              "alignment": "left"
            }
          },
          {
            "id": "7GRS9MJlIDi",
            "type": "header",
            "data": {
              "text": "سبز به جای آبی!",
              "level": 3
            }
          },
          {
            "id": "lsHBhJAWUH5",
            "type": "paragraph",
            "data": {
              "text": "اما چرا کارفور از برند هایپراستار به جای برند اصلی خودش در ایران استفاده کرده است؟ این برند قبلاً هم در شعبه پاکستان کارفور استفاده می‌شد تا اینکه در سال 2019 هایپراستار پاکستان به کارفور پاکستان تغییر نام داد. <a href=\"https://tribune.com.pk/story/1879580/carrefour-opens-pakistan\">(خبرگزاری پاکستانی اکسپرس تریبون)</a>"
            }
          },
          {
            "id": "tQWvaAvVvio",
            "type": "paragraph",
            "data": {
              "text": "علت این نام‌گذاری دقیقاً مشخص نیست اما مسئولین کارفور اشاراتی درباره دلیل این تغییر نام در مصاحبه‌های خود داشته‌اند. آن‌ها گفته‌اند که علت این تغییر نام ترس از حساسیت‌های کشورهای مسلمان روی کسب و کارهای غربی است. <a href=\"https://www.dailynewsegypt.com/2009/09/25/tehran-hypermarket-opens-without-carrefour-name/\">(دیلی نیوزِ مصر)</a>"
            }
          },
          {
            "id": "cqVH6aapOxy",
            "type": "paragraph",
            "data": {
              "text": "کارفور به واسطه حضور نیابتی هایپراستار در بازار ایران فعال است و خدماتی همچون خرده فروشی را عرضه می‌کند. خدماتی که در ظاهر چندان پیچیده و فناورانه نیست و همین الآن هم رقبای بزرگ و شناخته شده داخلی مشابه آن را ارائه می‌دهند."
            }
          }
        ]
      },
      "bodyEn": {
        "version": "2.30.7",
        "blocks": [
          {
            "id": "p6MfvVy7tpG",
            "type": "header",
            "data": {
              "text": "Hyperstar: Carrefour's shadow in Iran's sky",
              "level": 2
            }
          },
          {
            "id": "H_b858INaO",
            "type": "image",
            "data": {
              "caption": "Hyperstar's Iran Mall branch in Tehran",
              "file": {
                "fileId": "c523758b-42e3-4f93-b90f-24749468edc4"
              }
            }
          },
          {
            "id": "ObVY24LRd7",
            "type": "quote",
            "data": {
              "text": "We all know Hyperstar — the chain store that has been in Iran since 2009 (1388 in the Iranian calendar) and is known for its good discounts, brand variety and complete range. In recent years Hyperstar has also launched a strategic partnership with <b>Snapp</b> under the Snapp Market brand in the online-sales space, aiming to grow its Iranian market share. The <b>MyliMarket</b> brand, a Hyperstar subsidiary, has for some time also been active in the Iranian market to compete with smaller stores. It might be a big claim if someone said <b>by shopping at Hyperstar you're helping the Israeli economy!</b> — right in the heart of Israel's biggest enemy, Iran. An enemy that has repeatedly come close to direct military confrontation with Israel. In this note we examine this surprising claim together. Stay with us."
            }
          },
          {
            "id": "JDwgoyZX9Z",
            "type": "delimiter",
            "data": {}
          },
          {
            "id": "Rz6xJ7Bj8my",
            "type": "header",
            "data": {
              "text": "Chapter one: Carrefour is proud!",
              "level": 2
            }
          },
          {
            "id": "bNDJ7Jhvvle",
            "type": "quote",
            "data": {
              "text": "\"Carrefour is proud to have opened 50 stores in Israel today and to continue its international growth strategy [in Israel]. Israel is now the fifty-second country in which Carrefour operates across the world, thanks in particular to our franchise partners. We are confident that Carrefour will help Israeli customers who have been affected by the <b>cost-of-living crisis</b>.\"",
              "caption": "<b>Alexandre Bompard</b>, Chairman and CEO of the Carrefour Group / 9 May 2023 (<a href=\"https://www.carrefour.com/en/news/2023/arrivee-de-carrefour-en-israel\">Source: Carrefour official website</a>)"
            }
          },
          {
            "id": "Ot55C3I0B6",
            "type": "image",
            "data": {
              "caption": "Bompard's quote on Carrefour's official website",
              "file": {
                "fileId": "803b93bb-d14f-479f-b452-00c03d7a6ec2"
              }
            }
          },
          {
            "id": "uzVj_-4O8W1",
            "type": "paragraph",
            "data": {
              "text": "The name Carrefour may sound familiar. The French chain-store giant is the oldest retail chain in the world and the seventh most valuable brand in the retail industry. Carrefour today has more than 13,900 outlets across the world (<a href=\"https://www.carrefour.com/fr/groupe\">Source: Carrefour Group website</a>), and it has been accused of supporting the Israeli regime for years, a fixture on lists of brands supporting this regime. But how can a chain of stores help the Israeli economy?"
            }
          },
          {
            "id": "uozpNfbhMZJ",
            "type": "paragraph",
            "data": {
              "text": "The quote at the top of this article is from <b>Alexandre Bompard</b>, Chairman of Carrefour. In these words he refers to Carrefour's presence in Israel with the help of its partners. He also says that Carrefour's presence in the occupied territories can help Israelis affected by the <b>cost-of-living crisis</b>."
            }
          },
          {
            "id": "2k06g6V5aaF",
            "type": "quote",
            "data": {
              "text": "According to information published by the Organisation for Economic Co-operation and Development (OECD), in 2022 Israel had the highest cost of living among the 38 OECD countries — even surpassing Switzerland! This issue is known as the cost-of-living crisis in Israel.",
              "caption": "<a href=\"https://www.i24news.tv/en/news/israel/economy/1693119432-israel-named-oecd-country-with-highest-cost-of-living-in-2022\">Source: Israeli network i24</a>"
            }
          },
          {
            "id": "1QoTXwzDsDb",
            "type": "paragraph",
            "data": {
              "text": "Israel's economy, due to its dependence on imports in sectors such as food and agriculture, is highly uncompetitive and monopolistic. This monopoly has continuously raised the cost-of-living index in recent years. The issue, known in Israel as the cost-of-living crisis, has made many dual-passport citizens hesitant to choose Israel as a place to live. Food prices in Israel have risen 50% over the past two decades and are 25% to 80% above the OECD average, with dairy products, soft drinks and grain-based products especially expensive. In the food-retail sector, three local supermarket chains hold more than half the Israeli market. This monopoly limits competition and pushes prices up. <a href=\"https://oecdecoscope.blog/2025/04/02/why-is-life-so-expensive-in-israel/\">(Source)</a>"
            }
          },
          {
            "id": "43QtLMxF2x",
            "type": "quote",
            "data": {
              "text": "Imagine you live in Israel and face all sorts of insecurity every day — while paying Swiss cost-of-living prices!"
            }
          },
          {
            "id": "H0usdcc_Bu",
            "type": "delimiter",
            "data": {}
          },
          {
            "id": "xmXNjL6O2ai",
            "type": "header",
            "data": {
              "text": "Carrefour steps in",
              "level": 3
            }
          },
          {
            "id": "wWDw3DKd54H",
            "type": "paragraph",
            "data": {
              "text": "This is where Carrefour steps onto the field. Carrefour, with its broad international supply chain, can lower the cost of supplying goods and come to the aid of Israeli citizens — exactly what Carrefour's CEO referred to. This is so important to the Zionists in propaganda terms that, occasionally, officials at the level of prime minister or economy minister attend the opening of Carrefour branches! In its advertising Carrefour claims that an equivalent shopping basket can be delivered to consumers <b>up to 60% cheaper</b> than its local competitors. <a href=\"https://www.timesofisrael.com/french-retail-chain-carrefour-opens-50-stores-across-israel-vowing-to-disrupt-prices/\">(The Times of Israel)</a>"
            }
          },
          {
            "id": "wPxLni2GsJ",
            "type": "image",
            "data": {
              "caption": "Israeli Prime Minister and Minister of Economy and Industry at the Beit Shemesh branch of Carrefour Israel at its official opening / 8 May 2023",
              "file": {
                "fileId": "460ba094-4d4a-4e92-a134-bea582700cb3"
              }
            }
          },
          {
            "id": "y9u-ucaDTj1",
            "type": "paragraph",
            "data": {
              "text": "In the photos above, Netanyahu is pointing to the shopping-basket bill that Carrefour claims came in 60% cheaper. The Carrefour logo at the top of the list on the right, and the number 59.3% off at the top of the banner, stand out. <a href=\"https://www.gov.il/en/pages/event-carrefour080523\">(Source: official Israeli-government website)</a>"
            }
          },
          {
            "id": "1vPB23a834F",
            "type": "quote",
            "data": {
              "text": "\"We are convinced that Carrefour Israel will offer a real solution for Israeli consumers and significantly improve their purchasing power.\"",
              "caption": "<b>Patrick Lasfargues</b> / Head of Carrefour's International Division (<a href=\"https://www.timesofisrael.com/french-retail-chain-carrefour-opens-50-stores-across-israel-vowing-to-disrupt-prices/\">Source: The Times of Israel</a>)"
            }
          },
          {
            "id": "S-Cu819Jkbc",
            "type": "paragraph",
            "data": {
              "text": "The presence of a reputable, global, well-known brand like Carrefour can be seen as a symbol of the Israeli regime's leaders' efforts to counter the cost-of-living crisis — perhaps similar to the Abraham Accords as a symbol of breaking Israel's political isolation."
            }
          },
          {
            "id": "y_s4TxDAGlU",
            "type": "paragraph",
            "data": {
              "text": "But this is not Carrefour's only charge. Carrefour has various cooperation models for its international presence. One of these is using local partners and so-called franchising. Which brings us to Carrefour's second case-file."
            }
          },
          {
            "id": "DwS1smd2Er",
            "type": "delimiter",
            "data": {}
          },
          {
            "id": "h7ov238X7Rp",
            "type": "header",
            "data": {
              "text": "Carrefour partners up",
              "level": 3
            }
          },
          {
            "id": "rNsuXhzEiv1",
            "type": "paragraph",
            "data": {
              "text": "In Carrefour's partnership model, it usually enters a 50-50 joint venture with a local competitor, and all of that competitor's branches are switched over to Carrefour signage and supply chain. But who is Carrefour's partner in Israel?"
            }
          },
          {
            "id": "wUxFwGbL6Dx",
            "type": "paragraph",
            "data": {
              "text": "On 8 March 2022, the Carrefour Group unveiled a new franchise agreement in Israel with <b>Electra</b> / Electra Consumer Products and its subsidiary <b>Yenot Bitan</b>."
            }
          },
          {
            "id": "r-4ni_YWkVO",
            "type": "paragraph",
            "data": {
              "text": "Both companies are serious participants in illegal settlement-building and partners to the occupation by Israeli settlers. Their names are listed by the United Nations as commercial partners of illegal settlement-building. <a href=\"https://www.ohchr.org/sites/default/files/documents/hrbodies/hrcouncil/sessions-regular/session31/database-hrc3136/23-06-30-Update-israeli-settlement-opt-database-hrc3136.pdf\">(Source: UN High Commissioner for Human Rights)</a>"
            }
          },
          {
            "id": "10flPQYPm-",
            "type": "image",
            "data": {
              "caption": "The name of one of Electra's subsidiaries on the UN list of participants in illegal settlement-building",
              "file": {
                "fileId": "43777372-42e8-4f3b-bbab-c210ae06a75a"
              }
            }
          },
          {
            "id": "zczVlEUNEGI",
            "type": "paragraph",
            "data": {
              "text": "Electra is a large Israeli holding with serious involvement in Israeli settlement and government projects, and it also supplies the needs of settlers. The decision to partner with Electra has led to Carrefour being accused of complicity in the occupiers' settler activities."
            }
          },
          {
            "id": "kwyvDWA7G8p",
            "type": "paragraph",
            "data": {
              "text": "The reason Carrefour's name appears on every list of Zionist-goods boycotts — including BDS — is precisely this partnership with Electra. <a href=\"https://bdsmovement.net/boycott-carrefour\">(BDS)</a>"
            }
          },
          {
            "id": "aHP9MVOM_zH",
            "type": "paragraph",
            "data": {
              "text": "OK, so let's say by now we have understood what role Carrefour plays in Israel's survival. So what does any of this have to do with Hyperstar and us Iranians? Are we Carrefour customers too?"
            }
          },
          {
            "id": "x0ncTaUp-wO",
            "type": "header",
            "data": {
              "text": "Chapter two: Hyperstar, the Islamic Carrefour!",
              "level": 2
            }
          },
          {
            "id": "yeVGAoo1ycZ",
            "type": "header",
            "data": {
              "text": "Majid Al Futtaim and Carrefour in Iran",
              "level": 3
            }
          },
          {
            "id": "e5I625XpsEL",
            "type": "paragraph",
            "data": {
              "text": "As mentioned earlier, one of Carrefour's expansion models is partnership and joint investment with local partners. Carrefour's expansion in our region follows the same pattern. The Emirati holding <b>Majid Al Futtaim</b> (MAF) is Carrefour's strategic partner in the Middle East, and many of the region's branches — from North Africa to West Asia — have been opened through partnership with this very holding."
            }
          },
          {
            "id": "hSjbT8gN1c6",
            "type": "quote",
            "data": {
              "text": "Majid Al Futtaim operates in shopping centres, hypermarkets and hotels. The company built a key partnership with Carrefour from the start of its founding. In 2013, MAF paid 2.5 billion dirhams ($530 million) to acquire a 25% stake in the French giant.",
              "caption": "<a href=\"https://www.reuters.com/article/business/carrefour-sells-stake-in-middle-east-venture-for-683-million-idUSBRE94L0Z5/\">Source: Reuters</a>&nbsp;and <a href=\"https://www.thenationalnews.com/business/majid-al-futtaim-in-dh2-5-billion-carrefour-deal-to-buy-hypermarkets-1.576534/\">Emirati newspaper The National</a>"
            }
          },
          {
            "id": "_bZCljDMEZP",
            "type": "paragraph",
            "data": {
              "text": "In 2009 (1388 in the Iranian calendar), MAF and Carrefour opened the first Carrefour branch in Iran — in Tehran, under the name Hyperstar. That branch was launched with a 49-51 partnership in eastern Tehran, with an unnamed Iranian partner. Of the 49% foreign side, 25% belongs to MAF and 24% to Carrefour. <a href=\"https://www.dailynewsegypt.com/2009/09/25/tehran-hypermarket-opens-without-carrefour-name/\">(Daily News Egypt)</a>"
            }
          },
          {
            "id": "L8WE_ok2V6H",
            "type": "paragraph",
            "data": {
              "text": "In May 2007, the CEO of MAF's shopping-centres division gave an interesting interview to Arabian Business about their presence in Iran:"
            }
          },
          {
            "id": "iUh1rG3hMTE",
            "type": "quote",
            "data": {
              "text": "\"The French hypermarket group Carrefour has committed to opening its first hypermarket in Iran, and the retail arm of Majid Al Futtaim (MAF) — which runs Carrefour stores in the Middle East — has also committed to the project.\"",
              "caption": "<a href=\"https://www.arabianbusiness.com/industries/retail/carrefour-plans-iranian-store-145419\">Source: Arabian Business</a>"
            }
          },
          {
            "id": "7GRS9MJlIDi",
            "type": "header",
            "data": {
              "text": "Green instead of blue!",
              "level": 3
            }
          },
          {
            "id": "lsHBhJAWUH5",
            "type": "paragraph",
            "data": {
              "text": "But why has Carrefour used the Hyperstar brand instead of its own primary brand in Iran? This brand was previously used in Pakistan's Carrefour branch too, until 2019 when Hyperstar Pakistan rebranded to Carrefour Pakistan. <a href=\"https://tribune.com.pk/story/1879580/carrefour-opens-pakistan\">(Pakistani news outlet The Express Tribune)</a>"
            }
          },
          {
            "id": "tQWvaAvVvio",
            "type": "paragraph",
            "data": {
              "text": "The reason for this naming choice is not entirely clear, but Carrefour officials have hinted at it in interviews. They have said the reason for the rebrand was fear of Muslim-country sensitivities towards Western businesses. <a href=\"https://www.dailynewsegypt.com/2009/09/25/tehran-hypermarket-opens-without-carrefour-name/\">(Daily News Egypt)</a>"
            }
          },
          {
            "id": "cqVH6aapOxy",
            "type": "paragraph",
            "data": {
              "text": "Carrefour, by way of Hyperstar's proxy presence, is active in the Iranian market and offers services such as retail. These are services that on their surface aren't particularly complex or technological, and large well-known domestic competitors already provide similar services."
            }
          }
        ]
      }
    },
    {
      "slug": "cocacola-part-1",
      "sourceUrl": "https://qlist.ir/blog/cocacola-part-1/",
      "companySlug": null,
      "title": {
        "en": "Everything about boycotting Coca-Cola — Part one: Coca-Cola in Iran",
        "fa": "همه چیز درباره تحریم کوکاکولا؛ پرده اول، کوکاکولا در ایران"
      },
      "summary": {
        "en": "An introduction to the Coca-Cola system, proving the presence of its subsidiary brands in Iran, and responses to common doubts — citing official sources.",
        "fa": "معرفی سیستم کوکاکولا، اثبات حضور برندهای زیرمجموعه در ایران و پاسخ به شبهات رایج با استناد به منابع رسمی"
      },
      "cover": null,
      "body": {
        "time": 1772012339458,
        "version": "2.31.0-rc.7",
        "blocks": [
          {
            "id": "Ptx8beksdm",
            "type": "header",
            "data": {
              "text": "اول. معرفی کوکاکولا",
              "level": 2
            }
          },
          {
            "id": "jKYMnsiZQ7",
            "type": "paragraph",
            "data": {
              "text": "شرکت <b>کوکاکولا</b> واقعاً یک غول جهانی است. از سال 1886 که اولین نوشابه کولا توسط <b>جان پِمبِرتون</b> ساخته و با نام کوکاکولا فروخته شد این محصول با سرعت خارق‌العاده‌ای به سمت فراگیر شدن رفت. تا جایی که امروزه تقریبا در هر نقطه‌ای از جهان می‌توان آن را یافت. البته کوکاکولا نه صرفاً یک نوشابه گازدار مشکی است و نه صرفاً یک شرکت تجاری. بلکه یک نام بزرگ گره خورده با موضوعات کلان اقتصادی، زیست‌محیطی، فرهنگی و سیاسی در جهان است. (<a href=\"https://deepblue.lib.umich.edu/bitstream/handle/2027.42/86471/lhymson_1.pdf?sequence=1&amp;isAllowed=y\">منبع</a>)  با یک جستجو در گوگل اسکالر، حدود 8600 مقاله علمی که در عنوان آن‌ها دقیقاً عبارت کوکاکولا وجود دارد نمایش داده می‌شود که نشان دهنده اهمیت و اثرگذاری این شرکت است."
            }
          },
          {
            "id": "9JenrcbH4f",
            "type": "header",
            "data": {
              "text": "سیستمی به نام کوکاکولا ",
              "level": 3
            }
          },
          {
            "id": "wIodlsjq5y",
            "type": "paragraph",
            "data": {
              "text": "زمانی که نام کوکاکولا را می‌بریم در واقع درباره یک سیستم بزرگ جهانی با عناصر و اجزای متعدد صحبت می‌کنیم؛ <b>سیستم کوکاکولا</b>. برای آشنایی با کوکاکولا لازم است تا ابتدا این سیستم را که برآمده از مدل کسب‌وکار این شرکت است بشناسیم. سیستم کوکاکولا شبکه‌ای تشکیل شده از خود <b>شرکت اصلی</b> و مجموعه گسترده‌ای از <b>شرکای محلی</b> آن در جهان است. کسب‌وکارهایی که به آنها نوشابه‌ساز گفته می‌شود و عمده آنها به لحاظ مالکیتی و مدیریتی مستقل از کوکاکولا هستند. در این سیستم دارایی‌ها و فعالیت‌های هر یک از اجزا به شکلی کاملاً منسجم در خدمت اهداف کل سیستم قرار می‌گیرد. به این ترتیب هر یک از کسب‌وکارهای مستقل موجود در سیستم ضمن سودآوری خود، به رشد سیستم و در نهایت سودآوری بیشتر شرکت اصلی یعنی کوکاکولا کمک می‌کنند.(<a href=\"https://www.coca-colacompany.com/about-us/coca-cola-system\">وبسایت کوکاکولا</a>)"
            }
          },
          {
            "id": "qiopDx22t7",
            "type": "paragraph",
            "data": {
              "text": "در این شبکه بزرگ مهم‌ترین دارایی‌ها متعلق به خود شرکت کوکاکولا است؛ یعنی <b>بِرند</b> و <b>فرمول</b> محصول. تمام فعالیت‌های سیستم کوکاکولا با تکیه بر همین دارایی‌های کلیدی انجام می‌گیرد. قریب به 150 سال فعالیت تبلیغاتی و بازاریابی گسترده، محصول کوکاکولا را در ذهن مردم جهان تبدیل به یک اسطوره کرده است. و این محصول چیزی نیست جز یک طعم خاص که نام کوکاکولا بر آن نقش بسته باشد. محصول سنتی کوکاکولا آنچنان جایگاهی نزد مصرف‌کنندگانش دارد که حتی خود کوکاکولا هم نمی‌تواند به راحتی آن را تغییر دهد! مثل تلاش نافرجام این شرکت در سال 1985 برای معرفی طعم جدید که با اعتراض مصرف‌کنندگان مواجه و شرکت بعد از 77 روز مجبور به بازگرداندن طعم قبلی شد. (<a href=\"https://www.coca-colacompany.com/about-us/history/new-coke-the-most-memorable-marketing-blunder-ever\">وبسایت کوکاکولا</a>)"
            }
          },
          {
            "id": "eTaUlCG9Na",
            "type": "image",
            "data": {
              "caption": "",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 584,
                "height": 326,
                "size": "186717",
                "name": "image1.jpeg",
                "title": "Image1",
                "extension": "jpeg",
                "fileId": "65199e6e-9920-4e5a-9e2a-72a21e5f1539",
                "fileURL": "/files/65199e6e-9920-4e5a-9e2a-72a21e5f1539",
                "url": "/qlist-assets/65199e6e-9920-4e5a-9e2a-72a21e5f1539.jpg"
              }
            }
          },
          {
            "id": "_cutJxCwgM",
            "type": "paragraph",
            "data": {
              "text": "البته رسیدن به طعمی شبیه به کوکاکولا کار خیلی پیچیده‌ای نیست و تا به حال تلاش‌های موفقی هم برای آن انجام شده است.(<a href=\"https://strangelove.com.au/blogs/journal/what-gives-cola-its-distinct-flavour?srsltid=AfmBOoqqDvPzwfbGqtWQowOD541sZOAW6wBnNlWRtdi1feDNAlO86KOy\">استرنج‌لاو</a>) اما این طعم مشابه، بدون نام و بسته‌بندی آشنای کوکاکولا اعتماد هیچ مصرف‌کننده‌ای را جلب نمی‌کند. در واقع بزرگترین دارایی کوکاکولا چیزی نیست جز <b>بِرند</b>."
            }
          },
          {
            "id": "lxh8CrD2dk",
            "type": "image",
            "data": {
              "caption": "",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 1160,
                "height": 773,
                "size": "45597",
                "name": "image2.jpeg",
                "title": "Image2",
                "extension": "jpeg",
                "fileId": "94c8272c-755e-4ef2-b3e0-03a3410e48d6",
                "fileURL": "/files/94c8272c-755e-4ef2-b3e0-03a3410e48d6",
                "url": "/qlist-assets/94c8272c-755e-4ef2-b3e0-03a3410e48d6.jpg"
              }
            }
          },
          {
            "id": "IIhwk0ehvi",
            "type": "paragraph",
            "data": {
              "text": "کوکاکولا سال‌هاست برای ارتقای جایگاه برند خود در ذهن مخاطب تلاش‌های بسیار گسترده و حرفه‌ای تبلیغاتی انجام می‌دهد. حضور 100 ساله این شرکت در ادوار بازی‌های المپیک، همکاری 50 ساله با فیفا در جام‌های جهانی فوتبال و برگزاری اختصاصی تور جام جهانی فیفا، و مشارکت پر رنگ در مسابقات اتوموبیل‌رانی ناسکار تنها بخش کوچکی از این تلاش‌‌ها آن هم فقط در عرصه ورزش است که نتیجه آن قرار گرفتن کوکاکولا در جایگاه هفتمین برند ارزشمند جهانی در ارزیابی 2024 موسسه معتبر اینتربرند است. (<a href=\"https://www.coca-colacompany.com/about-us/sports-and-entertainment\">وبسایت کوکاکولا</a>) (<a href=\"https://interbrand.com/best-global-brands/\">اینتربرند</a>) این شرکت هم‌اکنون صاحب 200 برند است که مدعی است 30 مورد از آنها ارزش میلیارد دلاری دارند. (<a href=\"https://investors.coca-colacompany.com/about/our-brands\">وبسایت کوکاکولا</a>) بعد از این توضیحات راحت‌تر می‌توان فهمید که چرا مهم‌ترین دارایی کوکاکولا برند آن است."
            }
          },
          {
            "id": "_WAq5gBTRW",
            "type": "paragraph",
            "data": {
              "text": "به سیستم کوکاکولا برگردیم. شبکه‌ای که 700.000 نفر جمعیت دارد و در آن 200 شرکت نوشابه‌ساز با 950 کارخانه در سراسر جهان از جمله ایران، فلسطین اشغالی، کرانه باختری و نوار غزه مشغول فعالیت هستند. (<a href=\"https://www.coca-colacompany.com/about-us/coca-cola-system#accordion-27d09dd193-item-8e9e9d8e79\">وبسایت کوکاکولا</a>) آنها عصاره (کُنسانتره) یا شهد پایه نوشیدنی (فرمول اصلی) را از شرکت کوکاکولا دریافت کرده و آن را با آب (گازدار) و شیرین‌کننده ترکیب می‌کنند تا پس از بسته‌بندی به بازار عرضه شود. در این سیستم شرکت کوکاکولا صاحب برندها، توسعه‌دهنده محصولات، تامین‌کننده مواد پایه و کنترل‌کننده کیفیت است و علاوه بر آن مسئولیت انجام پیش‌نیازهای بازاریابی اثرگذار بر مصرف‌کنندگان از جمله تبلیغات و پویش‌های جهانی را هم بر عهده دارد. ادامه ماجرا با شرکای محلی است. آنها مسئولیت ارتباط با همه مشتریان و نقاط فروش مثل رستوران‌ها، فروشگاه‌ها، دکه‌ها و... را بر عهده دارند تا از این طریق راهبرد محلی کوکاکولا اجرایی شود. نتیجه این همکاری تا امروز رسیدن به عدد خیره‌کننده 2/2 میلیارد بار مصرف محصولات مختلف شرکت کوکاکولا در هر روز است!"
            }
          },
          {
            "id": "E0zFmacNpa",
            "type": "image",
            "data": {
              "caption": "اطلاع‌نگاشت سیستم کوکاکولا",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 1105,
                "height": 784,
                "size": "88530",
                "name": "image3.png",
                "title": "Image3",
                "extension": "png",
                "fileId": "60ec9d0a-5ccf-4e22-b0f5-f5cbc352abf9",
                "fileURL": "/files/60ec9d0a-5ccf-4e22-b0f5-f5cbc352abf9",
                "url": "/qlist-assets/60ec9d0a-5ccf-4e22-b0f5-f5cbc352abf9.png"
              }
            }
          },
          {
            "id": "b4nngwAZSi",
            "type": "paragraph",
            "data": {
              "text": "کوکاکولا عمده درآمد خود را از فروش عصاره‌ها و شهدها حاصل می‌کند و در بیشتر نوشابه‌ساز‌ها هیچ دخالت مالکیتی یا مدیریتی ندارد. این شرکت، راهبرد تقویت شبکه‌های محلی را به طور جدی دنبال می‌کند. به طوری که از بین بیش از 200 کشوری که کوکاکولا در بازار آنها رسما حضور دارد فقط و فقط در عمان، هند، مالزی، سنگاپور و چند کشور آسیایی و آفریقایی به طور مستقیم عملیات نوشابه‌سازی را انجام می‌دهد که این زیرمجموعه‌ها فقط 13 درصد از درآمد کل کوکاکولا در سال 2024 را شامل می‌شوند. این یعنی <b>عمده درآمد شرکت کوکاکولا از همان قراردادهای فروش عصاره و شهد و حق استفاده از برند حاصل می‌شود. </b>(<a href=\"https://www.coca-colacompany.com/about-us/coca-cola-system\">وبسایت کوکاکولا</a>)  با این توصیف، اگر کل دنیا را به دنبال یک بطری نوشابه ناب تولید شده توسط شرکت کوکاکولای آمریکا بگردید، احتمال موفقیتتان بسیار کم خواهد بود."
            }
          },
          {
            "id": "Ubz9Vjjd6u",
            "type": "header",
            "data": {
              "text": "کوکاکولا حتی در غزه!",
              "level": 3
            }
          },
          {
            "id": "El7TQrH8v8",
            "type": "paragraph",
            "data": {
              "text": "شرکت ملی نوشیدنی/NBC یکی از کوچک‌ترین شرکای نوشابه‌ساز کوکاکولا در غرب آسیاست. شرکتی که وظیفه پر کردن بطری‌های کوکا در غزه و کرانه باختری رود اردن را بر عهده دارد. این شرکت خصوصی فلسطینی که دفتر آن در رام‌الله است، از 1998 فعالیت تحت لیسانس کوکاکولا شروع کرده و هم اکنون 4 کارخانه تولیدی در 4 منطقه از جمله در باریکه غزه و شهر رام‌الله دارد که حدود 1000 فلسطینی در آن مشغول به کار هستند. (<a href=\"https://www.nbc-pal.ps/Locations\">وبسایت اِن‌بی‌سی</a>)"
            }
          },
          {
            "id": "QvRNrtt620",
            "type": "image",
            "data": {
              "caption": "کارخانه کوکاکولا ان‌بی‌سی در غزه",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 1113,
                "height": 576,
                "size": "111217",
                "name": "GazaPlant-img1.jpg",
                "title": "Gaza Plant Img1",
                "extension": "jpg",
                "fileId": "dc1f3ddc-5896-4f86-98c3-50f937a653d4",
                "fileURL": "/files/dc1f3ddc-5896-4f86-98c3-50f937a653d4",
                "url": "/qlist-assets/dc1f3ddc-5896-4f86-98c3-50f937a653d4.jpg"
              }
            }
          },
          {
            "id": "DoFSObODcp",
            "type": "paragraph",
            "data": {
              "text": "کوکاکولا و اِن‌بی‌سی به دنبال سیاست‌های مسئولیت اجتماعی شرکت‌ کوکاکولا، فعالیت‌های عام‌المنفعه‌ای را هم در این مناطق اجرا می‌کنند. مثلا طبق ادعای کوکاکولا، مطابق برنامه بهبود آب و فاضلاب در سال 2018 در غزه برای ارتقای بهداشت و دسترسی به آب سالم، احداث دستگاه نمک‌زدا برای تامین 90.000  لیتر آب شرب در غزه (معادل مصرف طبیعی حدود 1300 نفر در روز) اجرا شده‌است. (<a href=\"https://www.coca-colacompany.com/about-us/coca-cola-system/national-beverage-company\">وبسایت کوکاکولا</a>)"
            }
          },
          {
            "id": "GAW3CREoBs",
            "type": "paragraph",
            "data": {
              "text": "همچنین در سال 2007 کوکا و ان‌بی‌سی تحت پروژه‌ی به نام «رایانه‌ای کردن مدارس»، تعداد 723 تبلت و 335 رایانه به مدارس فلسطینی اهدا کردند. یا در سال 2002 تحت کارزاری به نام «بازگشت به مدرسه» شرکت، تعدادی کیف به دانش‌آموزان نیازمند فلسطینی اهدا کرده است. (<a href=\"https://www.coca-colacompany.com/about-us/coca-cola-system/national-beverage-company\">وبسایت کوکاکولا</a>) (<a href=\"https://nbc-pal.ps/CSR\">وبسایت ان‌بی‌سی</a>)  "
            }
          },
          {
            "id": "N4GcR7mXNk",
            "type": "image",
            "data": {
              "caption": "لپ‌تاپ‌های دانش‌آموزی اهدایی ان‌بی‌سی",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 624,
                "height": 468,
                "size": "112827",
                "name": "Computerization of Schools Project.jpg",
                "title": "Computerization of Schools Project",
                "extension": "jpg",
                "fileId": "79571f61-7278-47f5-9e35-3abb488f8e73",
                "fileURL": "/files/79571f61-7278-47f5-9e35-3abb488f8e73",
                "url": "/qlist-assets/79571f61-7278-47f5-9e35-3abb488f8e73.jpg"
              }
            }
          },
          {
            "id": "nBxzSvd607",
            "type": "paragraph",
            "data": {
              "text": "کوکاکولا برای فعالیت‌های اجتماعی خود یک زیرمجموعه‌ای به نام <b>بنیاد کوکاکولا</b> دارد. بنیادی که شرکت از آن تحت عنوان بازوی بشردوستانه خود یاد می‌کند. (<a href=\"https://www.coca-colacompany.com/about-us/the-coca-cola-foundation\">وبسایت کوکاکولا</a>)  این بنیاد ادعا دارد که در نقاط مختلف دنیا و به خصوص کشورهای در حال توسعه موضوعاتی از جمله دسترسی به آب، سلامت، اقتصاد چرخشی و مدیریت پسماند، تاب‌آوری آب‌وهوایی، توانمندسازی اقتصادی و... را دنبال می‌کند. <b>نکته جالب آن است که کوکاکولا خودش بارها از جانب فعالین حقوق بشر و محیط زیست در همین موضوعات متهم و یا حتی مجرم شناخته شده است.</b>"
            }
          },
          {
            "id": "av99Pt_bIN",
            "type": "paragraph",
            "data": {
              "text": "برای نمونه مساله آب بسیار دستمایه تبلیغات بنیاد کوکاکولا قرار گرفته‌است. این شرکت مدعی تلاش برای آبرسانی از طریق مخزن‌های بزرگ، آب‌شیرین‌کن و... به بسیاری از مناطق کم برخوردار است. با این حال کوکاکولا خود یک تهدید برای دسترسی مردم بسیاری از مناطق به آب است."
            }
          },
          {
            "id": "N_NSDWlOjE",
            "type": "quote",
            "data": {
              "text": "<b>کوکا و شرکایش فقط در سال 2023 به میزان 312 میلیارد لیتر آب (معادل مصرف طبیعی 12 میلیون نفر در یک سال!) مصرف کرده‌اند.</b>",
              "caption": "<a href=\"https://www.statista.com/statistics/1126344/water-use-the-coca-cola-company-globally/\">استاتیستا</a>",
              "alignment": "left"
            }
          },
          {
            "id": "6ybxzgKHSa",
            "type": "paragraph",
            "data": {
              "text": "در بسیاری از مناطق جهان که با مشکل کم‌آبی مواجه‌اند، سیستم کوکاکولا به برداشت گسترده از منابع آب شرب و کشاورزی متهم است. هند، مکزیک و السالوادور برخی از این مناطق هستند. (<a href=\"https://www.theguardian.com/environment/2003/jul/25/water.india\">گاردیَن1</a> و \n\n<a href=\"https://www.theguardian.com/global-development/2019/jul/30/el-salvador-water-crisis-privatization-gangs-corruption\">گاردیَن2</a>)(<a href=\"https://www.independent.co.uk/news/world/americas/coca-cola-mexico-wells-dry-bottled-water-sucking-san-felipe-ecatepec-chiapas-a7953026.html\">ایندیپندنت</a>) حتی کوکا در مواردی مثل هند بابت موضوع آب با محکومیت و اجبار به تعطیلی کارخانه هم روبرو شده‌است. (<a href=\"https://www.corpwatch.org/article/coca-cola-forced-shut-bottling-plant-india\">کورپ‌واچ</a>)"
            }
          },
          {
            "id": "_CRiGWluRr",
            "type": "image",
            "data": {
              "caption": "",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 1280,
                "height": 1024,
                "size": "186643",
                "name": "community-programs-to-support-access-to-water-and-sanitation-updated.jpg",
                "title": "Community Programs to Support Access to Water and Sanitation Updated",
                "extension": "jpg",
                "fileId": "8e779335-9fa5-4c70-a1d4-036d7a5170b8",
                "fileURL": "/files/8e779335-9fa5-4c70-a1d4-036d7a5170b8",
                "url": "/qlist-assets/8e779335-9fa5-4c70-a1d4-036d7a5170b8.jpg"
              }
            }
          },
          {
            "id": "GPFiH5ulAw",
            "type": "paragraph",
            "data": {
              "text": "کوکاکولا در حالی از اقتصاد چرخشی (مدلی از اقتصاد که در آن تا حد امکان چیزی دور ریخته نمی‌شود) حرف می‌زند و ادعای حمایت از روشش‌های مدیریت پسماند را دارد که خود بزرگ‌ترین تولیدکننده آلودگی‌های پلاستیکی جهان در سال 2023 بوده است! (<a href=\"https://brandaudit.breakfreefromplastic.org/brand-audit-2023/\">جنبش BFFP</a>)"
            }
          },
          {
            "id": "Jstf3_54zW",
            "type": "paragraph",
            "data": {
              "text": "موضوع سلامت نیز همیشه در تبلیغات بنیاد کوکاکولا و معرفی فعالیت‌های بنیادِ آن، یکی از موضوعات پرتکرار است. با این حال در طول سالیان حضور نوشابه‌های این شرکت در بازار، بارها متخصصان حوزه سلامت مضرات مصرف این محصولات را به اثبات رسانده اند و درباره تبعات مصرف آن‌ها هشدار داده‌اند. (<a href=\"https://mitpress.mit.edu/9780262049504/sweet-and-deadly/\">دانشگاه اِم‌آی‌تی</a>)"
            }
          },
          {
            "id": "D4ByMNF7TD",
            "type": "image",
            "data": {
              "caption": "اطلاع‌نگاشت جنبش زیست محیطی BFFP درباره آلوده‌کننده‌ترین شرکت‌های دنیا از لحاظ میزان تولید پلاستیک که کوکاکولا را در رتبه اول نشان می‌دهد. رتبه‌های بعدی هم جالب توجهند.",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 1080,
                "height": 1080,
                "size": "247052",
                "name": "Brand-Audit-2023-Corporate-Polluters.jpg",
                "title": "Brand Audit 2023 Corporate Polluters",
                "extension": "jpg",
                "fileId": "7c63e6da-de0c-481a-8d48-03776ecb279b",
                "fileURL": "/files/7c63e6da-de0c-481a-8d48-03776ecb279b",
                "url": "/qlist-assets/7c63e6da-de0c-481a-8d48-03776ecb279b.jpg"
              }
            }
          },
          {
            "id": "AehBYct_QC",
            "type": "paragraph",
            "data": {
              "text": "مواردی از این دست صداقت کوکاکولا در فعالیت‌ها و تبلیغاتش را با تردید مواجه می‌کند. با این وجود بنیاد کوکاکولا در بسیاری از کشورها از جمله غرب آسیا فعال است و با همکاری دانشگاه‌ها، سمن‌ها و نهادهای آمریکایی و بین‌المللی تحت عناوینی چون توانمندسازی، محیط زیست، آب، مدیریت پسماند و... برنامه‌هایی را اجرا می‌کند. (<a href=\"https://www.coca-cola.com/xf/en/media-center/the-coca-cola-foundation-women-empowerment-program-toumouhi\">وبسایت کوکاکولا</a>) (<a href=\"https://www.coca-colacompany.com/content/dam/company/us/en/policies/pdf/social/2022%20Charitable%20Contribution%20TCCF_Updated.pdf\">گزارش رسمی بنیاد کوکاکولا</a>)"
            }
          },
          {
            "id": "qbGkFULtim",
            "type": "image",
            "data": {
              "caption": "طُموحی (به معنای جاه‌طلبی من) یکی از برنامه‌های بنیاد کوکاکولاست که با همکاری دانشگاه کُرنل در حوزه توانمندسازی زنان در عربستان سعودی در حال اجرا است.",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 649,
                "height": 793,
                "size": "576716",
                "name": "Screenshot 2025-06-30 183918.png",
                "title": "Screenshot 2025 06 30 183918",
                "extension": "png",
                "fileId": "0ae64e5b-c5b5-4096-b40f-e5dea1087e11",
                "fileURL": "/files/0ae64e5b-c5b5-4096-b40f-e5dea1087e11",
                "url": "/assets/0ae64e5b-c5b5-4096-b40f-e5dea1087e11"
              }
            }
          },
          {
            "id": "Ry2odUj6uY",
            "type": "header",
            "data": {
              "text": "دوم. کوکاکولا در ایران",
              "level": 2
            }
          },
          {
            "id": "eRruxZC4Mf",
            "type": "image",
            "data": {
              "caption": "کارخانه کوکاکولا در مشهد",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 1170,
                "height": 889,
                "size": "146078",
                "name": "1892719_569.jpg",
                "title": "1892719 569",
                "extension": "jpg",
                "fileId": "3eb977ed-23ca-4d7a-b233-14939ed43eae",
                "fileURL": "/files/3eb977ed-23ca-4d7a-b233-14939ed43eae",
                "url": "/qlist-assets/3eb977ed-23ca-4d7a-b233-14939ed43eae.jpg"
              }
            }
          },
          {
            "id": "ijpktMMPDJ",
            "type": "paragraph",
            "data": {
              "text": "نوشابه گازدار از حدود دهه 30 یا 40 شمسی وارد ایران شد و روز به روز رواج بیشتری پیدا کرد. مثل بسیاری از کشورها، بازیگران این بازار جدید هم از همان نقطه شکل‌گیری، دو نام آمریکایی بودند: کوکاکولا و پپسی. هر کدام از این دو برند در یک یا چند کارخانه ایرانی تولید می‌شدند. از آن زمان تا امروز این دو اسم همواره بخشی از داستان نوشابه در ایران بوده‌اند. (<a href=\"https://jamejamonline.ir/002ADs\">جام جم</a>)  اما این حضور به خصوص پس از انقلاب اسلامی سال 57 با حواشی زیادی همراه بوده است. دو دلیل عمده می‌توان برای این حواشی پیدا کرد: یکی آمریکایی بودن این شرکت‌ها، و دوم شایعات همیشگی درباره ارتباطات و حمایت‌های آنها. در مورد پپسی حواشی با شایعه ارتباط این برند با بهائیت در دهه 40 شروع شد. تا جایی که حتی کار به فتوای حرمت خرید و فروش پپسی از طرف امام خمینی (ره) هم رسید. (<a href=\"https://hawzahnews.com/xd36q\">خبرگزاری حوزه</a>)"
            }
          },
          {
            "id": "2O1qX2uNyA",
            "type": "paragraph",
            "data": {
              "text": "شایعات پیرامون این شرکت‌ها البته اختصاص به ایران نداشته است. سایت رسمی کوکاکولای بین‌الملل یک صفحه ویژه با عنوان «شایعات و اطلاعات غلط» ایجاد کرده و در آن به شش گزاره رایج درباره این شرکت و محصولاتش پاسخ داده است که <b>از این شش سوال، دو مورد آن به ارتباط این شرکت با رژیم اسرائیل م</b><b>ربوط</b> <b>می‌شود.</b>"
            }
          },
          {
            "id": "7XDMuHyFb9",
            "type": "image",
            "data": {
              "caption": "صفحه شایعات و اطلاعات غلط در سایت رسمی کوکاکولا",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 972,
                "height": 837,
                "size": "96795",
                "name": "Screenshot 2025-07-02 164742.png",
                "title": "Screenshot 2025 07 02 164742",
                "extension": "png",
                "fileId": "46fe3ac2-63c8-4f27-9f36-7b581b1661ac",
                "fileURL": "/files/46fe3ac2-63c8-4f27-9f36-7b581b1661ac",
                "url": "/qlist-assets/46fe3ac2-63c8-4f27-9f36-7b581b1661ac.png"
              }
            }
          },
          {
            "id": "fjZL2ZXeo3",
            "type": "header",
            "data": {
              "text": "خوشگوار، نوشاب، کوکاکولا",
              "level": 3
            }
          },
          {
            "id": "vyuiRYwVcg",
            "type": "paragraph",
            "data": {
              "text": "یکی از کارخانه‌هایی که پیش از انقلاب اسلامی نوشابه کوکاکولا را در ایران تولید می‌کرد شرکت خوشگوار مشهد بود. همکاری خوشگوار و کوکاکولا حتی تا چند سال پس از انقلاب هم ادامه پیدا کرد تا این که بالاخره در اوایل دهه 60 متوقف شد."
            }
          },
          {
            "id": "hKHb8dT836",
            "type": "paragraph",
            "data": {
              "text": "در طول سال‌های جنگ با عراق، تحریم‌های آمریکایی علیه ایران با قوت اِعمال می‌شدند. به این ترتیب تولیدکننده‌های پپسی و کوکا از جمله خوشگوار که حالا دستشان از عصاره این شرکت‌ها کوتاه شده بود مجبور شدند به سراغ عصاره‌های ایرانی نوشابه بروند و تولید خود را با آنها ادامه دهند. اما با شروع دهه هفتاد و تغییر رویکردها در ارتباط با آمریکا و از طرف دیگر کاهش سخت‌گیری‌ها در رژیم تحریم‌ها، بار دیگر هوای همکاری با غول‌های آمریکایی به سر نوشابه‌سازهای وطنی افتاد. (<a href=\"https://jamejamonline.ir/002ADs\">جام جم</a>) (<a href=\"https://money.cnn.com/magazines/fortune/fortune_archive/2007/02/19/8400167/index2.htm\">سی‌اِن‌اِن</a>)"
            }
          },
          {
            "id": "xE1--nnFdi",
            "type": "image",
            "data": {
              "caption": "خط تولید نوشابه کوکاکولا در ایران",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 2448,
                "height": 1632,
                "size": "477789",
                "name": "1610670_202.jpg",
                "title": "1610670 202",
                "extension": "jpg",
                "fileId": "571044c9-2a03-4330-87cd-8a81b818e580",
                "fileURL": "/files/571044c9-2a03-4330-87cd-8a81b818e580",
                "url": "/assets/571044c9-2a03-4330-87cd-8a81b818e580"
              }
            }
          },
          {
            "id": "CDKfdZmOan",
            "type": "paragraph",
            "data": {
              "text": "خوشگوار در سال 1370 توانست رابطه‌اش با کوکاکولا را بار دیگر برقرار کرده و تولید تحت لیسانس این شرکت را از سر بگیرد. اما این بار یک بازیگر تازه نفس هم با قدرت، اسب خود را برای ورود به بازار زین کرده بود: شرکت جدیدی به نام نوشاب. این شرکت در سال 1372 قراردادی را با کوکاکولا منعقد کرد که در آن شرکت آمریکایی متعهد شد با 15 میلیون دلار سرمایه‌گذاری و تملک 27 درصد از سهام شرکت، در تولید نوشابه در ایران مشارکت مستقیم نماید؛ این یعنی <b>اولین سرمایه‌گذاری یک شرکت خارجی در ایران پس از انقلاب</b>. اتفاقی که از طرف یک شرکت آمریکایی و آن هم در صنعت نوشابه محقق شد!"
            }
          },
          {
            "id": "7Z7P4VWjjS",
            "type": "paragraph",
            "data": {
              "text": "اما در این رقابت جدید کارها برای رقیب تازه‌وارد یعنی نوشاب آن طور که باید پیش نرفت. در سال 1373 یعنی فقط یک سال پس از انعقاد قرارداد نوشاب و کوکاکولا، بیل کلینتون رئیس جمهور وقت آمریکا تحریم‌های ضد ایرانی را تشدید کرد. با این اتفاق کوکاکولا که تنها نیمی از سهم شراکت خود را پرداخت کرده بود، از پرداخت مابقی مبلغ سر باز زد. نوشاب که به تازگی تولیدش را شروع کرده و برای آن حدود 40 میلیون بطری شیشه‌ای با نشان کوکاکولا آماده کرده بود ناگهان حتی از دریافت عصاره کوکاکولا هم محروم شد."
            }
          },
          {
            "id": "54C6aS3QuP",
            "type": "image",
            "data": {
              "caption": "بطری کوکاکولا منتسب به شرکت نوشاب",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 1137,
                "height": 594,
                "size": "193519",
                "name": "gettyimages-582823528-594x595.jpg",
                "title": "Gettyimages 582823528 594x595",
                "extension": "jpg",
                "fileId": "a5ed8602-092b-44ed-9ac3-c8fc9022e6c8",
                "fileURL": "/files/a5ed8602-092b-44ed-9ac3-c8fc9022e6c8",
                "url": "/qlist-assets/a5ed8602-092b-44ed-9ac3-c8fc9022e6c8.jpg"
              }
            }
          },
          {
            "id": "CCZ7ovmw8b",
            "type": "paragraph",
            "data": {
              "text": "بعد از این که پیگیری‌های نوشاب از کوکاکولا نتیجه نداد این شرکت از شریک آمریکایی خود شکایت کرد و توانست در این دعوی پیروز شود. نوشاب همچنین تصمیم گرفت بطری‌های کوکاکولا که روی دستش مانده بود را با عصاره نوشابه ایرانی پر کرده و به بازار عرضه کند. با این اقدام نوشاب، شریک سابق که صاحب نشان تجاری روی شیشه‌ها بود شکایت متقابل خود را به دادگاه ایرانی برد و بابت نقض امتیاز برند از نوشاب غرامت خواست. شکایتی که به نتیجه رسید و منجر به پرداخت غرامت 5 میلیون دلاری نوشاب به شرکت آمریکایی شد. (<a href=\"https://jamejamonline.ir/002ADs\">جام‌جم</a>)(<a href=\"https://money.cnn.com/magazines/fortune/fortune_archive/2007/02/19/8400167/index2.htm\">سی‌اِن‌اِن</a>)(<a href=\"https://www.bbc.com/persian/business/story/2003/10/031005_he-ag-cocacola\">بی‌بی‌سی</a>) این ماجرا به خوبی نشان می‌دهد که بر عکس تصور رایج بسیاری از مردم، استفاده از یک برند ثبت شده و معتبر جهانی، بدون کسب اجازه از صاحب برند می‌تواند چه تبعات سنگینی را برای متخلف در پی داشته باشد."
            }
          },
          {
            "id": "3zouQY-2If",
            "type": "header",
            "data": {
              "text": "جنگ ۲۲ روزه و حواشی کوکاکولا",
              "level": 3
            }
          },
          {
            "id": "BemzPT9YfU",
            "type": "paragraph",
            "data": {
              "text": "کمی به عقب برگردیم. همزمان با دعوای حقوقی نوشاب و کوکاکولا بازار نوشیدنی ایران در مقطعی شاهد حضور همزمان دو نوع کوکای اصل خوشگوار و کوکای غیراصل نوشاب بود. اما به تدریج نوشاب با توجه به مشکلات پیش آمده به حاشیه رفت و در نهایت در سال 1392 توسط خوشگوار خریداری شد. به این ترتیب خوشگوار یگانه پرچمدار کوکاکولا در ایران شد. (<a href=\"https://daybev.com/Home/AboutUs\">وبسایت برند هِی‌دِی خوشگوار</a>)(<a href=\"https://money.cnn.com/magazines/fortune/fortune_archive/2007/02/19/8400167/index2.htm\">سی‌اِن‌اِن</a>)"
            }
          },
          {
            "id": "lnknbqTWGU",
            "type": "paragraph",
            "data": {
              "text": "اما آمریکایی بودن کوکا و شایعات مربوط به ارتباط و حمایت آن از رژیم اسرائیل همیشه باعث ایجاد حساسیت بر روی آن و تولیدکننده‌اش یعنی خوشگوار شده است. این موضوع به خصوص همزمان با اوج‌گیری تجاوزات و درگیری‌های رژیم اسرائیل داغ‌تر ‌شده و سر زبان‌ها می‌افتد. یکی از این برهه‌ها نیمه دوم دهه 80 همزمان با حملات این رژیم به غزه بود. این حملات منجر به تحریک اقشار انقلابی و برخی مسئولین برای مقابله با حضور کوکاکولا در بازار ایران شد."
            }
          },
          {
            "id": "F1VBDTZn4j",
            "type": "paragraph",
            "data": {
              "text": "یکی از پیشگامان این موضوع مجمع مردمی مطالبه‌گران مشهد بود که در نامه‌ای سرگشاده به مدیران خوشگوار، با طرح سوالاتی خواستار ارائه توضیح درباره ارتباط با شرکت کوکاکولا شدند. (<a href=\"https://www.magiran.com/article/1197175\">منبع</a>) این اقدام به ویژه پس از انتشار مصاحبه‌هایی از مدیران کوکاکولای بین‌الملل بود که حضور این شرکت در بازار ایران را تایید می‌کرد. (<a href=\"https://www.reuters.com/article/world/us-brands-hang-on-in-sanctions-hit-sudan-iran-idUSL1431181/\">خبرگزاری رویترز</a>)  این نامه و اتفاقات مشابه بار دیگر کوکاکولا و شرکت‌های حامی رژیم اسرائیل را در رسانه‌های ایران به تیتر اخبار کشاند. در آن زمان منوچهر متکی، وزیر وقت امور خارجه از تقدیم هفت جلد جزوه اسامی شركت‌های صهیونیستی و یا چند ملیتی كه اسرائیلی‌ها در آن سهام دارند خبر داد. او در توضیح این موضوع به نکته مهمی هم اشاره کرد: «شركت‌های چند ملیتی نیز، نوعی به هم آمیختگی را برای شناسایی‌شان ایجاد كرده‌اند.» (<a href=\"https://www.asriran.com/fa/news/4370/%D8%A7%D9%86%D8%AA%D8%B4%D8%A7%D8%B1-%D9%87%D9%81%D8%AA-%D8%AC%D9%84%D8%AF-%D8%A7%D8%B3%D8%A7%D9%85%DB%8C-%D8%B4%D8%B1%DA%A9%D8%AA%D9%87%D8%A7%DB%8C-%D8%B5%D9%87%DB%8C%D9%88%D9%86%DB%8C%D8%B3%D8%AA%DB%8C-%D8%AA%D9%88%D8%B3%D8%B7-%D9%88%D8%B2%D8%A7%D8%B1%D8%AA-%D8%AE%D8%A7%D8%B1%D8%AC%D9%87\">عصرایران</a>) مساله‌ای که به نظر می‌رسد برای کوکاکولا هم صادق است."
            }
          },
          {
            "id": "e53KEeIVDu",
            "type": "paragraph",
            "data": {
              "text": "در سال 1387 مجلس قانون جدیدی به نام «قانون الزام دولت به حمایت همه جانبه از مردم مظلوم فلسطین» تصویب کرد. از جمله بندهای این قانون منع دولت از واردات کالاها و انعقاد قرارداد با شرکت‌هایی بود که سهامداران اصلی آنها بنگاه‌های صهیونیستی بودند. (<a href=\"https://rc.majlis.ir/fa/law/show/134862\">وبسایت مجلس</a>) تنها چند روز بعد از این مصوبه، محرابیان، وزیر وقت صنایع، دستور تعلیق فعالیت كلیه شركت‌هایی كه صهیونیست‌ها بخشی از سهام آن را در خارج از كشور در اختیار دارند صادر کرد. (<a href=\"https://www.isna.ir/news/8710-10384/%D8%A7%D8%B2%D8%B3%D9%88%D9%8A-%D9%88%D8%B2%D8%A7%D8%B1%D8%AA-%D8%B5%D9%86%D8%A7%D9%8A%D8%B9-%D9%88-%D9%85%D8%B9%D8%A7%D8%AF%D9%86-%D8%A7%D9%86%D8%AC%D8%A7%D9%85-%D8%B4%D8%AF-%D8%AA%D8%B9%D9%84%D9%8A%D9%82-%D9%81%D8%B9%D8%A7%D9%84%D9%8A%D8%AA-%D8%B4%D8%B1%D9%83%D8%AA-%D9%87%D8%A7%D9%8A-%D9%85%D8%B8%D9%86%D9%88%D9%86\">خبرگزاری ایسنا</a>)  در ادامه وی به شرکت خوشگوار هم مهلت داد تا وضعیت ارتباط خود با کوکاکولا را مشخص کند. (<a href=\"https://www.asriran.com/fa/news/62492/%D8%A7%D8%AE%D8%B7%D8%A7%D8%B1-%D8%A8%D9%87-%D8%B4%D8%B1%D9%83%D8%AA-%D8%AE%D9%88%D8%B4%DA%AF%D9%88%D8%A7%D8%B1-%D8%A8%D8%B1%D8%A7%D9%8A-%D8%A7%D8%AA%D9%85%D8%A7%D9%85-%D9%82%D8%B1%D8%A7%D8%B1%D8%AF%D8%A7%D8%AF-%D8%A8%D8%A7-%D9%83%D9%88%D9%83%D8%A7%D9%83%D9%88%D9%84%D8%A7\">عصرایران</a>) این اتفاق می‌توانست نشان از این باشد که سهامداری صهیونیست‌ها در کوکاکولا برای وزارت صنایع مسجّل است و تنها موضوعی که باید روشن شود عبارت است از وجود ارتباط بین این شرکت و خوشگوار."
            }
          },
          {
            "id": "INqbzdMOI2",
            "type": "paragraph",
            "data": {
              "text": "البته نکته عجیب ماجرا این بود که خوشگوار همواره بر روی محصولش که با مجوز خود وزارت صنعت تولید می‌شد عبارت <b>«پر شده تحت لیسانس کمپانی کوکاکولا»</b> را ثبت می‌کرد. پس طبق قاعده این وزارتخانه باید صحت این ادعا را تایید کرده باشد. حال آن که وزیر بنا را بر عدم صحت گذاشت و به دنبال اقرار گرفتن از سوی خوشگوار رفت!"
            }
          },
          {
            "id": "zHCHvu7Xgq",
            "type": "image",
            "data": {
              "caption": "«پر شده تحت لیسانس کمپانی کوکاکولا» درج شده بر روی نوشابه تولید خوشگوار",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 3722,
                "height": 1786,
                "size": "629693",
                "name": "Coca.jpg",
                "title": "Coca",
                "extension": "jpg",
                "fileId": "5712b5a3-0a55-48a1-beb7-63e687af8474",
                "fileURL": "/files/5712b5a3-0a55-48a1-beb7-63e687af8474",
                "url": "/assets/5712b5a3-0a55-48a1-beb7-63e687af8474"
              }
            }
          },
          {
            "id": "0LGdmzMYfq",
            "type": "paragraph",
            "data": {
              "text": "خوشگوار خیلی زود به استعلام وزیر واکنش نشان داد و در اطلاعیه‌ای هرگونه ارتباط با کوکاکولای آمریکا و پرداخت پول به آن را رد کرد. این شرکت برای رفع اتهامات از خود به کلیدواژه «کشور ایرلند» متوسل شد. یکی از مدیران خوشگوار هم در مصاحبه‌ای اعلام کرد: <b>«ما همواره اسانس مورد نیاز خود را از كشور ایرلند خریداری كرده و در هیچ زمانی هم با شركت كوكاكولا و كشور آمریكا ارتباط نداشته و نخواهیم داشت [...] و تحت هیچ موضوعی مبلغی را به شركت كوكاكولا پرداخت نكرده‌ایم.»</b> (<a href=\"https://www.isna.ir/news/8710-15916/%D9%83%D9%88%D9%83%D8%A7%D9%83%D9%88%D9%84%D8%A7-%D8%AF%D8%B1-%D8%A7%D9%8A%D8%B1%D8%A7%D9%86-%D9%87%D8%B3%D8%AA-%D9%86%D9%8A%D8%B3%D8%AA-%D8%B9%D8%B6%D9%88-%D9%87%D9%8A%D8%A7%D8%AA-%D9%85%D8%AF%D9%8A%D8%B1%D9%87-%D8%B4%D8%B1%D9%83%D8%AA-%D8%AE%D9%88%D8%B4%DA%AF%D9%88%D8%A7%D8%B1-%D8%AA%D9%87%D8%B1%D8%A7%D9%86\">ایسنا</a>)(<a href=\"https://farsnews.ir/FarsNews/1232445836000824044/%D8%AE%D9%88%D8%B4%DA%AF%D9%88%D8%A7%D8%B1-%D8%A8%D8%A7-%D8%B1%DA%98%D9%8A%D9%85-%D8%B5%D9%87%D9%8A%D9%88%D9%86%D9%8A%D8%B3%D8%AA%D9%8A-%D8%A7%D8%B1%D8%AA%D8%A8%D8%A7%D8%B7%D9%8A-%D9%86%D8%AF%D8%A7%D8%B1%D8%AF\">فارس</a>) پاسخی عجیب که امید می‌رفت تا حدی خاطر مردم و حتی حاکمیت را نسبت به موضوع آرام کند."
            }
          },
          {
            "id": "ZqCA9e30wa",
            "type": "paragraph",
            "data": {
              "text": "با این وجود مساله هنوز مبهم بود و سوالات زیادی پیرامون آن وجود داشت. حتی در این باره از آیت‌الله علم‌الهدی امام جمعه مشهد نیز سوال می‌شد. وی در پاسخ گفته بود که پنجاه سال است سرمایه‌گذاران این کارخانه را می‌شناسد و از <b>متدین</b> و <b>ایرانی</b> بودن آنها خبر دارد! اما مساله کوکاکولا پیچیده است و بعد از دیدار با مسئولین شرکت و نماینده وزارت صمت هنوز نتوانسته در مورد صهیونیستی بودن محصول این کارخانه به جمع‌بندی برسد. (<a href=\"https://www.mashreghnews.ir/news/2450/%D8%B1%D9%88%D8%A7%D9%8A%D8%AA-%D8%A2%D9%8A%D8%AA-%D8%A7%D9%84%D9%84%D9%87-%D8%B9%D9%84%D9%85-%D8%A7%D9%84%D9%87%D8%AF%D9%8A-%D8%A7%D8%B2-%D8%AF%D9%8A%D8%AF%D8%A7%D8%B1-%D8%A8%D8%A7-%D8%B1%D9%87%D8%A8%D8%B1%D9%8A\">مشرق</a>)"
            }
          },
          {
            "id": "m0bPpPAnuM",
            "type": "paragraph",
            "data": {
              "text": "موضوع انتشار فهرست‌‌ها نیز همچنان پای ثابت اخبار این سال‌ها بود. فهرست‌هایی که وزارت خارجه باید بر اساس وظیفه قانونی خود از شرکت‌های صهیونیستی تهیه می‌کرد اما علیرغم هیاهوی رسانه‌ای هیچ وقت به شکلی عمومی و قابل اعتماد منتشر نشد. از جزوه‌های هفت‌گانه منوچهر متکی و نامه حسن قشقاوی به کمیسیون امنیت ملی گرفته تا ادعای خاندوزی وزیر اقتصاد دولت سیزدهم مبنی بر اعلام فهرست به سازمان توسعه تجارت و درخواست چند روز بعد قالیباف رئیس مجلس برای اعلام فهرست و جلوگیری از واردات آن. (<a href=\"https://jahannews.com/vdcb85b89rhbfwp.uiur.html\">جهان‌نیوز</a>) (<a href=\"https://snn.ir/004fMW\">خبرگزاری دانشجو</a>) (<a href=\"https://www.hamshahrionline.ir/news/814916/%D8%A8%D8%A8%DB%8C%D9%86%DB%8C%D8%AF-%D8%AF%D8%B1%D8%AE%D9%88%D8%A7%D8%B3%D8%AA-%D9%81%D9%88%D8%B1%DB%8C-%D9%82%D8%A7%D9%84%DB%8C%D8%A8%D8%A7%D9%81-%D8%A7%D8%B2-%D9%88%D8%B2%D8%A7%D8%B1%D8%AA-%D8%A7%D9%85%D9%88%D8%B1-%D8%AE%D8%A7%D8%B1%D8%AC%D9%87-%D9%81%D9%87%D8%B1%D8%B3%D8%AA-%DA%A9%D8%A7%D9%84%D8%A7%D9%87%D8%A7%DB%8C\">همشهری</a>) این دست برخوردها با موضوع نشان می‌داد موضوع پیچیده‌تر از آن است که حاکمیت بخواهد یا بتواند درباره‌اش به جمع‌بندی برسد."
            }
          },
          {
            "id": "nmQIRbjjN0",
            "type": "header",
            "data": {
              "text": "طوفان‌الاقصی و تشدید حواشی",
              "level": 3
            }
          },
          {
            "id": "6U-ebcXuqo",
            "type": "paragraph",
            "data": {
              "text": "در طول این سال‌ها، کشمکش حول خوشگوار، کوکاکولا، اسرائیل و ارتباط آنها با یکدیگر هیچ وقت تمام نشد. اما حمله جدید رژیم اسرائیل به غزه پس از طوفان‌الاقصی (15 مهر 1402) دوباره فتیله ماجرای خوشگوار و کوکاکولا را بالا کشید. یکی از اتفاقاتی که در رسانه‌ها نیز مورد توجه زیادی قرار گرفت جدال سیدحسین حسینی و المیرا شریفی مقدم مجریان تلویزیون روی آنتن زنده بر سر موضوع کوکاکولا و پپسی بود. (<a href=\"https://plus.parsine.com/?p=26865\">ویدیوی جدال دو مجری تلویزیون بر سر کوکاکولا</a>)"
            }
          },
          {
            "id": "XIBXOuMpn_",
            "type": "paragraph",
            "data": {
              "text": "کم کم پای نمایندگان مجلس هم به موضوع باز شد. از جمله علی خضریان سخنگوی کمیسیون اصل 90 که گفت در صورتی که ارتباط محصولاتی مثل کوکاکولا و نستله با شرکت‌های اصلی محرز شود باید آنها را تحریم کنیم. (<a href=\"https://nournews.ir/n/155382\">نورنیوز</a>)  این یعنی پس از گذشت نزدیک به دو دهه از زمان مطرح شدن این سوال در فضای عمومی کشور، <b>حاکمیت هنوز نتوانسته بود وجود یا عدم وجود این ارتباط را احراز کند!</b> گرچه پیش از آن، آصفری معاون اقتصادی وقت وزیر خارجه گفته\nهم گفته بود: «تولید کنندگان کوکاکولا در داخل کشور در جلسات به ما اعلام کردند که\nهیچ ارتباطی با شرکت کوکاکولا ندارند».<b> </b>(<a href=\"https://www.sharghdaily.com/fa/tiny/news-910384\">شرق</a>)"
            }
          },
          {
            "id": "7cg5NKLV3I",
            "type": "paragraph",
            "data": {
              "text": "با گسترش جنایات رژیم در غزه تلاش‌های رسانه‌ای برای کشف این معمای قدیمی نیز بیشتر شد. اما مدیران خوشگوار که حالا دیگر سال‌ها بود به این سوال و جواب‌ها، ادعاهای بی‌سند و تهدیدهای توخالی عادت کرده بودند، حتی نیازی به پاسخگویی به رسانه‌ها هم نمی‌دیدند. برای نمونه رسانه تبیان روایت پیگیری‌اش از شرکت خوشگوار و جواب‌های سربالای مسئولان شرکت را منتشر کرده است. (<a href=\"http://www.tebyan.net/x67Ds\">تبیان</a>) پایگاه خبری صبح طوس مشهد هم که در این زمینه به سراغ یکی از مدیران خوشگوار رفته بود با این پاسخ مواجه شد: «به جایی نمی‌رسید، دنبال پیگیری این موضوع نباشید!» (<a href=\"https://sobhtoos.ir/story/%D8%A7%D8%B2-%D9%BE%D8%A7%D8%B3%D8%AE-%D8%B9%D8%AC%DB%8C%D8%A8-%D9%85%D8%AF%DB%8C%D8%B1%D8%A7%D9%86-%D8%AE%D9%88%D8%B4%DA%AF%D9%88%D8%A7%D8%B1-%D8%AA%D8%A7-%D8%AA%D8%A3%D9%85%DB%8C%D9%86-%D8%A7%D8%B3%D8%A7%D9%86%D8%B3-%DA%A9%D9%88%D9%84%D8%A7-%D8%A8%D8%B1%D8%A7%DB%8C-%D8%AE%D9%88%D8%B4%DA%AF%D9%88%D8%A7%D8%B1\">صبح‌طوس</a>)"
            }
          },
          {
            "id": "F85038ADXD",
            "type": "paragraph",
            "data": {
              "text": "اما مهر ماه 1403 ناگهان خبری عجیب منتشر می‌شود: «توقف تولید نوشابه کوکاکولا در ایران». در این خبر اعلام شده بود که به دلیل مواضع دولت آمریکا و تحریم‌های جدید، کوکاکولا همکاری خود با شرکت‌های ایرانی را قطع کرده است و به زودی شاهد پایان حضور نوشابه‌های کوکاکولا در بازار ایران خواهیم بود. نکته جالب آن بود که رسانه‌ها و روزنامه‌های متعددی که خبر را منتشر کرده بودند، هیچ کدام منبع موثقی برای آن ذکر نکرده و نقل قول خود را به «خبرهایی که در فضای مجازی منتشر شده‌اند» منتسب می‌کردند! (<a href=\"https://www.eghtesadnews.com/fa/tiny/news-675419\">اقتصادنیوز</a>)(<a href=\"https://www.etemadonline.com/tiny/news-676045\">اعتماد</a>) با این وجود، یک جریان تحلیلی مکمل نیز بر این موج خبری سوار شد و به مرثیه‌سرایی برای این اتفاق پرداخت. در این تحلیل‌ها به مقایسه تراژیک خروج کوکاکولا با واردات آیفون، خودرو و لوازم خانگی پرداخته شده بود و درباره نقش مافیا و رقبا در این رخداد و نتایج اسف‌بار آن برای مردم و بازار نوشابه کشور توضیحاتی ارائه می‌شد. (<a href=\"https://www.ettelaat.com/news/65957/%D9%BE%D8%B4%D8%AA-%D9%BE%D8%B1%D8%AF%D9%87-%D8%B4%D8%A7%DB%8C%D8%B9%D9%87-%D8%AC%D9%86%D8%AC%D8%A7%D9%84%DB%8C-%D8%AF%D8%B1%D8%A8%D8%A7%D8%B1%D9%87-%DA%A9%D9%88%DA%A9%D8%A7%DA%A9%D9%88%D9%84%D8%A7-%D9%86%D9%88%D8%B4%D8%A7%D8%A8%D9%87-%D9%85%D8%AD%D8%A8%D9%88%D8%A8-%D8%A7%D8%B2-%D8%A8%D8%A7%D8%B2%D8%A7%D8%B1\">اطلاعات</a>)"
            }
          },
          {
            "id": "kzs_M9g7rM",
            "type": "paragraph",
            "data": {
              "text": "پس از انتشار این خبر هیچ اتفاقی برای محصولات کوکاکولا در بازار نیفتاد و این نوشابه‌ها مثل قبل و به وفور در یخچال مغازه‌ها در دسترس مشتریان ماندند. اما این خبر سوالات زیادی را دوباره در ذهن مصرف‌کننده ایرانی ایجاد کرد، مگر کوکاکولا در ایران حضور داشت که حالا قصد رفتن داشته باشد؟! مگر مسئولین خوشگوار نگفته بودند که ما هیچ وقت ارتباطی با کوکاکولای آمریکا نداشته‌ایم؟ بالاخره واقعیت ماجرای کوکاکولا در ایران چیست؟!"
            }
          },
          {
            "id": "OXXC43Niue",
            "type": "header",
            "data": {
              "text": "کوکاکولا در ایران است، نقطه.",
              "level": 3
            }
          },
          {
            "id": "xPpwXix1SY",
            "type": "paragraph",
            "data": {
              "text": "واقعیت آن است که ارتباط خوشگوار و کوکاکولا هیچ وقت مرموز و پنهان نبوده است. اما به خاطر آشفتگی فضای عمومی و رسانه‌ای کشور و بی‌اطلاعی از اصول اولیه تجاری، این امکان به وجود آمد تا با فرافکنی، ابهام‌، تردید و اطلاعات غلط، سال‌ها این موضوع، یک سوال پیچیده و بی‌جواب به نظر بیاید. بیایید یک بار همه شواهد این ارتباط را با هم مرور کنیم:"
            }
          },
          {
            "id": "hG-sQbgw8k",
            "type": "header",
            "data": {
              "text": "شاهد ۱ – اقرار کوکاکولا",
              "level": 4
            }
          },
          {
            "id": "lrnEFG2vMA",
            "type": "paragraph",
            "data": {
              "text": "شرکت خوشگوار یک نوشابه‌ساز رسمی در سیستم کوکاکولا است که امتیاز تولید و توزیع انحصاری در داخل مرزهای جغرافیایی ایران را در اختیار دارد. دقیقاً مثل حدود 200 نوشابه‌ساز رسمی دیگری که در مناطق مختلف جهان در این سیستم حضور داشته و تولید و رساندن محصولات کوکاکولا به دست مصرف‌کنندگان را بر عهده دارند. خوشگوار در سایت رسمی کوکاکولای جهانی هم به عنوان یکی از شرکای نوشابه‌ساز منطقه اوراسیا و خاورمیانه این شرکت معرفی شده است. (<a href=\"https://www.coca-colacompany.com/about-us/coca-cola-system\">وبسایت کوکاکولا</a>)"
            }
          },
          {
            "id": "WFGzCEbJmv",
            "type": "image",
            "data": {
              "caption": "نام خوشگوار در میان شرکای رسمی کوکاکولا در وبسایت رسمی این شرکت",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 1197,
                "height": 933,
                "size": "92865",
                "name": "Screenshot 2025-07-30 160555.png",
                "title": "Screenshot 2025 07 30 160555",
                "extension": "png",
                "fileId": "3f784500-b450-4f37-9a48-494c0f08e905",
                "fileURL": "/files/3f784500-b450-4f37-9a48-494c0f08e905",
                "url": "/qlist-assets/3f784500-b450-4f37-9a48-494c0f08e905.png"
              }
            }
          },
          {
            "id": "VYGregH-K0",
            "type": "header",
            "data": {
              "text": "شاهد ۲ – تحت لیسانس کوکاکولا",
              "level": 4
            }
          },
          {
            "id": "LXPNjZzqdX",
            "type": "paragraph",
            "data": {
              "text": "در طول سال‌های حضور محصولات کوکاکولا در بازار ایران، همواره روی آن عبارت <b>«اصل»</b> و پشت آن عبارت <b>«تحت لیسانس کوکاکولای بین‌الملل»</b> درج شده‌است. بر خلاف تصور رایج مردم، نوشتن چنین جملاتی بر روی محصولی که به شکل رسمی و با اخذ مجوزهای قانونی تولید و توزیع می‌شود بار حقوقی سنگینی دارد و حتما باید مورد تایید مراجع قانونی قرار گرفته‌باشد. این موضوع نشان می‌دهد که خود شرکت\nخوشگوار تلاش کرده تا مشتریانش را در مورد این که با یک کوکاکولای اصل مواجه هستند قانع کند."
            }
          },
          {
            "id": "Fw6yRLRGIN",
            "type": "header",
            "data": {
              "text": "شاهد ۳ – علامت تجاری",
              "level": 4
            }
          },
          {
            "id": "43Ea5j_Uik",
            "type": "paragraph",
            "data": {
              "text": "محصول کوکاکولایی که توسط خوشگوار تولید و عرضه می‌شود به صورت قانونی و رسمی از نام، نشان، هویت بصری، بطری و سایر علائم تجاری متعلق به شرکت کوکاکولای بین‌الملل استفاده می‌کند. دارایی‌هایی که در ایران هم ثبت و حفاظت رسمی شده‌اند. (<a href=\"https://ipm.ssaa.ir/Search-Result?page=2&amp;DecNo=6Nboabm7stk4+94oPsqirw==&amp;RN=PonS3YuZuXKt5q+qKvqzdw==\">سازمان ثبت اسناد1</a>)(<a href=\"https://ipm.ssaa.ir/Search-Result?page=2&amp;DecNo=MCTSeEAw0DzJGsu2bIrIVA==&amp;RN=4PSYaVy5/PeOfPCwWyWGCQ==\">سازمان ثبت اسناد2</a>) بر خلاف تصور رایج، ایران قوانین مناسبی برای حفاظت از علائم تجاری (برندها) دارد. طبق ماده 31 قانون ثبت اختراعات، طرح‌های صنعتی و علائم تجاری، <b>«حق استفاده انحصاری از یك علامت به كسی اختصاص دارد كه آن علامت را طبق مقررات این قانون به ثبت رسانده باشد»</b>. به موجب این قانون «استفاده از هر علامت كه در ایران ثبت شده باشد، توسط هر شخص غیر از مالک علامت‌، مشروط به موافقت مالك آن می‌ باشد».  پس خوشگوار به طور طبیعی در قالب یک توافق با شرکت کوکاکولا توانسته است از علائم تجاری این شرکت استفاده کند:"
            }
          },
          {
            "id": "1IzwK_QhbB",
            "type": "quote",
            "data": {
              "text": "طبق ماده 40 قانون ثبت اختراعات، طرح های صنعتی و علائم تجاری، <b>«مالك علامت ثبت شده می‌تواند علیه هر شخصی كه بدون موافقت وی از علامت استفاده كند و یا شخصی كه مرتكب عملی شود كه عادتاً منتهی به تجاوز به حقوق ناشی از ثبت علامت گردد، در دادگاه اقامه دعوی نماید. این حقوق شامل موارد استفاده از علامتی می‌شود كه شبیه علامت ثبت شده است و استفاده از آن برای كالا یا خدمات مشابه‌، موجب گمراهی عموم می‌گردد.»</b> پیش‌تر ماجرای شکایت کوکاکولا از شرکت نوشاب بابت استفاده بدون توافق از برند که در دادگاه ایرانی منجر به حکم به نفع صاحب برند شد ذکر گردید. این ماجرا به خوبی توانمندی قوانین کشور در حفاظت از دارایی‌های تجاری شرکت‌ها را نشان می‌دهد.",
              "caption": "",
              "alignment": "left"
            }
          },
          {
            "id": "QKA0Vgf8Hq",
            "type": "image",
            "data": {
              "caption": "دارایی‌های تجاری ثبت شده تحت عنوان دِ کوکاکولا کمپانی | the COCA COLA company در سازمان ثبت اسناد ایران",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 517,
                "height": 857,
                "size": "240196",
                "name": "Screenshot 2025-07-30 at 17-02-41 جستجوی علائم تجاری.png",
                "title": "Screenshot 2025 07 30 at 17 02 41 جستجوی علائم تجاری",
                "extension": "png",
                "fileId": "791b6a9b-d27b-424e-a27b-fc597b420460",
                "fileURL": "/files/791b6a9b-d27b-424e-a27b-fc597b420460",
                "url": "/qlist-assets/791b6a9b-d27b-424e-a27b-fc597b420460.png"
              }
            }
          },
          {
            "id": "wd_xnncNey",
            "type": "header",
            "data": {
              "text": "شاهد ۴ – سکوت رقبا",
              "level": 4
            }
          },
          {
            "id": "t9cs7pTnSL",
            "type": "paragraph",
            "data": {
              "text": "استفاده غیرمجاز از برند یک شرکت دیگر طبق قانون به وضوح یک اقدام ضد رقابت و مصداق رقابت غیرمنصفانه (فصل ششم قانون حمایت از مالکیت صنعتی) است. (<a href=\"https://rc.majlis.ir/fa/law/show/1809131\">وبسایت مجلس</a>) یعنی قانون اجازه نمی‌دهد در حالی که شرکت‌های رقیب مجبورند بخش قابل توجهی از منابع خود را صرف بازاریابی و تبلیغات کنند، یک شرکت بتواند بدون صرف هزینه و به «شکل رسمی» از برند دیگری استفاده کند. برندی که مالکش سالیانه میلیاردها دلار صرف تبلیغات و تقویت آن کرده است. اگر استفاده از برند کوکاکولا بدون اجازه شرکت کوکاکولا انجام شده بود، بر اساس قوانین موجود، رقبای خوشگوار به راحتی می‌توانستند از این شرکت در دادگاه شکایت کنند. از طرف دیگر برای آنها نیز این امکان وجود داشت که از همین برند بر روی محصولات خود استفاده کرده و به راحتی سهم بازار خود را گسترش دهند. چنان که خوشگوار هم به اذعان مدیر خودش به پشتوانه همین برند توانسته است سهم بازار خود را تا این حد گسترش دهد: «بازار فروش ما وابسته به همین نام است و نمی‌توانیم آنرا حذف كنیم». (<a href=\"https://aftabnews.ir/000LgZ\">آفتاب‌نیوز</a>)"
            }
          },
          {
            "id": "A5jlQOJuwV",
            "type": "paragraph",
            "data": {
              "text": "این در حالی است که در طول این سال‌ها هیچ کدام از این دو اقدام از سوی شرکت‌های رقیب خوشگوار انجام نشده و تولید نوشابه با برند کوکاکولا به شکل انحصاری در اختیار خوشگوار مانده است. پس می‌توان نتیجه گرفت که استفاده خوشگوار از برند کوکاکولا حتماً با اجازه رسمی صاحب برند است."
            }
          },
          {
            "id": "QreiI6RU-L",
            "type": "header",
            "data": {
              "text": "سوم. قرارداد کوکاکولا و خوشگوار",
              "level": 2
            }
          },
          {
            "id": "CbhF--s6MJ",
            "type": "paragraph",
            "data": {
              "text": "اطلاعات، اسناد و استدلال‌هایی که تا اینجا ارائه شد به خوبی می‌توانند ارتباط مستقیم خوشگوار با کوکاکولا را اثبات کنند، اما از تیر ماه ۱۴۰۳ به این سو دیگر چندان نیازی به آنها نیست! در این تاریخ، نامه‌ای منتشر شد که یک پیوست بسیار مهم داشت. پیوستی که عملاً هرگونه ابهام و شبهه‌ای که در طول این سال‌ها درباره کوکاکولا در ایران مطرح شده بود را به طور کامل برطرف کرد:"
            }
          },
          {
            "id": "Jx4Fgpw0bb",
            "type": "header",
            "data": {
              "text": "جنگ در اوکراین، اعتراف در ایران!",
              "level": 3
            }
          },
          {
            "id": "aYdCKDkZhV",
            "type": "image",
            "data": {
              "caption": "تصویر دستورالعمل سازمان توسعه تجارت مبنی بر درخواست جلوگیری از صادرات انواع نوشابه‌های تولیدی شرکت خوشگوار تحت لیسانس کوکاکولا",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 648,
                "height": 730,
                "size": "88022",
                "name": "2349458_869.png",
                "title": "2349458 869",
                "extension": "png",
                "fileId": "8f61625b-a450-4840-b494-1b7aa4eb5612",
                "fileURL": "/files/8f61625b-a450-4840-b494-1b7aa4eb5612",
                "url": "/qlist-assets/8f61625b-a450-4840-b494-1b7aa4eb5612.png"
              }
            }
          },
          {
            "id": "xactvwvRrC",
            "type": "paragraph",
            "data": {
              "text": "ماجرا از جایی آغاز شد که با آغاز جنگ روسیه و اوکراین، شرکت کوکاکولا در اسفند 1400 طی بیانیه‌ای رسمی اعلام کرد که فعالیت و فروش محصولات خود در روسیه را متوقف خواهد کرد. این تصمیم ناگهانی موجب شد تا به تدریج و با پایان موجودی انبارها، تقاضای انباشته‌ای برای محصولات این شرکت در بازار روسیه شکل بگیرد. در این زمان برخی از تجار فرصت را غنیمت شمرده و به خرید نوشابه‌های کوکاکولای تولید خوشگوار از ایران و صادرات آن به روسیه پرداختند."
            }
          },
          {
            "id": "dSlhXXD6Tc",
            "type": "image",
            "data": {
              "caption": "قوطی کوکاکولای تولید خوشگوار در روسیه",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 900,
                "height": 510,
                "size": "121442",
                "name": "FcpLN4eX0AA2pkp_Cropped.jpg",
                "title": "Fcp L N4e X0 a A2pkp Cropped",
                "extension": "jpg",
                "fileId": "d0498119-819f-4a30-aade-ef3c5c19ceeb",
                "fileURL": "/files/d0498119-819f-4a30-aade-ef3c5c19ceeb",
                "url": "/qlist-assets/d0498119-819f-4a30-aade-ef3c5c19ceeb.jpg"
              }
            }
          },
          {
            "id": "67ebC_2sky",
            "type": "paragraph",
            "data": {
              "text": "با گسترش این مساله، در تیر ماه 1403 سازمان توسعه تجارت طی نامه‌ای از گمرک درخواست می‌کند که از صادرات انواع نوشابه‌های تولیدی شرکت خوشگوار جلوگیری به عمل آید. (<a href=\"https://dotic.ir/news/16637/%D8%A8%D8%AE%D8%B4%D9%86%D8%A7%D9%85%D9%87-%D9%85%D9%88%D8%B6%D9%88%D8%B9-%D8%AC%D9%84%D9%88%DA%AF%DB%8C%D8%B1%DB%8C-%D8%A7%D8%B2-%D8%B5%D8%A7%D8%AF%D8%B1%D8%A7%D8%AA-%D8%A7%D9%86%D9%88%D8%A7%D8%B9-%D9%86%D9%88%D8%B4%D8%A7%D8%A8%D9%87-%D9%87%D8%A7%DB%8C-%D8%AA%D9%88%D9%84%DB%8C%D8%AF%DB%8C-%D8%B4%D8%B1%DA%A9%D8%AA-%D8%AE%D9%88%D8%B4%DA%AF%D9%88%D8%A7%D8%B1-%D8%AA%D8%AD%D8%AA-%D9%84%DB%8C%D8%B3%D8%A7%D9%86%D8%B3-%DA%A9%D9%85%D9%BE%D8%A7%D9%86%DB%8C-%DA%A9%D9%88%DA%A9%D8%A7%DA%A9%D9%88%D9%84%D8%A7\">پایگاه قوانین و مقررات کشور</a>) البته این درخواستی بود که خود شرکت خوشگوار به سازمان توسعه تجارت ارسال کرده بود و دلیل آن چیزی نبود جز مفاد قرارداد رسمی این شرکت با شرکت کوکاکولای آمریکا که در آن خوشگوار اجازه داشت صرفاً در قلمرو سرزمینی جمهوری اسلامی ایران محصولات متعلق به کوکاکولا را به فروش برساند. این نامه یک\nپیوست بسیار مهم هم داشت، آن هم متن قرارداد رسمی امضا شده بین <b>شرکت سهامی خوشگوار تهران،\nایران</b> و <b>شرکت کوکاکولا آتالانتا، آمریکا</b> بود."
            }
          },
          {
            "id": "JzJHEZWkFg",
            "type": "quote",
            "data": {
              "text": "متن «<a href=\"https://dotic.ir/news/16637\">قرارداد کوکاکولا و خوشگوار</a>» را در سایت پایگاه اطلاع‌رسانی قوانین و مقررات کشور بخوانید.",
              "caption": "",
              "alignment": "left"
            }
          },
          {
            "id": "6CRUsu4y7F",
            "type": "paragraph",
            "data": {
              "text": "قراردادی که دیدن آن قبل از هر چیز\nاظهارات و ادعاهای خوشگوار و مدیرانش را در ذهن تداعی می‌کرد:"
            }
          },
          {
            "id": "x1dwsIbr4D",
            "type": "quote",
            "data": {
              "text": "<b>« ... در\nهیچ زمانی هم با شركت كوكاكولا و كشور آمریكا ارتباط نداشته و نخواهیم داشت... »</b>",
              "caption": "مهدی صیادیان - عضو هیات مدیره شركت خوشگوار تهران - ۲۹ دی ۱۳۸۷ (<a href=\"http://www.isna.ir/xdPZL\">منبع: ایرنا</a>)",
              "alignment": "left"
            }
          },
          {
            "id": "WTP4tJykI0",
            "type": "image",
            "data": {
              "caption": "",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 875,
                "height": 373,
                "size": "175259",
                "name": "image_14.png",
                "title": "Image 14",
                "extension": "png",
                "fileId": "ee6f71c1-f10f-459b-a398-4723cee05e3a",
                "fileURL": "/files/ee6f71c1-f10f-459b-a398-4723cee05e3a",
                "url": "/qlist-assets/ee6f71c1-f10f-459b-a398-4723cee05e3a.png"
              }
            }
          },
          {
            "id": "1P0t_4L4lW",
            "type": "paragraph",
            "data": {
              "text": "در ادامه به بررسی و تحلیل مفاد مهم و\nجالب توجه این قرارداد می‌پردازیم. برخی از این موارد می‌توانند شبهات رایج در\nزمینه حضور رسمی شرکت‌های بین‌المللی در ایران بخصوص کوکاکولا را برطرف نمایند:"
            }
          },
          {
            "id": "rGJZhKAwr1",
            "type": "header",
            "data": {
              "text": "ماده ۱ و ۲۸  – از&nbsp;آتلانتا تا تهران",
              "level": 3
            }
          },
          {
            "id": "om4TWaRdAD",
            "type": "image",
            "data": {
              "caption": "",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 718,
                "height": 92,
                "size": "17985",
                "name": "image_15.jpeg",
                "title": "Image 15",
                "extension": "jpeg",
                "fileId": "4f74470b-d3e6-451f-9647-dbb7c4ada485",
                "fileURL": "/files/4f74470b-d3e6-451f-9647-dbb7c4ada485",
                "url": "/qlist-assets/4f74470b-d3e6-451f-9647-dbb7c4ada485.jpg"
              }
            }
          },
          {
            "id": "g_-xnQKmV6",
            "type": "image",
            "data": {
              "caption": "",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 1427,
                "height": 101,
                "size": "25090",
                "name": "image_16.jpeg",
                "title": "Image 16",
                "extension": "jpeg",
                "fileId": "6cc1e6ba-87f7-42ef-b02b-f95dc209ab08",
                "fileURL": "/files/6cc1e6ba-87f7-42ef-b02b-f95dc209ab08",
                "url": "/qlist-assets/6cc1e6ba-87f7-42ef-b02b-f95dc209ab08.jpg"
              }
            }
          },
          {
            "id": "eimakociGv",
            "type": "paragraph",
            "data": {
              "text": "چنان که قبلا توضیح داده شد، خوشگوار\nجزئی از سیستم نوشابه‌سازی، توزیع و فروش بین‌المللی کوکاکولا است که هدف نهایی آن، افزایش فروش و درآمد شرکت کوکاکولا در ضمنِ کسب درآمد برای شرکای آن است. از همین\nبابت در ماده 28، بر حقوق شرکت کوکاکولا نسبت به این سیستم تصریح و تاکید شده است.\nدر سیستم کوکاکولا، امتیاز و انحصار تولید، توزیع و فروش محصول در هر منطقه\nجغرافیاییِ مشخص شده به یک یا چند نوشابه‌ساز سپرده شده است. به همین ترتیب طبق\nبند 1، <b>خوشگوار صرفاً انحصار عرضه کوکاکولا در مرزهای جغرافیایی جمهوری اسلامی\nایران را در اختیار دارد.</b>"
            }
          },
          {
            "id": "iYN1_FDwCi",
            "type": "header",
            "data": {
              "text": "ماده ۱۳&nbsp;– تضمین منافع",
              "level": 3
            }
          },
          {
            "id": "Ycf4jkgoEW",
            "type": "paragraph",
            "data": {
              "text": "ممکن است ساده انگارانه چنین ادعا شود\nکه اگرچه شرکت کوکاکولا حق استفاده از برند را به خوشگوار داده است، اما این به\nمعنای رسیدن منفعتی به کوکاکولا نیست. اما در ماده 13 تصریح شده است که <b>کلیه حقوق\nو منافع ایجاد شده از طریق استفاده از علایم تجاری و... باید متضمن منافع شرکت\nباشد</b>، که در راس این منافع <b>افزایش فروش و نفوذ برند شرکت کوکاکولا است.</b>"
            }
          },
          {
            "id": "Y-LbsuEtDv",
            "type": "header",
            "data": {
              "text": "مقدمه د&nbsp;– تامین‌کننده ایرلندی!",
              "level": 3
            }
          },
          {
            "id": "9hJsl8n0Pd",
            "type": "image",
            "data": {
              "caption": "",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 790,
                "height": 74,
                "size": "14959",
                "name": "image_17.jpeg",
                "title": "Image 17",
                "extension": "jpeg",
                "fileId": "00a452e8-7703-4dae-a15d-2e1e4aec3923",
                "fileURL": "/files/00a452e8-7703-4dae-a15d-2e1e4aec3923",
                "url": "/qlist-assets/00a452e8-7703-4dae-a15d-2e1e4aec3923.jpg"
              }
            }
          },
          {
            "id": "lOjFpvIqc1",
            "type": "paragraph",
            "data": {
              "text": " بخش (د) از مقدمه قرارداد، می‌تواند نقش <b>«ایرلند»</b> را که بر رابطه خوشگوار با کوکاکولای آمریکا سایه انداخته بود روشن کند. کشوری که مطرح کردن نامش موجب\nایجاد ابهام در بین رسانه‌ها،\nمردم و حتی مسئولینی شد که شناخت عمیقی از موضوع نداشتند. در این بند تصریح شده\nاست که شرکت کوکاکولا در <b>تامین کنسانتره برای خوشگوار</b>، تعدادی شرکت ثالث را به\nعنوان <b>«تامین‌کننده مُجاز»</b> تعیین کرده است. "
            }
          },
          {
            "id": "8f1itpPDab",
            "type": "paragraph",
            "data": {
              "text": "شرکت کوکاکولا علاوه بر آمریکا، در\nبرخی دیگر از مناطق جهان نیز کارخانجاتی برای تولید «کنسانتره» دارد. از این جمله می‌توان به شرکت‌های\nکنسانتره‌سازی در کاستاریکا، هند و برزیل اشاره کرد که همگی در چند سال اخیر با\nسرمایه‌گذاری کوکاکولا راه‌اندازی شده و تحت مالکیت آن قرار دارند. (<a href=\"https://news.co.cr/coca-cola-company-announced-establishment-one-largest-plants-guanacaste-costa-rica/71357/\">کاستا ریکا اِستار</a>)(<a href=\"https://timesofindia.indiatimes.com/city/ahmedabad/coca-cola-to-invest-rs-3000-crore-to-set-up-plant-in-sanand/articleshow/105824471.cms\">تایمز آف ایندیا</a>)(<a href=\"https://www.reuters.com/business/retail-consumer/coca-cola-invests-some-90-mln-expand-production-brazils-amazonas-2024-12-13/\">رویترز</a>)"
            }
          },
          {
            "id": "tSfVVYIw-c",
            "type": "paragraph",
            "data": {
              "text": "در\nسیستم کوکاکولا ۴ بخش جغرافیایی اصلی <b>آمریکای شمالی</b>، <b>آمریکای جنوبی</b>، <b>اروپا-خاورمیانه-آفریقا</b>، و <b>آسیا</b> تعریف شده است که هر یک از شرکت‌های ذکر شده بسته به\nظرفیت خود بخشی از نیاز نوشابه‌سازهای این مناطق را تامین می‌کنند. (<a href=\"https://www.investopedia.com/articles/markets/112515/how-does-cocacola-actually-make-money.asp\">اینوِستوپدیا</a>) از مهم‌ترین\nمناطقی که کوکاکولا در آن کنسانتره‌هایش را تولید می‌کند ایرلند است. یکی از این\nکارخانجات کنسانتره‌سازی ایرلند در منطقه دراهیدا/Drogheda بود\nکه البته در سال 1387 فعالیت آن متوقف شد. در نیمه دهه 80 و پس از پیگیری‌های مجمع\nمطالبه مردمی مشهد، برخی از خبرگزاری‌ها و روزنامه‌های داخلی و خارجی، کشور ایرلند و شرکت کنسانتره دراهیدا را به عنوان تامین‌کننده کنسانتره برای خوشگوار اعلام\nکردند. هنگامی که از دراهیدا درباره این ارتباط ادعایی با خوشگوار پرسیده شد، شرکت، موضوع را به کوکاکولا ارجاع داد. در ادامه یکی از مدیران شرکت کوکاکولا در این باره\nمورد سوال قرار گرفت. وی فروش کنسانتره به ایران را تایید نمود اما باز هم درباره\nمبدا آن سکوت کرد. (<a href=\"http://www.mehrnews.com/x5pzj\">مهر</a>)(<a href=\"https://web.archive.org/web/20250825072711/https:/www.thetimes.com/comment/register/article/iran-targets-irish-coke-connection-dms08jhpx6r\">تایمز</a>)(<a href=\"https://web.archive.org/web/20230924052119/https:/money.cnn.com/magazines/fortune/fortune_archive/2007/02/19/8400167/?postversion=2007020606\">سی‌اِن‌اِن</a>)"
            }
          },
          {
            "id": "xD5aiTJG5Y",
            "type": "paragraph",
            "data": {
              "text": "مدتی بعد با\nاظهار نظر مدیران خوشگوار عملاً مبدا ایرلند برای تامین کنسانتره تایید شد. (<a href=\"http://www.isna.ir/xdPZL\">ایسنا</a>) کوکاکولا در ایرلند چند کارخانه تولید کنسانتره داشت که البته\nدر سال‌های اخیر بیشتر آنها از جمله دراهیدا را تعطیل و ظرفیت تولیدشان را در\nکارخانه بالینا/Ballina تجمیع کرد. (<a href=\"https://www.irishtimes.com/business/retail-and-services/coca-cola-closes-athy-plant-with-82-job-losses-1.3481557\">آیریش‌تایمز</a>)(<a href=\"https://www.eurofound.europa.eu/en/resources/article/2007/coca-cola-move-production-non-unionised-plant\">یوروفاوند</a>) به این ترتیب با\nتوجه به پیشینه تامین خوشگوار از ایرلند، می‌توان حدس زد که «تامین‌کننده مجاز»\nبرای خرید کنسانتره که در قرارداد خوشگوار با کوکاکولا ذکر شده است همین کارخانه بالینا\nباشد. با این وجود این مساله چندان اهمیتی ندارد. چرا که مطابق مستندات ذکر شده،\nهمه کارخانجات کنسانتره‌‌سازی سیستم کوکاکولا در هر نقطه از دنیا تحت مالکیت این شرکت\nقرار دارند. این موضوع خصوصاً به جهت حفظ محرمانگی فرمول برای کوکاکولا حایز اهمیت\nاست. از این رو خوشگوار مواد اولیه خود را از هر کنسانتره‌سازی که تامین کرده باشد\nدر نهایت این خرید مستقیما از شرکت کوکاکولا انجام شده و درآمد حاصل از آن متعلق به کوکاکولای\nآمریکا خواهد بود."
            }
          },
          {
            "id": "APC-aOOOgB",
            "type": "header",
            "data": {
              "text": "ماده ۲۳&nbsp;– به شرط قیمت",
              "level": 3
            }
          },
          {
            "id": "9H5TT0Rgpk",
            "type": "image",
            "data": {
              "caption": "",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 1375,
                "height": 195,
                "size": "27107",
                "name": "image_18.jpeg",
                "title": "Image 18",
                "extension": "jpeg",
                "fileId": "c13d6c5b-dfbd-4b5f-8b47-f24745b603e6",
                "fileURL": "/files/c13d6c5b-dfbd-4b5f-8b47-f24745b603e6",
                "url": "/qlist-assets/c13d6c5b-dfbd-4b5f-8b47-f24745b603e6.jpg"
              }
            }
          },
          {
            "id": "MNFEZM_--l",
            "type": "image",
            "data": {
              "caption": "",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 1459,
                "height": 164,
                "size": "37124",
                "name": "image_19.jpeg",
                "title": "Image 19",
                "extension": "jpeg",
                "fileId": "7abd8d83-0590-44e4-b734-939bb9c96842",
                "fileURL": "/files/7abd8d83-0590-44e4-b734-939bb9c96842",
                "url": "/qlist-assets/7abd8d83-0590-44e4-b734-939bb9c96842.jpg"
              }
            }
          },
          {
            "id": "EwEat-P4Ri",
            "type": "paragraph",
            "data": {
              "text": "این بخش از قرارداد به خوبی توضیحات\nبالا را تایید می‌کند. مطابق این بند، <b>قیمت کنسانتره</b> خریداری شده توسط\nخوشگوار را هم شرکت کوکاکولا تعیین می‌کند. لذا روشن است که فروشنده کنسانتره\nعملاً شرکت کوکاکولا است. مطابق قرارداد، حتی سقف قیمت فروش محصول نهایی (نوشابه) در\nبازار ایران هم از جانب کوکاکولا مشخص می‌شود."
            }
          },
          {
            "id": "PCpdCrz3Cb",
            "type": "header",
            "data": {
              "text": "ماده ۲۵&nbsp;– تحریم بدون خسارت",
              "level": 3
            }
          },
          {
            "id": "hTlXl2HSky",
            "type": "image",
            "data": {
              "caption": "",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 1412,
                "height": 197,
                "size": "30738",
                "name": "image_20.jpeg",
                "title": "Image 20",
                "extension": "jpeg",
                "fileId": "b1306d26-6ece-4470-aca8-d2a1a6a977ec",
                "fileURL": "/files/b1306d26-6ece-4470-aca8-d2a1a6a977ec",
                "url": "/qlist-assets/b1306d26-6ece-4470-aca8-d2a1a6a977ec.jpg"
              }
            }
          },
          {
            "id": "Jy0Dz09S0Y",
            "type": "paragraph",
            "data": {
              "text": "از جمله مواردی که برای نفی حضور رسمی\nشرکت‌های خارجی و محصولات آنها در ایران به آن تکیه می‌شود موضوع تحریم‌های پولی و\nبانکی و عدم امکان نقل و انتقال پول برای ایران است. قرارداد حاضر که بین دو شرکت ایرانی و آمریکایی منعقد شده\nبه خوبی نشان می‌دهد که نقل و انتقال پول بین آنها بدون مشکل انجام می‌شود. چرا که اولاً\nدر بند الف ماده 23، از حق شرکت کوکاکولا در تعیین «شرایط حمل و پرداخت و ارز یا\nارزهای مورد قبول» صحبت شده است."
            }
          },
          {
            "id": "0JCxESvRv-",
            "type": "paragraph",
            "data": {
              "text": "ثانیاً در بند الف ماده 25 شرط شده است که اگر\n«شرکت، تامین‌کنندگان مجاز یا نوشابه‌ساز قادر نباشند ارز خارجی را که باید بابت\nواردات کنسانتره یا .... در خارج کشور پرداخت شود اخذ نمایند» «شرکت یا نوشابه‌ساز\nمی‌تواند قرارداد حاضر را <b>بدون مسئولیت خسارت</b> ... فوراً فسخ نماید». لذا\nاگر مشکل جدی در نقل و انتقال پول وجود داشت گنجاندن چنین بندی در قرارداد بی‌معنی\nبود یا بر اساس آن تا به حال قرارداد باید به راحتی از سوی یکی از طرفین فسخ می‌شد."
            }
          },
          {
            "id": "hJU5oYMd5G",
            "type": "header",
            "data": {
              "text": "ماده ۳۱&nbsp;– قرنطینه!",
              "level": 3
            }
          },
          {
            "id": "Wzf0_6sGFK",
            "type": "image",
            "data": {
              "caption": "",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 1359,
                "height": 280,
                "size": "52394",
                "name": "image_21.jpeg",
                "title": "Image 21",
                "extension": "jpeg",
                "fileId": "7c7ac9bd-4f7b-444b-946b-99bc72da61c2",
                "fileURL": "/files/7c7ac9bd-4f7b-444b-946b-99bc72da61c2",
                "url": "/qlist-assets/7c7ac9bd-4f7b-444b-946b-99bc72da61c2.jpg"
              }
            }
          },
          {
            "id": "fT82yuwdn0",
            "type": "paragraph",
            "data": {
              "text": "یکی از بخش‌های جذاب قرارداد کوکاکولا\nو خوشگوار ماده ۳۱ آن است. این ماده اطمینان داده است که اگر به واسطه اقداماتی از\nجانب مردم یا حاکمیت، هر کدام از طرفین نتوانند تعهداتشان را ایفا نمایند مسئولیتی متوجه آن‌ها نخواهد\nبود. از جمله این اقدامات به طور مشخص به\n«قرار گرفتن در لیست سیاه، بایکوت، تحریم‌های وضع شده توسط یک ملت مستقل یا\nتشکیلاتی فراملیتی از ملل مستقل که به هر نحو حادث شود یا ... نامیده شدن به عنوان\nدشمن ملت، حکم قانونی یا اقدامات اداری (اعم از لغو هرگونه مجوز دولتی ... )،\nتحریم عمومی، <b>قرنطینه</b>، ... » اشاره شده است. ذکر صریح و شفاف چنین مصادیقی\nدر قرارداد اگرچه عجیب، اما نشان از آگاهی و البته نگرانی کوکاکولا و خوشگوار از\nتهدیدهایی دارد که در ایران و جهان از سوی ملت‌ها، حکومت‌ها و جنبش‌هایی مثل بی‌دی‌اس\nمتوجه آنهاست."
            }
          },
          {
            "id": "fNM9WwUMKI",
            "type": "header",
            "data": {
              "text": "چهارم. مشهورات درباره کوکاکولا",
              "level": 2
            }
          },
          {
            "id": "whiSnhoMyn",
            "type": "header",
            "data": {
              "text": "یک معافیت بشردوستانه! کوکاکولا و تحریم‌های آمریکا",
              "level": 3
            }
          },
          {
            "id": "opaAUWJ8RT",
            "type": "paragraph",
            "data": {
              "text": "با روشن شدن حضور رسمی کوکاکولا در ایران این سوال مهم به ذهن متبادر\nمی‌شود که مگر ایران تحت شدیدترین تحریم‌ها نیست. پس چطور یک شرکت آمریکایی به طور\nرسمی و بدون هیچ مشکلی در ایران حضور دارد؟ این سوال را کمیسیون بورس و اوراق بهادار ایالات متحده/SEC نیز\nدر قالب نامه‌ای از کوکاکولا پرسید و خواستار ارائه توضیح از سوی این شرکت شد.\nکوکاکولا در پاسخ رسمی به این نامه ضمن تایید حضور و فعالیت در ایران از طریق\nاعطای لیسانس به یک نوشابه‌ساز محلی، این اقدام را تحت مجوز اخذ شده از دفتر کنترل\nدارایی‌های خارجی وزارت خزانه‌داری ایالات متحده (اوفَک/OFAC)\nاعلام کرد. (<a href=\"https://www.sec.gov/Archives/edgar/data/21344/000002134406000056/filename1.htm\">کمیسیون بورس و اوراق بهادار آمریکا</a>) همچنین مسئول\nارتباطات شرکت طی نامه‌ای در پاسخ به مقاله منتشر شده در روزنامه تایمز ایرلند، باز\nهم به مجوز اوفک اشاره کرد و توضیح داد که کنسانتره فروخته شده به ایران به عنوان\nغذا در نظر گرفته شده و از این طریق مشمول استثنائات تحریمی قرار گرفته است. او\nتاکید کرد که ارتباط کوکاکولا با ایران نه با دور زدن تحریم، بلکه از مسیر یک\nروزنه قانونی در حال انجام است. (<a href=\"https://www.irishtimes.com/opinion/letters/coca-cola-shipments-to-iran-1.1197701\">آیریش‌تایمز</a>)"
            }
          },
          {
            "id": "Rzb8KZJivB",
            "type": "paragraph",
            "data": {
              "text": "روزنامه نیویورک تایمز فهرستی از شرکت‌هایی که ذیل معافیت‌های\nبشردوستانه(!) کنگره آمریکا مجوز فعالیت تجاری با ایران را از اوفک دریافت کرده‌اند\nمنتشر کرده است که نام کوکاکولا هم در آن دیده می‌شود. (<a href=\"https://archive.nytimes.com/www.nytimes.com/interactive/2010/12/24/world/24-sanctions.html\">نیویورک‌تایمز</a>) لازم به توضیح\nاست که در برخی از حوزه‌ها از جمله پزشکی، غذا و کشاورزی، آموزشی و... از سوی دولت\nایالات متحده مجوزهایی برای فعالیت شرکت‌ها و موسسات آمریکایی در ایران داده شده\nاست. (<a href=\"https://graphics.wsj.com/iran-sanctions/\">وال‌استریت‌ژورنال</a>)"
            }
          },
          {
            "id": "NLpyD0s7Vs",
            "type": "header",
            "data": {
              "text": "کوکای اصلی یه چیز دیگه‌ست! بررسی یک ادعای مشهور",
              "level": 3
            }
          },
          {
            "id": "ZK_z6CVi5n",
            "type": "paragraph",
            "data": {
              "text": "یکی از جملات پر تکرار درباره کوکاکولا که به واسطه آن، نفی حضور محصولات اصلی این شرکت در ایران نتیجه‌گیری می‌شود این است که اگر خارج از\nایران کوکای اصلی را امتحان کرده باشید متوجه می‌شوید که طعم آن بسیار متفاوت و\nبهتر از نوشابه مشابه موجود در ایران است. اما این ادعا اختصاص به ایران ندارد. یکی از سوالات پرتکراری که در سایت رسمی کوکاکولای بین‌الملل به آن پاسخ داده شده همین\nتفاوت طعم کوکاکولا در کشورهای مختلف است. کوکاکولا این گزاره را رد کرده و دلیل\nاین برداشت را عواملی چون دمای مصرف و شرایط نگهداری عنوان می‌کند. (<a href=\"https://www.coca-cola.com/hk/en/about-us/faq?lylvjg=9\">وبسایت کوکاکولا</a>) اما به هر ترتیب آنچه مسلّم است\nاین که تفاوت طعم اگر هم واقعیت داشته باشد به معنای عدم اصالت محصول\nنیست. چرا که این موضوع کل سیستم کوکاکولا را شامل شده و موجب شده است تا شرکت\nنسبت به آن واکنش نشان دهد."
            }
          },
          {
            "id": "bA0hEFkwZt",
            "type": "image",
            "data": {
              "caption": "آیا طعم کوکاکولا در کشورهای مختلف متفاوت است؟ تصویر واکنش کوکاکولا به این پرسش در وبسایت رسمی‌اش",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 1259,
                "height": 525,
                "size": "38394",
                "name": "image_22.png",
                "title": "Image 22",
                "extension": "png",
                "fileId": "6192a0ea-776b-45bc-a05f-2e73d72b055e",
                "fileURL": "/files/6192a0ea-776b-45bc-a05f-2e73d72b055e",
                "url": "/qlist-assets/6192a0ea-776b-45bc-a05f-2e73d72b055e.png"
              }
            }
          },
          {
            "id": "BTPSVGfuAP",
            "type": "header",
            "data": {
              "text": "پنجم. از گازدار تا پالپ‌دار، سبد برندهای کوکا در ایران",
              "level": 2
            }
          },
          {
            "id": "zRDxMUianG",
            "type": "paragraph",
            "data": {
              "text": "اگرچه همه برندهای شرکت کوکاکولا در ایران حضور\nندارند، اما سبد برندهای این شرکت در ایران همچنان متنوع است. در حال حاضر برند\nاصلی <b>کوکاکولا</b> و زیربرندهای آن (<b>زیرو و لایت</b>)،<b> فانتا</b> و <b>فانتا\nلایت</b>،<b> اسپرایت</b> و <b>اسپرایت لایت</b> که همگی نوشابه‌های گازدار هستند،\nدر کنار آب معدنی <b>دِسانی</b> برندهای اصلی و بی‌واسطه شرکت کوکاکولا محسوب می‌شوند\nکه در ایران تولید می‌شود. (<a href=\"https://www.coca-cola.com/us/en/brands\">وبسایت کوکاکولا</a>)"
            }
          },
          {
            "id": "E_-Xq5bWKn",
            "type": "paragraph",
            "data": {
              "text": "یکی دیگر از برندهای مهم تولید شده در ایران که تحت امتیاز\nشرکت کوکاکولا قرار دارد نوشابه‌های کانادادرای است. کانادادرای یک برند قدیمی با\nاصالت کانادایی است. این برند که در طول حیات خود بارها بین شرکت‌های مختلف دست به\nدست شده، در حال حاضر متعلق به گروه کیوریگ دکتر پِپِر است. (<a href=\"https://www.keurigdrpepper.com/keurig-dr-pepper-unveils-bold-new-flavors-across-iconic-u-s-cold-beverages-portfolio/#:~:text=About%20Keurig%20Dr%20Pepper&amp;text=Our%20brands%20include%20Keurig%C2%AE,a%20purpose%20to%20Drink%20Well.\">کیوریگ دکتر پپر</a>) اما در دنیای\nتجارت گاهی شرکت‌ها به واسطه محدودیت‌های خود برای دسترسی به بازارهای مختلف، از\nظرفیت سایر شرکت‌ها استفاده می‌کنند. شرکت کیوریگ دکتر پپر نیز در مناطقی که امکان\nحضور مستقیم در آنها را نداشته، امتیاز برخی برندهای خود از جمله کانادادرای\nرا در اختیار شرکت کوکاکولا قرار داده است. به عنوان مثال می‌توان به بازار ژاپن\nاشاره کرد که در آن شرکت کوکاکولا امتیاز عرضه کانادادرای را در اختیار دارد. (<a href=\"https://www.coca-cola.com/jp/ja/brands\">وبسایت کوکاکولا</a>)"
            }
          },
          {
            "id": "fQ_EqIXyGX",
            "type": "paragraph",
            "data": {
              "text": "در ایران برند کانادادرای از مدت‌ها پیش در ذهن مردم با\nعنوان نوشابه زرد، کاملاً شناخته شده بود. به همین واسطه شرکت خوشگوار در اواخر دهه\n80 تصمیم گرفت تا از این سابقه ذهنی استفاده کرده و به واسطه ارتباطی که با شرکت\nکوکاکولا داشت، دوباره جایگاه آن را در بازار ایران احیا کند. (<a href=\"http://www.khabaronline.ir/xnbs\">خبرآنلاین</a>)"
            }
          },
          {
            "id": "keKPQcpVdt",
            "type": "image",
            "data": {
              "caption": "تبلیغ قدیمی کانادادرای در ایران",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 495,
                "height": 619,
                "size": "48623",
                "name": "images.jpeg",
                "title": "Images",
                "extension": "jpeg",
                "fileId": "86ad927e-0661-4b3b-9ac2-07a7e755bb85",
                "fileURL": "/files/86ad927e-0661-4b3b-9ac2-07a7e755bb85",
                "url": "/qlist-assets/86ad927e-0661-4b3b-9ac2-07a7e755bb85.jpg"
              }
            }
          },
          {
            "id": "OuJozNqYBH",
            "type": "paragraph",
            "data": {
              "text": "کانادادرای در ایران توسط شرکت یوروپیَن رِفرِشمِنتس ثبت شده\nاست؛ (<a href=\"https://ipm.ssaa.ir/Search-Result?page=2&amp;DecNo=mguUNB4a21tcgSQMo+b4aJA/VXoJoJqXfUUhJc6oboWUZJI1fm6OSGSDaEDfnYIN&amp;RN=mmEbN16iuYjCsOfESA/u0A==\">سازمان ثبت اسناد</a>) شرکتی ایرلندی متعلق\nبه شرکت کوکاکولا. (<a href=\"https://ir.cocacolaep.com/news-releases/news-release-details/coca-cola-ep-plc-holdings-company\">کوکاکولا‌-ای‌پی</a>)(<a href=\"https://www.bloomberg.com/profile/company/0102719D:ID\">بلومبرگ</a>) به این ترتیب روشن است که صاحب\nامتیاز این برند در ایران کوکاکولا بوده و خوشگوار نیز به همین واسطه امکان عرضه\nآن در ایران را به دست آورده است. در نامه سال 2006 شرکت کوکاکولا به کمیسیون بورس\nو اوراق بهادار ایالات متحده هم اعلام شده بود که پس از عرضه برندهای کوکاکولا،\nفانتا و اسپرایت، این شرکت به دنبال دریافت مجوز از اوفک برای عرضه برخی برندهای\nدیگر از جمله کانادادرای در ایران است. اتفاقی که دو سال بعد محقق شد. (<a href=\"https://www.sec.gov/Archives/edgar/data/21344/000002134406000056/filename1.htm#:~:text=We%20have%20authorized%20a%20local,with%20the%20applicable%20beverage%20concentrates.\">کمیسیون بورس و اوراق بهادار آمریکا</a>) علاوه\nبر این، برندهای آبمیوه مینوت‌مِید، نوشیدنی‌های ورزشی پاورِید و قهوه کاستا که\nهمگی متعلق به شرکت کوکاکولا هستند نیز در مقاطعی به صورت تولید داخل، واردات یا\nقاچاق در بازار ایران حضور داشته یا دارند. (<a href=\"https://www.coca-cola.com/us/en/brands\">وبسایت کوکاکولا</a>)"
            }
          },
          {
            "id": "VRr0RokPPd",
            "type": "image",
            "data": {
              "caption": "اطلاعات ثبت علامت تجاری کانادادرای در ایران",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 1024,
                "height": 767,
                "size": "200057",
                "name": "Screenshot 2025-09-28 153725.png",
                "title": "Screenshot 2025 09 28 153725",
                "extension": "png",
                "fileId": "5bf2de0d-ba93-4947-bb53-a389fb60bb0e",
                "fileURL": "/files/5bf2de0d-ba93-4947-bb53-a389fb60bb0e",
                "url": "/qlist-assets/5bf2de0d-ba93-4947-bb53-a389fb60bb0e.png"
              }
            }
          },
          {
            "id": "LylFJ7yOwv",
            "type": "paragraph",
            "data": {
              "text": "در کنار برندهای متعلق به کوکاکولا، برندهای دیگری نیز در\nایران حضور دارند که به واسطه سرمایه‌گذاری و مشارکت کوکاکولا با صاحبان آنها، زیر\nچتر این شرکت قرار می‌گیرند. از جمله مهم‌ترین این برندها باید به آبمیوه‌های <b>رانی</b>\nو ماءالشعیرهای <b>باربیکن</b> اشاره کرد. در سال 1384 گروه عوجان عربستان سعودی با\nتاسیس شرکت عوجان ایرانیان (تجارت شرق اینداستریز) و عرضه آبمیوه رانی به بازار ایران وارد شد. (<a href=\"https://rasmio.com/company/10103000114/شرکت%20تجارت%20شرق%20ایندستریز/\">رسمیو</a>) پس از چند سال این\nشرکت اقدام به سرمایه‌گذاری جهت تولید محصولات رانی و ماءالشعیر باربیکن در داخل\nکشور نمود که تا امروز هم فعالیت آن به طور گسترده ادامه دارد. (<a href=\"https://www.irna.ir/x38GRR\">ایرنا</a>)(<a href=\"http://www.magiran.com/n1109238\">اطلاعات</a>)"
            }
          },
          {
            "id": "p-O6gdguGr",
            "type": "image",
            "data": {
              "caption": "",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 2800,
                "height": 1240,
                "size": "1284310",
                "name": "52874578-2807-b__9506.jpg",
                "title": "52874578 2807 B  9506",
                "extension": "jpg",
                "fileId": "55259612-146e-4570-ab34-11e0f90af56d",
                "fileURL": "/files/55259612-146e-4570-ab34-11e0f90af56d",
                "url": "/assets/55259612-146e-4570-ab34-11e0f90af56d"
              }
            }
          },
          {
            "id": "XU4umgjxVr",
            "type": "paragraph",
            "data": {
              "text": "در سال 1390 شرکت کوکاکولا اقدام به یک سرمایه‌گذاری 980\nمیلیون دلاری در کسب‌وکار نوشیدنی گروه عوجان نمود.  به دنبال این سرمایه‌گذاری دو شرکت رانی\nرفرشمنتس و نوشیدنی‌سازی عوجان-کوکاکولا متولد شدند. در این شراکت مهم، کوکاکولا به ترتیب\n50 و 49 درصد از سهام این دو شرکت را تصاحب کرد. (<a href=\"https://investors.coca-colacompany.com/news-events/press-releases/detail/301/aujan-industries-and-the-coca-cola-company-announce-signing-of-980-million-agreement\">کوکاکولا کمپانی</a>) رانی\nرفرشمنتس وظیفه مالکیت و نگهداری برندهای رانی و باربیکن را داشته و عوجان\nکوکاکولا تولید و توزیع را بر عهده گرفته است. (<a href=\"https://aujan.com/our-companies/fmgc/rani-refreshments-2/\">عوجان 1</a>)(<a href=\"https://aujan.com/our-companies/fmgc/aujan-coca-cola-beverages-company/\">عوجان 2</a>) طبق همین\nسازوکار، در ایران هم برندهای رانی و باربیکن توسط رانی رفرشمنتس به ثبت رسیده‌اند\nکه به این ترتیب می‌توان آنها را در ردیف برندهای شرکت کوکاکولا شناسایی کرد. (<a href=\"https://ipm.ssaa.ir/Search-Result?page=2&amp;DecNo=ZiXek/s9R8hZR73q3eQCag==&amp;RN=8M4JdJBGbGldz4KOkPyinw==\">سازمان ثبت اسناد 1</a>)(<a href=\"https://ipm.ssaa.ir/Search-Result?page=2&amp;DecNo=cnIUYdPuNCsLYc6GqE5lMztFNa/MFT5aCuyu7j6y4vg7RYtem+mgLL23gSxDS4ZK&amp;RN=NEN6YzRGsZ0gpMw27xm2nA==\">سازمان ثبت اسناد 2</a>)"
            }
          },
          {
            "id": "d4AC0JvJay",
            "type": "image",
            "data": {
              "caption": "",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 582,
                "height": 256,
                "size": "81092",
                "name": "rani-02.jpg",
                "title": "Rani 02",
                "extension": "jpg",
                "fileId": "758e5ccc-1c6c-46e8-bcb3-3ae262599c04",
                "fileURL": "/files/758e5ccc-1c6c-46e8-bcb3-3ae262599c04",
                "url": "/qlist-assets/758e5ccc-1c6c-46e8-bcb3-3ae262599c04.jpg"
              }
            }
          },
          {
            "id": "1wyoejP7L9",
            "type": "paragraph",
            "data": {
              "text": "مصرف‌کنندگان ایرانی ممکن است خارج از ایران هم با برخی از\nبرندهای اختصاصی کوکاکولا مواجه شوند. به عنوان مثال نوشابه <b>کریستال</b> در\nعراق به وفور یافت می‌شود. این برند هم متعلق به خانواده برندهای کوکاکولا بوده و\nتوسط نوشابه‌سازی ایچجک ترکیه تولید می‌شود. ایچجک یکی از نوشابه‌سازهای بزرگ\nسیستم کوکاکولا است که امتیاز توزیع برندهای این شرکت در بسیاری از کشورهای آسیای\nمرکزی و غرب آسیا از جمله عراق را در اختیار دارد. در حال حاضر 20 درصد از سهام\nایچجک هم متعلق به خود شرکت کوکاکولا است. (<a href=\"https://www.cci.com.tr/en/cci-at-a-glance/our-operating-geography/middle-east/iraq\">ایچجک 1</a>)(<a href=\"https://www.cci.com.tr/en/investor-relations/corporate-governance/shareholder-structure-and-subsidiaries\">ایچجک 2</a>)"
            }
          },
          {
            "id": "5MH4LSAi9B",
            "type": "image",
            "data": {
              "caption": "نوشابه کریستال و عبارت «محصولی از خانواده کوکاکولا» بر روی آن",
              "withBorder": false,
              "withBackground": false,
              "stretched": false,
              "file": {
                "width": 1195,
                "height": 969,
                "size": "436478",
                "name": "img_1_1769419511071.jpg",
                "title": "Img 1 1769419511071",
                "extension": "jpg",
                "fileId": "7c3dc54f-eb45-4ea4-907b-04cb6bb4bd6c",
                "fileURL": "/files/7c3dc54f-eb45-4ea4-907b-04cb6bb4bd6c",
                "url": "/assets/7c3dc54f-eb45-4ea4-907b-04cb6bb4bd6c"
              }
            }
          },
          {
            "id": "zi_w01ciIB",
            "type": "header",
            "data": {
              "text": "آخر. کوکاکولا و حمایت از اسرائیل",
              "level": 2
            }
          },
          {
            "id": "OUZZRJ_8PL",
            "type": "paragraph",
            "data": {
              "text": "کلاف پیچیده ماجرای حضور کوکاکولا در ایران، پس از سال‌ها امروز سررشته خود را به دست آورده‌است. کلافی که احتمالا بازشدنش نیمی از سوالات مصرف کننده را پاسخ می‌دهد. بله، کوکاکولا در ایران است. اما نیمه دیگر یعنی اتهامات وارده به کوکاکولا پیرامون ارتباطش با اسرائیل همچنان بی‌جواب می‌ماند. نیمه‌ای که به زودی در پرده دوم یادداشت قرنطینه درباره کوکاکولا روشن خواهد شد."
            }
          }
        ]
      },
      "bodyEn": {
        "version": "2.30.7",
        "blocks": [
          {
            "id": "Ptx8beksdm",
            "type": "header",
            "data": {
              "text": "One. Introducing Coca-Cola",
              "level": 2
            }
          },
          {
            "id": "jKYMnsiZQ7",
            "type": "paragraph",
            "data": {
              "text": "The <b>Coca-Cola</b> company really is a global giant. From 1886, when the first cola drink was made by <b>John Pemberton</b> and sold under the name Coca-Cola, the product spread at an extraordinary speed — to the point that today it can be found in almost every corner of the world. Coca-Cola, of course, is neither just a black fizzy drink nor merely a commercial company; it is a great name tied to large economic, environmental, cultural and political issues in the world. (<a href=\"https://deepblue.lib.umich.edu/bitstream/handle/2027.42/86471/lhymson_1.pdf?sequence=1&amp;isAllowed=y\">Source</a>) A Google Scholar search returns about 8,600 academic articles whose titles contain the exact phrase \"Coca-Cola\" — a reflection of the company's importance and influence."
            }
          },
          {
            "id": "9JenrcbH4f",
            "type": "header",
            "data": {
              "text": "A system called Coca-Cola",
              "level": 3
            }
          },
          {
            "id": "wIodlsjq5y",
            "type": "paragraph",
            "data": {
              "text": "When we mention the name Coca-Cola we are in fact talking about a large global system with many elements and parts — the <b>Coca-Cola system</b>. To understand Coca-Cola we first need to know this system, which is born of the company's business model. The Coca-Cola system is a network composed of the <b>parent company</b> itself and a broad set of <b>local partners</b> around the world. These partners are called bottlers, and most are independent of Coca-Cola in ownership and management. In this system, the assets and activities of each component serve the goals of the whole system in a completely coherent way. Thus each independent business in the system, while profitable in its own right, helps grow the system and ultimately increases the profitability of the parent company, Coca-Cola. (<a href=\"https://www.coca-colacompany.com/about-us/coca-cola-system\">Coca-Cola website</a>)"
            }
          },
          {
            "id": "qiopDx22t7",
            "type": "paragraph",
            "data": {
              "text": "In this large network the most important assets belong to the Coca-Cola company itself — namely the <b>brand</b> and the product <b>formula</b>. All Coca-Cola-system activities lean on these key assets. Nearly 150 years of broad advertising and marketing have made Coca-Cola's product into a myth in people's minds. And that product is nothing more than a particular flavour with the Coca-Cola name on it. The classic Coca-Cola product has such status with consumers that even the company itself cannot easily change it! For example, the company's unsuccessful 1985 attempt to introduce a new flavour met consumer protests and was rolled back after 77 days. (<a href=\"https://www.coca-colacompany.com/about-us/history/new-coke-the-most-memorable-marketing-blunder-ever\">Coca-Cola website</a>)"
            }
          },
          {
            "id": "eTaUlCG9Na",
            "type": "image",
            "data": {
              "caption": "",
              "file": {
                "fileId": "65199e6e-9920-4e5a-9e2a-72a21e5f1539"
              }
            }
          },
          {
            "id": "_cutJxCwgM",
            "type": "paragraph",
            "data": {
              "text": "Of course, achieving a flavour similar to Coca-Cola isn't terribly complicated, and there have been successful attempts at it. (<a href=\"https://strangelove.com.au/blogs/journal/what-gives-cola-its-distinct-flavour\">Strangelove</a>) But that similar flavour, without the familiar Coca-Cola name and packaging, doesn't earn the trust of any consumer. In fact Coca-Cola's biggest asset is nothing other than its <b>brand</b>."
            }
          },
          {
            "id": "lxh8CrD2dk",
            "type": "image",
            "data": {
              "caption": "",
              "file": {
                "fileId": "94c8272c-755e-4ef2-b3e0-03a3410e48d6"
              }
            }
          },
          {
            "id": "IIhwk0ehvi",
            "type": "paragraph",
            "data": {
              "text": "For years Coca-Cola has made very broad, professional advertising efforts to lift its brand in the audience's mind. The company's 100-year presence at the Olympic Games, 50-year cooperation with FIFA at the World Cup and the exclusive FIFA World Cup Trophy Tour, and substantial sponsorship of NASCAR — these are just a small part of those efforts, and only in sport. The result is Coca-Cola sitting at the 7th-most-valuable global brand in Interbrand's 2024 ranking. (<a href=\"https://www.coca-colacompany.com/about-us/sports-and-entertainment\">Coca-Cola website</a>) (<a href=\"https://interbrand.com/best-global-brands/\">Interbrand</a>) The company now owns 200 brands, of which it claims 30 are billion-dollar-value brands. (<a href=\"https://investors.coca-colacompany.com/about/our-brands\">Coca-Cola website</a>) After these descriptions it's easier to understand why Coca-Cola's most important asset is its brand."
            }
          },
          {
            "id": "_WAq5gBTRW",
            "type": "paragraph",
            "data": {
              "text": "Back to the Coca-Cola system. A network with 700,000 people, in which 200 bottling companies with 950 factories worldwide — including in Iran, occupied Palestine, the West Bank and the Gaza Strip — are active. (<a href=\"https://www.coca-colacompany.com/about-us/coca-cola-system#accordion-27d09dd193-item-8e9e9d8e79\">Coca-Cola website</a>) They receive the concentrate (the base syrup, the master formula) from the Coca-Cola company and combine it with (carbonated) water and sweetener before packaging and selling it. In this system the Coca-Cola company owns the brands, develops the products, supplies the base materials and controls quality — and also handles the marketing prerequisites that affect consumers, including advertising and global campaigns. The rest is up to the local partners. They are responsible for relationships with all customers and points of sale — restaurants, shops, kiosks and so on — so that the local Coca-Cola strategy is executed. The result of this cooperation today is the staggering figure of 2.2 billion daily consumptions of various Coca-Cola products!"
            }
          },
          {
            "id": "E0zFmacNpa",
            "type": "image",
            "data": {
              "caption": "An infographic of the Coca-Cola system",
              "file": {
                "fileId": "60ec9d0a-5ccf-4e22-b0f5-f5cbc352abf9"
              }
            }
          },
          {
            "id": "b4nngwAZSi",
            "type": "paragraph",
            "data": {
              "text": "Coca-Cola earns most of its revenue from selling concentrates and syrups, and in most bottlers it has no ownership or management role. The company seriously pursues a strategy of strengthening local networks: of the more than 200 countries where Coca-Cola is officially present, it carries out bottling operations directly only in Oman, India, Malaysia, Singapore and a handful of other Asian and African countries — and these subsidiaries only made up 13% of Coca-Cola's total 2024 revenue. This means <b>most of Coca-Cola's revenue comes from the same concentrate-sale and brand-licensing contracts</b>. (<a href=\"https://www.coca-colacompany.com/about-us/coca-cola-system\">Coca-Cola website</a>) Given this, if you searched the whole world for a bottle of \"pure\" cola produced by Coca-Cola America, your chances of success would be very low."
            }
          },
          {
            "id": "Ubz9Vjjd6u",
            "type": "header",
            "data": {
              "text": "Coca-Cola — even in Gaza!",
              "level": 3
            }
          },
          {
            "id": "El7TQrH8v8",
            "type": "paragraph",
            "data": {
              "text": "The National Beverage Company (NBC) is one of Coca-Cola's smaller bottling partners in West Asia. The company is responsible for filling Coca-Cola bottles in Gaza and the West Bank. This private Palestinian company, headquartered in Ramallah, has operated under licence from Coca-Cola since 1998 and now has four production plants in four regions including the Gaza Strip and Ramallah, employing around 1,000 Palestinians. (<a href=\"https://www.nbc-pal.ps/Locations\">NBC website</a>)"
            }
          },
          {
            "id": "QvRNrtt620",
            "type": "image",
            "data": {
              "caption": "Coca-Cola NBC factory in Gaza",
              "file": {
                "fileId": "dc1f3ddc-5896-4f86-98c3-50f937a653d4"
              }
            }
          },
          {
            "id": "DoFSObODcp",
            "type": "paragraph",
            "data": {
              "text": "Coca-Cola and NBC, following Coca-Cola's corporate-social-responsibility policies, also carry out public-benefit activities in these areas. For example, Coca-Cola claims that under a 2018 water and wastewater improvement programme in Gaza — to upgrade hygiene and access to safe water — a desalination unit was built to provide 90,000 litres of drinking water in Gaza (the natural equivalent of around 1,300 people's daily use). (<a href=\"https://www.coca-colacompany.com/about-us/coca-cola-system/national-beverage-company\">Coca-Cola website</a>)"
            }
          },
          {
            "id": "GAW3CREoBs",
            "type": "paragraph",
            "data": {
              "text": "Also in 2007, under a project called \"Computerising schools\", Coca-Cola and NBC donated 723 tablets and 335 computers to Palestinian schools. And in 2002 under a campaign called \"Back to school\", the company donated school bags to needy Palestinian students. (<a href=\"https://www.coca-colacompany.com/about-us/coca-cola-system/national-beverage-company\">Coca-Cola website</a>) (<a href=\"https://nbc-pal.ps/CSR\">NBC website</a>)"
            }
          },
          {
            "id": "N4GcR7mXNk",
            "type": "image",
            "data": {
              "caption": "Student laptops donated by NBC",
              "file": {
                "fileId": "79571f61-7278-47f5-9e35-3abb488f8e73"
              }
            }
          },
          {
            "id": "nBxzSvd607",
            "type": "paragraph",
            "data": {
              "text": "For its social activities Coca-Cola has a subsidiary called <b>The Coca-Cola Foundation</b> — a foundation the company refers to as its philanthropic arm. (<a href=\"https://www.coca-colacompany.com/about-us/the-coca-cola-foundation\">Coca-Cola website</a>) The foundation claims to pursue issues such as water access, health, circular economy and waste management, climate resilience, economic empowerment and more in different parts of the world — particularly in developing countries. <b>The interesting point is that Coca-Cola itself has repeatedly been accused — and even found guilty — by human-rights and environmental activists in these very areas.</b>"
            }
          },
          {
            "id": "av99Pt_bIN",
            "type": "paragraph",
            "data": {
              "text": "For example, the issue of water is a frequent advertising theme of the Coca-Cola Foundation. The company claims to work on water delivery — through large tanks, desalination units and so on — to many underprivileged areas. Yet Coca-Cola is itself a threat to many populations' access to water."
            }
          },
          {
            "id": "N_NSDWlOjE",
            "type": "quote",
            "data": {
              "text": "<b>In 2023 alone Coca-Cola and its partners consumed 312 billion litres of water (the natural-consumption equivalent of 12 million people for a year!)</b>",
              "caption": "<a href=\"https://www.statista.com/statistics/1126344/water-use-the-coca-cola-company-globally/\">Statista</a>"
            }
          },
          {
            "id": "6ybxzgKHSa",
            "type": "paragraph",
            "data": {
              "text": "In many regions of the world facing water scarcity, the Coca-Cola system is accused of large-scale extraction from drinking-water and agricultural sources. India, Mexico and El Salvador are some of these places. (<a href=\"https://www.theguardian.com/environment/2003/jul/25/water.india\">Guardian 1</a> and <a href=\"https://www.theguardian.com/global-development/2019/jul/30/el-salvador-water-crisis-privatization-gangs-corruption\">Guardian 2</a>) (<a href=\"https://www.independent.co.uk/news/world/americas/coca-cola-mexico-wells-dry-bottled-water-sucking-san-felipe-ecatepec-chiapas-a7953026.html\">The Independent</a>) In cases like India, Coca-Cola has even faced convictions and forced plant closures over the water issue. (<a href=\"https://www.corpwatch.org/article/coca-cola-forced-shut-bottling-plant-india\">CorpWatch</a>)"
            }
          },
          {
            "id": "_CRiGWluRr",
            "type": "image",
            "data": {
              "caption": "",
              "file": {
                "fileId": "8e779335-9fa5-4c70-a1d4-036d7a5170b8"
              }
            }
          },
          {
            "id": "GPFiH5ulAw",
            "type": "paragraph",
            "data": {
              "text": "Coca-Cola talks about the circular economy (an economy in which, as much as possible, nothing is thrown away) and claims to support waste-management methods — while in 2023 it was the world's largest producer of plastic pollution! (<a href=\"https://brandaudit.breakfreefromplastic.org/brand-audit-2023/\">BFFP movement</a>)"
            }
          },
          {
            "id": "Jstf3_54zW",
            "type": "paragraph",
            "data": {
              "text": "Health is also always a recurring theme in the Coca-Cola Foundation's advertising and activity descriptions. Yet over the years Coca-Cola's drinks have been on the market, health-sector experts have repeatedly demonstrated the harms of consuming these products and warned about the consequences of their consumption. (<a href=\"https://mitpress.mit.edu/9780262049504/sweet-and-deadly/\">MIT</a>)"
            }
          },
          {
            "id": "D4ByMNF7TD",
            "type": "image",
            "data": {
              "caption": "BFFP environmental-movement infographic on the most polluting companies in terms of plastic production — Coca-Cola is shown in first place. The other rankings are also of interest.",
              "file": {
                "fileId": "7c63e6da-de0c-481a-8d48-03776ecb279b"
              }
            }
          },
          {
            "id": "AehBYct_QC",
            "type": "paragraph",
            "data": {
              "text": "Cases like these cast doubt on the honesty of Coca-Cola's activities and advertising. Nevertheless, the Coca-Cola Foundation is active in many countries, including West Asia, and in cooperation with universities, NGOs and American and international bodies it runs programmes under headings like empowerment, environment, water and waste management. (<a href=\"https://www.coca-cola.com/xf/en/media-center/the-coca-cola-foundation-women-empowerment-program-toumouhi\">Coca-Cola website</a>) (<a href=\"https://www.coca-colacompany.com/content/dam/company/us/en/policies/pdf/social/2022%20Charitable%20Contribution%20TCCF_Updated.pdf\">Official Coca-Cola Foundation report</a>)"
            }
          },
          {
            "id": "qbGkFULtim",
            "type": "image",
            "data": {
              "caption": "Tomouhi (meaning \"my ambition\") is one of the Coca-Cola Foundation's programmes, run with Cornell University, on women's empowerment in Saudi Arabia.",
              "file": {
                "fileId": "0ae64e5b-c5b5-4096-b40f-e5dea1087e11"
              }
            }
          },
          {
            "id": "Ry2odUj6uY",
            "type": "header",
            "data": {
              "text": "Two. Coca-Cola in Iran",
              "level": 2
            }
          },
          {
            "id": "eRruxZC4Mf",
            "type": "image",
            "data": {
              "caption": "Coca-Cola factory in Mashhad",
              "file": {
                "fileId": "3eb977ed-23ca-4d7a-b233-14939ed43eae"
              }
            }
          },
          {
            "id": "ijpktMMPDJ",
            "type": "paragraph",
            "data": {
              "text": "Carbonated drinks entered Iran around the 1950s-60s (the 1330s-1340s in the Iranian calendar) and grew more popular by the day. Like many countries, the players in this new market — from the moment of its formation — were two American names: Coca-Cola and Pepsi. Each of these two brands was produced in one or more Iranian factories. From then to today these two names have been part of the story of soft drinks in Iran. (<a href=\"https://jamejamonline.ir/002ADs\">Jam-e Jam</a>) But this presence has had many controversies, especially after the Islamic Revolution of 1979. Two main reasons can be found for these controversies: first the American-ness of these companies, and second the perennial rumours about their connections and support. With Pepsi, controversy began with the rumour of the brand's link to the Bahá'í faith in the 1960s — to the point that it even reached a fatwa from Imam Khomeini against buying and selling Pepsi. (<a href=\"https://hawzahnews.com/xd36q\">Hawzah News</a>)"
            }
          },
          {
            "id": "2O1qX2uNyA",
            "type": "paragraph",
            "data": {
              "text": "Rumours about these companies are not exclusive to Iran. Coca-Cola's official international site has created a dedicated page titled \"Rumours and misinformation\" that responds to six common claims about the company and its products. <b>Of these six questions, two concern the company's relationship with the Israeli regime.</b>"
            }
          },
          {
            "id": "7XDMuHyFb9",
            "type": "image",
            "data": {
              "caption": "The rumours and misinformation page on Coca-Cola's official site",
              "file": {
                "fileId": "46fe3ac2-63c8-4f27-9f36-7b581b1661ac"
              }
            }
          },
          {
            "id": "fjZL2ZXeo3",
            "type": "header",
            "data": {
              "text": "Khoshgovar, Nooshab, Coca-Cola",
              "level": 3
            }
          },
          {
            "id": "vyuiRYwVcg",
            "type": "paragraph",
            "data": {
              "text": "One of the plants that produced Coca-Cola in Iran before the Islamic Revolution was Khoshgovar Mashhad. Khoshgovar's cooperation with Coca-Cola continued for several years after the Revolution, until it was finally halted at the beginning of the 1980s."
            }
          },
          {
            "id": "hKHb8dT836",
            "type": "paragraph",
            "data": {
              "text": "During the war with Iraq, American sanctions on Iran were strongly enforced. Pepsi and Coca-Cola producers — including Khoshgovar — who had lost access to those companies' concentrate had to switch to Iranian beverage syrups and continue production with them. But with the start of the 1990s (1370s) and shifts in the Iran-US relationship — and the loosening of the sanctions regime on the other hand — domestic bottlers were once again tempted to cooperate with the American giants. (<a href=\"https://jamejamonline.ir/002ADs\">Jam-e Jam</a>) (<a href=\"https://money.cnn.com/magazines/fortune/fortune_archive/2007/02/19/8400167/index2.htm\">CNN</a>)"
            }
          },
          {
            "id": "xE1--nnFdi",
            "type": "image",
            "data": {
              "caption": "Coca-Cola production line in Iran",
              "file": {
                "fileId": "571044c9-2a03-4330-87cd-8a81b818e580"
              }
            }
          },
          {
            "id": "CDKfdZmOan",
            "type": "paragraph",
            "data": {
              "text": "Khoshgovar managed in 1991 (1370) to re-establish its relationship with Coca-Cola and resume production under licence. But this time a new player had also saddled its horse to powerfully enter the market: a new company called Nooshab. In 1993 (1372) Nooshab signed a contract with Coca-Cola in which the American company committed to investing $15 million and acquiring 27% of the company's shares, participating directly in beverage production in Iran. This was <b>the first investment by a foreign company in Iran after the Revolution</b> — and it came from an American company in the beverage industry!"
            }
          },
          {
            "id": "7Z7P4VWjjS",
            "type": "paragraph",
            "data": {
              "text": "But in this new competition things did not go as Nooshab — the newcomer — had hoped. In 1994 (1373), just a year after the Nooshab-Coca-Cola contract, then-US president Bill Clinton intensified anti-Iran sanctions. Coca-Cola, which had only paid half its share of the partnership, refused to pay the rest. Nooshab, which had just started production and had prepared around 40 million glass bottles bearing the Coca-Cola brand, was suddenly even cut off from receiving Coca-Cola concentrate."
            }
          },
          {
            "id": "54C6aS3QuP",
            "type": "image",
            "data": {
              "caption": "A Coca-Cola bottle attributed to Nooshab",
              "file": {
                "fileId": "a5ed8602-092b-44ed-9ac3-c8fc9022e6c8"
              }
            }
          },
          {
            "id": "CCZ7ovmw8b",
            "type": "paragraph",
            "data": {
              "text": "After Nooshab's follow-ups with Coca-Cola produced no result, the company sued its American partner and won the case. Nooshab also decided to fill the Coca-Cola bottles it was stuck with using Iranian beverage syrup and put them on the market. With this action Nooshab found itself sued in return by Coca-Cola, the trademark owner — Coca-Cola took its counter-claim to Iranian court, demanding damages for trademark infringement. The complaint succeeded and resulted in Nooshab paying $5 million in damages to the American company. (<a href=\"https://jamejamonline.ir/002ADs\">Jam-e Jam</a>) (<a href=\"https://money.cnn.com/magazines/fortune/fortune_archive/2007/02/19/8400167/index2.htm\">CNN</a>) (<a href=\"https://www.bbc.com/persian/business/story/2003/10/031005_he-ag-cocacola\">BBC</a>) This case clearly shows that, contrary to many people's common assumption, using a registered, internationally recognised brand without the owner's permission can carry heavy consequences for the offender."
            }
          },
          {
            "id": "3zouQY-2If",
            "type": "header",
            "data": {
              "text": "The 22-day war and the Coca-Cola controversies",
              "level": 3
            }
          },
          {
            "id": "BemzPT9YfU",
            "type": "paragraph",
            "data": {
              "text": "Let's go back a little. At the time of the Nooshab-Coca-Cola legal dispute, the Iranian beverage market briefly saw both the original Khoshgovar Coca-Cola and the unofficial Nooshab Coca-Cola side by side. But Nooshab, given its problems, gradually faded and was finally bought by Khoshgovar in 2013 (1392). Khoshgovar thus became the sole flag-bearer of Coca-Cola in Iran. (<a href=\"https://daybev.com/Home/AboutUs\">Khoshgovar's HiDay brand website</a>) (<a href=\"https://money.cnn.com/magazines/fortune/fortune_archive/2007/02/19/8400167/index2.htm\">CNN</a>)"
            }
          },
          {
            "id": "lnknbqTWGU",
            "type": "paragraph",
            "data": {
              "text": "But the Americanness of Coca-Cola and the rumours about its relationship with and support for the Israeli regime have always created sensitivities about it and its producer Khoshgovar. The issue becomes especially hot — and on everyone's lips — when the Israeli regime's aggressions and conflicts escalate. One such moment was the second half of the 2000s (1380s) during the regime's attacks on Gaza. These attacks prompted revolutionary segments and certain officials to push back against Coca-Cola's presence in the Iranian market."
            }
          },
          {
            "id": "F1VBDTZn4j",
            "type": "paragraph",
            "data": {
              "text": "One of the pioneers on this issue was the Mashhad People's Demand Forum, which in an open letter to Khoshgovar's directors asked them to explain the relationship with the Coca-Cola company. (<a href=\"https://www.magiran.com/article/1197175\">Source</a>) This came especially after the publication of interviews with international Coca-Cola executives confirming the company's presence in the Iranian market. (<a href=\"https://www.reuters.com/article/world/us-brands-hang-on-in-sanctions-hit-sudan-iran-idUSL1431181/\">Reuters news agency</a>) This letter and similar events again brought Coca-Cola and Israel-supporting companies into Iranian media headlines. At that time Manouchehr Mottaki, the then-foreign-minister, announced the handover of seven volumes of brochures listing the names of Zionist or multinational companies in which Israelis held shares. He noted an important point in explaining it: \"Multinational companies have created a kind of intermingling that makes them hard to identify.\" (<a href=\"https://www.asriran.com/fa/news/4370/\">Asr-e Iran</a>) Something that seems to be true for Coca-Cola too."
            }
          },
          {
            "id": "e53KEeIVDu",
            "type": "paragraph",
            "data": {
              "text": "In 2008 (1387) parliament passed a new law called the \"Law obliging the government to comprehensively support the oppressed people of Palestine\". Among its clauses was a ban on the government importing goods from — and contracting with — companies whose main shareholders were Zionist entities. (<a href=\"https://rc.majlis.ir/fa/law/show/134862\">Parliament website</a>) Just days after this resolution, Mehrabian, the then-industry-minister, ordered the suspension of all companies in which Zionists held part of the ownership abroad. (<a href=\"https://www.isna.ir/news/8710-10384/\">ISNA news agency</a>) He then gave Khoshgovar a deadline to clarify its relationship with Coca-Cola. (<a href=\"https://www.asriran.com/fa/news/62492/\">Asr-e Iran</a>) This may have indicated that Zionist shareholding in Coca-Cola was already taken for granted by the Industry Ministry — and that the only thing to clarify was whether this company was linked to Khoshgovar."
            }
          },
          {
            "id": "INqbzdMOI2",
            "type": "paragraph",
            "data": {
              "text": "The strange thing was that Khoshgovar always printed on its product — produced with the Industry Ministry's own permits — the phrase <b>\"Filled under licence from the Coca-Cola Company\"</b>. So by the rules, this ministry must have endorsed that claim. Yet the minister assumed the claim untrue and sought a confession from Khoshgovar!"
            }
          },
          {
            "id": "zHCHvu7Xgq",
            "type": "image",
            "data": {
              "caption": "\"Filled under licence from the Coca-Cola Company\" printed on Khoshgovar's beverages",
              "file": {
                "fileId": "5712b5a3-0a55-48a1-beb7-63e687af8474"
              }
            }
          },
          {
            "id": "0LGdmzMYfq",
            "type": "paragraph",
            "data": {
              "text": "Khoshgovar reacted quickly to the minister's inquiry and in a statement denied any link with American Coca-Cola or any payment to it. To dispel suspicions, the company invoked the keyword \"Ireland\". One Khoshgovar director said in an interview: <b>\"We have always purchased our needed essence from Ireland and have not had — and will not have — any relationship with the Coca-Cola Company or the United States […] and have not paid any sums to Coca-Cola for any reason.\"</b> (<a href=\"https://www.isna.ir/news/8710-15916/\">ISNA</a>) (<a href=\"https://farsnews.ir/FarsNews/1232445836000824044/\">Fars</a>) A strange response that was hoped would somewhat calm public and even government concerns."
            }
          },
          {
            "id": "ZqCA9e30wa",
            "type": "paragraph",
            "data": {
              "text": "Even so, the issue remained unclear and many questions surrounded it. Even Ayatollah Alamolhoda, the Friday-prayer leader of Mashhad, was asked about it. He replied that he had known this factory's investors for fifty years and knew them to be religiously devout and Iranian! But the Coca-Cola issue, he said, is complicated, and after meeting with the company's officials and the ministry's representative he still couldn't reach a conclusion about whether the factory's product was Zionist or not. (<a href=\"https://www.mashreghnews.ir/news/2450/\">Mashregh</a>)"
            }
          },
          {
            "id": "m0bPpPAnuM",
            "type": "paragraph",
            "data": {
              "text": "The matter of publishing the lists also remained a recurring feature of those years' news. Lists that the Foreign Ministry was legally required to compile of Zionist companies — but, despite media noise, were never reliably published. From Manouchehr Mottaki's seven brochures and Hassan Qashqavi's letter to the National Security Commission, to the claim by Khandouzi, the 13th government's finance minister, that lists were declared to the Trade Promotion Organisation — and then Speaker Ghalibaf's request a few days later for the list to be released to prevent imports. (<a href=\"https://jahannews.com/vdcb85b89rhbfwp.uiur.html\">Jahan News</a>) (<a href=\"https://snn.ir/004fMW\">Student news agency</a>) (<a href=\"https://www.hamshahrionline.ir/news/814916/\">Hamshahri</a>) These responses showed the issue is more complicated than the government wants — or is able — to resolve."
            }
          },
          {
            "id": "nmQIRbjjN0",
            "type": "header",
            "data": {
              "text": "Al-Aqsa Storm and intensifying controversies",
              "level": 3
            }
          },
          {
            "id": "6U-ebcXuqo",
            "type": "paragraph",
            "data": {
              "text": "Throughout these years the tug-of-war over Khoshgovar, Coca-Cola, Israel and their relationships never ended. But the Israeli regime's new assault on Gaza after Al-Aqsa Storm (7 October 2023) again lit the fuse on the Khoshgovar-Coca-Cola affair. One of the events that drew much media attention was a live-TV clash between presenters Seyed Hossein Hosseini and Elmira Sharifi Moghaddam about Coca-Cola and Pepsi. (<a href=\"https://plus.parsine.com/?p=26865\">Video of the on-air clash about Coca-Cola</a>)"
            }
          },
          {
            "id": "XIBXOuMpn_",
            "type": "paragraph",
            "data": {
              "text": "Parliament representatives gradually entered the conversation too — including Ali Khezrian, spokesperson for the Article-90 commission, who said: \"If the link of products like Coca-Cola and Nestlé with the parent companies is established, we must boycott them.\" (<a href=\"https://nournews.ir/n/155382\">Nour News</a>) That is — nearly two decades after this question was first publicly raised, <b>the government had still not been able to confirm or deny this link!</b> Although earlier, Asefari, then-deputy economic-foreign-minister, had said: \"Coca-Cola producers inside the country told us in meetings that they have no relationship with the Coca-Cola Company\". (<a href=\"https://www.sharghdaily.com/fa/tiny/news-910384\">Shargh</a>)"
            }
          },
          {
            "id": "7cg5NKLV3I",
            "type": "paragraph",
            "data": {
              "text": "As the regime's crimes in Gaza widened, media efforts to solve this old puzzle also intensified. But Khoshgovar's executives, having grown used over many years to these questions, unverified claims and empty threats, did not even feel any need to respond to the media. For example, Tebyan media published the account of its follow-up with Khoshgovar and the dismissive answers from company officials. (<a href=\"http://www.tebyan.net/x67Ds\">Tebyan</a>) Mashhad's Sobh-e Toos news outlet, having approached one of Khoshgovar's directors on the issue, was told: \"You won't get anywhere — don't bother pursuing this matter!\" (<a href=\"https://sobhtoos.ir/story/\">Sobh-e Toos</a>)"
            }
          },
          {
            "id": "F85038ADXD",
            "type": "paragraph",
            "data": {
              "text": "But in October 2024 (Mehr 1403) a strange piece of news suddenly emerged: \"Coca-Cola production in Iran halted\". It was claimed that, due to the US administration's positions and new sanctions, Coca-Cola had cut its cooperation with Iranian companies, and we would soon see the end of Coca-Cola drinks in the Iranian market. The interesting point was that none of the many outlets and newspapers publishing this story cited a credible source, attributing it instead to \"news circulated on social media\"! (<a href=\"https://www.eghtesadnews.com/fa/tiny/news-675419\">Eqtesad News</a>) (<a href=\"https://www.etemadonline.com/tiny/news-676045\">Etemad</a>) Even so, an accompanying analytical current rode on this wave and lamented the supposed event. These analyses made tragic comparisons between Coca-Cola's exit and the importation of iPhones, cars and home appliances, explaining the role of mafias and rivals in this event and its tragic consequences for the people and the Iranian beverage market. (<a href=\"https://www.ettelaat.com/news/65957/\">Ettelaat</a>)"
            }
          },
          {
            "id": "kzs_M9g7rM",
            "type": "paragraph",
            "data": {
              "text": "Nothing happened to Coca-Cola products in the market after this news, and the drinks remained as abundant in shop fridges as before. But this news once again raised many questions in the Iranian consumer's mind: was Coca-Cola in Iran in the first place, that it could now intend to leave?! Hadn't Khoshgovar's officials said we never had any relationship with American Coca-Cola? What, in the end, is the reality of Coca-Cola in Iran?!"
            }
          },
          {
            "id": "OXXC43Niue",
            "type": "header",
            "data": {
              "text": "Coca-Cola is in Iran. Full stop.",
              "level": 3
            }
          },
          {
            "id": "xPpwXix1SY",
            "type": "paragraph",
            "data": {
              "text": "The reality is that the Khoshgovar-Coca-Cola relationship has never been mysterious or hidden. But owing to the disorder of the public and media space and unfamiliarity with basic business principles, it has been possible — through projection, ambiguity, doubt and misinformation — for this matter to look like a complicated, unanswered question for years. Let us review all the evidence of this relationship together:"
            }
          },
          {
            "id": "hG-sQbgw8k",
            "type": "header",
            "data": {
              "text": "Evidence 1 — Coca-Cola's own admission",
              "level": 4
            }
          },
          {
            "id": "lrnEFG2vMA",
            "type": "paragraph",
            "data": {
              "text": "Khoshgovar is an official bottler in the Coca-Cola system, holding the right to produce and exclusively distribute inside Iran's geographical borders — exactly like the 200 or so other official bottlers around the world in this system, responsible for producing and getting Coca-Cola products to consumers. Khoshgovar is also listed on Coca-Cola's global official website as one of the company's bottling partners for the Eurasia & Middle East region. (<a href=\"https://www.coca-colacompany.com/about-us/coca-cola-system\">Coca-Cola website</a>)"
            }
          },
          {
            "id": "WFGzCEbJmv",
            "type": "image",
            "data": {
              "caption": "Khoshgovar's name among Coca-Cola's official partners on the company's official website",
              "file": {
                "fileId": "3f784500-b450-4f37-9a48-494c0f08e905"
              }
            }
          },
          {
            "id": "VYGregH-K0",
            "type": "header",
            "data": {
              "text": "Evidence 2 — Under Coca-Cola licence",
              "level": 4
            }
          },
          {
            "id": "LXPNjZzqdX",
            "type": "paragraph",
            "data": {
              "text": "Throughout the years Coca-Cola products have been on the Iranian market, the front has always carried <b>\"Original\"</b> and the back <b>\"Under licence from International Coca-Cola\"</b>. Contrary to common assumption, printing such phrases on a product that is officially produced and distributed under legal permits carries serious legal weight and must be approved by legal authorities. This shows that Khoshgovar itself has tried to convince its customers that they are dealing with an original Coca-Cola."
            }
          },
          {
            "id": "Fw6yRLRGIN",
            "type": "header",
            "data": {
              "text": "Evidence 3 — Trademark",
              "level": 4
            }
          },
          {
            "id": "43Ea5j_Uik",
            "type": "paragraph",
            "data": {
              "text": "The Coca-Cola product produced and distributed by Khoshgovar legally and officially uses the name, logo, visual identity, bottle and other trademarks belonging to the International Coca-Cola Company — assets that are also registered and officially protected in Iran. (<a href=\"https://ipm.ssaa.ir/Search-Result?page=2&amp;DecNo=6Nboabm7stk4+94oPsqirw==&amp;RN=PonS3YuZuXKt5q+qKvqzdw==\">Document Registration 1</a>) (<a href=\"https://ipm.ssaa.ir/Search-Result?page=2&amp;DecNo=MCTSeEAw0DzJGsu2bIrIVA==&amp;RN=4PSYaVy5/PeOfPCwWyWGCQ==\">Document Registration 2</a>) Contrary to common belief, Iran has proper laws for the protection of trademarks (brands). Under Article 31 of the Patent, Industrial Designs and Trademarks Law, <b>\"the exclusive right to use a mark belongs to whoever has registered it in accordance with this law\"</b>. According to this law \"the use of any mark registered in Iran, by anyone other than the owner of the mark, is subject to the owner's agreement.\" So Khoshgovar has naturally been able to use Coca-Cola's marks under some kind of agreement with the company:"
            }
          },
          {
            "id": "1IzwK_QhbB",
            "type": "quote",
            "data": {
              "text": "Per Article 40 of the Patent, Industrial Designs and Trademarks Law: <b>\"The owner of a registered mark may file suit in court against any person who uses the mark without its consent, or against any person committing an act that would ordinarily lead to violation of the rights arising from the registration of the mark. These rights cover use of a mark that is similar to the registered mark and whose use for similar goods or services causes confusion to the public.\"</b> The earlier case of Coca-Cola's lawsuit against Nooshab for using the brand without an agreement — which an Iranian court ruled in favour of the brand owner — was mentioned above. This case clearly demonstrates the strength of the country's laws in protecting companies' commercial assets."
            }
          },
          {
            "id": "QKA0Vgf8Hq",
            "type": "image",
            "data": {
              "caption": "Commercial assets registered under the name \"The Coca-Cola Company\" in Iran's Document Registration Organisation",
              "file": {
                "fileId": "791b6a9b-d27b-424e-a27b-fc597b420460"
              }
            }
          },
          {
            "id": "wd_xnncNey",
            "type": "header",
            "data": {
              "text": "Evidence 4 — Competitors' silence",
              "level": 4
            }
          },
          {
            "id": "t9cs7pTnSL",
            "type": "paragraph",
            "data": {
              "text": "Using another company's brand without permission is clearly an anti-competitive act and an instance of unfair competition under the law (Chapter Six of the Industrial Property Protection Law). (<a href=\"https://rc.majlis.ir/fa/law/show/1809131\">Parliament website</a>) That is, the law does not allow one company — while competitors have to spend a significant portion of their resources on marketing and advertising — to officially use another company's brand without cost. A brand whose owner spends billions of dollars a year on advertising and reinforcement. If Khoshgovar's use of the Coca-Cola brand were done without Coca-Cola's permission, Khoshgovar's competitors could have easily sued the company under existing laws. They could also have used the same brand on their own products and easily expanded their market share. As it is, Khoshgovar — by its own director's admission — has been able to grow its market share through this very brand: \"Our sales market depends on this name and we cannot remove it.\" (<a href=\"https://aftabnews.ir/000LgZ\">Aftab News</a>)"
            }
          },
          {
            "id": "A5jlQOJuwV",
            "type": "paragraph",
            "data": {
              "text": "Yet over all these years, none of Khoshgovar's competitors has taken either of these two steps, and Coca-Cola production has remained exclusively with Khoshgovar. We can therefore conclude that Khoshgovar's use of the Coca-Cola brand is definitely with the brand owner's official permission."
            }
          },
          {
            "id": "QreiI6RU-L",
            "type": "header",
            "data": {
              "text": "Three. The Coca-Cola - Khoshgovar contract",
              "level": 2
            }
          },
          {
            "id": "CbhF--s6MJ",
            "type": "paragraph",
            "data": {
              "text": "The information, documents and reasoning presented so far adequately establish Khoshgovar's direct relationship with Coca-Cola — but from July 2024 (Tir 1403) onwards, they are barely needed any more! On that date, a letter was published with a very important attachment — an attachment that effectively cleared away any ambiguity and doubt raised about Coca-Cola in Iran over all those years:"
            }
          },
          {
            "id": "Jx4Fgpw0bb",
            "type": "header",
            "data": {
              "text": "War in Ukraine, confession in Iran!",
              "level": 3
            }
          },
          {
            "id": "aYdCKDkZhV",
            "type": "image",
            "data": {
              "caption": "The Trade Development Organisation's instruction asking that the export of all beverages produced by Khoshgovar under Coca-Cola licence be prevented.",
              "file": {
                "fileId": "8f61625b-a450-4840-b494-1b7aa4eb5612"
              }
            }
          },
          {
            "id": "xactvwvRrC",
            "type": "paragraph",
            "data": {
              "text": "It started when, with the outbreak of the Russia-Ukraine war, Coca-Cola in March 2022 (Esfand 1400) officially announced it would suspend its activity and product sales in Russia. This sudden decision gradually — as warehouse stocks ran down — built up pent-up demand for the company's products in the Russian market. At that time some traders seized the opportunity and bought Khoshgovar-produced Coca-Cola drinks in Iran for export to Russia."
            }
          },
          {
            "id": "dSlhXXD6Tc",
            "type": "image",
            "data": {
              "caption": "A Khoshgovar-made Coca-Cola can in Russia",
              "file": {
                "fileId": "d0498119-819f-4a30-aade-ef3c5c19ceeb"
              }
            }
          },
          {
            "id": "67ebC_2sky",
            "type": "paragraph",
            "data": {
              "text": "As the issue grew, in July 2024 (Tir 1403) the Trade Development Organisation, in a letter, asked customs to prevent the export of beverages produced by Khoshgovar. (<a href=\"https://dotic.ir/news/16637/\">National laws and regulations database</a>) This was actually a request that Khoshgovar itself had sent to the Trade Development Organisation, and the reason was nothing other than the terms of its official contract with the American Coca-Cola company — under which Khoshgovar was only permitted to sell Coca-Cola's products within the territorial borders of the Islamic Republic of Iran. This letter had a very important attachment too: the text of the official contract signed between <b>Khoshgovar Tehran Joint-Stock Company, Iran</b> and <b>The Coca-Cola Atlanta Company, USA</b>."
            }
          },
          {
            "id": "JzJHEZWkFg",
            "type": "quote",
            "data": {
              "text": "Read the text of the <a href=\"https://dotic.ir/news/16637\">Coca-Cola - Khoshgovar contract</a> on the National laws and regulations database."
            }
          },
          {
            "id": "6CRUsu4y7F",
            "type": "paragraph",
            "data": {
              "text": "A contract which, before anything else, called to mind the statements and claims made by Khoshgovar and its directors:"
            }
          },
          {
            "id": "x1dwsIbr4D",
            "type": "quote",
            "data": {
              "text": "<b>\"…we have not had — and will not have — any relationship with the Coca-Cola Company or the United States at any time…\"</b>",
              "caption": "Mehdi Sayyadian — board member of Khoshgovar Tehran — 19 January 2009 (29 Dey 1387) (<a href=\"http://www.isna.ir/xdPZL\">Source: IRNA</a>)"
            }
          },
          {
            "id": "WTP4tJykI0",
            "type": "image",
            "data": {
              "caption": "",
              "file": {
                "fileId": "ee6f71c1-f10f-459b-a398-4723cee05e3a"
              }
            }
          },
          {
            "id": "1P0t_4L4lW",
            "type": "paragraph",
            "data": {
              "text": "Below we examine and analyse the important and interesting clauses of this contract. Some of these can resolve common doubts about the official presence of international companies in Iran — especially Coca-Cola:"
            }
          },
          {
            "id": "rGJZhKAwr1",
            "type": "header",
            "data": {
              "text": "Articles 1 and 28 — From Atlanta to Tehran",
              "level": 3
            }
          },
          {
            "id": "om4TWaRdAD",
            "type": "image",
            "data": {
              "caption": "",
              "file": {
                "fileId": "4f74470b-d3e6-451f-9647-dbb7c4ada485"
              }
            }
          },
          {
            "id": "g_-xnQKmV6",
            "type": "image",
            "data": {
              "caption": "",
              "file": {
                "fileId": "6cc1e6ba-87f7-42ef-b02b-f95dc209ab08"
              }
            }
          },
          {
            "id": "eimakociGv",
            "type": "paragraph",
            "data": {
              "text": "As explained earlier, Khoshgovar is part of Coca-Cola's international bottling, distribution and sales system whose ultimate goal is to increase Coca-Cola's sales and revenue while generating revenue for its partners. For this reason, Article 28 specifies and emphasises Coca-Cola's rights over this system. In the Coca-Cola system, the right and exclusivity to produce, distribute and sell the product in each defined geographical area is granted to one or more bottlers. Similarly, under Article 1, <b>Khoshgovar holds exclusivity to supply Coca-Cola only within the geographical borders of the Islamic Republic of Iran.</b>"
            }
          },
          {
            "id": "iYN1_FDwCi",
            "type": "header",
            "data": {
              "text": "Article 13 — Guarantee of benefits",
              "level": 3
            }
          },
          {
            "id": "Ycf4jkgoEW",
            "type": "paragraph",
            "data": {
              "text": "One might naively claim that although Coca-Cola has given Khoshgovar the right to use the brand, this does not mean the company is gaining any benefit. But Article 13 explicitly states that <b>all rights and benefits arising from use of the trademarks and other elements must guarantee the company's benefits</b> — at the top of which is <b>increased sales and brand penetration of the Coca-Cola Company.</b>"
            }
          },
          {
            "id": "Y-LbsuEtDv",
            "type": "header",
            "data": {
              "text": "Preamble (d) — Irish supplier!",
              "level": 3
            }
          },
          {
            "id": "9hJsl8n0Pd",
            "type": "image",
            "data": {
              "caption": "",
              "file": {
                "fileId": "00a452e8-7703-4dae-a15d-2e1e4aec3923"
              }
            }
          },
          {
            "id": "lOjFpvIqc1",
            "type": "paragraph",
            "data": {
              "text": "Clause (d) of the contract's preamble can clarify the role of <b>\"Ireland\"</b> that had cast a shadow over Khoshgovar's relationship with American Coca-Cola — a country whose mention created ambiguity among media, the public and even officials who lacked deep familiarity with the issue. This clause specifies that, in supplying concentrate to Khoshgovar, the Coca-Cola company has designated a number of third-party companies as <b>\"authorised suppliers\"</b>."
            }
          },
          {
            "id": "8f1itpPDab",
            "type": "paragraph",
            "data": {
              "text": "In addition to America, Coca-Cola has factories producing concentrate in some other parts of the world. Among these are concentrate-making plants in Costa Rica, India and Brazil, all of which were set up in recent years with Coca-Cola investment and are wholly owned by it. (<a href=\"https://news.co.cr/coca-cola-company-announced-establishment-one-largest-plants-guanacaste-costa-rica/71357/\">Costa Rica Star</a>) (<a href=\"https://timesofindia.indiatimes.com/city/ahmedabad/coca-cola-to-invest-rs-3000-crore-to-set-up-plant-in-sanand/articleshow/105824471.cms\">Times of India</a>) (<a href=\"https://www.reuters.com/business/retail-consumer/coca-cola-invests-some-90-mln-expand-production-brazils-amazonas-2024-12-13/\">Reuters</a>)"
            }
          },
          {
            "id": "tSfVVYIw-c",
            "type": "paragraph",
            "data": {
              "text": "In the Coca-Cola system, four main geographical regions are defined: <b>North America</b>, <b>South America</b>, <b>Europe-Middle East-Africa</b> and <b>Asia</b> — and each of the companies mentioned, depending on its capacity, supplies part of the needs of bottlers in these regions. (<a href=\"https://www.investopedia.com/articles/markets/112515/how-does-cocacola-actually-make-money.asp\">Investopedia</a>) Among the most important regions where Coca-Cola produces its concentrates is Ireland. One of these Irish concentrate-making plants was in Drogheda, which actually halted activity in 2008 (1387). In the mid-2000s and following the Mashhad people's-demand forum's follow-ups, several Iranian and foreign outlets named Ireland and the Drogheda concentrate plant as Khoshgovar's supplier. When Drogheda was asked about this alleged relationship with Khoshgovar, the company referred the matter to Coca-Cola. A Coca-Cola executive was then questioned. He confirmed concentrate sales to Iran but again stayed silent on the source. (<a href=\"http://www.mehrnews.com/x5pzj\">Mehr</a>) (<a href=\"https://web.archive.org/web/20250825072711/https:/www.thetimes.com/comment/register/article/iran-targets-irish-coke-connection-dms08jhpx6r\">The Times</a>) (<a href=\"https://web.archive.org/web/20230924052119/https:/money.cnn.com/magazines/fortune/fortune_archive/2007/02/19/8400167/?postversion=2007020606\">CNN</a>)"
            }
          },
          {
            "id": "xD5aiTJG5Y",
            "type": "paragraph",
            "data": {
              "text": "Some time later, Khoshgovar executives effectively confirmed Ireland as the concentrate supply origin. (<a href=\"http://www.isna.ir/xdPZL\">ISNA</a>) Coca-Cola had several concentrate-producing factories in Ireland — though in recent years it closed most of them, including Drogheda, and consolidated their capacity in the Ballina plant. (<a href=\"https://www.irishtimes.com/business/retail-and-services/coca-cola-closes-athy-plant-with-82-job-losses-1.3481557\">Irish Times</a>) (<a href=\"https://www.eurofound.europa.eu/en/resources/article/2007/coca-cola-move-production-non-unionised-plant\">Eurofound</a>) Given the history of supplying Khoshgovar from Ireland, one can guess that the \"authorised supplier\" for buying concentrate mentioned in Khoshgovar's contract with Coca-Cola is this very Ballina factory. Even so, the matter is of little importance — because as the documents cited show, all the concentrate-producing factories in the Coca-Cola system, anywhere in the world, are under that company's ownership. This is especially important for Coca-Cola to keep the formula confidential. So whichever concentrate plant Khoshgovar buys its raw materials from, this purchase is ultimately made directly from the Coca-Cola company, and the resulting revenue belongs to American Coca-Cola."
            }
          },
          {
            "id": "APC-aOOOgB",
            "type": "header",
            "data": {
              "text": "Article 23 — Price-conditioned",
              "level": 3
            }
          },
          {
            "id": "9H5TT0Rgpk",
            "type": "image",
            "data": {
              "caption": "",
              "file": {
                "fileId": "c13d6c5b-dfbd-4b5f-8b47-f24745b603e6"
              }
            }
          },
          {
            "id": "MNFEZM_--l",
            "type": "image",
            "data": {
              "caption": "",
              "file": {
                "fileId": "7abd8d83-0590-44e4-b734-939bb9c96842"
              }
            }
          },
          {
            "id": "EwEat-P4Ri",
            "type": "paragraph",
            "data": {
              "text": "This part of the contract confirms the explanations above. Under this clause, the <b>price of the concentrate</b> purchased by Khoshgovar is also set by the Coca-Cola company. So it's clear that the concentrate seller is effectively Coca-Cola. Under the contract, even the cap on the final product (beverage) sale price in the Iranian market is set by Coca-Cola."
            }
          },
          {
            "id": "PCpdCrz3Cb",
            "type": "header",
            "data": {
              "text": "Article 25 — Sanctioned without damages",
              "level": 3
            }
          },
          {
            "id": "hTlXl2HSky",
            "type": "image",
            "data": {
              "caption": "",
              "file": {
                "fileId": "b1306d26-6ece-4470-aca8-d2a1a6a977ec"
              }
            }
          },
          {
            "id": "Jy0Dz09S0Y",
            "type": "paragraph",
            "data": {
              "text": "One of the points often invoked to deny the official presence of foreign companies and their products in Iran is the issue of monetary and banking sanctions and the impossibility of moving money to and from Iran. The present contract, signed between an Iranian and an American company, clearly shows that monetary transfers between them happen without problems. Because, first, in clause (a) of Article 23, the Coca-Cola company's right to determine \"shipping and payment conditions and the acceptable currency or currencies\" is mentioned."
            }
          },
          {
            "id": "0JCxESvRv-",
            "type": "paragraph",
            "data": {
              "text": "Second, clause (a) of Article 25 stipulates that if \"the company, the authorised suppliers or the bottler cannot obtain the foreign currency that must be paid abroad for importing concentrate or…\", \"the company or the bottler may terminate this contract immediately, <b>without liability for damages</b>, …\". So if there were a serious problem moving money, including such a clause in the contract would be meaningless, or under it the contract would already easily have been terminated by one of the parties."
            }
          },
          {
            "id": "hJU5oYMd5G",
            "type": "header",
            "data": {
              "text": "Article 31 — Quarantine!",
              "level": 3
            }
          },
          {
            "id": "Wzf0_6sGFK",
            "type": "image",
            "data": {
              "caption": "",
              "file": {
                "fileId": "7c7ac9bd-4f7b-444b-946b-99bc72da61c2"
              }
            }
          },
          {
            "id": "fT82yuwdn0",
            "type": "paragraph",
            "data": {
              "text": "One of the more interesting parts of the Coca-Cola - Khoshgovar contract is Article 31. This article assures that if, due to actions by the public or the government, either party cannot fulfil its obligations, no responsibility will fall on them. Among these actions it explicitly mentions: \"being placed on a blacklist, boycotted, sanctioned by an independent nation or a supranational body of independent nations occurring in any manner; or … being designated as an enemy of a nation; a legal ruling or administrative action (including the revocation of any government permit …); a public boycott; <b>quarantine</b>; …\" The explicit, clear listing of such items in a contract is — though striking — a sign of Coca-Cola's and Khoshgovar's awareness, and concern, about the threats they face in Iran and across the world from people, governments and movements like BDS."
            }
          },
          {
            "id": "fNM9WwUMKI",
            "type": "header",
            "data": {
              "text": "Four. Famous claims about Coca-Cola",
              "level": 2
            }
          },
          {
            "id": "whiSnhoMyn",
            "type": "header",
            "data": {
              "text": "A humanitarian exemption! Coca-Cola and US sanctions",
              "level": 3
            }
          },
          {
            "id": "opaAUWJ8RT",
            "type": "paragraph",
            "data": {
              "text": "With Coca-Cola's official presence in Iran clarified, an important question comes to mind: isn't Iran under the harshest sanctions? Then how does an American company officially operate in Iran without any problem? The US Securities and Exchange Commission (SEC) also asked Coca-Cola this question in a letter, demanding an explanation. In its official response, Coca-Cola — while confirming presence and activity in Iran through licensing a local bottler — said the activity is under a licence obtained from the US Treasury's Office of Foreign Assets Control (OFAC). (<a href=\"https://www.sec.gov/Archives/edgar/data/21344/000002134406000056/filename1.htm\">SEC</a>) The company's communications director, in a letter responding to an article published in the Irish Times, also pointed to the OFAC licence and explained that the concentrate sold to Iran is classified as food and is therefore covered by sanctions exemptions. He emphasised that Coca-Cola's relationship with Iran is not a sanctions evasion but is being conducted through a legal loophole. (<a href=\"https://www.irishtimes.com/opinion/letters/coca-cola-shipments-to-iran-1.1197701\">Irish Times</a>)"
            }
          },
          {
            "id": "Rzb8KZJivB",
            "type": "paragraph",
            "data": {
              "text": "The New York Times has published a list of companies that have obtained OFAC licences for commercial activity with Iran under the US Congress's humanitarian(!) exemptions — and Coca-Cola is on it. (<a href=\"https://archive.nytimes.com/www.nytimes.com/interactive/2010/12/24/world/24-sanctions.html\">New York Times</a>) Note that in some areas — medicine, food, agriculture, education and so on — the US government has granted licences for American companies and institutions to operate in Iran. (<a href=\"https://graphics.wsj.com/iran-sanctions/\">Wall Street Journal</a>)"
            }
          },
          {
            "id": "NLpyD0s7Vs",
            "type": "header",
            "data": {
              "text": "Real Coke is different! Examining a popular claim",
              "level": 3
            }
          },
          {
            "id": "ZK_z6CVi5n",
            "type": "paragraph",
            "data": {
              "text": "One of the recurring statements about Coca-Cola — used to deny the presence of the company's real products in Iran — is that if you've tried real Coke outside Iran you'll notice its flavour is very different and better than the similar drink available in Iran. But this claim is not exclusive to Iran. One of the frequently asked questions answered on Coca-Cola's official international site is this very flavour difference of Coca-Cola in different countries. Coca-Cola has rejected this claim and explains this impression as a result of factors like consumption temperature and storage conditions. (<a href=\"https://www.coca-cola.com/hk/en/about-us/faq?lylvjg=9\">Coca-Cola website</a>) In any case, what is certain is that even if the flavour difference is real, it does not mean the product is not genuine — because this matter covers the entire Coca-Cola system, prompting the company to respond to it."
            }
          },
          {
            "id": "bA0hEFkwZt",
            "type": "image",
            "data": {
              "caption": "Does Coca-Cola taste different in different countries? Image of Coca-Cola's response to this question on its official site",
              "file": {
                "fileId": "6192a0ea-776b-45bc-a05f-2e73d72b055e"
              }
            }
          },
          {
            "id": "BTPSVGfuAP",
            "type": "header",
            "data": {
              "text": "Five. From fizzy to pulpy: Coca-Cola's brand portfolio in Iran",
              "level": 2
            }
          },
          {
            "id": "zRDxMUianG",
            "type": "paragraph",
            "data": {
              "text": "Although not all Coca-Cola brands are present in Iran, the company's brand portfolio in Iran is still varied. The main brand <b>Coca-Cola</b> and its sub-brands (<b>Zero and Light</b>), <b>Fanta</b> and <b>Fanta Light</b>, <b>Sprite</b> and <b>Sprite Light</b> — all carbonated drinks — alongside the bottled water <b>Dasani</b> are the Coca-Cola company's primary, direct brands produced in Iran. (<a href=\"https://www.coca-cola.com/us/en/brands\">Coca-Cola website</a>)"
            }
          },
          {
            "id": "E_-Xq5bWKn",
            "type": "paragraph",
            "data": {
              "text": "Another important brand produced in Iran under Coca-Cola licence is Canada Dry. Canada Dry is an old brand with Canadian origins. The brand, which over its lifetime has passed between several companies, currently belongs to the Keurig Dr Pepper group. (<a href=\"https://www.keurigdrpepper.com/keurig-dr-pepper-unveils-bold-new-flavors-across-iconic-u-s-cold-beverages-portfolio/\">Keurig Dr Pepper</a>) But in the business world, companies sometimes use other companies' capacity to access markets they themselves cannot. Keurig Dr Pepper, in regions where it cannot operate directly, has granted Coca-Cola the rights to some of its brands — including Canada Dry. For example, in the Japanese market Coca-Cola holds the rights to distribute Canada Dry. (<a href=\"https://www.coca-cola.com/jp/ja/brands\">Coca-Cola website</a>)"
            }
          },
          {
            "id": "fQ_EqIXyGX",
            "type": "paragraph",
            "data": {
              "text": "In Iran the Canada Dry brand has long been known by the public as \"the yellow soda\". So Khoshgovar, in the late 2000s (1380s), decided to use this familiarity and — given its relationship with Coca-Cola — revive its position in the Iranian market. (<a href=\"http://www.khabaronline.ir/xnbs\">Khabar Online</a>)"
            }
          },
          {
            "id": "keKPQcpVdt",
            "type": "image",
            "data": {
              "caption": "An old Canada Dry advert in Iran",
              "file": {
                "fileId": "86ad927e-0661-4b3b-9ac2-07a7e755bb85"
              }
            }
          },
          {
            "id": "OuJozNqYBH",
            "type": "paragraph",
            "data": {
              "text": "Canada Dry is registered in Iran by European Refreshments — an Irish company belonging to Coca-Cola. (<a href=\"https://ipm.ssaa.ir/Search-Result?page=2\">Document Registration</a>) (<a href=\"https://ir.cocacolaep.com/news-releases/news-release-details/coca-cola-ep-plc-holdings-company\">Coca-Cola EP</a>) (<a href=\"https://www.bloomberg.com/profile/company/0102719D:ID\">Bloomberg</a>) It is therefore clear that this brand is owned in Iran by Coca-Cola, and Khoshgovar has been able to supply it in Iran on the same basis. Coca-Cola's 2006 letter to the SEC also stated that after supplying the Coca-Cola, Fanta and Sprite brands, the company was seeking permission from OFAC to supply some other brands — including Canada Dry — in Iran. Something that came to pass two years later. (<a href=\"https://www.sec.gov/Archives/edgar/data/21344/000002134406000056/filename1.htm\">SEC</a>) In addition, the Minute Maid juice, Powerade sports-drink and Costa Coffee brands — all owned by Coca-Cola — have at various points been present in the Iranian market through local production, import or smuggling. (<a href=\"https://www.coca-cola.com/us/en/brands\">Coca-Cola website</a>)"
            }
          },
          {
            "id": "VRr0RokPPd",
            "type": "image",
            "data": {
              "caption": "Canada Dry trademark registration information in Iran",
              "file": {
                "fileId": "5bf2de0d-ba93-4947-bb53-a389fb60bb0e"
              }
            }
          },
          {
            "id": "LylFJ7yOwv",
            "type": "paragraph",
            "data": {
              "text": "Alongside Coca-Cola-owned brands, other brands are also present in Iran which — through Coca-Cola's investments and partnerships with their owners — fall under the company's umbrella. The most important of these are the <b>Rani</b> fruit drinks and <b>Barbican</b> malt beverages. In 2005 (1384) Saudi Arabia's Aujan group entered the Iranian market by founding Aujan Iranian (East Trade Industries) and supplying Rani fruit drinks. (<a href=\"https://rasmio.com/company/10103000114\">Rasmio</a>) A few years later this company invested to produce Rani products and Barbican malt drinks domestically — operations that continue extensively to this day. (<a href=\"https://www.irna.ir/x38GRR\">IRNA</a>) (<a href=\"http://www.magiran.com/n1109238\">Ettelaat</a>)"
            }
          },
          {
            "id": "p-O6gdguGr",
            "type": "image",
            "data": {
              "caption": "",
              "file": {
                "fileId": "55259612-146e-4570-ab34-11e0f90af56d"
              }
            }
          },
          {
            "id": "XU4umgjxVr",
            "type": "paragraph",
            "data": {
              "text": "In 2011 (1390) Coca-Cola made a $980 million investment in Aujan group's beverages business. Following this investment, two companies — Rani Refreshments and Aujan-Coca-Cola Beverages — were born. In this important partnership Coca-Cola took 50% and 49% of these two companies' shares respectively. (<a href=\"https://investors.coca-colacompany.com/news-events/press-releases/detail/301/aujan-industries-and-the-coca-cola-company-announce-signing-of-980-million-agreement\">Coca-Cola Company</a>) Rani Refreshments owns and maintains the Rani and Barbican brands, while Aujan-Coca-Cola handles production and distribution. (<a href=\"https://aujan.com/our-companies/fmgc/rani-refreshments-2/\">Aujan 1</a>) (<a href=\"https://aujan.com/our-companies/fmgc/aujan-coca-cola-beverages-company/\">Aujan 2</a>) Under the same arrangement, the Rani and Barbican brands are registered in Iran by Rani Refreshments — making them identifiable as Coca-Cola-company brands. (<a href=\"https://ipm.ssaa.ir/Search-Result?page=2\">Document Registration 1</a>) (<a href=\"https://ipm.ssaa.ir/Search-Result?page=2\">Document Registration 2</a>)"
            }
          },
          {
            "id": "d4AC0JvJay",
            "type": "image",
            "data": {
              "caption": "",
              "file": {
                "fileId": "758e5ccc-1c6c-46e8-bcb3-3ae262599c04"
              }
            }
          },
          {
            "id": "1wyoejP7L9",
            "type": "paragraph",
            "data": {
              "text": "Iranian consumers may also encounter some of Coca-Cola's special brands outside Iran. For example, the drink <b>Crystal</b> is widely available in Iraq. This brand also belongs to the Coca-Cola family of brands and is produced by Turkey's CCİ (İçecek) bottler. CCİ is one of the larger bottlers in the Coca-Cola system, holding the rights to distribute the company's brands in many central- and west-Asian countries including Iraq. Coca-Cola itself now also owns 20% of CCİ. (<a href=\"https://www.cci.com.tr/en/cci-at-a-glance/our-operating-geography/middle-east/iraq\">CCİ 1</a>) (<a href=\"https://www.cci.com.tr/en/investor-relations/corporate-governance/shareholder-structure-and-subsidiaries\">CCİ 2</a>)"
            }
          },
          {
            "id": "5MH4LSAi9B",
            "type": "image",
            "data": {
              "caption": "Crystal drink with the phrase \"A product from the Coca-Cola family\" on its label",
              "file": {
                "fileId": "7c3dc54f-eb45-4ea4-907b-04cb6bb4bd6c"
              }
            }
          },
          {
            "id": "zi_w01ciIB",
            "type": "header",
            "data": {
              "text": "Finally: Coca-Cola and supporting Israel",
              "level": 2
            }
          },
          {
            "id": "OUZZRJ_8PL",
            "type": "paragraph",
            "data": {
              "text": "The tangled story of Coca-Cola's presence in Iran has, after years, finally found its loose end today. A thread which, once pulled, perhaps answers half the consumer's questions. Yes — Coca-Cola is in Iran. But the other half — the accusations against Coca-Cola regarding its relationship with Israel — remains unanswered. That half will be revealed soon in the second part of qlist's Coca-Cola dossier."
            }
          }
        ]
      }
    }
  ],
  "assetManifest": {
    "b4ed84bf-c809-40a0-a7c7-808d2342252b": "b4ed84bf-c809-40a0-a7c7-808d2342252b.png",
    "5dd1a6e6-4fc2-469e-af5a-25db4cc16a0a": "5dd1a6e6-4fc2-469e-af5a-25db4cc16a0a.png",
    "e7f6e54f-b790-442d-9a79-4c3723da5b76": "e7f6e54f-b790-442d-9a79-4c3723da5b76.jpg",
    "19ea970c-f17c-49fe-b935-6face159732b": "19ea970c-f17c-49fe-b935-6face159732b.png",
    "17eb52b3-db9c-4deb-80ed-5ce869113ef6": "17eb52b3-db9c-4deb-80ed-5ce869113ef6.png",
    "1c46adbb-b7bb-4370-b11d-f6427dbc3f93": "1c46adbb-b7bb-4370-b11d-f6427dbc3f93.png",
    "c1dfb757-3aa6-44b2-8003-0827206cd68a": "c1dfb757-3aa6-44b2-8003-0827206cd68a.png",
    "26b73fda-bd99-4899-9ed2-dd73636bb2b8": "26b73fda-bd99-4899-9ed2-dd73636bb2b8.png",
    "acbeccec-e85d-4ea5-8a9a-ebea16b3620f": "acbeccec-e85d-4ea5-8a9a-ebea16b3620f.png",
    "fc6a69df-bd93-490b-ab81-8431bad23316": "fc6a69df-bd93-490b-ab81-8431bad23316.png",
    "35a0dd19-47de-44bf-82e0-2a55ddfe716c": "35a0dd19-47de-44bf-82e0-2a55ddfe716c.png",
    "13361db9-ed10-4f5b-b76a-9f8a6378033b": "13361db9-ed10-4f5b-b76a-9f8a6378033b.png",
    "0c62fef4-fad5-4122-b536-88094aa16ce8": "0c62fef4-fad5-4122-b536-88094aa16ce8.png",
    "abb9e4f6-93b4-449a-82df-de1de0eb7700": "abb9e4f6-93b4-449a-82df-de1de0eb7700.png",
    "aea44a11-39fa-45b3-904c-8bbe60f98143": "aea44a11-39fa-45b3-904c-8bbe60f98143.png",
    "c7945832-0946-4bf1-a27c-a947bd84e34d": "c7945832-0946-4bf1-a27c-a947bd84e34d.png",
    "125ccf47-9eae-42e0-a8cd-772558b2ab95": "125ccf47-9eae-42e0-a8cd-772558b2ab95.png",
    "e4815e17-f867-40ea-a783-2d549b9c0d58": "e4815e17-f867-40ea-a783-2d549b9c0d58.jpg",
    "efa107d5-7c8a-449e-bac8-70545959675a": "efa107d5-7c8a-449e-bac8-70545959675a.png",
    "819503e3-a4d5-4af3-95c2-dc3798441388": "819503e3-a4d5-4af3-95c2-dc3798441388.png",
    "194e8c5b-de18-4a3b-bed8-d3e36183988f": "194e8c5b-de18-4a3b-bed8-d3e36183988f.png",
    "a77aa550-5536-4196-a236-f93b0e164117": "a77aa550-5536-4196-a236-f93b0e164117.png",
    "f9e6cf85-44f7-4899-8de5-f4ae7ed81347": "f9e6cf85-44f7-4899-8de5-f4ae7ed81347.png",
    "835e86c0-b6e3-460c-bbf1-0eeffaa6e8bc": "835e86c0-b6e3-460c-bbf1-0eeffaa6e8bc.png",
    "77094194-fb10-450b-928b-4a38f0846922": "77094194-fb10-450b-928b-4a38f0846922.png",
    "f6ca94b0-1fa3-4d19-9128-93c60eab34fc": "f6ca94b0-1fa3-4d19-9128-93c60eab34fc.png",
    "e569ff93-8121-4501-922f-805c061fe2be": "e569ff93-8121-4501-922f-805c061fe2be.png",
    "5a49e08d-2056-47da-8c73-e9ecefaf2777": "5a49e08d-2056-47da-8c73-e9ecefaf2777.jpg",
    "560a8d68-bf21-4c45-bf06-31e2dda0efa4": "560a8d68-bf21-4c45-bf06-31e2dda0efa4.png",
    "49ab3759-09f0-4c9e-a8a5-3d475e23ec8e": "49ab3759-09f0-4c9e-a8a5-3d475e23ec8e.png",
    "2728c9b2-3115-4f9e-87d8-d47f645492e3": "2728c9b2-3115-4f9e-87d8-d47f645492e3.png",
    "e18ba909-1009-493c-b45f-6d2516daf4ab": "e18ba909-1009-493c-b45f-6d2516daf4ab.png",
    "b8693aa3-3475-4f1d-b9f2-5790ed0e7580": "b8693aa3-3475-4f1d-b9f2-5790ed0e7580.png",
    "fd285d04-2809-4d00-89d9-eccb1915fa11": "fd285d04-2809-4d00-89d9-eccb1915fa11.jpg",
    "dd50ef86-9fdd-4457-b9e5-739b51cbeae3": "dd50ef86-9fdd-4457-b9e5-739b51cbeae3.png",
    "7c0eab32-374c-40d3-9cf4-10eb145b3dd2": "7c0eab32-374c-40d3-9cf4-10eb145b3dd2.png",
    "f3bd2312-daf3-484f-9404-7685dbddcdf5": "f3bd2312-daf3-484f-9404-7685dbddcdf5.png",
    "f62154ae-33f4-4478-a2ef-cf5d80e9d3a2": "f62154ae-33f4-4478-a2ef-cf5d80e9d3a2.png",
    "035deef9-c3ba-44af-8ba1-eca229bd9ba1": "035deef9-c3ba-44af-8ba1-eca229bd9ba1.png",
    "5e43ebc4-fec7-495a-a77c-1fde4166bcfc": "5e43ebc4-fec7-495a-a77c-1fde4166bcfc.png",
    "5aa2e9ef-3cf0-4328-ba75-66f00c93537c": "5aa2e9ef-3cf0-4328-ba75-66f00c93537c.png",
    "688115c5-a691-43ff-b24d-2506760362a7": "688115c5-a691-43ff-b24d-2506760362a7.png",
    "5f32c21e-f75b-4719-871d-0f98dba8bfd4": "5f32c21e-f75b-4719-871d-0f98dba8bfd4.png",
    "6e43b5c1-5433-4074-847f-c726f74912eb": "6e43b5c1-5433-4074-847f-c726f74912eb.png",
    "bd136a6e-18a4-4b1b-95b9-3174ad1537bf": "bd136a6e-18a4-4b1b-95b9-3174ad1537bf.png",
    "c87f7c45-fafc-4e87-ba65-0755aef9dda2": "c87f7c45-fafc-4e87-ba65-0755aef9dda2.png",
    "13134619-3cb0-4992-82c5-f297527c8e8d": "13134619-3cb0-4992-82c5-f297527c8e8d.png",
    "7a3cfce0-b4d1-4c65-8592-58972ba68b09": "7a3cfce0-b4d1-4c65-8592-58972ba68b09.png",
    "c217d2fc-8f57-48b0-b307-313f1e9f6e00": "c217d2fc-8f57-48b0-b307-313f1e9f6e00.png",
    "e2f32ac3-b570-41cf-ad4d-2c685888704f": "e2f32ac3-b570-41cf-ad4d-2c685888704f.png",
    "221ef687-3634-41d1-8b81-2a138c7752d5": "221ef687-3634-41d1-8b81-2a138c7752d5.png",
    "3dcfec2f-0288-4293-9ac2-53fbe162508b": "3dcfec2f-0288-4293-9ac2-53fbe162508b.png",
    "b836db68-88b9-4f08-a897-415245c3331d": "b836db68-88b9-4f08-a897-415245c3331d.png",
    "420da01e-4f22-4b8b-bc88-250cc40d3c19": "420da01e-4f22-4b8b-bc88-250cc40d3c19.png",
    "3b2d9545-663b-444c-91ab-6a41e62506cf": "3b2d9545-663b-444c-91ab-6a41e62506cf.png",
    "790f385a-cc73-4653-9d8d-304c88393af2": "790f385a-cc73-4653-9d8d-304c88393af2.png",
    "7921bc99-61f1-4536-9c16-274fb92d2b39": "7921bc99-61f1-4536-9c16-274fb92d2b39.png",
    "171f00ff-aaad-4a59-a43c-6a83355341f4": "171f00ff-aaad-4a59-a43c-6a83355341f4.png",
    "574d0133-aab8-4b41-a52c-4ef6b1460263": "574d0133-aab8-4b41-a52c-4ef6b1460263.png",
    "d244b55d-09d3-4ac5-9d23-eb378832bdb0": "d244b55d-09d3-4ac5-9d23-eb378832bdb0.png",
    "02af7f13-c132-4778-9d87-c23d31795a82": "02af7f13-c132-4778-9d87-c23d31795a82.png",
    "9828c841-2069-4c20-b5b8-aa64c249f4cb": "9828c841-2069-4c20-b5b8-aa64c249f4cb.png",
    "0d088aed-6b1a-410d-9ed6-bad3e203b970": "0d088aed-6b1a-410d-9ed6-bad3e203b970.png",
    "3139087a-af00-4f57-bd9f-884cffe44638": "3139087a-af00-4f57-bd9f-884cffe44638.png",
    "22fc04c8-866a-4fc9-a18e-d2590c839c26": "22fc04c8-866a-4fc9-a18e-d2590c839c26.png",
    "8b191f58-f7ca-448b-8751-0fd793bba960": "8b191f58-f7ca-448b-8751-0fd793bba960.png",
    "37bd75a9-b584-4a70-8d0f-dc8477f2d432": "37bd75a9-b584-4a70-8d0f-dc8477f2d432.png",
    "b38779e8-6f19-4a8f-9a1c-dbcdc8af5628": "b38779e8-6f19-4a8f-9a1c-dbcdc8af5628.png",
    "a9a39760-d7a9-44c7-8bf0-9dfe2aef67d2": "a9a39760-d7a9-44c7-8bf0-9dfe2aef67d2.png",
    "eb42cdbb-2198-4af7-80a1-58b9fc7c4f99": "eb42cdbb-2198-4af7-80a1-58b9fc7c4f99.png",
    "dc833532-8774-4f7c-b5b7-7cee1e577acc": "dc833532-8774-4f7c-b5b7-7cee1e577acc.png",
    "080234e7-f90b-455d-8e0f-19d914ea0053": "080234e7-f90b-455d-8e0f-19d914ea0053.png",
    "a50ce2f6-4f6b-4c10-b9ae-1ec998ab1d18": "a50ce2f6-4f6b-4c10-b9ae-1ec998ab1d18.png",
    "27bae53e-bc80-4697-b09d-75c7341cf73e": "27bae53e-bc80-4697-b09d-75c7341cf73e.png",
    "fee52cce-0365-4b13-aa41-9045a87c46ef": "fee52cce-0365-4b13-aa41-9045a87c46ef.png",
    "354db9b8-b195-4507-a0b8-602264f74eee": "354db9b8-b195-4507-a0b8-602264f74eee.png",
    "0034be70-bd14-40c0-aea2-a460264af362": "0034be70-bd14-40c0-aea2-a460264af362.png",
    "0ec6ca5c-5bbd-4b20-a3e2-874d09c0ff08": "0ec6ca5c-5bbd-4b20-a3e2-874d09c0ff08.png",
    "fc907bb2-f710-439c-a337-298de290ce61": "fc907bb2-f710-439c-a337-298de290ce61.jpg",
    "27b3c769-1b76-4909-b550-75c32d329185": "27b3c769-1b76-4909-b550-75c32d329185.jpg",
    "b0d09b15-b3bb-48b1-bc25-9c326677c914": "b0d09b15-b3bb-48b1-bc25-9c326677c914.png",
    "81329ca3-d043-4a19-8885-ca017e45aaed": "81329ca3-d043-4a19-8885-ca017e45aaed.png",
    "5a129186-789a-4a8c-94b9-24ae62b361ab": "5a129186-789a-4a8c-94b9-24ae62b361ab.png",
    "2b353a14-be23-4c75-80cf-4caf33a25e0f": "2b353a14-be23-4c75-80cf-4caf33a25e0f.png",
    "7c3e50fb-b4bc-4d5e-a9dc-17eba5c5fae7": "7c3e50fb-b4bc-4d5e-a9dc-17eba5c5fae7.png",
    "99e9d745-9860-4fc2-9096-2afed827186e": "99e9d745-9860-4fc2-9096-2afed827186e.png",
    "f5e7a13e-fab7-42e1-9d5b-226aef7d1528": "f5e7a13e-fab7-42e1-9d5b-226aef7d1528.png",
    "20e5b21b-9e3f-4dce-a3de-7486fc8e0ad0": "20e5b21b-9e3f-4dce-a3de-7486fc8e0ad0.png",
    "11cbf0b3-8f2e-46c9-8938-d6e20ab3a2b0": "11cbf0b3-8f2e-46c9-8938-d6e20ab3a2b0.png",
    "df5455f2-f8d5-4326-a600-bd6ba5e78224": "df5455f2-f8d5-4326-a600-bd6ba5e78224.png",
    "47ac4db4-afa8-4e9c-a682-52b1499908b5": "47ac4db4-afa8-4e9c-a682-52b1499908b5.png",
    "c7a19fc8-df79-43ff-ac68-8781101d346f": "c7a19fc8-df79-43ff-ac68-8781101d346f.png",
    "ee561297-da76-4999-8d1b-9d33f5819ef4": "ee561297-da76-4999-8d1b-9d33f5819ef4.png",
    "3b451fc9-103f-474e-b655-afd2f47d4120": "3b451fc9-103f-474e-b655-afd2f47d4120.jpg",
    "77f97241-dbff-40a5-9146-da3262366063": "77f97241-dbff-40a5-9146-da3262366063.webp",
    "c783d1d6-930b-41c5-a349-a91bbf29815c": "c783d1d6-930b-41c5-a349-a91bbf29815c.webp",
    "35aabe66-012d-46a0-b468-5f204b12737b": "35aabe66-012d-46a0-b468-5f204b12737b.webp",
    "2f2bf087-d07c-4c5a-977e-99167dffa27e": "2f2bf087-d07c-4c5a-977e-99167dffa27e.webp",
    "816b9cf9-568a-4b38-b64d-32db5c8e9469": "816b9cf9-568a-4b38-b64d-32db5c8e9469.webp",
    "46476d45-44fc-43e6-bb55-50f278659420": "46476d45-44fc-43e6-bb55-50f278659420.webp",
    "8116a9cb-a69a-4e7c-8085-24347f742210": "8116a9cb-a69a-4e7c-8085-24347f742210.webp",
    "d7349ff3-6a82-475a-9175-5df41ec9598b": "d7349ff3-6a82-475a-9175-5df41ec9598b.webp",
    "c12fcbc7-481d-4e01-86af-9c7728b249ab": "c12fcbc7-481d-4e01-86af-9c7728b249ab.webp",
    "f0fe035f-ca05-4cbd-a1ac-4ef26717c45b": "f0fe035f-ca05-4cbd-a1ac-4ef26717c45b.webp",
    "b612e331-080f-431e-9dce-f66897afd358": "b612e331-080f-431e-9dce-f66897afd358.webp",
    "bc7560c9-cabe-4df1-9463-778806a50828": "bc7560c9-cabe-4df1-9463-778806a50828.webp",
    "3ed3590d-c2d9-480c-938c-a020dbbc8ca4": "3ed3590d-c2d9-480c-938c-a020dbbc8ca4.webp",
    "e29dae59-148d-48f1-aad4-5e2cb9c163c4": "e29dae59-148d-48f1-aad4-5e2cb9c163c4.webp",
    "9762ba46-49a5-45a6-8fff-93d1cdc28deb": "9762ba46-49a5-45a6-8fff-93d1cdc28deb.webp",
    "a136e893-060f-4249-b647-9f9c8e7e02f7": "a136e893-060f-4249-b647-9f9c8e7e02f7.webp",
    "64ddd0a4-0eef-4f1c-a2a3-bf9ae7c556ea": "64ddd0a4-0eef-4f1c-a2a3-bf9ae7c556ea.webp",
    "712386e5-905c-4f28-818f-08dd3b3132fe": "712386e5-905c-4f28-818f-08dd3b3132fe.webp",
    "53211373-644c-40d4-9a7f-a584f589d51d": "53211373-644c-40d4-9a7f-a584f589d51d.webp",
    "1a999fc5-50d3-48c0-b691-dc071b1fff99": "1a999fc5-50d3-48c0-b691-dc071b1fff99.webp",
    "4af9d39d-d405-432b-95a4-15ebaef239ba": "4af9d39d-d405-432b-95a4-15ebaef239ba.webp",
    "c9c6b191-fb28-4627-8759-47743a72f75c": "c9c6b191-fb28-4627-8759-47743a72f75c.webp",
    "74dde232-7b79-4c1e-b950-4dcf0a5adc52": "74dde232-7b79-4c1e-b950-4dcf0a5adc52.webp",
    "40d62404-321e-47a3-afca-46d3f252982b": "40d62404-321e-47a3-afca-46d3f252982b.jpg",
    "63bc6556-9830-49ec-a5f9-131b0b5a22e0": "63bc6556-9830-49ec-a5f9-131b0b5a22e0.webp",
    "3193a059-893c-4c09-89b5-bcfd386791f0": "3193a059-893c-4c09-89b5-bcfd386791f0.webp",
    "7926addf-7976-4182-a787-bf8d60938baf": "7926addf-7976-4182-a787-bf8d60938baf.webp",
    "d0ff83e9-42f6-4b9d-9d9b-cba6e763558a": "d0ff83e9-42f6-4b9d-9d9b-cba6e763558a.webp",
    "d9f48f6f-2168-4df5-a5a1-d0eba1f8ceae": "d9f48f6f-2168-4df5-a5a1-d0eba1f8ceae.webp",
    "5edb453a-34e1-42c5-b6fc-bde2b165bca4": "5edb453a-34e1-42c5-b6fc-bde2b165bca4.webp",
    "38f0fd8f-ef19-4d7b-a008-cc59250f89b0": "38f0fd8f-ef19-4d7b-a008-cc59250f89b0.webp",
    "64618fb8-5ed5-4581-9f11-845163a377f1": "64618fb8-5ed5-4581-9f11-845163a377f1.webp",
    "e1b3dc02-3813-4933-be7f-204164d376d1": "e1b3dc02-3813-4933-be7f-204164d376d1.webp",
    "f39f2528-e529-488a-b5ff-59fb4ef6682f": "f39f2528-e529-488a-b5ff-59fb4ef6682f.jpg",
    "4d0a0933-f5a1-47d0-901f-e2f1ed1b6337": "4d0a0933-f5a1-47d0-901f-e2f1ed1b6337.jpg",
    "871a0e5a-720a-4bb4-a829-c6ef0dff50cf": "871a0e5a-720a-4bb4-a829-c6ef0dff50cf.webp",
    "4b478e80-2c4a-4a9f-97f9-446e5aaeac45": "4b478e80-2c4a-4a9f-97f9-446e5aaeac45.webp",
    "5f1d26e3-cccd-42e3-ae6a-b5b9a98fd0eb": "5f1d26e3-cccd-42e3-ae6a-b5b9a98fd0eb.webp",
    "ab18f93c-f966-466e-97e4-d5b663ca94e9": "ab18f93c-f966-466e-97e4-d5b663ca94e9.webp",
    "4320af1c-7746-40b2-a7f4-5ce927562055": "4320af1c-7746-40b2-a7f4-5ce927562055.webp",
    "1d133791-c577-49f2-babd-b6904f46b0b8": "1d133791-c577-49f2-babd-b6904f46b0b8.webp",
    "2b85d968-c232-42a9-8029-97033e568d89": "2b85d968-c232-42a9-8029-97033e568d89.webp",
    "83c5b7c7-fd14-4bfc-bb1d-23389baf52d6": "83c5b7c7-fd14-4bfc-bb1d-23389baf52d6.webp",
    "17322403-834e-47e2-8a7a-aeabdc115eaf": "17322403-834e-47e2-8a7a-aeabdc115eaf.webp",
    "dc2fb676-91de-4230-a2e0-82f7a1ecd4f9": "dc2fb676-91de-4230-a2e0-82f7a1ecd4f9.webp",
    "80fe2727-50ee-42f4-b99e-ad1164ecc95a": "80fe2727-50ee-42f4-b99e-ad1164ecc95a.webp",
    "52f2faf5-2956-4c8e-9102-4506fe878e48": "52f2faf5-2956-4c8e-9102-4506fe878e48.webp",
    "a438251d-0fa8-4fc8-a3b6-37f9ca44b25a": "a438251d-0fa8-4fc8-a3b6-37f9ca44b25a.webp",
    "1ae0fc51-51b6-4aba-aa91-d02ba4076229": "1ae0fc51-51b6-4aba-aa91-d02ba4076229.webp",
    "c523758b-42e3-4f93-b90f-24749468edc4": "c523758b-42e3-4f93-b90f-24749468edc4.webp",
    "803b93bb-d14f-479f-b452-00c03d7a6ec2": "803b93bb-d14f-479f-b452-00c03d7a6ec2.webp",
    "460ba094-4d4a-4e92-a134-bea582700cb3": "460ba094-4d4a-4e92-a134-bea582700cb3.jpg",
    "94c8272c-755e-4ef2-b3e0-03a3410e48d6": "94c8272c-755e-4ef2-b3e0-03a3410e48d6.jpg",
    "dc1f3ddc-5896-4f86-98c3-50f937a653d4": "dc1f3ddc-5896-4f86-98c3-50f937a653d4.jpg",
    "43777372-42e8-4f3b-bbab-c210ae06a75a": "43777372-42e8-4f3b-bbab-c210ae06a75a.webp",
    "60ec9d0a-5ccf-4e22-b0f5-f5cbc352abf9": "60ec9d0a-5ccf-4e22-b0f5-f5cbc352abf9.png",
    "65199e6e-9920-4e5a-9e2a-72a21e5f1539": "65199e6e-9920-4e5a-9e2a-72a21e5f1539.jpg",
    "79571f61-7278-47f5-9e35-3abb488f8e73": "79571f61-7278-47f5-9e35-3abb488f8e73.jpg",
    "8e779335-9fa5-4c70-a1d4-036d7a5170b8": "8e779335-9fa5-4c70-a1d4-036d7a5170b8.jpg",
    "3eb977ed-23ca-4d7a-b233-14939ed43eae": "3eb977ed-23ca-4d7a-b233-14939ed43eae.jpg",
    "7c63e6da-de0c-481a-8d48-03776ecb279b": "7c63e6da-de0c-481a-8d48-03776ecb279b.jpg",
    "46fe3ac2-63c8-4f27-9f36-7b581b1661ac": "46fe3ac2-63c8-4f27-9f36-7b581b1661ac.png",
    "3f784500-b450-4f37-9a48-494c0f08e905": "3f784500-b450-4f37-9a48-494c0f08e905.png",
    "8f61625b-a450-4840-b494-1b7aa4eb5612": "8f61625b-a450-4840-b494-1b7aa4eb5612.png",
    "a5ed8602-092b-44ed-9ac3-c8fc9022e6c8": "a5ed8602-092b-44ed-9ac3-c8fc9022e6c8.jpg",
    "d0498119-819f-4a30-aade-ef3c5c19ceeb": "d0498119-819f-4a30-aade-ef3c5c19ceeb.jpg",
    "791b6a9b-d27b-424e-a27b-fc597b420460": "791b6a9b-d27b-424e-a27b-fc597b420460.png",
    "ee6f71c1-f10f-459b-a398-4723cee05e3a": "ee6f71c1-f10f-459b-a398-4723cee05e3a.png",
    "4f74470b-d3e6-451f-9647-dbb7c4ada485": "4f74470b-d3e6-451f-9647-dbb7c4ada485.jpg",
    "00a452e8-7703-4dae-a15d-2e1e4aec3923": "00a452e8-7703-4dae-a15d-2e1e4aec3923.jpg",
    "6cc1e6ba-87f7-42ef-b02b-f95dc209ab08": "6cc1e6ba-87f7-42ef-b02b-f95dc209ab08.jpg",
    "c13d6c5b-dfbd-4b5f-8b47-f24745b603e6": "c13d6c5b-dfbd-4b5f-8b47-f24745b603e6.jpg",
    "b1306d26-6ece-4470-aca8-d2a1a6a977ec": "b1306d26-6ece-4470-aca8-d2a1a6a977ec.jpg",
    "7abd8d83-0590-44e4-b734-939bb9c96842": "7abd8d83-0590-44e4-b734-939bb9c96842.jpg",
    "7c7ac9bd-4f7b-444b-946b-99bc72da61c2": "7c7ac9bd-4f7b-444b-946b-99bc72da61c2.jpg",
    "6192a0ea-776b-45bc-a05f-2e73d72b055e": "6192a0ea-776b-45bc-a05f-2e73d72b055e.png",
    "86ad927e-0661-4b3b-9ac2-07a7e755bb85": "86ad927e-0661-4b3b-9ac2-07a7e755bb85.jpg",
    "5bf2de0d-ba93-4947-bb53-a389fb60bb0e": "5bf2de0d-ba93-4947-bb53-a389fb60bb0e.png",
    "758e5ccc-1c6c-46e8-bcb3-3ae262599c04": "758e5ccc-1c6c-46e8-bcb3-3ae262599c04.jpg"
  }
}

export default data
